import React from 'react';
import { navigate } from '@reach/router';

class MansionMap extends React.Component {
  onClickHandler = e => {
    navigate(`/venues/floors/${e.currentTarget.id}`);
  };

  render() {
    return (
      <div className="mansion-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0"
          y="0"
          enableBackground="new 0 0 271.2 262.4"
          viewBox="0 0 271.2 262.4"
        >
          <g>
            <path d="M233.5 219.3L250.4 219.3" className="st0"></path>
            <text
              className="st1 st2 st3"
              transform="translate(248.252 216.988)"
            >
              1
            </text>
            <path d="M227.1 183.2L250.4 183.2" className="st0"></path>
            <text className="st1 st2 st3" transform="translate(247.772 180.88)">
              2
            </text>
            <path d="M227.1 162.3L250.4 162.3" className="st0"></path>
            <text className="st1 st2 st3" transform="translate(247.737 160.02)">
              3
            </text>
            <path d="M214.3 141.5L250.4 141.5" className="st0"></path>
            <text className="st1 st2 st3" transform="translate(247.753 139.25)">
              4
            </text>
            <g>
              <path d="M214.3 120.8L250.4 120.8" className="st0"></path>
              <text
                className="st1 st2 st3"
                transform="translate(247.756 118.524)"
              >
                5
              </text>
            </g>
            <g>
              <path d="M174 102.7L250.4 102.7" className="st0"></path>
              <text
                className="st1 st2 st3"
                transform="translate(247.732 100.385)"
              >
                6
              </text>
            </g>
            <g>
              <path d="M171.2 80L250.4 80" className="st0"></path>
              <text
                className="st1 st2 st3"
                transform="translate(247.948 77.703)"
              >
                7
              </text>
            </g>
            <g>
              <g>
                <path d="M174.1 158.7L174.1 215.4" className="st4"></path>
                <path d="M206.2 156.4L206.2 157.3" className="st4"></path>
                <path d="M206.2 158.7L206.2 215.4" className="st4"></path>
                <path d="M227.3 156.4L227.3 216.4" className="st4"></path>
                <path d="M227.9 155.8L202.9 155.8" className="st4"></path>
                <path
                  d="M198.8 154.5c0-.2-.2-.3-.3-.3-.2 0-.3.2-.3.3s.2.3.3.3c.1.1.3-.1.3-.3"
                  className="st4"
                ></path>
                <path
                  d="M197.4 154.5c0 .4.3.7.7.7s.7-.3.7-.7"
                  className="st4"
                ></path>
                <path
                  d="M199.2 153.3c-.4-.1-.9-.1-1.2.2-.4.2-.6.6-.6 1.1M201.2 154.7c1.7 1.2 3.5 2.1 5.4 2.8M201.2 154.7c-.6-.6-1.3-1.1-2-1.4M200.5 155.8c1.8 1.2 3.7 2.2 5.7 2.9M200.5 155.8c-.5-.5-1.1-.9-1.7-1.3"
                  className="st4"
                ></path>
                <path d="M206.2 158.7L206.3 158.6" className="st4"></path>
                <path d="M206.3 158.6c.2-.3.3-.6.3-.9" className="st4"></path>
                <path d="M206.6 157.6L206.7 157.5" className="st4"></path>
                <path d="M202.9 155.8L202.9 153.6" className="st4"></path>
                <path d="M177.4 155.8L177.4 153.6" className="st4"></path>
                <path
                  d="M206.9 155.8L206.9 156.1 206.6 156.1 206.6 156.3 206.4 156.3 206.4 156.4 206.2 156.4"
                  className="st4"
                ></path>
                <path
                  d="M227.9 155.8L227.9 156.1 227.6 156.1 227.6 156.3 227.4 156.3 227.4 156.4 227.3 156.4"
                  className="st4"
                ></path>
                <path d="M174.1 156.4L174.1 157.3" className="st4"></path>
                <path d="M142.9 155.8L177.4 155.8" className="st4"></path>
                <path
                  d="M173.4 155.8L173.4 156.1 173.8 156.1 173.8 156.3 173.9 156.3 173.9 156.4 174.1 156.4"
                  className="st4"
                ></path>
                <path
                  d="M182.3 154.5c0-.2-.2-.3-.3-.3-.2 0-.3.2-.3.3s.2.3.3.3c.1.1.3-.1.3-.3"
                  className="st4"
                ></path>
                <path
                  d="M181.6 154.5c0 .4.3.7.7.7.4 0 .7-.3.7-.7M182.9 154.5c0-.7-.6-1.3-1.3-1.3-.1 0-.3 0-.4.1M173.7 157.5c1.9-.7 3.7-1.6 5.4-2.8M181.1 153.3c-.8.4-1.5.8-2 1.4M174.1 158.7c2-.7 4-1.7 5.7-2.9M181.6 154.5c-.7.3-1.2.7-1.7 1.3"
                  className="st4"
                ></path>
                <path d="M174.1 158.7L174 158.6" className="st4"></path>
                <path d="M173.7 157.6c0 .3.1.7.3.9" className="st4"></path>
                <path d="M173.7 157.6L173.7 157.5" className="st4"></path>
                <path d="M233.8 219.3L38.5 219.3" className="st4"></path>
                <path d="M121.7 203.1L117.2 203.1" className="st4"></path>
                <path d="M121.5 204L117.4 204" className="st4"></path>
                <path d="M93.3 158.7L93.3 215.4" className="st4"></path>
                <path d="M61.2 156.4L61.2 157.3" className="st4"></path>
                <path d="M61.2 158.7L61.2 215.4" className="st4"></path>
                <path d="M40.1 185.6L40.1 215.4" className="st4"></path>
                <path d="M45.7 155.8L60.5 155.8" className="st4"></path>
                <path d="M60.5 155.8L64.5 155.8" className="st4"></path>
                <path
                  d="M69.3 154.5c0-.2-.2-.3-.3-.3s-.3.2-.3.3.2.3.3.3c.2.1.3-.1.3-.3"
                  className="st4"
                ></path>
                <path
                  d="M68.7 154.5c0 .4.3.7.7.7.4 0 .7-.3.7-.7M70 154.5c0-.4-.2-.8-.6-1.1-.4-.2-.8-.3-1.2-.2M60.7 157.5c1.9-.7 3.7-1.6 5.4-2.8M68.2 153.3c-.8.4-1.5.8-2 1.4M61.2 158.7c2-.7 4-1.7 5.7-2.9M68.6 154.5c-.7.3-1.2.7-1.7 1.3"
                  className="st4"
                ></path>
                <path d="M61.2 158.7L61.1 158.6" className="st4"></path>
                <path d="M60.8 157.6c0 .3.1.7.3.9" className="st4"></path>
                <path d="M60.8 157.6L60.7 157.5" className="st4"></path>
                <path
                  d="M60.5 155.8L60.5 156.1 60.8 156.1 60.8 156.3 61 156.3 61 156.4 61.2 156.4"
                  className="st4"
                ></path>
                <path
                  d="M45.7 155.8L45.7 156.1 46.1 156.1 46.1 156.3 46.2 156.3 46.2 156.4 46.4 156.4"
                  className="st4"
                ></path>
                <path d="M93.3 156.4L93.3 157.3" className="st4"></path>
                <path d="M124.5 155.8L90 155.8" className="st4"></path>
                <path
                  d="M93.9 155.8L93.9 156.1 93.6 156.1 93.6 156.3 93.4 156.3 93.4 156.4 93.3 156.4"
                  className="st4"
                ></path>
                <path
                  d="M85.8 154.5c0-.2-.2-.3-.3-.3-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2.1.3-.1.3-.3"
                  className="st4"
                ></path>
                <path
                  d="M84.5 154.5c0 .4.3.7.7.7.4 0 .7-.3.7-.7M86.2 153.3c-.7-.2-1.4.1-1.7.8-.1.1-.1.3-.1.4M88.3 154.7c1.7 1.2 3.5 2.1 5.4 2.8M88.3 154.7c-.6-.6-1.3-1.1-2-1.4M87.5 155.8c1.8 1.2 3.7 2.2 5.8 2.9M87.5 155.8c-.5-.5-1.1-.9-1.7-1.3"
                  className="st4"
                ></path>
                <path d="M93.3 158.7L93.3 158.6" className="st4"></path>
                <path d="M93.3 158.6c.2-.3.3-.6.3-.9" className="st4"></path>
                <path d="M93.7 157.6L93.7 157.5" className="st4"></path>
                <path
                  d="M197 181.1L183.4 181.1 183.4 175.9"
                  className="st5"
                ></path>
                <path
                  d="M197 175.9c0-3.8-3-6.8-6.8-6.8s-6.8 3-6.8 6.8"
                  className="st5"
                ></path>
                <path d="M197 175.9L197 181.1" className="st5"></path>
                <path
                  d="M193.6 173.1c-1.7-1.9-4.7-2-6.6-.3l-.3.3"
                  className="st5"
                ></path>
                <path d="M182.5 181.1L182.5 175.9" className="st5"></path>
                <path d="M197.8 175.9L197.8 181.1" className="st5"></path>
                <path d="M181.9 181.1L198.4 181.1" className="st5"></path>
                <path
                  d="M198.4 181.1L198.4 182 181.9 182 181.9 181.1"
                  className="st5"
                ></path>
                <path
                  d="M197.8 175.9c-.1-4.2-3.7-7.6-7.9-7.4-4 .1-7.3 3.4-7.4 7.4"
                  className="st5"
                ></path>
                <path d="M85 198L85 200.6" className="st5"></path>
                <path d="M85 200.6L85 215.4" className="st5"></path>
                <path d="M86 198L86 200.6" className="st5"></path>
                <path d="M86 200.6L86 215.4" className="st5"></path>
                <path d="M69.4 200.6L69.4 215.4" className="st5"></path>
                <path d="M68.5 200.6L68.5 215.4" className="st5"></path>
                <path d="M86 198L68.5 198" className="st5"></path>
                <path d="M77.2 195L86.4 197.2" className="st5"></path>
                <path d="M77.2 193.5L87.1 196.1" className="st5"></path>
                <path d="M77.2 195L68.1 197.2" className="st5"></path>
                <path d="M77.2 193.5L67.4 196.1" className="st5"></path>
                <path d="M87.1 196.1L86.3 197.3" className="st5"></path>
                <path d="M86.3 197.3L68.1 197.3" className="st5"></path>
                <path d="M68.5 197.7L68.5 198" className="st5"></path>
                <path d="M68.1 197.3L68.1 197.7" className="st5"></path>
                <path d="M86 197.7L86 198" className="st5"></path>
                <path d="M86.3 197.3L86.3 197.7" className="st5"></path>
                <path d="M67.4 196.1L68.1 197.3" className="st5"></path>
                <path
                  d="M84.5 198.8L81.1 198.8 81.1 209.7 84.5 209.7 84.5 198.8"
                  className="st5"
                ></path>
                <path
                  d="M77.4 198.8L81.1 198.8 81.1 209.7 77.4 209.7 77.4 198.8"
                  className="st5"
                ></path>
                <path
                  d="M69.9 198.8L73.7 198.8 73.7 209.7 70 209.7 70 198.8"
                  className="st5"
                ></path>
                <path
                  d="M77.4 198.8L73.7 198.8 73.7 209.7 77.4 209.7 77.4 198.8"
                  className="st5"
                ></path>
                <path d="M69.4 210.8L85 210.8" className="st5"></path>
                <path d="M80.8 210.8L80.8 215.4" className="st5"></path>
                <path d="M77.1 210.8L77.1 215.4" className="st5"></path>
                <path d="M73.3 210.8L73.3 215.4" className="st5"></path>
                <path
                  d="M40.1 215.4L39.8 215.4 39.8 216"
                  className="st4"
                ></path>
                <path d="M39.8 216c-.5 0-1 .4-1 1" className="st4"></path>
                <path d="M38.8 217L38.5 217 38.5 219.3" className="st4"></path>
                <path d="M40.1 215.4L117.5 215.4" className="st4"></path>
                <path d="M121.4 215.4L122.5 215.4" className="st4"></path>
                <path d="M121.4 216.4L122.5 216.4" className="st4"></path>
                <path d="M121.4 217.3L122.5 217.3" className="st4"></path>
                <path d="M121.4 218.3L122.5 218.3" className="st4"></path>
                <path d="M124.7 215.4L142.6 215.4" className="st4"></path>
                <path d="M124.7 216.4L142.6 216.4" className="st4"></path>
                <path d="M124.7 217.3L142.6 217.3" className="st4"></path>
                <path d="M124.7 218.3L142.6 218.3" className="st4"></path>
                <path d="M144.9 215.4L146 215.4" className="st4"></path>
                <path d="M144.9 216.4L146 216.4" className="st4"></path>
                <path d="M144.9 217.3L146 217.3" className="st4"></path>
                <path d="M144.9 218.3L146 218.3" className="st4"></path>
                <path
                  d="M61.2 215.4L60.8 215.4 60.8 216"
                  className="st4"
                ></path>
                <path d="M60.8 216c-.5 0-1 .4-1 1" className="st4"></path>
                <path d="M59.9 217L59.5 217 59.5 219.3" className="st4"></path>
                <path
                  d="M93.3 215.4L93.6 215.4 93.6 216"
                  className="st4"
                ></path>
                <path d="M94.6 217c0-.5-.4-1-1-1" className="st4"></path>
                <path d="M94.6 217L94.9 217 94.9 219.3" className="st4"></path>
                <path d="M149.9 215.4L206.6 215.4" className="st4"></path>
                <path d="M69.4 198L69.4 200.6" className="st5"></path>
                <path d="M68.5 198L68.5 200.6" className="st5"></path>
                <path
                  d="M196.3 173.3L193.6 173.3 193.6 180.9"
                  className="st5"
                ></path>
                <path
                  d="M193.6 173.3L190.2 173.3 190.2 181.1 193.6 181.1 193.6 173.3"
                  className="st5"
                ></path>
                <path d="M182.5 175.9L182.5 181.1" className="st5"></path>
                <path
                  d="M184.1 173.3L186.8 173.3 186.8 180.9"
                  className="st5"
                ></path>
                <path
                  d="M186.8 173.3L190.2 173.3 190.2 181.1 186.8 181.1 186.8 173.3"
                  className="st5"
                ></path>
                <path d="M196.5 173.3L183.9 173.3" className="st5"></path>
                <path d="M190.2 171.6L191.5 169.2" className="st5"></path>
                <path d="M190.2 171.6L188.8 169.2" className="st5"></path>
                <path d="M190.2 173.1L191.5 171.8" className="st5"></path>
                <path d="M190.2 173.1L188.9 171.8" className="st5"></path>
                <path d="M193.6 173.3L193.6 170" className="st5"></path>
                <path d="M186.7 173.3L186.7 170" className="st5"></path>
                <path d="M193.6 173.1L195.3 171.4" className="st5"></path>
                <path d="M186.7 173.1L185 171.4" className="st5"></path>
                <path d="M108.2 177.3L108.2 169.5" className="st5"></path>
                <path
                  d="M108.2 169.5L101.8 169.5 101.8 177.3"
                  className="st5"
                ></path>
                <path d="M108.2 177.3L108.2 170.9" className="st5"></path>
                <path
                  d="M108.2 170.9L105 170.9 105 177.3"
                  className="st5"
                ></path>
                <path d="M101.8 177.3L101.8 170.9" className="st5"></path>
                <path
                  d="M101.8 170.9L105 170.9 105 177.3"
                  className="st5"
                ></path>
                <path d="M108.2 170.7L108.2 170.9" className="st5"></path>
                <path
                  d="M108.2 170.9L101.8 170.9 101.8 170.7"
                  className="st5"
                ></path>
                <path
                  d="M96.4 177.3H113.60000000000001V177.8H96.4z"
                  className="st6"
                ></path>
                <path d="M116.2 176.5L151.2 176.5" className="st4"></path>
                <path d="M149.9 177.5L149.9 183" className="st4"></path>
                <path d="M117.5 177.5L117.5 183" className="st4"></path>
                <path d="M117.5 185.6L117.5 201.8" className="st4"></path>
                <path d="M117.5 204L117.5 219.3" className="st4"></path>
                <path d="M145.4 201.7L145.4 198.6" className="st4"></path>
                <path
                  d="M145.4 198.7c-2.7-2.6-6.2-4.2-9.9-4.6M131.9 194c-3.7.4-7.2 2-9.9 4.7"
                  className="st4"
                ></path>
                <path d="M122 198.6L122 201.7" className="st4"></path>
                <path d="M121.4 204L121.4 219.3" className="st4"></path>
                <path d="M116.7 177.5L150.7 177.5" className="st4"></path>
                <path d="M150.8 177.4L150.8 177" className="st4"></path>
                <path d="M150.7 177.5L150.7 177.4" className="st4"></path>
                <path d="M150.9 177L150.9 176.9" className="st4"></path>
                <path d="M151.1 176.9L151.1 176.8" className="st4"></path>
                <path d="M151.2 176.6L151.2 176.5" className="st4"></path>
                <path d="M150.8 177.4L150.7 177.4" className="st4"></path>
                <path d="M151.1 176.9L150.9 176.9" className="st4"></path>
                <path d="M150.9 177L150.8 177" className="st4"></path>
                <path d="M151.2 176.6c-.1 0-.1 0-.1.1" className="st4"></path>
                <path d="M116.6 177.4L116.6 177" className="st4"></path>
                <path d="M116.7 177.5L116.7 177.4" className="st4"></path>
                <path d="M116.4 177L116.4 176.9" className="st4"></path>
                <path d="M116.3 176.9L116.3 176.8" className="st4"></path>
                <path d="M116.2 176.6L116.2 176.5" className="st4"></path>
                <path d="M116.6 177.4L116.7 177.4" className="st4"></path>
                <path d="M116.3 176.9L116.4 176.9" className="st4"></path>
                <path d="M116.4 177L116.6 177" className="st4"></path>
                <path d="M116.3 176.8c0-.1-.1-.1-.1-.1" className="st4"></path>
                <path d="M93.3 162.3L121.6 162.3" className="st4"></path>
                <path
                  d="M93.3 163.6L121.1 163.6 121.1 163.4 121.3 163.4 121.3 163.2"
                  className="st4"
                ></path>
                <path d="M121.3 163.2c.1-.2.1-.4.2-.6" className="st4"></path>
                <path
                  d="M121.5 162.6L121.6 162.6 121.6 162.3"
                  className="st4"
                ></path>
                <path
                  d="M206.2 215.4L206.6 215.4 206.6 216"
                  className="st4"
                ></path>
                <path d="M207.5 217c0-.5-.4-1-1-1" className="st4"></path>
                <path
                  d="M207.5 217L207.8 217 207.8 219.3"
                  className="st4"
                ></path>
                <path
                  d="M174.1 215.4L173.8 215.4 173.8 216"
                  className="st4"
                ></path>
                <path d="M173.8 216c-.5 0-1 .4-1 1" className="st4"></path>
                <path
                  d="M172.8 217L172.5 217 172.5 219.3"
                  className="st4"
                ></path>
                <path d="M39.5 185.3L39.5 184.3" className="st4"></path>
                <path d="M39.8 185.6L39.8 185.3" className="st4"></path>
                <path d="M39.1 184.3L39.1 184" className="st4"></path>
                <path d="M38.8 184L38.8 183.6" className="st4"></path>
                <path d="M38.5 183.3L38.5 183 61.2 183" className="st4"></path>
                <path d="M39.8 185.6L61.2 185.6" className="st4"></path>
                <path d="M39.5 185.3L39.8 185.3" className="st4"></path>
                <path d="M38.8 184L39.1 184" className="st4"></path>
                <path d="M38.8 176.5L61.2 176.5" className="st4"></path>
                <path d="M39.3 177.5L61.2 177.5" className="st4"></path>
                <path d="M39.2 177.4L39.2 177" className="st4"></path>
                <path d="M39.3 177.5L39.3 177.4" className="st4"></path>
                <path d="M39.1 177L39.1 176.9" className="st4"></path>
                <path d="M38.9 176.9L38.9 176.8" className="st4"></path>
                <path d="M38.8 176.6L38.8 176.5" className="st4"></path>
                <path d="M39.2 177.4L39.3 177.4" className="st4"></path>
                <path d="M38.9 176.9L39.1 176.9" className="st4"></path>
                <path d="M39.1 177L39.2 177" className="st4"></path>
                <path d="M38.9 176.8c0-.1-.1-.1-.1-.1" className="st4"></path>
                <path d="M56.7 182.7L56.4 182.7" className="st5"></path>
                <path
                  d="M56.4 182.6c-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.1 0-.1 0 0 0M56.5 180.4c-.3.4-.3 1-.1 1.4"
                  className="st5"
                ></path>
                <path d="M56.7 180.4L56.5 180.4" className="st5"></path>
                <path
                  d="M56.5 180.1s-.1 0 0 0c-.1 0-.1.1 0 0-.1.1 0 .1 0 0M56.5 180.2s-.1 0 0 0c-.1.1-.1.1 0 0-.1.1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M56.7 180.1L56.5 180.1" className="st5"></path>
                <path d="M56.7 180.2L56.5 180.2" className="st5"></path>
                <path d="M56.7 177.8L56.4 177.8" className="st5"></path>
                <path
                  d="M56.4 177.8s-.1 0 0 0c-.1.1-.1.1 0 .1"
                  className="st5"
                ></path>
                <path d="M56.7 177.9L56.4 177.9" className="st5"></path>
                <path d="M56.4 178.7c-.2.5-.1 1 .1 1.4" className="st5"></path>
                <path d="M56.4 182.6L56.7 182.6" className="st5"></path>
                <path d="M56.9 180.1c.2-.4.3-1 .1-1.4" className="st5"></path>
                <path d="M56.7 177.9L56.9 177.9" className="st5"></path>
                <path
                  d="M56.9 177.9c.1 0 .1 0 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M56.7 177.8L56.9 177.8" className="st5"></path>
                <path d="M56.7 180.2L56.8 180.2" className="st5"></path>
                <path d="M56.7 180.1L56.8 180.1" className="st5"></path>
                <path d="M56.9 180.2" className="st5"></path>
                <path d="M57 182.6L56.7 182.6" className="st5"></path>
                <path
                  d="M56.9 180.4c0-.1 0-.1 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M56.7 180.4L56.8 180.4" className="st5"></path>
                <path
                  d="M57 181.8c.2-.5.1-1-.1-1.4M57 182.6"
                  className="st5"
                ></path>
                <path d="M56.7 182.7L57 182.7" className="st5"></path>
                <path
                  d="M56.9 177.9c-.1.3-.1.5 0 .8M56.4 178.7c.1-.3.1-.5 0-.8M57 181.8c-.1.3-.1.5 0 .8M56.4 182.6c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M57.2 183L56.1 183 56.1 182.7 57.2 182.7 57.2 183"
                  className="st5"
                ></path>
                <path
                  d="M57.2 177.8L56.1 177.8 56.1 177.5 57.2 177.5 57.2 177.8"
                  className="st5"
                ></path>
                <path d="M53.6 182.7L53.3 182.7" className="st5"></path>
                <path d="M53.4 180.4c-.3.4-.3 1-.1 1.4" className="st5"></path>
                <path d="M53.6 180.4L53.4 180.4" className="st5"></path>
                <path
                  d="M53.4 180.1s0 .1 0 0c0 .1 0 .1 0 0M53.4 180.2c0 .1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M53.6 180.1L53.4 180.1" className="st5"></path>
                <path d="M53.6 180.2L53.4 180.2" className="st5"></path>
                <path d="M53.6 177.8L53.3 177.8" className="st5"></path>
                <path
                  d="M53.4 177.8c-.1 0-.1 0 0 0-.1 0-.1 0 0 0v.1"
                  className="st5"
                ></path>
                <path d="M53.6 177.9L53.3 177.9" className="st5"></path>
                <path d="M53.3 178.7c-.2.5-.1 1 .1 1.4" className="st5"></path>
                <path d="M53.3 182.6L53.6 182.6" className="st5"></path>
                <path d="M53.8 180.1c.3-.4.3-1 .1-1.4" className="st5"></path>
                <path d="M53.6 177.9L53.9 177.9" className="st5"></path>
                <path
                  d="M53.8 177.9c.1 0 .1 0 0 0 .1 0 .1-.1 0 0 .1-.1.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M53.6 177.8L53.9 177.8" className="st5"></path>
                <path d="M53.6 180.2L53.8 180.2" className="st5"></path>
                <path d="M53.6 180.1L53.8 180.1" className="st5"></path>
                <path
                  d="M53.8 180.2s.1 0 0 0c.1 0 .1 0 0 0 .1 0 0 0 0 0"
                  className="st5"
                ></path>
                <path d="M53.9 182.6L53.6 182.6" className="st5"></path>
                <path
                  d="M53.8 180.4c.1-.1.1-.1 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M53.6 180.4L53.8 180.4" className="st5"></path>
                <path
                  d="M54 181.8c.2-.5.1-1-.1-1.4M54 182.7c0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M53.6 182.7L53.9 182.7" className="st5"></path>
                <path
                  d="M53.9 177.9c-.1.3-.1.5 0 .8M53.3 178.7c.1-.3.1-.5 0-.8M53.9 181.8c-.1.3-.1.5 0 .8M53.3 182.6c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M54.1 183L53.1 183 53.1 182.7 54.1 182.7 54.1 183"
                  className="st5"
                ></path>
                <path
                  d="M54.1 177.8L53.1 177.8 53.1 177.5 54.1 177.5 54.1 177.8"
                  className="st5"
                ></path>
                <path d="M50.5 182.7L50.2 182.7" className="st5"></path>
                <path
                  d="M50.3 182.6c-.1 0-.1 0 0 0m-.1 0M50.4 180.4c-.2.4-.3 1-.1 1.4"
                  className="st5"
                ></path>
                <path d="M50.5 180.4L50.4 180.4" className="st5"></path>
                <path
                  d="M50.4 180.1s-.1 0 0 0c-.1 0-.1.1 0 0M50.4 180.2c-.1 0-.1.1 0 0-.1.1-.1.1 0 0-.1.2 0 .2 0 0"
                  className="st5"
                ></path>
                <path d="M50.5 180.1L50.4 180.1" className="st5"></path>
                <path d="M50.5 180.2L50.4 180.2" className="st5"></path>
                <path d="M50.5 177.8L50.3 177.8" className="st5"></path>
                <path d="M50.3 177.8s-.1 0 0 0v.1" className="st5"></path>
                <path d="M50.5 177.9L50.3 177.9" className="st5"></path>
                <path d="M50.3 178.7c-.2.5-.1 1 .1 1.4" className="st5"></path>
                <path d="M50.2 182.6L50.5 182.6" className="st5"></path>
                <path d="M50.7 180.1c.3-.4.3-1 .1-1.4" className="st5"></path>
                <path d="M50.5 177.9L50.8 177.9" className="st5"></path>
                <path
                  d="M50.8 177.9c.1 0 .1 0 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M50.5 177.8L50.8 177.8" className="st5"></path>
                <path d="M50.5 180.2L50.7 180.2" className="st5"></path>
                <path d="M50.5 180.1L50.7 180.1" className="st5"></path>
                <path
                  d="M50.7 180.2c.1 0 .1 0 0 0 .1 0 .1 0 0 0 .1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M50.9 182.6L50.5 182.6" className="st5"></path>
                <path
                  d="M50.7 180.4c.1 0 .1 0 0 0 .1-.1.1-.1 0 0 .1-.1.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M50.5 180.4L50.7 180.4" className="st5"></path>
                <path
                  d="M50.9 181.8c.2-.5.1-1-.1-1.4M50.9 182.7c0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M50.5 182.7L50.9 182.7" className="st5"></path>
                <path
                  d="M50.8 177.9c-.1.3-.1.5 0 .8M50.3 178.7c.1-.3.1-.5 0-.8M50.9 181.8c-.1.3-.1.5 0 .8M50.2 182.6c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M51.1 183L50 183 50 182.7 51.1 182.7 51.1 183"
                  className="st5"
                ></path>
                <path
                  d="M51.1 177.8L50 177.8 50 177.5 51.1 177.5 51.1 177.8"
                  className="st5"
                ></path>
                <path d="M47.5 182.7L47.2 182.7" className="st5"></path>
                <path
                  d="M47.2 182.6c-.1 0-.1 0 0 0M47.3 180.4c-.3.4-.3 1-.1 1.4"
                  className="st5"
                ></path>
                <path d="M47.5 180.4L47.3 180.4" className="st5"></path>
                <path
                  d="M47.3 180.1c-.1 0-.1.1 0 0 0 .1 0 .1 0 0M47.3 180.2c-.1.1-.1.1 0 0 0 .1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M47.5 180.1L47.3 180.1" className="st5"></path>
                <path d="M47.5 180.2L47.3 180.2" className="st5"></path>
                <path d="M47.5 177.8L47.2 177.8" className="st5"></path>
                <path d="M47.2 177.8v.1" className="st5"></path>
                <path d="M47.5 177.9L47.2 177.9" className="st5"></path>
                <path d="M47.2 178.7c-.2.5-.1 1 .1 1.4" className="st5"></path>
                <path d="M47.2 182.6L47.5 182.6" className="st5"></path>
                <path d="M47.7 180.1c.3-.4.3-1 .1-1.4" className="st5"></path>
                <path d="M47.5 177.9L47.8 177.9" className="st5"></path>
                <path
                  d="M47.7 177.9c.1 0 .1 0 0 0 .1 0 .1 0 0 0 .1-.1.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M47.5 177.8L47.7 177.8" className="st5"></path>
                <path d="M47.5 180.2L47.7 180.2" className="st5"></path>
                <path d="M47.5 180.1L47.7 180.1" className="st5"></path>
                <path
                  d="M47.7 180.2s.1 0 0 0c.1 0 .1 0 0 0 .1 0 0 0 0 0"
                  className="st5"
                ></path>
                <path d="M47.8 182.6L47.5 182.6" className="st5"></path>
                <path
                  d="M47.7 180.4c.1-.1.1-.1 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M47.5 180.4L47.7 180.4" className="st5"></path>
                <path
                  d="M47.8 181.8c.2-.5.1-1-.1-1.4M47.8 182.7s.1 0 0 0c.1 0 .1 0 0 0 .1-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M47.5 182.7L47.8 182.7" className="st5"></path>
                <path
                  d="M47.8 177.9c-.1.3-.1.5 0 .8M47.2 178.7c.1-.3.1-.5 0-.8M47.8 181.8c-.1.3-.1.5 0 .8M47.2 182.6c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M48 183L47 183 47 182.7 48 182.7 48 183"
                  className="st5"
                ></path>
                <path
                  d="M48 177.8L47 177.8 47 177.5 48 177.5 48 177.8"
                  className="st5"
                ></path>
                <path d="M44.4 182.7L44.1 182.7" className="st5"></path>
                <path d="M44.3 180.4c-.2.4-.3 1-.1 1.4" className="st5"></path>
                <path d="M44.4 180.4L44.3 180.4" className="st5"></path>
                <path
                  d="M44.3 180.1c-.1 0-.1 0 0 0-.1 0-.1.1 0 0-.1.1-.1.1 0 0M44.3 180.2c-.1 0-.1 0 0 0-.1.1-.1.1 0 0-.1.1-.1.1 0 0"
                  className="st5"
                ></path>
                <path d="M44.4 180.1L44.3 180.1" className="st5"></path>
                <path d="M44.4 180.2L44.3 180.2" className="st5"></path>
                <path d="M44.4 177.8L44.2 177.8" className="st5"></path>
                <path
                  d="M44.2 177.8s-.1 0 0 0c-.1.1-.1.1 0 .1"
                  className="st5"
                ></path>
                <path d="M44.4 177.9L44.2 177.9" className="st5"></path>
                <path d="M44.1 178.7c-.2.5-.1 1 .1 1.4" className="st5"></path>
                <path d="M44.1 182.6L44.4 182.6" className="st5"></path>
                <path d="M44.6 180.1c.2-.4.3-1 .1-1.4" className="st5"></path>
                <path d="M44.4 177.9L44.7 177.9" className="st5"></path>
                <path
                  d="M44.7 177.9c.1 0 .1 0 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M44.4 177.8L44.7 177.8" className="st5"></path>
                <path d="M44.4 180.2L44.6 180.2" className="st5"></path>
                <path d="M44.4 180.1L44.6 180.1" className="st5"></path>
                <path d="M44.7 180.2" className="st5"></path>
                <path d="M44.8 182.6L44.4 182.6" className="st5"></path>
                <path
                  d="M44.6 180.4c.1 0 .1 0 0 0 .1-.1.1-.1 0 0 .1-.1.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M44.4 180.4L44.6 180.4" className="st5"></path>
                <path
                  d="M44.8 181.8c.2-.5.1-1-.1-1.4M44.8 182.7c0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M44.4 182.7L44.8 182.7" className="st5"></path>
                <path
                  d="M44.7 177.9c-.1.3-.1.5 0 .8M44.2 178.7c.1-.3.1-.5 0-.8M44.7 181.8c-.1.3-.1.5 0 .8M44.1 182.6c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M45 183L43.9 183 43.9 182.7 45 182.7 45 183"
                  className="st5"
                ></path>
                <path
                  d="M45 177.8L43.9 177.8 43.9 177.5 45 177.5 45 177.8"
                  className="st5"
                ></path>
                <path
                  d="M198.5 148c.8 2.3 2.4 4.3 4.4 5.6"
                  className="st4"
                ></path>
                <path d="M198.4 148L195 148" className="st4"></path>
                <path
                  d="M195 148c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8M190.2 148c-.1.8.5 1.5 1.3 1.5.3 0 .6 0 .8-.2.5-.3.7-.8.7-1.3"
                  className="st4"
                ></path>
                <path
                  d="M196 146.7c-.7-1.5-2.5-2.2-4.1-1.5-1.1.5-1.8 1.6-1.8 2.8"
                  className="st4"
                ></path>
                <path d="M196 146.7L199.5 146.7" className="st4"></path>
                <path
                  d="M199.6 146.7c.5 2.3 1.9 4.3 3.8 5.6M193 148c0-.4-.4-.8-.8-.8s-.8.4-.8.8.4.8.8.8.8-.4.8-.8"
                  className="st4"
                ></path>
                <path d="M202.9 153.6L203 153.4" className="st4"></path>
                <path d="M203 153.4c.2-.3.3-.6.3-1" className="st4"></path>
                <path d="M203.3 152.5L203.4 152.3" className="st4"></path>
                <path
                  d="M177.4 153.6c2.1-1.3 3.6-3.2 4.4-5.6"
                  className="st4"
                ></path>
                <path d="M181.9 148L185.3 148" className="st4"></path>
                <path
                  d="M188.9 148c.1-1-.7-1.8-1.7-1.9-1-.1-1.8.7-1.9 1.7v.2M187.3 148c-.1.8.5 1.5 1.3 1.5.3 0 .6 0 .9-.2.5-.3.7-.8.7-1.3"
                  className="st4"
                ></path>
                <path
                  d="M190.2 148c0-1.7-1.4-3.1-3.1-3.1-1.2 0-2.3.7-2.8 1.8"
                  className="st4"
                ></path>
                <path d="M184.3 146.7L180.8 146.7" className="st4"></path>
                <path
                  d="M176.9 152.3c2-1.3 3.3-3.3 3.8-5.6M188.9 148c0-.4-.4-.8-.8-.8s-.8.4-.8.8.4.8.8.8.8-.4.8-.8"
                  className="st4"
                ></path>
                <path d="M177.4 153.6L177.3 153.4" className="st4"></path>
                <path d="M177 152.4c0 .4.1.7.3 1" className="st4"></path>
                <path d="M177 152.5L176.9 152.3" className="st4"></path>
                <path
                  d="M191 144.5c-.6 1.1-.8 2.3-.8 3.5M191.9 145.2c.1-.3 0-.6-.2-.7-.2-.2-.6-.2-.8 0M190.2 148c.1-1.2-.2-2.4-.8-3.5"
                  className="st4"
                ></path>
                <path
                  d="M189.4 144.5c-.2-.2-.6-.2-.8 0-.2.2-.3.5-.2.7M190.8 144.3c0-.3-.3-.6-.6-.6s-.6.3-.6.6M190.8 144.3c-.2.6-.3 1.2-.5 1.9M190 146.2c-.1-.6-.3-1.3-.5-1.9"
                  className="st4"
                ></path>
                <path d="M64.5 155.8L64.5 153.6" className="st4"></path>
                <path d="M90 155.8L90 153.6" className="st4"></path>
                <path
                  d="M64.5 153.6c2.1-1.3 3.6-3.2 4.4-5.6"
                  className="st4"
                ></path>
                <path d="M68.9 148L72.4 148" className="st4"></path>
                <path
                  d="M75.9 148c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8M74.4 148c-.1.8.5 1.5 1.3 1.5.8.1 1.5-.5 1.5-1.3v-.2"
                  className="st4"
                ></path>
                <path
                  d="M77.2 148c0-1.7-1.4-3.1-3.1-3.1-1.2 0-2.3.7-2.8 1.8"
                  className="st4"
                ></path>
                <path d="M71.4 146.7L67.8 146.7" className="st4"></path>
                <path
                  d="M64 152.3c2-1.3 3.3-3.3 3.8-5.6M75.9 148c0-.4-.4-.8-.8-.8s-.8.4-.8.8.4.8.8.8.8-.4.8-.8"
                  className="st4"
                ></path>
                <path d="M64.5 153.6L64.4 153.4" className="st4"></path>
                <path d="M64.1 152.4c0 .4.1.7.3 1" className="st4"></path>
                <path d="M64.1 152.5L64 152.3" className="st4"></path>
                <path
                  d="M85.5 148c.8 2.3 2.4 4.3 4.4 5.6"
                  className="st4"
                ></path>
                <path d="M85.5 148L82.1 148" className="st4"></path>
                <path
                  d="M82.1 148c.1-1-.7-1.8-1.7-1.9-1-.1-1.8.7-1.9 1.7v.2M77.2 148c-.1.8.5 1.5 1.3 1.5.3 0 .6 0 .9-.2.5-.3.7-.8.7-1.3"
                  className="st4"
                ></path>
                <path
                  d="M83.1 146.7c-.7-1.6-2.5-2.3-4.1-1.6-1.1.5-1.9 1.6-1.8 2.9"
                  className="st4"
                ></path>
                <path d="M83.1 146.7L86.6 146.7" className="st4"></path>
                <path
                  d="M86.6 146.7c.5 2.3 1.9 4.3 3.8 5.6M80.1 148c0-.4-.4-.8-.8-.8s-.8.4-.8.8.4.8.8.8.8-.4.8-.8"
                  className="st4"
                ></path>
                <path d="M90 153.6L90.1 153.4" className="st4"></path>
                <path d="M90.1 153.4c.2-.3.3-.6.3-1" className="st4"></path>
                <path d="M90.4 152.5L90.5 152.3" className="st4"></path>
                <path
                  d="M77.2 148c0-1.2-.2-2.4-.8-3.5M76.5 144.5c-.2-.2-.6-.2-.8 0-.2.2-.3.5-.2.7M78 144.5c-.6 1.1-.9 2.3-.8 3.5M79 145.2c.1-.3 0-.6-.2-.7-.2-.2-.5-.2-.8 0M77.8 144.3c0-.3-.3-.6-.6-.6s-.6.3-.6.6M77.1 146.2c-.1-.6-.3-1.3-.5-1.9M77.8 144.3c-.2.6-.3 1.2-.5 1.9"
                  className="st4"
                ></path>
                <path d="M51 144.1L59.4 144.1" className="st4"></path>
                <path d="M59.4 144.1L76.6 144.1" className="st4"></path>
                <path d="M77.8 144.1L189.6 144.1" className="st4"></path>
                <path d="M190.7 144.1L214.3 144.1" className="st4"></path>
                <path d="M59.4 135.7L59.4 144.1" className="st4"></path>
                <path d="M215 135.1L58.7 135.1" className="st4"></path>
                <path
                  d="M59.4 135.7L59.2 135.7 59.2 135.5 59.1 135.5 59.1 135.4 58.7 135.4 58.7 135.1"
                  className="st4"
                ></path>
                <path
                  d="M215 135.1L215 135.4 214.6 135.4 214.6 135.5 214.5 135.5 214.5 135.7 214.3 135.7"
                  className="st4"
                ></path>
                <path d="M69.4 144.1L69.4 146.7" className="st4"></path>
                <path d="M207.2 144.1L207.2 155.8" className="st4"></path>
                <path d="M59.4 144.1L59.4 155.8" className="st4"></path>
                <path d="M51 135.7L51 144.1" className="st4"></path>
                <path
                  d="M58.7 135.1L50.3 135.1 50.3 135.4 50.6 135.4 50.6 135.5 50.8 135.5 50.8 135.7 50.9 135.7"
                  className="st4"
                ></path>
                <path d="M50.9 135.7L59.2 135.7" className="st4"></path>
                <path
                  d="M215 135.1L215 135.4 214.6 135.4 214.6 135.5 214.5 135.5 214.5 135.7 214.3 135.7 214.3 144.1"
                  className="st4"
                ></path>
                <path d="M46.4 156.4L46.4 176.5" className="st4"></path>
                <path d="M115.1 185.3L115.1 184.3" className="st4"></path>
                <path d="M114.8 184.3L114.8 184" className="st4"></path>
                <path d="M114.5 184L114.5 183.6" className="st4"></path>
                <path
                  d="M112.1 183.3L112.1 183 153.2 183"
                  className="st4"
                ></path>
                <path d="M115.5 185.6L151.9 185.6" className="st4"></path>
                <path d="M114.5 184L114.8 184" className="st4"></path>
                <path d="M114.8 184.3L115.1 184.3" className="st4"></path>
                <path
                  d="M114.5 183.6c-.8-.2-1.6-.3-2.4-.3"
                  className="st4"
                ></path>
                <path d="M152.2 185.3L152.2 184.3" className="st4"></path>
                <path d="M151.9 185.6L151.9 185.3" className="st4"></path>
                <path d="M152.6 184.3L152.6 184" className="st4"></path>
                <path d="M152.9 184L152.9 183.6" className="st4"></path>
                <path d="M153.2 183.3L153.2 183" className="st4"></path>
                <path d="M152.2 185.3L151.9 185.3" className="st4"></path>
                <path d="M152.9 184L152.6 184" className="st4"></path>
                <path d="M152.6 184.3L152.2 184.3" className="st4"></path>
                <path d="M153.2 183.3c-.2 0-.3.1-.3.3" className="st4"></path>
                <path
                  d="M154.2 41.8L154.2 37.9 125.6 37.9 125.6 41.8"
                  className="st4"
                ></path>
                <path
                  d="M125.6 42.4L125.6 61.9 154.2 61.9 154.2 42.4"
                  className="st4"
                ></path>
                <path d="M172.9 72.9L124.9 72.9" className="st4"></path>
                <path d="M125.6 73.5L125.6 79.4" className="st4"></path>
                <path
                  d="M125.6 80L125.6 81.9 172.2 81.9 172.2 80"
                  className="st4"
                ></path>
                <path d="M172.2 79.4L172.2 73.5" className="st4"></path>
                <path d="M175.6 93.6L89.8 93.6" className="st4"></path>
                <path d="M90.5 94.3L90.5 100.1" className="st4"></path>
                <path
                  d="M90.5 100.7L90.5 102.7 175 102.7 175 100.7"
                  className="st4"
                ></path>
                <path d="M175 100.1L175 94.3" className="st4"></path>
                <path d="M203.7 120.8L203.7 115" className="st4"></path>
                <path d="M93.5 114.3L65 114.3" className="st4"></path>
                <path d="M65.7 115L65.7 120.8" className="st4"></path>
                <path d="M221.8 205.7L221.8 216.5" className="st4"></path>
                <path d="M208.8 205.7L208.8 216.5" className="st4"></path>
                <path
                  d="M221.8 205.7c.1-3.6-2.7-6.6-6.2-6.7-3.6-.1-6.6 2.7-6.7 6.2v.5"
                  className="st4"
                ></path>
                <path d="M125.6 80L125.6 93.6" className="st4"></path>
                <path d="M125.6 73.5L125.6 79.4" className="st4"></path>
                <path d="M125.6 61.9L125.6 72.9" className="st4"></path>
                <path d="M145.4 72.9L145.4 61.9" className="st4"></path>
                <path
                  d="M120 155.8L120 147.9 115.2 147.9 115.2 155.8"
                  className="st5"
                ></path>
                <path
                  d="M115.4 149.5L117.6 149.5 117.6 155.8"
                  className="st5"
                ></path>
                <path d="M120 149.5L115.2 149.5" className="st5"></path>
                <path
                  d="M110.5 155.8L110.5 147.9 115.2 147.9 115.2 155.8"
                  className="st5"
                ></path>
                <path
                  d="M115.1 149.5L112.8 149.5 112.8 155.8"
                  className="st5"
                ></path>
                <path d="M110.5 149.5L115.2 149.5" className="st5"></path>
                <path
                  d="M120 155.8L120 147.9 110.5 147.9 110.5 155.8"
                  className="st5"
                ></path>
                <path
                  d="M140.1 150.8c.5 1.5 1.5 2.8 2.8 3.8"
                  className="st4"
                ></path>
                <path d="M140.1 150.8L138.2 150.8" className="st4"></path>
                <path
                  d="M138.2 150.8c.2-1.1-.5-2.1-1.6-2.3-.7-.1-1.4.1-1.9.7"
                  className="st4"
                ></path>
                <path
                  d="M139.2 149.8c-.3-1.6-1.9-2.6-3.5-2.3-.7.1-1.3.5-1.7 1.1M134 148.6c-.4.5-.3 1.1.2 1.5.2.1.4.2.6.2.4 0 .8-.2 1-.6"
                  className="st4"
                ></path>
                <path d="M139.2 149.8L140.9 149.8" className="st4"></path>
                <path
                  d="M141 149.8c.4 1.7 1.4 3.2 2.9 4.2M135.8 149.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6"
                  className="st4"
                ></path>
                <path d="M142.9 156.4L142.9 154.5" className="st4"></path>
                <path d="M143.8 154L143.8 155.8" className="st4"></path>
                <path
                  d="M124.5 154.5c1.3-1 2.2-2.3 2.7-3.8"
                  className="st4"
                ></path>
                <path d="M127.3 150.8L129.1 150.8" className="st4"></path>
                <path
                  d="M132.7 149.1c-.7-.9-1.9-1-2.8-.3-.6.5-.8 1.2-.7 1.9"
                  className="st4"
                ></path>
                <path
                  d="M133.4 148.5c-1-1.3-2.9-1.5-4.1-.5-.5.4-.9 1-1 1.7M131.7 149.7c.2.4.6.6 1 .6.6 0 1-.5 1-1.1 0-.2-.1-.5-.2-.6"
                  className="st4"
                ></path>
                <path d="M128.2 149.8L126.4 149.8" className="st4"></path>
                <path
                  d="M123.6 154c1.5-1 2.5-2.5 2.9-4.2M132.8 149.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6"
                  className="st4"
                ></path>
                <path d="M124.5 156.4L124.5 154.5" className="st4"></path>
                <path d="M123.6 154L123.6 155.8" className="st4"></path>
                <path
                  d="M122.9 146.7L124.2 146.7 124.2 144.1 122.9 144.1 122.9 146.7"
                  className="st4"
                ></path>
                <path d="M204.4 114.3L168.9 114.3" className="st4"></path>
                <path
                  d="M204.4 114.3L204.4 114.7 204.1 114.7 204.1 114.8 203.9 114.8 203.9 115 203.7 115 168.9 115"
                  className="st4"
                ></path>
                <path d="M93.5 115L65.5 115" className="st4"></path>
                <path
                  d="M65 114.3L65 114.7 65.3 114.7 65.3 114.8 65.5 114.8 65.5 115 65.7 115"
                  className="st4"
                ></path>
                <path
                  d="M51.9 145.1c0-.2-.1-.3-.3-.4-.2 0-.3.1-.4.3v.1c0 .2.2.3.4.3.2-.1.3-.2.3-.3M51 144.8c0 .3.3.6.6.6"
                  className="st4"
                ></path>
                <path
                  d="M51 144.8L51 144.1 59.4 144.1 59.4 146.7 56.6 146.7"
                  className="st4"
                ></path>
                <path
                  d="M54.1 145.5c.8.6 1.7 1 2.6 1.2M54.1 145.5c-.6-.6-1.5-.9-2.4-.8M214 145.1c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.1.3-.3M213.7 145.4c.3 0 .6-.3.6-.6"
                  className="st4"
                ></path>
                <path
                  d="M214.3 144.8L214.3 144.1 207.2 144.1 207.2 146.7 208.7 146.7"
                  className="st4"
                ></path>
                <path
                  d="M208.7 146.7c1-.2 1.8-.6 2.6-1.2M213.7 144.8c-.9-.1-1.8.2-2.4.8"
                  className="st4"
                ></path>
                <path d="M65.1 203.9L65.3 203.9" className="st7"></path>
                <path
                  d="M65.5 205.5L65.5 205.5 65.6 205.5 65.6 205.5 65.6 205.5 65.6 205.5 65.6 205.5 65.6 205.4 65.7 205.4 65.7 205.4 65.7 205.4"
                  className="st7"
                ></path>
                <path d="M65.9 205.3L65.9 205.3" className="st7"></path>
                <path d="M65.2 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.9 205.3L65.9 205.3" className="st7"></path>
                <path d="M65.8 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.8 205.2L65.2 205.2" className="st7"></path>
                <path d="M65.8 205.2L65.2 205.2" className="st7"></path>
                <path
                  d="M65.9 205.3L65.9 205.3 65.9 205.3 65.9 205.3 65.9 205.3 65.9 205.3 65.9 205.3"
                  className="st7"
                ></path>
                <path
                  d="M65.2 205.4L65.2 205.4 65.2 205.3 65.2 205.3 65.2 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 205.4L65.2 205.4 65.2 205.3 65.2 205.3 65.2 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 205.3L65.2 205.3 65.2 205.4 65.2 205.4"
                  className="st7"
                ></path>
                <path d="M65.2 205.4L65.2 205.4" className="st7"></path>
                <path d="M65.2 205.4L65.2 205.4" className="st7"></path>
                <path d="M65.2 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.2 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.2 205.4L65.2 205.4" className="st7"></path>
                <path d="M65.2 205.3L65.8 205.3" className="st7"></path>
                <path d="M65.2 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.2 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.5 204.1L65.4 204.1" className="st7"></path>
                <path
                  d="M65.2 204.1L65.5 204.1 65.5 204.1 65.4 204.1"
                  className="st7"
                ></path>
                <path d="M65.3 203.9" className="st7"></path>
                <path
                  d="M65.3 203.9L65.3 203.9 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.5 204 65.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.4 204.1L65.4 204 65.4 204 65.4 204 65.4 204 65.4 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204.1 65.3 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.3 204L65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204 65.2 204"
                  className="st7"
                ></path>
                <path
                  d="M65.3 204.1L65.3 204 65.3 204 65.3 204 65.3 204 65.3 204 65.3 204.1 65.3 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.2 204.1L65.2 204.1 65.2 204 65.2 204"
                  className="st7"
                ></path>
                <path
                  d="M65.2 205.4L65.2 205.4 65.2 205.3 65.2 205.3"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.5L65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.9 205.5 65.9 205.5 65.9 205.5 65.9 205.5 65.9 205.5 65.9 205.5 65.9 205.5 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.3 65.9 205.3"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.3L65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.7 205.4L65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.4L65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.5L65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.7 205.4L65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.8 205.4 65.7 205.4 65.7 205.4 65.7 205.4"
                  className="st7"
                ></path>
                <path d="M65.8 205.4L65.8 205.4" className="st7"></path>
                <path
                  d="M65.7 205.4L65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.4 65.8 205.4 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.7 205.4L65.7 205.5 65.7 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5"
                  className="st7"
                ></path>
                <path
                  d="M65.7 205.4L65.7 205.4 65.7 205.4 65.7 205.4 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.7 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.8 205.5 65.9 205.5 65.9 205.5 65.9 205.5 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.3 65.9 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3"
                  className="st7"
                ></path>
                <path
                  d="M65.5 204.1L65.5 204.2 65.5 204.2 65.6 204.3 65.7 204.3 65.7 204.4 65.7 204.6 65.8 204.7 65.8 204.8 65.8 204.9"
                  className="st7"
                ></path>
                <path
                  d="M65.9 205.3L65.9 205.3 65.9 205.3 65.9 205.3 65.9 205.3 65.9 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3 65.8 205.3"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.3L65.8 205.3 65.8 205.3"
                  className="st7"
                ></path>
                <path d="M65.8 204.9L65.8 204.9" className="st7"></path>
                <path
                  d="M65.8 204.9L65.8 204.9 65.8 204.9 65.8 204.9 65.8 204.9 65.8 204.9 65.8 204.9 65.8 204.9 65.8 204.9 65.8 204.9"
                  className="st7"
                ></path>
                <path
                  d="M65.8 204.9L65.8 204.9 65.8 205 65.9 205 65.9 205 65.9 205 65.9 205 65.9 205 65.9 205 65.9 205.1 65.9 205.1 65.9 205.1 65.9 205.1 65.9 205.1 65.9 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.2 65.8 205.2 65.8 205.2 65.9 205.2 65.9 205.2 65.9 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 204.9"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.2L65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.1 65.8 205.1 65.8 205.1"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205L65.8 205 65.8 205 65.8 205 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 204.9 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205"
                  className="st7"
                ></path>
                <path
                  d="M65.8 204.9L65.8 204.9 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.1L65.8 205.1 65.8 205.1 65.8 205.1"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.1L65.8 205.1 65.8 205"
                  className="st7"
                ></path>
                <path
                  d="M65.8 204.9L65.8 204.9 65.8 204.9 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205 65.8 205"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.1L65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.2 65.8 205.2 65.7 205.2 65.7 205.2 65.7 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.8 205.1 65.7 205.1 65.7 205.1 65.7 205.1 65.7 205 65.7 205 65.7 205 65.7 205 65.8 205 65.8 205 65.8 205 65.8 204.9 65.8 204.9"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.3L65.7 205.3 65.7 205.3 65.7 205.3 65.7 205.3 65.7 205.3 65.8 205.3 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2 65.8 205.2"
                  className="st7"
                ></path>
                <path
                  d="M65.8 205.3L65.8 205.3 65.8 205.3"
                  className="st7"
                ></path>
                <path d="M65.8 205.3L65.8 205.2" className="st7"></path>
                <path
                  d="M65.8 205.3L65.8 205.3 65.8 205.3 65.8 205.3"
                  className="st7"
                ></path>
                <path d="M65.4 204.1L65.4 204.1" className="st7"></path>
                <path
                  d="M65.4 204.1L65.3 204.1 65.3 204.1 65.4 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.5 204.1L65.5 204.1 65.4 204.1"
                  className="st7"
                ></path>
                <path d="M65.4 204.1L65.4 204.1" className="st7"></path>
                <path
                  d="M65.5 204.1L65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.4 204.1L65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.4 204.1 65.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.8 204.9L65.8 204.7 65.8 204.7 65.8 204.6 65.8 204.5 65.8 204.4 65.7 204.4 65.7 204.3 65.7 204.3 65.7 204.2 65.6 204.2 65.6 204.2 65.6 204.1 65.5 204.1 65.5 204.1 65.5 204.1 65.5 204.1 65.4 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.9 205.4L65.9 205.4 65.9 205.4 65.9 205.4 65.9 205.3 65.9 205.3"
                  className="st7"
                ></path>
                <path d="M65.8 205.4L65.8 205.4" className="st7"></path>
                <path d="M65.7 205.2L65.2 205.2" className="st7"></path>
                <path d="M65.9 205.3L65.9 205.3" className="st7"></path>
                <path d="M65.8 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.8 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.3 204.1L65.2 204.1" className="st7"></path>
                <path d="M65.4 204.1L65.2 204.1" className="st7"></path>
                <path d="M65.2 204L65.2 204" className="st7"></path>
                <path d="M65.8 205.2L65.8 205.3" className="st7"></path>
                <path
                  d="M64.8 205.5L64.8 205.5 64.8 205.5 64.8 205.5 64.7 205.5 64.7 205.5 64.7 205.5 64.7 205.4 64.7 205.4 64.6 205.4 64.6 205.4"
                  className="st7"
                ></path>
                <path d="M64.4 205.3L64.4 205.3" className="st7"></path>
                <path d="M65.2 205.3L65.1 205.3" className="st7"></path>
                <path
                  d="M64.4 205.3L64.4 205.3 64.4 205.3"
                  className="st7"
                ></path>
                <path d="M64.6 205.3L65.2 205.3" className="st7"></path>
                <path d="M64.6 205.2L65.2 205.2" className="st7"></path>
                <path d="M64.6 205.2L65.2 205.2" className="st7"></path>
                <path
                  d="M64.4 205.3L64.4 205.3 64.4 205.3 64.4 205.3 64.4 205.3 64.4 205.3"
                  className="st7"
                ></path>
                <path
                  d="M65.1 205.4L65.1 205.4 65.1 205.3 65.1 205.3 65.1 205.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 205.4L65.1 205.4 65.1 205.3 65.1 205.3 65.1 205.4"
                  className="st7"
                ></path>
                <path d="M65.2 205.3L65.2 205.4" className="st7"></path>
                <path d="M65.1 205.4L65.1 205.4" className="st7"></path>
                <path d="M65.1 205.4L65.2 205.4" className="st7"></path>
                <path d="M65.1 205.3L65.1 205.3" className="st7"></path>
                <path d="M65.1 205.3L65.2 205.3" className="st7"></path>
                <path d="M65.1 205.4L65.1 205.4" className="st7"></path>
                <path d="M65.1 205.3L64.5 205.3" className="st7"></path>
                <path d="M65.1 205.3L65.1 205.3" className="st7"></path>
                <path d="M65.1 205.3L65.2 205.3" className="st7"></path>
                <path d="M64.9 204.1L64.9 204.1" className="st7"></path>
                <path
                  d="M65.2 204.1L64.9 204.1 64.9 204.1 64.9 204.1"
                  className="st7"
                ></path>
                <path d="M65.3 203.9L65.1 203.9" className="st7"></path>
                <path d="M65.1 203.9" className="st7"></path>
                <path
                  d="M65.3 203.9L65 203.9 65 203.9 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 64.9 204 64.9 204 64.9 204 64.9 204 64.9 204 64.9 204 64.9 204 64.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M64.9 204.1L64.9 204.1 64.9 204 64.9 204 64.9 204 64.9 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65 204 65 204 65 204 65 204 65 204 65 204.1 65 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65 204L65 204 65 204 65 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.1 204 65.2 204"
                  className="st7"
                ></path>
                <path
                  d="M65 204.1L65 204 65 204 65 204 65 204 65 204 65 204.1 65 204.1"
                  className="st7"
                ></path>
                <path
                  d="M65.1 204.1L65.1 204.1 65.2 204 65.2 204"
                  className="st7"
                ></path>
                <path d="M65.2 205.4L65.2 205.3" className="st7"></path>
                <path
                  d="M64.6 205.5L64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.4 205.5 64.4 205.5 64.4 205.5 64.4 205.5 64.4 205.4 64.4 205.4 64.4 205.4 64.4 205.4 64.4 205.4 64.4 205.4 64.4 205.4 64.4 205.3 64.4 205.3"
                  className="st7"
                ></path>
                <path
                  d="M64.5 205.3L64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.4L64.6 205.4 64.6 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.4L64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.6 205.4 64.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.5L64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.4L64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4"
                  className="st7"
                ></path>
                <path d="M64.5 205.4L64.5 205.4" className="st7"></path>
                <path
                  d="M64.6 205.4L64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.3 64.5 205.3 64.5 205.3 64.5 205.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.4L64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.4L64.6 205.4 64.6 205.4 64.6 205.4 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.6 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.5 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.4 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M64.9 204.1L64.8 204.2 64.8 204.2 64.7 204.3 64.6 204.3 64.6 204.4 64.6 204.6 64.6 204.7 64.6 204.8 64.6 204.9"
                  className="st7"
                ></path>
                <path
                  d="M64.4 205.3L64.4 205.3 64.4 205.3 64.4 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3 64.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.3L64.6 205.3 64.5 205.3"
                  className="st7"
                ></path>
                <path d="M64.5 204.9L64.6 204.9" className="st7"></path>
                <path
                  d="M64.5 204.9L64.5 204.9 64.5 204.9 64.5 204.9 64.6 204.9 64.6 204.9 64.6 204.9 64.6 204.9 64.6 204.9"
                  className="st7"
                ></path>
                <path
                  d="M64.5 204.9L64.5 204.9 64.5 204.9 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 204.9"
                  className="st7"
                ></path>
                <path
                  d="M64.5 205.2L64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.2 64.5 205.1 64.5 205.1"
                  className="st7"
                ></path>
                <path
                  d="M64.5 205L64.5 205 64.5 205 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 204.9 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205 64.5 205"
                  className="st7"
                ></path>
                <path
                  d="M64.5 204.9L64.5 204.9 64.5 204.9 64.5 205 64.5 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.5 205 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1"
                  className="st7"
                ></path>
                <path
                  d="M64.5 205.1L64.5 205.1 64.5 205.1 64.5 205.1"
                  className="st7"
                ></path>
                <path
                  d="M64.5 205.1L64.5 205.1 64.5 205"
                  className="st7"
                ></path>
                <path
                  d="M64.5 204.9L64.5 204.9 64.5 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205.1 64.6 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.5 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.1L64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.2 64.6 205.2 64.6 205.2 64.6 205.2 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205.1 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 205 64.6 204.9 64.6 204.9 64.6 204.9"
                  className="st7"
                ></path>
                <path
                  d="M64.6 205.3L64.6 205.3 64.6 205.3 64.6 205.3 64.6 205.3 64.6 205.3 64.6 205.2 64.6 205.2 64.6 205.2 64.6 205.2 64.6 205.2 64.6 205.2"
                  className="st7"
                ></path>
                <path
                  d="M64.5 205.3L64.5 205.3 64.5 205.3"
                  className="st7"
                ></path>
                <path d="M64.5 205.3L64.5 205.2" className="st7"></path>
                <path
                  d="M64.5 205.3L64.5 205.3 64.5 205.3 64.5 205.3"
                  className="st7"
                ></path>
                <path d="M65 204.1L65 204.1" className="st7"></path>
                <path
                  d="M64.9 204.1L65 204.1 65 204.1 64.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M64.9 204.1L64.9 204.1 64.9 204.1"
                  className="st7"
                ></path>
                <path d="M64.9 204.1L64.9 204.1" className="st7"></path>
                <path
                  d="M64.9 204.1L64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M64.9 204.1L64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1 64.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M64.5 204.9L64.5 204.7 64.5 204.7 64.5 204.6 64.5 204.5 64.6 204.4 64.6 204.4 64.6 204.3 64.6 204.3 64.7 204.2 64.7 204.2 64.7 204.2 64.8 204.1 64.8 204.1 64.8 204.1 64.8 204.1 64.9 204.1 64.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M64.4 205.4L64.4 205.4 64.4 205.4 64.4 205.4 64.4 205.4 64.4 205.3"
                  className="st7"
                ></path>
                <path d="M64.5 205.4L64.5 205.4" className="st7"></path>
                <path d="M64.6 205.2L65.2 205.2" className="st7"></path>
                <path d="M64.4 205.3L64.4 205.3" className="st7"></path>
                <path d="M64.5 205.3L65.1 205.3" className="st7"></path>
                <path d="M64.5 205.3L65.1 205.3" className="st7"></path>
                <path d="M65 204.1L65.2 204.1" className="st7"></path>
                <path d="M64.9 204.1L65.2 204.1" className="st7"></path>
                <path d="M65.2 204L65.2 204" className="st7"></path>
                <path d="M64.5 205.2L64.5 205.3" className="st7"></path>
                <path d="M65.2 203.9L65.1 203.9" className="st7"></path>
                <path d="M65.1 203.9L65.2 203.9" className="st7"></path>
                <path d="M65.1 203.9L65.2 203.9" className="st7"></path>
                <path d="M65.1 203.9L65.1 203.9" className="st7"></path>
                <path
                  d="M65.1 203.9L65.1 203.9 65.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.9L65.1 203.9 65.1 203.9 65.1 203.9 65.1 203.9 65.1 203.9"
                  className="st7"
                ></path>
                <path d="M65.2 203.9L65.2 203.9" className="st7"></path>
                <path d="M65.2 203.9L65.2 203.9" className="st7"></path>
                <path
                  d="M65.2 203.9L65.2 203.9 65.2 203.9"
                  className="st7"
                ></path>
                <path d="M65.2 203.9L65.2 203.9" className="st7"></path>
                <path d="M65.2 203.9L65.2 203.9" className="st7"></path>
                <path
                  d="M65.2 203.9L65.2 203.9 65.2 203.9 65.2 203.9 65.2 203.9 65.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.9L65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.7L65.1 203.7 65.1 203.7 65.1 203.8 65 203.8 65 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.8L65.1 203.8 65.1 203.8 65.1 203.8 65.2 203.8 65.2 203.8 65.2 203.7 65.1 203.7 65.1 203.7 65.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.7L65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.8L65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8 65.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.8L65.1 203.8 65.1 203.8 65.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.9L65.1 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.2 203.9L65.2 203.8 65.2 203.8 65.3 203.8 65.3 203.8 65.3 203.8 65.3 203.8 65.3 203.8 65.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.3 203.7L65.3 203.7 65.3 203.7 65.3 203.8 65.3 203.8 65.3 203.8 65.3 203.8 65.3 203.8 65.2 203.8 65.2 203.7 65.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 203.8L65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.7 65.2 203.7 65.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.2 203.8L65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.7 65.2 203.7 65.2 203.7 65.2 203.7 65.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 203.7L65.2 203.7 65.2 203.7 65.2 203.7 65.2 203.7 65.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.2 203.8L65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.3 203.8L65.3 203.8 65.2 203.8 65.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.2 203.9L65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8 65.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M65.2 203.6L65.1 203.6 65.1 203.6 65.1 203.6 65.1 203.6 65.1 203.6 65.1 203.6 65.1 203.6 65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.7 65.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 203.7L65.2 203.7 65.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.2 203.6L65.2 203.6 65.2 203.6 65.2 203.6 65.2 203.6 65.2 203.6 65.2 203.6 65.2 203.6 65.2 203.7 65.2 203.7 65.2 203.7 65.2 203.7 65.3 203.7 65.3 203.7 65.3 203.7 65.3 203.7 65.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 206.2L65.1 206.2 65.1 206.2"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.1L65.1 206.2 65.1 206.2"
                  className="st7"
                ></path>
                <path d="M65.1 206.2" className="st7"></path>
                <path d="M65.3 206.2L65.3 206.2" className="st7"></path>
                <path d="M65.3 206.1L65.3 206.2" className="st7"></path>
                <path d="M65.3 206.1" className="st7"></path>
                <path d="M65.1 206.2L65.3 206.2" className="st7"></path>
                <path d="M65.1 206.1L65.3 206.1" className="st7"></path>
                <path d="M65.1 206.1L65.3 206.1" className="st7"></path>
                <path
                  d="M65.1 206c-.1 0-.1.1 0 0-.1.1-.1.1 0 0M65.3 206.1s0-.1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.1L65.1 206 65.3 206 65.3 206.1"
                  className="st7"
                ></path>
                <path d="M65.2 206" className="st7"></path>
                <path d="M65.1 206L65.2 206" className="st7"></path>
                <path d="M65.1 206L65.2 206" className="st7"></path>
                <path d="M65.2 206" className="st7"></path>
                <path
                  d="M65 206.7L65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65.1 206.7 65.1 206.6 65.1 206.6 65.1 206.6 65.1 206.6 65.1 206.6 65.1 206.6 65.1 206.6 65.1 206.6 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.4 65.1 206.4 65 206.4 65 206.4 65 206.4 65 206.4 65 206.4 65 206.3 65 206.3 65 206.3 65 206.3 65 206.3 65 206.3 65 206.3 65 206.3 65 206.2 65.1 206.2 65.1 206.2 65.1 206.2 65.1 206.2 65.1 206.2"
                  className="st7"
                ></path>
                <path d="M65.1 206.2L65.1 207" className="st7"></path>
                <path d="M65.2 206.2L65.2 207" className="st7"></path>
                <path d="M65.2 206L65.1 206" className="st7"></path>
                <path d="M65.2 206L65.2 206 65.2 206" className="st7"></path>
                <path
                  d="M65.2 206L65.2 205.9 65.3 205.9 65.3 205.9 65.3 205.9 65.3 205.9 65.3 205.9 65.2 205.9"
                  className="st7"
                ></path>
                <path
                  d="M65.3 205.9L65.3 205.9 65.2 205.9"
                  className="st7"
                ></path>
                <path
                  d="M65.3 205.9L65.3 205.9 65.3 205.9 65.3 205.9 65.3 205.9 65.3 205.8 65.3 205.8 65.3 205.8 65.3 205.8 65.4 205.8 65.4 205.8 65.4 205.8 65.4 205.8 65.4 205.8 65.4 205.8 65.4 205.8 65.4 205.8 65.5 205.8 65.5 205.8 65.5 205.8 65.5 205.8 65.5 205.8 65.5 205.8 65.5 205.8 65.5 205.8 65.5 205.8 65.5 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.7 65.6 205.6 65.6 205.6 65.5 205.6 65.2 205.6"
                  className="st7"
                ></path>
                <path d="M65.5 205.6L65.2 205.6" className="st7"></path>
                <path d="M65.6 205.6" className="st7"></path>
                <path d="M65.2 205.5L65.5 205.5" className="st7"></path>
                <path
                  d="M65.2 205.5L65.5 205.5 65.5 205.5"
                  className="st7"
                ></path>
                <path
                  d="M65.5 205.6L65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.5 65.5 205.5 65.5 205.5 65.5 205.5 65.5 205.5"
                  className="st7"
                ></path>
                <path
                  d="M65.5 205.6L65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6 65.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.5 205.6L65.5 205.6 65.4 205.6 65.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.5 205.6L65.4 205.6 65.4 205.6 65.4 205.6 65.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.4 205.6L65.4 205.6 65.4 205.6 65.4 205.6 65.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.4 205.6L65.4 205.6 65.4 205.6 65.4 205.6 65.4 205.6 65.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.4 205.6L65.4 205.6 65.4 205.6 65.4 205.6"
                  className="st7"
                ></path>
                <path d="M65.4 205.6L65.4 205.6" className="st7"></path>
                <path
                  d="M65.4 205.6L65.3 205.6 65.3 205.6 65.3 205.6 65.3 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.3 205.6L65.3 205.6 65.3 205.6 65.3 205.6"
                  className="st7"
                ></path>
                <path d="M65.3 205.6L65.3 205.6" className="st7"></path>
                <path
                  d="M65.3 205.6L65.3 205.6 65.3 205.6 65.3 205.6 65.3 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.3 205.6L65.3 205.6 65.3 205.6 65.3 205.6"
                  className="st7"
                ></path>
                <path d="M65.3 205.6" className="st7"></path>
                <path
                  d="M65.2 205.6L65.2 205.6 65.2 205.6 65.2 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.2 205.6L65.2 205.6 65.2 205.6 65.2 205.6"
                  className="st7"
                ></path>
                <path d="M65.3 205.6" className="st7"></path>
                <path d="M65.2 205.6L65.2 205.6" className="st7"></path>
                <path d="M65.2 205.6" className="st7"></path>
                <path d="M65.1 205.6L65.1 205.6" className="st7"></path>
                <path d="M65.1 206L65.1 206 65.2 206" className="st7"></path>
                <path
                  d="M65.1 206L65.1 205.9 65.1 205.9 65.1 205.9 65.1 205.9 65.1 205.9 65.1 205.9 65 205.9 65.2 205.9"
                  className="st7"
                ></path>
                <path d="M65 205.9L65 205.9 65.2 205.9" className="st7"></path>
                <path
                  d="M65.1 205.9L65 205.9 65 205.9 65 205.9 65 205.8 65 205.8 65 205.8 65 205.8 65 205.8 65 205.8 65 205.8 65 205.8 64.9 205.8 64.9 205.8 64.9 205.8 64.9 205.8 64.9 205.8 64.9 205.8 64.9 205.8 64.9 205.8 64.8 205.8 64.8 205.8 64.8 205.8 64.8 205.8 64.8 205.8 64.8 205.8 64.8 205.8 64.8 205.7 64.8 205.7 64.8 205.7 64.7 205.7 64.7 205.7 64.7 205.7 64.7 205.7 64.7 205.7 64.7 205.7 64.7 205.7 64.7 205.7 64.7 205.6 64.8 205.6 64.8 205.6 65.2 205.6"
                  className="st7"
                ></path>
                <path d="M64.8 205.6L65.2 205.6" className="st7"></path>
                <path d="M64.8 205.6" className="st7"></path>
                <path d="M65.2 205.5L64.8 205.5" className="st7"></path>
                <path
                  d="M65.2 205.5L64.8 205.5 64.8 205.5"
                  className="st7"
                ></path>
                <path
                  d="M64.8 205.6L64.8 205.6 64.8 205.6 64.8 205.6 64.8 205.6 64.8 205.6 64.9 205.6 64.9 205.6 64.9 205.6 64.9 205.6 64.8 205.6 64.8 205.5 64.8 205.5 64.8 205.5 64.8 205.5 64.8 205.5"
                  className="st7"
                ></path>
                <path
                  d="M64.8 205.6L64.8 205.6 64.8 205.6 64.9 205.6 64.9 205.6 64.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M64.8 205.6L64.9 205.6 64.9 205.6 64.9 205.6 64.9 205.6 64.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M64.9 205.6L64.9 205.6 64.9 205.6 64.9 205.6 64.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M64.9 205.6L64.9 205.6 64.9 205.6 64.9 205.6 64.9 205.6"
                  className="st7"
                ></path>
                <path d="M64.9 205.6L64.9 205.6" className="st7"></path>
                <path
                  d="M64.9 205.6L64.9 205.6 64.9 205.6 64.9 205.6 64.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M64.9 205.6L64.9 205.6 64.9 205.6 64.9 205.6 65 205.6 65 205.6"
                  className="st7"
                ></path>
                <path d="M64.9 205.6L64.9 205.6" className="st7"></path>
                <path
                  d="M65 205.6L65 205.6 65 205.6 65 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65 205.6L65 205.6 65 205.6 65 205.6 65 205.6"
                  className="st7"
                ></path>
                <path d="M65 205.6L65 205.6" className="st7"></path>
                <path
                  d="M65 205.6L65 205.6 65 205.6 65 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 205.6L65.1 205.6 65.1 205.6"
                  className="st7"
                ></path>
                <path d="M65.1 205.6" className="st7"></path>
                <path
                  d="M65.1 205.6L65.1 205.6 65.1 205.6 65.1 205.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 205.6L65.1 205.6 65.1 205.6"
                  className="st7"
                ></path>
                <path d="M65.2 205.6" className="st7"></path>
                <path d="M65.1 205.6L65.1 205.6" className="st7"></path>
                <path d="M65.2 205.6" className="st7"></path>
                <path d="M65.2 205.6L65.2 205.6" className="st7"></path>
                <path
                  d="M65 205.9c-.1 0-.1.1-.1.2s0 .1.1.2M65.3 206.2c.1 0 .1-.1.1-.2s0-.1-.1-.2"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.5L65.1 206.5 65.1 206.5 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.3L65.1 206.3 65.1 206.3 65.1 206.3 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.2L65.1 206.3 65.1 206.3 65.1 206.3 65.1 206.3 65.1 206.3 65.1 206.3"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.2L65.1 206.2 65.1 206.2 65.1 206.2 65.1 206.2 65.1 206.3 65.1 206.3 65.1 206.3 65 206.3 65 206.3 65 206.3 65 206.3 65 206.3 65 206.3 65 206.4 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.4 65.1 206.5 65.1 206.5 65.1 206.5"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.4L65.1 206.5 65.1 206.5 65.1 206.5"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.6L65.1 206.6 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.5 65.1 206.6 65.1 206.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 206.7L65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.8 65.1 206.8 65 206.8 65 206.8 65 206.8 65 206.8 65 206.8 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7 65.1 206.7"
                  className="st7"
                ></path>
                <path d="M65.3 206.2L65.3 206.2" className="st7"></path>
                <path
                  d="M65.3 206.7L65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.6 65.3 206.6 65.3 206.6 65.3 206.6 65.3 206.6 65.3 206.6 65.3 206.6 65.3 206.5 65.3 206.5 65.3 206.5 65.3 206.5 65.3 206.5 65.3 206.5 65.3 206.5 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.2 65.3 206.2 65.3 206.2 65.3 206.2 65.3 206.2 65.2 206.2"
                  className="st7"
                ></path>
                <path
                  d="M65.2 206.5L65.2 206.5 65.2 206.5 65.3 206.5 65.3 206.5 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.2 206.4 65.2 206.4 65.2 206.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 206.3L65.2 206.3 65.2 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.4 65.2 206.4 65.2 206.4 65.2 206.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 206.2L65.2 206.3 65.2 206.3 65.2 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.2 206.3 65.2 206.3"
                  className="st7"
                ></path>
                <path
                  d="M65.2 206.2L65.2 206.2 65.3 206.2 65.3 206.2 65.3 206.2 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.3 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.4 65.3 206.5 65.3 206.5 65.3 206.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 206.4L65.2 206.5 65.2 206.5 65.2 206.5"
                  className="st7"
                ></path>
                <path
                  d="M65.3 206.6L65.3 206.6 65.3 206.5 65.3 206.5 65.2 206.5 65.2 206.5 65.2 206.5 65.2 206.5 65.2 206.6 65.2 206.6"
                  className="st7"
                ></path>
                <path
                  d="M65.2 206.7L65.2 206.7 65.2 206.7 65.2 206.7 65.2 206.7 65.2 206.7 65.2 206.7 65.3 206.7 65.3 206.8 65.3 206.8 65.3 206.8 65.3 206.8 65.3 206.8 65.3 206.8 65.3 206.8 65.3 206.7 65.3 206.7 65.4 206.7 65.4 206.7 65.4 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.3 206.7 65.2 206.7 65.2 206.7 65.2 206.7 65.2 206.7"
                  className="st7"
                ></path>
                <path d="M65.1 207.6L65.2 207.6" className="st7"></path>
                <path
                  d="M65.1 207.6L65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.2 207.5 65.3 207.5 65.3 207.5 65.3 207.5 65.3 207.6 65.3 207.6 65.3 207.6 65.2 207.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.6L65.1 207.6 65 207.6 65 207.6 65 207.6 65 207.6 65 207.6 65 207.6 65 207.7 65 207.7 65 207.7 65 207.7 65 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65 207.7 65 207.6 65 207.6 65 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.6L65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.6L65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.1 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.7 65.2 207.7 65.3 207.7 65.3 207.7 65.3 207.6 65.3 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.7 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6 65.1 207.6"
                  className="st7"
                ></path>
                <path
                  d="M65.3 207.6L65.3 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.2 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.2 207.7 65.2 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.3 207.6 65.2 207.6 65.2 207.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.7L65.1 207.7 65.1 207.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 207.7L65.3 207.7 65.3 207.7 65.3 207.7 65.3 207.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.7L65.1 207.7 65.1 207.7"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.7L65.2 207.7 65.2 207.7 65.3 207.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.5L65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4"
                  className="st7"
                ></path>
                <path
                  d="M65 207.3L65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65.1 207.2 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.3 65.1 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.4 65 207.4 65 207.4 65 207.4 65 207.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.1L65.1 207.1 65.1 207.1 65.1 207.1"
                  className="st7"
                ></path>
                <path
                  d="M65 207.2L65 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.5L65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.2 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65 207.3 65 207.3 65 207.3 65 207.3"
                  className="st7"
                ></path>
                <path
                  d="M65 207.4L65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.2 65.1 207.2 65.1 207.2"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.2L65.1 207.2 65.1 207.2"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.3L65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.4L65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.5 65.2 207.5 65.2 207.5 65.1 207.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.4L65.2 207.4 65.1 207.4 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3 65.1 207.3"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.5L65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.2 207.4 65.2 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.4 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.1 207.5 65.2 207.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.5L65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.5L65.3 207.5 65.3 207.5 65.3 207.5 65.3 207.5 65.3 207.5 65.3 207.5 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207 65.3 207 65.3 207 65.3 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.1 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.4 65.3 207.4"
                  className="st7"
                ></path>
                <path
                  d="M65.3 207.3L65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.1 65.3 207.1 65.3 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.1L65.2 207.1 65.2 207.1 65.2 207.1"
                  className="st7"
                ></path>
                <path
                  d="M65.3 207.2L65.3 207.2 65.3 207.2 65.3 207.2 65.3 207.2 65.2 207.2 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1 65.2 207.1"
                  className="st7"
                ></path>
                <path
                  d="M65.3 207.5L65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.2 207.4 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.2 207.2 65.3 207.2 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3 65.3 207.3"
                  className="st7"
                ></path>
                <path
                  d="M65.3 207.4L65.3 207.3 65.3 207.3 65.3 207.3 65.2 207.3 65.2 207.3 65.2 207.2 65.2 207.2 65.2 207.2"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.2L65.2 207.2 65.2 207.2"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.3L65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.4L65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.5 65.2 207.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.4L65.2 207.4 65.2 207.4 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3 65.2 207.3"
                  className="st7"
                ></path>
                <path
                  d="M65.2 207.5L65.2 207.5 65.2 207.5 65.3 207.5 65.3 207.5 65.3 207.5 65.3 207.5 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.3 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.4 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5 65.2 207.5"
                  className="st7"
                ></path>
                <path
                  d="M65.1 207.5L65.1 207.5 65.1 207.5 65 207.5 65 207.5 65 207.5 65 207.4 65 207.4 65 207.4 65 207.4 65 207.4 65 207.4 65 207.4 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.1 65 207.1 65 207.1 65 207.1 65 207.1 65 207.1 65 207.1 65.1 207.1 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.2 207 65.2 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65.1 207.1 65 207.1 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.2 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.3 65 207.4 65 207.4"
                  className="st7"
                ></path>
                <path d="M89.4 203.9L89.2 203.9" className="st7"></path>
                <path
                  d="M88.9 205.5L88.9 205.5 88.9 205.5 88.9 205.5 88.9 205.5 88.9 205.5 88.9 205.5 88.8 205.5 88.8 205.4 88.8 205.4 88.8 205.4 88.7 205.4"
                  className="st7"
                ></path>
                <path d="M88.5 205.3L88.5 205.3" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M88.5 205.3L88.5 205.3" className="st7"></path>
                <path d="M88.7 205.3L89.3 205.3" className="st7"></path>
                <path d="M88.7 205.2L89.3 205.2" className="st7"></path>
                <path d="M88.7 205.2L89.3 205.2" className="st7"></path>
                <path
                  d="M88.5 205.3L88.5 205.3 88.5 205.3 88.5 205.3 88.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M89.2 205.4L89.2 205.4 89.2 205.3 89.2 205.3 89.2 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 205.4L89.3 205.4 89.3 205.3 89.2 205.3 89.2 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 205.3L89.3 205.3 89.3 205.4 89.3 205.4"
                  className="st7"
                ></path>
                <path d="M89.2 205.4L89.2 205.4" className="st7"></path>
                <path d="M89.3 205.4L89.3 205.4" className="st7"></path>
                <path d="M89.2 205.3L89.2 205.3" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.2 205.4L89.2 205.4" className="st7"></path>
                <path d="M89.2 205.3L88.6 205.3" className="st7"></path>
                <path d="M89.2 205.3L89.2 205.3" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M89 204.1L89 204.1" className="st7"></path>
                <path
                  d="M89.3 204.1L89 204.1 89 204.1 89 204.1"
                  className="st7"
                ></path>
                <path d="M89.2 203.9" className="st7"></path>
                <path
                  d="M89.1 203.9L89.1 203.9 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89 204 89 204 89 204 89 204 89 204 89 204 89 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89 204.1L89 204 89 204 89 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.1 204 89.1 204 89.1 204 89.1 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89.1 204L89.1 204 89.1 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.2 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204"
                  className="st7"
                ></path>
                <path
                  d="M89.1 204.1L89.1 204.1 89.1 204 89.1 204 89.1 204 89.1 204 89.1 204.1 89.1 204.1 89.1 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89.2 204.1L89.3 204.1 89.3 204 89.3 204"
                  className="st7"
                ></path>
                <path
                  d="M89.3 205.4L89.3 205.4 89.3 205.3 89.3 205.3"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.5L88.7 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.5 205.5 88.5 205.5 88.5 205.4 88.5 205.4 88.5 205.4 88.5 205.4 88.5 205.4 88.5 205.4 88.5 205.4 88.5 205.3 88.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M88.6 205.3L88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.4L88.7 205.4 88.7 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.4L88.7 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.7 205.4 88.7 205.4 88.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.5L88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.4L88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M88.6 205.4L88.6 205.4 88.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.4L88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.3 88.7 205.3 88.6 205.3 88.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.4L88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.6 205.5 88.6 205.5 88.6 205.5"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.4L88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.4 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.7 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.5 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.4 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3"
                  className="st7"
                ></path>
                <path
                  d="M89 204.1L88.9 204.2 88.9 204.2 88.8 204.3 88.8 204.3 88.7 204.4 88.7 204.6 88.7 204.7 88.7 204.8 88.7 204.9"
                  className="st7"
                ></path>
                <path
                  d="M88.5 205.3L88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3 88.6 205.3"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.3L88.7 205.3 88.6 205.3"
                  className="st7"
                ></path>
                <path d="M88.6 204.9L88.7 204.9" className="st7"></path>
                <path
                  d="M88.6 204.9L88.6 204.9 88.6 204.9 88.7 204.9 88.7 204.9 88.7 204.9 88.7 204.9 88.7 204.9"
                  className="st7"
                ></path>
                <path
                  d="M88.6 204.9L88.6 204.9 88.6 204.9 88.6 204.9 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 204.9 88.6 204.9"
                  className="st7"
                ></path>
                <path
                  d="M88.6 205.2L88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.2 88.6 205.1 88.6 205.1"
                  className="st7"
                ></path>
                <path
                  d="M88.6 205L88.6 205 88.6 205 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.7 205.1 88.7 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 204.9 88.6 204.9 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205.1 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205 88.6 205"
                  className="st7"
                ></path>
                <path
                  d="M88.6 204.9L88.6 204.9 88.7 204.9 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.6 205.1"
                  className="st7"
                ></path>
                <path
                  d="M88.6 205.1L88.6 205.1 88.6 205.1 88.7 205.1"
                  className="st7"
                ></path>
                <path
                  d="M88.6 205.1L88.7 205.1 88.7 205"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.1L88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.2 88.7 205.2 88.7 205.2 88.7 205.2 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 204.9 88.7 204.9 88.7 204.9 88.7 204.9 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205.1 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205 88.7 205"
                  className="st7"
                ></path>
                <path
                  d="M88.7 205.3L88.7 205.3 88.7 205.3 88.7 205.3 88.7 205.3 88.7 205.3 88.7 205.2 88.7 205.2 88.7 205.2 88.7 205.2 88.7 205.2 88.7 205.2 88.7 205.2"
                  className="st7"
                ></path>
                <path
                  d="M88.6 205.3L88.6 205.3 88.6 205.3"
                  className="st7"
                ></path>
                <path d="M88.6 205.3L88.6 205.2" className="st7"></path>
                <path
                  d="M88.6 205.3L88.6 205.3 88.6 205.3"
                  className="st7"
                ></path>
                <path d="M89.1 204.1L89.1 204.1" className="st7"></path>
                <path
                  d="M89 204.1L89.1 204.1 89.1 204.1 89 204.1"
                  className="st7"
                ></path>
                <path d="M89 204.1L89 204.1" className="st7"></path>
                <path d="M89 204.1L89 204.1" className="st7"></path>
                <path
                  d="M89 204.1L89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89 204.1L89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1 89 204.1"
                  className="st7"
                ></path>
                <path
                  d="M88.6 204.9L88.6 204.7 88.6 204.7 88.6 204.6 88.6 204.5 88.7 204.4 88.7 204.4 88.7 204.3 88.7 204.3 88.8 204.2 88.8 204.2 88.8 204.2 88.9 204.1 88.9 204.1 88.9 204.1 89 204.1 89 204.1 89 204.1"
                  className="st7"
                ></path>
                <path
                  d="M88.5 205.4L88.5 205.4 88.5 205.4 88.5 205.4 88.5 205.4 88.5 205.3"
                  className="st7"
                ></path>
                <path d="M88.6 205.4L88.6 205.4" className="st7"></path>
                <path d="M88.7 205.2L89.3 205.2" className="st7"></path>
                <path d="M88.6 205.3L88.5 205.3" className="st7"></path>
                <path d="M88.6 205.3L89.2 205.3" className="st7"></path>
                <path d="M88.6 205.3L89.2 205.3" className="st7"></path>
                <path d="M89.1 204.1L89.3 204.1" className="st7"></path>
                <path d="M89 204.1L89.3 204.1" className="st7"></path>
                <path d="M89.3 204L89.3 204" className="st7"></path>
                <path d="M88.6 205.2L88.6 205.3" className="st7"></path>
                <path
                  d="M89.6 205.5L89.7 205.5 89.7 205.5 89.7 205.5 89.7 205.5 89.7 205.5 89.7 205.5 89.7 205.5 89.7 205.4 89.8 205.4 89.8 205.4 89.8 205.4"
                  className="st7"
                ></path>
                <path d="M90 205.3L90 205.3" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M90 205.3L90 205.3" className="st7"></path>
                <path d="M89.9 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.9 205.2L89.3 205.2" className="st7"></path>
                <path d="M89.9 205.2L89.3 205.2" className="st7"></path>
                <path
                  d="M90 205.3L90 205.3 90 205.3 90 205.3 90 205.3 90 205.3"
                  className="st7"
                ></path>
                <path
                  d="M89.3 205.4L89.3 205.4 89.3 205.3 89.3 205.3 89.3 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 205.4L89.3 205.4 89.3 205.3 89.3 205.3 89.3 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 205.3L89.3 205.3 89.3 205.4 89.3 205.4"
                  className="st7"
                ></path>
                <path d="M89.3 205.4L89.3 205.4" className="st7"></path>
                <path d="M89.3 205.4L89.3 205.4" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.3 205.4L89.3 205.4" className="st7"></path>
                <path d="M89.3 205.3L89.9 205.3" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.3 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.6 204.1L89.6 204.1" className="st7"></path>
                <path
                  d="M89.3 204.1L89.6 204.1 89.6 204.1 89.6 204.1"
                  className="st7"
                ></path>
                <path d="M89.2 203.9L89.4 203.9" className="st7"></path>
                <path d="M89.4 203.9" className="st7"></path>
                <path
                  d="M89.1 203.9L89.4 203.9 89.4 203.9 89.4 204 89.4 204 89.4 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.6 204 89.6 204 89.6 204 89.6 204.1 89.6 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89.5 204.1L89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.5 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89.4 204L89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204 89.3 204"
                  className="st7"
                ></path>
                <path
                  d="M89.4 204.1L89.4 204.1 89.4 204 89.4 204 89.4 204 89.4 204 89.4 204.1 89.5 204.1 89.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89.3 204.1L89.3 204.1 89.3 204 89.3 204"
                  className="st7"
                ></path>
                <path
                  d="M89.3 205.4L89.3 205.4 89.3 205.3 89.3 205.3"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.5L89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 90 205.5 90 205.5 90 205.5 90 205.5 90 205.5 90 205.5 90 205.5 90 205.5 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.3 90 205.3"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.3L90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.4 89.9 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.4L89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.8 205.4 89.8 205.4 89.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.4L89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.5L89.9 205.5 89.9 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.4L89.8 205.4 89.8 205.4 89.8 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.9 205.4 89.8 205.4 89.8 205.4"
                  className="st7"
                ></path>
                <path d="M89.9 205.4L89.9 205.4" className="st7"></path>
                <path
                  d="M89.8 205.4L89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.4 89.9 205.4 89.9 205.4 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.4L89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5"
                  className="st7"
                ></path>
                <path
                  d="M89.8 205.4L89.8 205.4 89.8 205.4 89.8 205.4 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.8 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 89.9 205.5 90 205.5 90 205.5 90 205.5 90 205.5 90 205.5 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.4 90 205.3 90 205.3 90 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3"
                  className="st7"
                ></path>
                <path
                  d="M89.6 204.1L89.6 204.2 89.7 204.2 89.7 204.3 89.8 204.3 89.8 204.4 89.8 204.6 89.9 204.7 89.9 204.8 89.9 204.9"
                  className="st7"
                ></path>
                <path
                  d="M90 205.3L90 205.3 90 205.3 90 205.3 90 205.3 90 205.3 90 205.3 90 205.3 90 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.3"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.3L89.9 205.3 89.9 205.3"
                  className="st7"
                ></path>
                <path d="M89.9 204.9L89.9 204.9" className="st7"></path>
                <path
                  d="M89.9 204.9L90 204.9 90 204.9 89.9 204.9 89.9 204.9 89.9 204.9 89.9 204.9 89.9 204.9 89.9 204.9 89.9 204.9"
                  className="st7"
                ></path>
                <path
                  d="M89.9 204.9L89.9 204.9 90 204.9 90 205 90 205 90 205 90 205 90 205 90 205 90 205 90 205 90 205.1 90 205.1 90 205.1 90 205.1 90 205.1 90 205.1 90 205.1 90 205.1 90 205.1 90 205.2 90 205.2 90 205.2 90 205.2 90 205.2 90 205.2 90 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205 90 205 90 205 90 205 90 205 90 205 89.9 205 89.9 205 89.9 204.9"
                  className="st7"
                ></path>
                <path
                  d="M90 205.2L90 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.1 89.9 205.1 89.9 205.1"
                  className="st7"
                ></path>
                <path
                  d="M90 205L89.9 205 89.9 205 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 204.9 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205"
                  className="st7"
                ></path>
                <path
                  d="M89.9 204.9L89.9 204.9 89.9 204.9 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.1L89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.1L89.9 205.1 89.9 205"
                  className="st7"
                ></path>
                <path
                  d="M89.9 204.9L89.9 204.9 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.1L89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205.1 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 205 89.9 204.9 89.9 204.9 89.9 204.9"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.3L89.8 205.3 89.8 205.3 89.9 205.3 89.9 205.3 89.9 205.3 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2 89.9 205.2"
                  className="st7"
                ></path>
                <path
                  d="M89.9 205.3L89.9 205.3 89.9 205.3"
                  className="st7"
                ></path>
                <path d="M89.9 205.3L89.9 205.2" className="st7"></path>
                <path
                  d="M89.9 205.3L89.9 205.3 89.9 205.3 89.9 205.3"
                  className="st7"
                ></path>
                <path d="M89.5 204.1L89.5 204.1" className="st7"></path>
                <path
                  d="M89.5 204.1L89.5 204.1 89.5 204.1 89.5 204.1"
                  className="st7"
                ></path>
                <path d="M89.6 204.1L89.6 204.1" className="st7"></path>
                <path d="M89.5 204.1L89.5 204.1" className="st7"></path>
                <path
                  d="M89.6 204.1L89.6 204.1 89.6 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.6 204.1 89.6 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89.6 204.1L89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.5 204.1 89.6 204.1 89.6 204.1 89.6 204.1"
                  className="st7"
                ></path>
                <path
                  d="M89.9 204.9L89.9 204.7 89.9 204.7 89.9 204.6 89.9 204.5 89.9 204.4 89.9 204.4 89.8 204.3 89.8 204.3 89.8 204.2 89.7 204.2 89.7 204.2 89.7 204.1 89.7 204.1 89.6 204.1 89.6 204.1 89.6 204.1 89.6 204.1"
                  className="st7"
                ></path>
                <path
                  d="M90 205.4L90 205.4 90 205.4 90 205.4 90 205.3"
                  className="st7"
                ></path>
                <path d="M90 205.4L89.9 205.4" className="st7"></path>
                <path d="M89.9 205.2L89.3 205.2" className="st7"></path>
                <path d="M90 205.3L90 205.3" className="st7"></path>
                <path d="M89.9 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.9 205.3L89.3 205.3" className="st7"></path>
                <path d="M89.5 204.1L89.3 204.1" className="st7"></path>
                <path d="M89.5 204.1L89.3 204.1" className="st7"></path>
                <path d="M89.3 204L89.3 204" className="st7"></path>
                <path d="M89.9 205.2L89.9 205.3" className="st7"></path>
                <path d="M89.3 203.9L89.4 203.9" className="st7"></path>
                <path d="M89.3 203.9L89.3 203.9" className="st7"></path>
                <path
                  d="M89.3 203.9L89.3 203.9 89.3 203.9"
                  className="st7"
                ></path>
                <path d="M89.4 203.9L89.3 203.9" className="st7"></path>
                <path d="M89.3 203.9L89.3 203.9" className="st7"></path>
                <path d="M89.4 203.9L89.4 203.9" className="st7"></path>
                <path
                  d="M89.3 203.9L89.3 203.9 89.3 203.9 89.3 203.9 89.3 203.9 89.4 203.9"
                  className="st7"
                ></path>
                <path d="M89.3 203.9L89.2 203.9" className="st7"></path>
                <path d="M89.2 203.9L89.3 203.9" className="st7"></path>
                <path
                  d="M89.2 203.9L89.2 203.9 89.3 203.9"
                  className="st7"
                ></path>
                <path d="M89.2 203.9L89.3 203.9" className="st7"></path>
                <path d="M89.2 203.9L89.2 203.9" className="st7"></path>
                <path d="M89.2 203.9L89.2 203.9" className="st7"></path>
                <path
                  d="M89.2 203.9L89.2 203.9 89.2 203.9 89.2 203.9 89.2 203.9 89.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M89.4 203.9L89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.4 203.7L89.4 203.7 89.4 203.7 89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.8 89.4 203.7 89.4 203.7 89.3 203.7 89.3 203.7 89.3 203.8 89.3 203.8 89.3 203.8 89.4 203.8 89.4 203.8 89.4 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.3 203.8L89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.7 89.3 203.7 89.3 203.7 89.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M89.4 203.7L89.4 203.7 89.3 203.7 89.3 203.7 89.3 203.7 89.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M89.4 203.8L89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.4 203.8L89.4 203.8 89.4 203.8 89.4 203.8 89.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.3 203.9L89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 203.9L89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 203.7L89.2 203.7 89.2 203.7 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 203.8L89.2 203.8 89.2 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.7 89.3 203.7 89.2 203.7 89.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 203.7L89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.7 89.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 203.8L89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.2 203.8 89.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 203.8L89.2 203.8 89.2 203.8 89.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 203.9L89.3 203.9 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8 89.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M89.3 203.6L89.3 203.6 89.3 203.6 89.3 203.6 89.3 203.6 89.3 203.6 89.3 203.6 89.3 203.6 89.3 203.6 89.3 203.6 89.4 203.6 89.4 203.7 89.4 203.7 89.4 203.7 89.4 203.7 89.4 203.7 89.4 203.7 89.4 203.7 89.4 203.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 203.7L89.3 203.7 89.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 203.6L89.3 203.6 89.2 203.6 89.2 203.6 89.2 203.6 89.2 203.6 89.2 203.6 89.2 203.6 89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.7 89.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.2L89.4 206.2 89.4 206.2"
                  className="st7"
                ></path>
                <path d="M89.4 206.1L89.4 206.2" className="st7"></path>
                <path d="M89.4 206.1" className="st7"></path>
                <path d="M89.2 206.2L89.2 206.2" className="st7"></path>
                <path
                  d="M89.2 206.1L89.2 206.2 89.2 206.2"
                  className="st7"
                ></path>
                <path d="M89.2 206.2" className="st7"></path>
                <path d="M89.4 206.2L89.2 206.2" className="st7"></path>
                <path d="M89.4 206.1L89.2 206.1" className="st7"></path>
                <path d="M89.4 206.1L89.2 206.1" className="st7"></path>
                <path
                  d="M89.4 206.1s0-.1 0 0c0-.1 0-.1 0 0M89.2 206s0 .1 0 0c0 .1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M89.4 206.1L89.4 206 89.2 206 89.2 206.1"
                  className="st7"
                ></path>
                <path d="M89.4 206" className="st7"></path>
                <path d="M89.3 206L89.2 206" className="st7"></path>
                <path d="M89.3 206L89.2 206" className="st7"></path>
                <path d="M89.2 206" className="st7"></path>
                <path
                  d="M89.5 206.7L89.5 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.6 89.4 206.6 89.4 206.6 89.4 206.6 89.4 206.6 89.4 206.6 89.4 206.6 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.2 89.4 206.2 89.4 206.2 89.4 206.2 89.4 206.2 89.4 206.2"
                  className="st7"
                ></path>
                <path d="M89.3 206.2L89.3 207" className="st7"></path>
                <path d="M89.2 206.2L89.2 207" className="st7"></path>
                <path d="M89.2 206L89.4 206" className="st7"></path>
                <path d="M89.2 206L89.2 206 89.3 206" className="st7"></path>
                <path
                  d="M89.2 206L89.2 205.9 89.2 205.9 89.2 205.9 89.2 205.9 89.2 205.9 89.3 205.9"
                  className="st7"
                ></path>
                <path
                  d="M89.2 205.9L89.2 205.9 89.3 205.9"
                  className="st7"
                ></path>
                <path
                  d="M89.2 205.9L89.2 205.9 89.2 205.9 89.2 205.9 89.1 205.9 89.1 205.8 89.1 205.8 89.1 205.8 89.1 205.8 89.1 205.8 89.1 205.8 89.1 205.8 89.1 205.8 89.1 205.8 89 205.8 89 205.8 89 205.8 89 205.8 89 205.8 89 205.8 89 205.8 89 205.8 88.9 205.8 88.9 205.8 88.9 205.8 88.9 205.8 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.7 88.9 205.6 88.9 205.6 89.3 205.6"
                  className="st7"
                ></path>
                <path d="M88.9 205.6L89.3 205.6" className="st7"></path>
                <path d="M88.9 205.6" className="st7"></path>
                <path d="M89.3 205.5L88.9 205.5" className="st7"></path>
                <path
                  d="M89.3 205.5L88.9 205.5 88.9 205.5"
                  className="st7"
                ></path>
                <path d="M88.9 205.5L88.9 205.5" className="st7"></path>
                <path
                  d="M88.9 205.6L88.9 205.6 88.9 205.6 88.9 205.6 88.9 205.6 89 205.6 89 205.6 89 205.6 89 205.6 89 205.6 89 205.6 89 205.6 89 205.5 88.9 205.5 88.9 205.5 88.9 205.5"
                  className="st7"
                ></path>
                <path
                  d="M89 205.6L89 205.6 89 205.6 89 205.6 89 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89 205.6L89 205.6 89 205.6 89 205.6 89 205.6 89 205.6"
                  className="st7"
                ></path>
                <path d="M89 205.6L89 205.6" className="st7"></path>
                <path
                  d="M89 205.6L89 205.6 89 205.6 89 205.6 89 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89 205.6L89 205.6 89 205.6 89 205.6 89 205.6 89 205.6"
                  className="st7"
                ></path>
                <path d="M89 205.6L89 205.6" className="st7"></path>
                <path
                  d="M89 205.6L89 205.6 89 205.6 89 205.6 89 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.1 205.6L89.1 205.6 89.1 205.6 89.1 205.6 89.1 205.6"
                  className="st7"
                ></path>
                <path d="M89.1 205.6L89.1 205.6" className="st7"></path>
                <path
                  d="M89.1 205.6L89.1 205.6 89.1 205.6 89.1 205.6 89.1 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.1 205.6L89.1 205.6 89.1 205.6 89.1 205.6"
                  className="st7"
                ></path>
                <path d="M89.1 205.6L89.1 205.6" className="st7"></path>
                <path
                  d="M89.1 205.6L89.1 205.6 89.1 205.6 89.1 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.2 205.6L89.2 205.6 89.2 205.6"
                  className="st7"
                ></path>
                <path d="M89.2 205.6" className="st7"></path>
                <path
                  d="M89.2 205.6L89.2 205.6 89.2 205.6 89.2 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.2 205.6L89.2 205.6 89.2 205.6"
                  className="st7"
                ></path>
                <path d="M89.2 205.6" className="st7"></path>
                <path d="M89.3 205.6L89.3 205.6" className="st7"></path>
                <path d="M89.3 205.6" className="st7"></path>
                <path d="M89.3 205.6L89.3 205.6" className="st7"></path>
                <path d="M89.4 206L89.4 206 89.3 206" className="st7"></path>
                <path
                  d="M89.4 206L89.4 205.9 89.4 205.9 89.4 205.9 89.4 205.9 89.4 205.9 89.4 205.9 89.3 205.9"
                  className="st7"
                ></path>
                <path
                  d="M89.4 205.9L89.4 205.9 89.3 205.9"
                  className="st7"
                ></path>
                <path
                  d="M89.4 205.9L89.4 205.9 89.4 205.9 89.4 205.9 89.4 205.9 89.4 205.9 89.4 205.8 89.4 205.8 89.4 205.8 89.5 205.8 89.5 205.8 89.5 205.8 89.5 205.8 89.5 205.8 89.5 205.8 89.5 205.8 89.5 205.8 89.6 205.8 89.6 205.8 89.6 205.8 89.6 205.8 89.6 205.8 89.6 205.8 89.6 205.8 89.6 205.8 89.6 205.8 89.7 205.8 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.7 89.7 205.6 89.7 205.6 89.7 205.6 89.3 205.6"
                  className="st7"
                ></path>
                <path d="M89.7 205.6L89.3 205.6" className="st7"></path>
                <path d="M89.7 205.6" className="st7"></path>
                <path d="M89.3 205.5L89.6 205.5" className="st7"></path>
                <path
                  d="M89.3 205.5L89.6 205.5 89.6 205.5"
                  className="st7"
                ></path>
                <path d="M89.6 205.5L89.6 205.5" className="st7"></path>
                <path
                  d="M89.6 205.6L89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.5 89.6 205.5 89.6 205.5 89.6 205.5 89.6 205.5"
                  className="st7"
                ></path>
                <path
                  d="M89.6 205.6L89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.6 205.6L89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6"
                  className="st7"
                ></path>
                <path d="M89.6 205.6L89.6 205.6" className="st7"></path>
                <path
                  d="M89.6 205.6L89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6 89.6 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.6 205.6L89.6 205.6 89.5 205.6 89.5 205.6 89.5 205.6"
                  className="st7"
                ></path>
                <path d="M89.6 205.6L89.6 205.6" className="st7"></path>
                <path
                  d="M89.5 205.6L89.5 205.6 89.5 205.6 89.5 205.6 89.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.5 205.6L89.5 205.6 89.5 205.6 89.5 205.6 89.5 205.6"
                  className="st7"
                ></path>
                <path d="M89.5 205.6L89.5 205.6" className="st7"></path>
                <path
                  d="M89.5 205.6L89.5 205.6 89.5 205.6 89.5 205.6 89.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.5 205.6L89.5 205.6 89.4 205.6 89.4 205.6 89.4 205.6"
                  className="st7"
                ></path>
                <path d="M89.5 205.6L89.5 205.6" className="st7"></path>
                <path
                  d="M89.4 205.6L89.4 205.6 89.4 205.6 89.4 205.6 89.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.4 205.6L89.4 205.6 89.4 205.6 89.4 205.6"
                  className="st7"
                ></path>
                <path d="M89.4 205.6" className="st7"></path>
                <path
                  d="M89.4 205.6L89.4 205.6 89.4 205.6 89.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M89.3 205.6L89.3 205.6 89.3 205.6"
                  className="st7"
                ></path>
                <path d="M89.4 205.6" className="st7"></path>
                <path d="M89.3 205.6L89.3 205.6" className="st7"></path>
                <path d="M89.3 205.6" className="st7"></path>
                <path d="M89.3 205.6L89.3 205.6" className="st7"></path>
                <path
                  d="M89.4 206.2c.1 0 .1-.1.1-.2s0-.1-.1-.2M89.1 205.9c-.1 0-.1.1-.1.2s0 .1.1.2"
                  className="st7"
                ></path>
                <path
                  d="M89.3 206.5L89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.3 206.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 206.3L89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.4 89.4 206.4 89.3 206.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 206.2L89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3"
                  className="st7"
                ></path>
                <path
                  d="M89.3 206.2L89.4 206.2 89.4 206.2 89.4 206.2 89.4 206.2 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.3 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.4 89.4 206.5 89.4 206.5 89.4 206.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 206.4L89.4 206.5 89.4 206.5 89.3 206.5"
                  className="st7"
                ></path>
                <path
                  d="M89.4 206.6L89.4 206.6 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.5 89.4 206.5 89.3 206.6 89.3 206.6"
                  className="st7"
                ></path>
                <path
                  d="M89.3 206.7L89.3 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.8 89.4 206.8 89.4 206.8 89.4 206.8 89.4 206.8 89.4 206.8 89.4 206.8 89.5 206.8 89.5 206.7 89.5 206.7 89.5 206.7 89.5 206.7 89.5 206.7 89.5 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7 89.4 206.7"
                  className="st7"
                ></path>
                <path
                  d="M89.1 206.7L89.1 206.7 89.1 206.7 89.1 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.6 89.2 206.6 89.2 206.6 89.2 206.6 89.2 206.6 89.2 206.6 89.2 206.6 89.2 206.6 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.3 89.2 206.3 89.1 206.3 89.1 206.3 89.1 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.2 89.2 206.2 89.2 206.2 89.2 206.2 89.2 206.2 89.2 206.2 89.2 206.2 89.2 206.2"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.5L89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.3L89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.2L89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.2L89.2 206.2 89.2 206.2 89.2 206.2 89.2 206.2 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.3 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.4 89.2 206.5 89.2 206.5 89.2 206.5"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.4L89.2 206.5 89.2 206.5 89.2 206.5"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.6L89.2 206.6 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.5 89.2 206.6 89.2 206.6"
                  className="st7"
                ></path>
                <path
                  d="M89.2 206.7L89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.8 89.2 206.8 89.2 206.8 89.1 206.8 89.1 206.8 89.1 206.8 89.1 206.8 89.1 206.8 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.1 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7 89.2 206.7"
                  className="st7"
                ></path>
                <path d="M89.4 207.6L89.2 207.6" className="st7"></path>
                <path
                  d="M89.4 207.6L89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.5 89.4 207.5 89.4 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.6 89.2 207.6 89.2 207.6"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.6L89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.5 207.6 89.5 207.6 89.5 207.6 89.5 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.6 89.4 207.7 89.4 207.7 89.4 207.7 89.3 207.7 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.6L89.4 207.6 89.4 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.6L89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.7 89.3 207.7 89.3 207.7 89.4 207.7 89.4 207.7 89.4 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.7 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6 89.3 207.6"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.6L89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7 89.1 207.7 89.1 207.7 89.1 207.7 89.1 207.7 89.1 207.7 89.1 207.7 89.1 207.7 89.1 207.6 89.1 207.6 89.1 207.6 89.1 207.6 89.1 207.6 89.1 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6 89.2 207.6"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.7L89.4 207.7 89.4 207.7 89.4 207.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.7L89.2 207.7 89.2 207.7 89.2 207.7 89.2 207.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.7L89.3 207.7 89.4 207.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.7L89.2 207.7 89.2 207.7 89.2 207.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.5L89.3 207.5 89.3 207.5 89.4 207.5 89.4 207.5 89.4 207.4 89.4 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.3L89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.2 89.3 207.2 89.3 207.2 89.3 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.1L89.3 207.1 89.3 207.1"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.2L89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.5L89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.3 89.4 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.2 89.3 207.2 89.3 207.2 89.3 207.2 89.3 207.2 89.3 207.2 89.3 207.2 89.3 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.4L89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.3 207.3 89.3 207.2 89.3 207.2 89.3 207.2"
                  className="st7"
                ></path>
                <path d="M89.4 207.2L89.3 207.2" className="st7"></path>
                <path
                  d="M89.4 207.3L89.4 207.4 89.3 207.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.4L89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.5 89.3 207.5 89.3 207.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.4L89.3 207.4 89.3 207.4 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.3"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.5L89.3 207.5 89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5 89.3 207.5"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.5L89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.5L89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.1 207.5 89.1 207.4 89.1 207.4 89.1 207.4 89.1 207.4 89.1 207.4 89.1 207.4 89.1 207.4 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.1 89.1 207.1 89.1 207.1 89.1 207.1 89.1 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207 89.2 207 89.2 207 89.2 207 89.2 207 89.2 207 89.2 207 89.2 207 89.2 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.2 207 89.2 207 89.3 207 89.3 207 89.3 207 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.2 89.2 207.2 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.2 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.3 89.1 207.4 89.1 207.4"
                  className="st7"
                ></path>
                <path
                  d="M89.1 207.3L89.1 207.2 89.1 207.2 89.1 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.1 207.3 89.1 207.4 89.1 207.4 89.1 207.4 89.2 207.4 89.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.1L89.2 207.1 89.2 207.1"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.2L89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.2 207.1 89.3 207.1 89.3 207.1"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.5L89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.3 207.3 89.3 207.3 89.3 207.3 89.3 207.2 89.3 207.2 89.3 207.2 89.3 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.2 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.4L89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.2 89.2 207.2 89.3 207.2"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.2L89.2 207.2 89.2 207.2"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.3L89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.4L89.2 207.4 89.2 207.4 89.3 207.4 89.3 207.5 89.3 207.5 89.3 207.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 207.4L89.3 207.4 89.3 207.4 89.3 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3 89.2 207.3"
                  className="st7"
                ></path>
                <path
                  d="M89.2 207.5L89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.3 207.4 89.2 207.4 89.2 207.4 89.2 207.4 89.2 207.5 89.2 207.5 89.2 207.5 89.3 207.5 89.3 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.2 207.5 89.3 207.5 89.3 207.5"
                  className="st7"
                ></path>
                <path
                  d="M89.4 207.5L89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.5 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.4 89.4 207.3 89.5 207.3 89.5 207.3 89.5 207.3 89.5 207.3 89.5 207.3 89.5 207.3 89.5 207.2 89.5 207.2 89.5 207.2 89.5 207.2 89.5 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207 89.4 207 89.4 207 89.4 207 89.4 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.3 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.1 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.2 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.3 89.4 207.4 89.4 207.4"
                  className="st7"
                ></path>
                <path d="M65.1 170L65.3 170" className="st7"></path>
                <path
                  d="M65.5 171.6L65.5 171.6 65.5 171.5 65.6 171.5 65.6 171.5 65.6 171.5 65.6 171.5 65.6 171.5 65.6 171.5 65.7 171.5 65.7 171.5 65.7 171.5"
                  className="st7"
                ></path>
                <path d="M65.9 171.4L65.9 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.9 171.4L65.9 171.4" className="st7"></path>
                <path d="M65.8 171.3L65.2 171.3" className="st7"></path>
                <path d="M65.8 171.3L65.2 171.3" className="st7"></path>
                <path d="M65.8 171.3L65.2 171.3" className="st7"></path>
                <path
                  d="M65.9 171.4L65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 171.5L65.2 171.5 65.2 171.4 65.2 171.4 65.2 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 171.5L65.2 171.5 65.2 171.4 65.2 171.4 65.2 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 171.4L65.2 171.4 65.2 171.5 65.2 171.5"
                  className="st7"
                ></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.8 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.5 170.2L65.4 170.2" className="st7"></path>
                <path
                  d="M65.2 170.1L65.5 170.1 65.5 170.2 65.4 170.2"
                  className="st7"
                ></path>
                <path d="M65.3 170" className="st7"></path>
                <path
                  d="M65.3 170L65.3 170 65.3 170 65.3 170 65.3 170 65.3 170 65.3 170.1 65.3 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.5 170.1 65.5 170.1"
                  className="st7"
                ></path>
                <path
                  d="M65.4 170.1L65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170 65.3 170 65.3 170 65.3 170 65.3 170 65.3 170 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1"
                  className="st7"
                ></path>
                <path
                  d="M65.3 170.1L65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.2 170.1 65.2 170.1 65.2 170.1 65.2 170.1 65.2 170.1 65.2 170.1 65.2 170.1 65.2 170.1 65.2 170.1 65.2 170 65.2 170 65.2 170"
                  className="st7"
                ></path>
                <path
                  d="M65.3 170.1L65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1 65.3 170.1"
                  className="st7"
                ></path>
                <path
                  d="M65.2 170.1L65.2 170.1 65.2 170.1 65.2 170.1"
                  className="st7"
                ></path>
                <path
                  d="M65.2 171.5L65.2 171.5 65.2 171.4 65.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.6L65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.9 171.6 65.9 171.6 65.9 171.6 65.9 171.6 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.4 65.9 171.4 65.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.4L65.8 171.4 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.7 171.5L65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.5L65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.6L65.8 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.7 171.5L65.7 171.5 65.7 171.5 65.7 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.8 171.5 65.7 171.5 65.7 171.5 65.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.5L65.8 171.4 65.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M65.7 171.5L65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.4 65.7 171.4 65.7 171.4 65.7 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M65.7 171.5L65.7 171.5 65.7 171.5 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6"
                  className="st7"
                ></path>
                <path
                  d="M65.7 171.5L65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.5 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.7 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.8 171.6 65.9 171.6 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.5 65.9 171.4 65.9 171.4 65.9 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.3"
                  className="st7"
                ></path>
                <path
                  d="M65.5 170.2L65.5 170.2 65.5 170.3 65.6 170.3 65.7 170.4 65.7 170.5 65.7 170.6 65.8 170.7 65.8 170.9 65.8 171"
                  className="st7"
                ></path>
                <path
                  d="M65.9 171.4L65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4 65.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.4L65.8 171.4 65.8 171.4"
                  className="st7"
                ></path>
                <path d="M65.8 171L65.8 171" className="st7"></path>
                <path
                  d="M65.8 171L65.8 171 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171L65.8 171 65.8 171 65.8 171 65.8 171 65.9 171 65.9 171 65.9 171.1 65.9 171.1 65.9 171.1 65.9 171.1 65.9 171.1 65.9 171.1 65.9 171.1 65.9 171.1 65.9 171.1 65.9 171.2 65.9 171.2 65.9 171.2 65.9 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.3 65.9 171.3 65.9 171.3 65.9 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171 65.8 171 65.8 171 65.8 171"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.3L65.8 171.3 65.8 171.3 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.1L65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171L65.8 171 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171 65.8 171 65.8 171"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171L65.8 171 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.1L65.8 171.1 65.8 171.2"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.1L65.8 171.1 65.8 171.1 65.8 171.1"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171L65.8 171 65.8 171 65.8 171 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171.1 65.8 171 65.8 171 65.8 171 65.8 171"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.1L65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.7 171.2 65.7 171.2 65.7 171.2 65.7 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.8 171.2 65.7 171.2 65.7 171.1 65.7 171.1 65.7 171.1 65.7 171.1 65.7 171.1 65.7 171.1 65.7 171.1 65.8 171.1 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171 65.8 171"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.4L65.7 171.4 65.7 171.4 65.7 171.4 65.7 171.4 65.7 171.3 65.7 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.3 65.8 171.2"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171.4L65.8 171.4 65.8 171.4"
                  className="st7"
                ></path>
                <path d="M65.8 171.3L65.8 171.3" className="st7"></path>
                <path
                  d="M65.8 171.4L65.8 171.4 65.8 171.4 65.8 171.4"
                  className="st7"
                ></path>
                <path d="M65.4 170.2L65.4 170.2" className="st7"></path>
                <path
                  d="M65.4 170.2L65.3 170.2 65.3 170.2 65.4 170.2"
                  className="st7"
                ></path>
                <path
                  d="M65.5 170.2L65.5 170.2 65.4 170.2"
                  className="st7"
                ></path>
                <path d="M65.4 170.2L65.4 170.2" className="st7"></path>
                <path
                  d="M65.5 170.2L65.4 170.2 65.4 170.1 65.4 170.1 65.4 170.1 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2"
                  className="st7"
                ></path>
                <path
                  d="M65.4 170.2L65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.4 170.2 65.5 170.2"
                  className="st7"
                ></path>
                <path
                  d="M65.8 171L65.8 170.8 65.8 170.7 65.8 170.6 65.8 170.6 65.8 170.5 65.7 170.5 65.7 170.4 65.7 170.4 65.7 170.3 65.6 170.3 65.6 170.2 65.6 170.2 65.5 170.2 65.5 170.2 65.5 170.2 65.5 170.2 65.4 170.2"
                  className="st7"
                ></path>
                <path
                  d="M65.9 171.5L65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4 65.9 171.4"
                  className="st7"
                ></path>
                <path d="M65.8 171.5L65.8 171.5" className="st7"></path>
                <path d="M65.7 171.2L65.2 171.2" className="st7"></path>
                <path d="M65.9 171.4L65.9 171.4" className="st7"></path>
                <path d="M65.8 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.8 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.3 170.2L65.2 170.2" className="st7"></path>
                <path d="M65.4 170.2L65.2 170.2" className="st7"></path>
                <path d="M65.2 170L65.2 170" className="st7"></path>
                <path d="M65.8 171.3L65.8 171.3" className="st7"></path>
                <path
                  d="M64.8 171.6L64.8 171.6 64.8 171.5 64.8 171.5 64.7 171.5 64.7 171.5 64.7 171.5 64.7 171.5 64.7 171.5 64.6 171.5 64.6 171.5"
                  className="st7"
                ></path>
                <path d="M64.4 171.4L64.4 171.4" className="st7"></path>
                <path d="M65.2 171.4L65.1 171.4" className="st7"></path>
                <path
                  d="M64.4 171.4L64.4 171.4 64.4 171.4"
                  className="st7"
                ></path>
                <path d="M64.6 171.3L65.2 171.3" className="st7"></path>
                <path d="M64.6 171.3L65.2 171.3" className="st7"></path>
                <path d="M64.6 171.3L65.2 171.3" className="st7"></path>
                <path
                  d="M64.4 171.4L64.4 171.4 64.4 171.4 64.4 171.4 64.4 171.4 64.4 171.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 171.5L65.1 171.5 65.1 171.4 65.1 171.4 65.1 171.5"
                  className="st7"
                ></path>
                <path
                  d="M65.1 171.5L65.1 171.5 65.1 171.4 65.1 171.4 65.1 171.5"
                  className="st7"
                ></path>
                <path d="M65.2 171.4L65.2 171.5" className="st7"></path>
                <path d="M65.1 171.4L65.1 171.4" className="st7"></path>
                <path d="M65.1 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.1 171.4L65.1 171.4" className="st7"></path>
                <path d="M65.1 171.4L65.2 171.4" className="st7"></path>
                <path d="M65.1 171.4L65.1 171.4" className="st7"></path>
                <path d="M65.1 171.4L64.5 171.4" className="st7"></path>
                <path d="M65.1 171.4L65.1 171.4" className="st7"></path>
                <path d="M65.1 171.4L65.2 171.4" className="st7"></path>
                <path d="M64.9 170.2L64.9 170.2" className="st7"></path>
                <path
                  d="M65.2 170.1L64.9 170.1 64.9 170.2 64.9 170.2"
                  className="st7"
                ></path>
                <path d="M65.3 170L65.1 170" className="st7"></path>
                <path d="M65.1 170" className="st7"></path>
                <path
                  d="M65.3 170L65 170 65 170 65 170 65 170 65 170 65 170 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.1"
                  className="st7"
                ></path>
                <path
                  d="M64.9 170.1L64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170 65.1 170 65.1 170 65.1 170 65.1 170 65.1 170.1 65.1 170.1 65.1 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1"
                  className="st7"
                ></path>
                <path
                  d="M65 170.1L65 170.1 65 170.1 65 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170.1 65.1 170 65.1 170 65.2 170"
                  className="st7"
                ></path>
                <path
                  d="M65 170.1L65 170.1 65 170.1 65 170.1 65 170.1 65 170.1 65 170.1"
                  className="st7"
                ></path>
                <path
                  d="M65.1 170.1L65.1 170.1 65.2 170.1"
                  className="st7"
                ></path>
                <path d="M65.2 171.5L65.2 171.4" className="st7"></path>
                <path
                  d="M64.6 171.6L64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.4 171.6 64.4 171.6 64.4 171.5 64.4 171.5 64.4 171.5 64.4 171.5 64.4 171.5 64.4 171.5 64.4 171.5 64.4 171.5 64.4 171.4 64.4 171.4 64.4 171.4"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171.4L64.5 171.4 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.5L64.6 171.5 64.6 171.5 64.6 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.5L64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.6L64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.5L64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171.5L64.5 171.4 64.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.5L64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.4 64.6 171.4 64.6 171.4 64.6 171.4 64.6 171.4 64.6 171.4 64.6 171.4 64.5 171.4 64.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.5L64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.6 64.6 171.6 64.6 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.5L64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.5 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.6 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.6 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.5 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.3"
                  className="st7"
                ></path>
                <path
                  d="M64.9 170.2L64.8 170.2 64.8 170.3 64.7 170.3 64.6 170.4 64.6 170.5 64.6 170.6 64.6 170.7 64.6 170.9 64.6 171"
                  className="st7"
                ></path>
                <path
                  d="M64.4 171.4L64.4 171.4 64.4 171.4 64.4 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4 64.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.4L64.6 171.4 64.5 171.4"
                  className="st7"
                ></path>
                <path d="M64.5 171L64.6 171" className="st7"></path>
                <path
                  d="M64.5 171L64.5 171 64.5 171 64.5 171 64.5 171 64.6 171 64.6 171 64.6 171 64.6 171 64.6 171"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171L64.5 171 64.5 171 64.5 171 64.5 171 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171 64.5 171 64.5 171"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171.3L64.5 171.3 64.5 171.3 64.5 171.3 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171.1L64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171 64.5 171 64.5 171 64.5 171 64.5 171"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171L64.5 171 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171 64.5 171 64.5 171"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171L64.5 171 64.5 171 64.5 171 64.5 171 64.6 171 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.1 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171.1L64.5 171.1 64.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171.1L64.5 171.1 64.5 171.1 64.5 171.1"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171L64.5 171 64.6 171 64.6 171 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.5 171.1 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.5 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171 64.6 171 64.6 171"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.1L64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.2 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171.1 64.6 171 64.6 171 64.6 171 64.6 171 64.6 171 64.6 171"
                  className="st7"
                ></path>
                <path
                  d="M64.6 171.4L64.6 171.4 64.6 171.4 64.6 171.3 64.6 171.3 64.6 171.3 64.6 171.3 64.6 171.3 64.6 171.3 64.6 171.3 64.6 171.2"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171.4L64.5 171.4 64.5 171.4"
                  className="st7"
                ></path>
                <path d="M64.5 171.3L64.5 171.3" className="st7"></path>
                <path
                  d="M64.5 171.4L64.5 171.4 64.5 171.4 64.5 171.4"
                  className="st7"
                ></path>
                <path d="M65 170.2L65 170.2" className="st7"></path>
                <path
                  d="M64.9 170.2L65 170.2 65 170.2 64.9 170.2"
                  className="st7"
                ></path>
                <path
                  d="M64.9 170.2L64.9 170.2 64.9 170.2"
                  className="st7"
                ></path>
                <path d="M64.9 170.2L64.9 170.2" className="st7"></path>
                <path
                  d="M64.9 170.2L64.9 170.2 64.9 170.1 64.9 170.1 64.9 170.1 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2"
                  className="st7"
                ></path>
                <path
                  d="M64.9 170.2L64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2 64.9 170.2"
                  className="st7"
                ></path>
                <path
                  d="M64.5 171L64.5 170.8 64.5 170.7 64.5 170.6 64.5 170.6 64.6 170.5 64.6 170.5 64.6 170.4 64.6 170.4 64.7 170.3 64.7 170.3 64.7 170.2 64.8 170.2 64.8 170.2 64.8 170.2 64.8 170.2 64.9 170.2 64.9 170.2"
                  className="st7"
                ></path>
                <path
                  d="M64.4 171.5L64.4 171.4 64.4 171.4 64.4 171.4 64.4 171.4 64.4 171.4"
                  className="st7"
                ></path>
                <path d="M64.5 171.5L64.5 171.5" className="st7"></path>
                <path d="M64.6 171.2L65.2 171.2" className="st7"></path>
                <path d="M64.4 171.4L64.4 171.4" className="st7"></path>
                <path d="M64.5 171.4L65.1 171.4" className="st7"></path>
                <path d="M64.5 171.4L65.1 171.4" className="st7"></path>
                <path d="M65 170.2L65.2 170.2" className="st7"></path>
                <path d="M64.9 170.2L65.2 170.2" className="st7"></path>
                <path d="M65.2 170L65.2 170" className="st7"></path>
                <path d="M64.5 171.3L64.5 171.3" className="st7"></path>
                <path d="M65.1 170L65.1 170 65.2 170" className="st7"></path>
                <path d="M65.1 170L65.2 170" className="st7"></path>
                <path d="M65.1 169.9L65.2 169.9" className="st7"></path>
                <path d="M65.1 170L65.1 169.9" className="st7"></path>
                <path d="M65.1 169.9L65.2 169.9" className="st7"></path>
                <path d="M65.1 169.9L65.1 169.9" className="st7"></path>
                <path
                  d="M65.1 170L65.1 170 65.1 170 65.1 170 65.1 170 65.1 170"
                  className="st7"
                ></path>
                <path d="M65.2 170L65.2 170 65.2 170" className="st7"></path>
                <path d="M65.2 170L65.2 170" className="st7"></path>
                <path
                  d="M65.2 170L65.2 169.9 65.2 169.9"
                  className="st7"
                ></path>
                <path d="M65.2 169.9L65.2 169.9" className="st7"></path>
                <path d="M65.2 169.9L65.2 169.9" className="st7"></path>
                <path
                  d="M65.2 170L65.2 170 65.2 170 65.2 170 65.2 170 65.2 170"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.9L65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.8L65.1 169.8 65.1 169.8 65.1 169.8 65 169.8 65 169.8 65 169.9 65.1 169.9 65.1 169.9 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.8L65.1 169.8 65.1 169.9 65.1 169.9 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.8L65.1 169.8 65.1 169.9 65.1 169.9 65.2 169.9 65.2 169.8 65.2 169.8 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.8L65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.8L65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9 65.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.9L65.1 169.8 65.1 169.8 65.1 169.9 65.1 169.9 65.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.9L65.1 169.9 65.1 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.2 169.9L65.2 169.9 65.3 169.9 65.3 169.9 65.3 169.9 65.3 169.9 65.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.3 169.8L65.3 169.8 65.3 169.8 65.3 169.8 65.3 169.8 65.3 169.9 65.3 169.9 65.3 169.9 65.3 169.8 65.2 169.8 65.2 169.8 65.3 169.8 65.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.3 169.8L65.2 169.8 65.2 169.9 65.2 169.9 65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.2 169.8L65.2 169.8 65.2 169.8 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.3 169.8L65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8 65.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.2 169.8L65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.3 169.9L65.3 169.9 65.3 169.8 65.2 169.8 65.2 169.9 65.2 169.9 65.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.2 169.9L65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9 65.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M65.2 169.7L65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.7 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8 65.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 169.8L65.2 169.8 65.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.2 169.7L65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.7 65.2 169.8 65.2 169.8 65.2 169.8 65.3 169.8 65.3 169.8 65.3 169.8 65.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M65.3 172.3L65.1 172.3 65.1 172.2"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.2L65.1 172.2 65.1 172.2"
                  className="st7"
                ></path>
                <path d="M65.1 172.2" className="st7"></path>
                <path d="M65.3 172.3L65.3 172.2" className="st7"></path>
                <path d="M65.3 172.2L65.3 172.2" className="st7"></path>
                <path d="M65.3 172.2" className="st7"></path>
                <path d="M65.1 172.2L65.3 172.2" className="st7"></path>
                <path d="M65.1 172.2L65.3 172.2" className="st7"></path>
                <path d="M65.1 172.1L65.3 172.1" className="st7"></path>
                <path
                  d="M65.1 172.1c-.1 0-.1 0 0 0-.1.1-.1.1 0 0 0 .1 0 .1 0 0M65.3 172.2s0-.1 0 0c0-.1 0-.1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.1L65.1 172.1 65.3 172.1 65.3 172.1"
                  className="st7"
                ></path>
                <path d="M65.2 172.1" className="st7"></path>
                <path d="M65.1 172.1L65.2 172.1" className="st7"></path>
                <path d="M65.1 172.1L65.2 172.1" className="st7"></path>
                <path d="M65.2 172.1" className="st7"></path>
                <path
                  d="M65 172.8L65 172.8 65 172.8 65 172.8 65 172.7 65.1 172.7 65.1 172.7 65.1 172.7 65.1 172.7 65.1 172.7 65.1 172.7 65.1 172.7 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.5 65.1 172.5 65.1 172.5 65 172.5 65 172.5 65 172.5 65 172.4 65 172.4 65 172.4 65 172.4 65 172.4 65 172.4 65 172.4 65 172.3 65 172.3 65 172.3 65 172.3 65.1 172.3 65.1 172.3 65.1 172.3 65.1 172.3 65.1 172.3"
                  className="st7"
                ></path>
                <path d="M65.1 172.3L65.1 173.1" className="st7"></path>
                <path d="M65.2 172.3L65.2 173.1" className="st7"></path>
                <path d="M65.2 172.1L65.1 172.1" className="st7"></path>
                <path d="M65.2 172.1L65.2 172 65.2 172" className="st7"></path>
                <path
                  d="M65.2 172L65.3 172 65.3 172 65.3 172 65.3 172 65.3 172 65.2 172"
                  className="st7"
                ></path>
                <path d="M65.3 172L65.3 172 65.2 172" className="st7"></path>
                <path
                  d="M65.3 172L65.3 172 65.3 172 65.3 171.9 65.3 171.9 65.3 171.9 65.3 171.9 65.3 171.9 65.3 171.9 65.3 171.9 65.3 171.9 65.4 171.9 65.4 171.9 65.4 171.9 65.4 171.9 65.4 171.9 65.4 171.9 65.4 171.9 65.4 171.9 65.5 171.9 65.5 171.9 65.5 171.9 65.5 171.9 65.5 171.9 65.5 171.8 65.5 171.8 65.5 171.8 65.5 171.8 65.5 171.8 65.6 171.8 65.6 171.8 65.6 171.8 65.6 171.8 65.6 171.8 65.6 171.8 65.6 171.8 65.6 171.8 65.6 171.7 65.6 171.7 65.6 171.7 65.6 171.7 65.6 171.7 65.5 171.7 65.2 171.7"
                  className="st7"
                ></path>
                <path d="M65.5 171.7L65.2 171.7" className="st7"></path>
                <path d="M65.6 171.7" className="st7"></path>
                <path d="M65.2 171.6L65.5 171.6" className="st7"></path>
                <path
                  d="M65.2 171.6L65.5 171.6 65.5 171.6"
                  className="st7"
                ></path>
                <path
                  d="M65.5 171.7L65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.6 65.5 171.6 65.5 171.6 65.5 171.6 65.5 171.6 65.5 171.6 65.5 171.6"
                  className="st7"
                ></path>
                <path
                  d="M65.5 171.7L65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.7 65.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.5 171.7L65.5 171.7 65.5 171.7 65.5 171.7 65.4 171.7 65.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.5 171.7L65.4 171.7 65.4 171.7 65.4 171.7 65.4 171.7 65.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.4 171.7L65.4 171.7 65.4 171.7 65.4 171.7 65.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.4 171.7L65.4 171.7 65.4 171.7 65.4 171.7 65.4 171.7 65.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.4 171.7L65.4 171.7 65.4 171.7 65.4 171.7 65.4 171.7"
                  className="st7"
                ></path>
                <path d="M65.4 171.7L65.4 171.7" className="st7"></path>
                <path
                  d="M65.4 171.7L65.4 171.7 65.3 171.7 65.3 171.7 65.3 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 171.7L65.3 171.7 65.3 171.7 65.3 171.7 65.3 171.7"
                  className="st7"
                ></path>
                <path d="M65.3 171.7L65.3 171.7" className="st7"></path>
                <path
                  d="M65.3 171.7L65.3 171.7 65.3 171.7 65.3 171.7 65.3 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 171.7L65.3 171.7 65.3 171.7 65.3 171.7 65.3 171.7"
                  className="st7"
                ></path>
                <path d="M65.3 171.6" className="st7"></path>
                <path
                  d="M65.2 171.7L65.2 171.7 65.2 171.7 65.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.2 171.7L65.2 171.7 65.2 171.7 65.2 171.7 65.2 171.7"
                  className="st7"
                ></path>
                <path d="M65.3 171.6" className="st7"></path>
                <path d="M65.2 171.7L65.2 171.7" className="st7"></path>
                <path d="M65.2 171.6" className="st7"></path>
                <path d="M65.1 171.7L65.1 171.7" className="st7"></path>
                <path d="M65.1 172.1L65.1 172 65.2 172" className="st7"></path>
                <path
                  d="M65.1 172L65.1 172 65.1 172 65.1 172 65.1 172 65.1 172 65 172 65.2 172"
                  className="st7"
                ></path>
                <path d="M65 172L65 172 65.2 172" className="st7"></path>
                <path
                  d="M65.1 172L65.1 172 65 172 65 171.9 65 171.9 65 171.9 65 171.9 65 171.9 65 171.9 65 171.9 65 171.9 65 171.9 65 171.9 65 171.9 64.9 171.9 64.9 171.9 64.9 171.9 64.9 171.9 64.9 171.9 64.9 171.9 64.9 171.9 64.9 171.9 64.8 171.9 64.8 171.9 64.8 171.8 64.8 171.8 64.8 171.8 64.8 171.8 64.8 171.8 64.8 171.8 64.8 171.8 64.7 171.8 64.7 171.8 64.7 171.8 64.7 171.8 64.7 171.8 64.7 171.8 64.7 171.7 64.7 171.7 64.7 171.7 64.7 171.7 64.8 171.7 64.8 171.7 65.2 171.7"
                  className="st7"
                ></path>
                <path d="M64.8 171.7L65.2 171.7" className="st7"></path>
                <path d="M64.8 171.7" className="st7"></path>
                <path d="M65.2 171.6L64.8 171.6" className="st7"></path>
                <path
                  d="M65.2 171.6L64.8 171.6 64.8 171.6"
                  className="st7"
                ></path>
                <path
                  d="M64.8 171.7L64.8 171.7 64.8 171.7 64.8 171.7 64.8 171.7 64.8 171.7 64.8 171.7 64.9 171.7 64.9 171.6 64.9 171.6 64.8 171.6 64.8 171.6 64.8 171.6 64.8 171.6 64.8 171.6 64.8 171.6"
                  className="st7"
                ></path>
                <path
                  d="M64.8 171.7L64.8 171.7 64.9 171.7 64.9 171.7 64.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M64.8 171.7L64.9 171.7 64.9 171.7 64.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M64.9 171.7L64.9 171.7 64.9 171.7 64.9 171.7 64.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M64.9 171.7L64.9 171.7 64.9 171.7 64.9 171.7 64.9 171.7 64.9 171.7"
                  className="st7"
                ></path>
                <path d="M64.9 171.7L64.9 171.7" className="st7"></path>
                <path
                  d="M64.9 171.7L64.9 171.7 64.9 171.7 64.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M64.9 171.7L64.9 171.7 64.9 171.7 64.9 171.7 65 171.7 65 171.7"
                  className="st7"
                ></path>
                <path d="M64.9 171.7L64.9 171.7" className="st7"></path>
                <path
                  d="M65 171.7L65 171.7 65 171.7 65 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65 171.7L65 171.7 65 171.7 65 171.7 65 171.7"
                  className="st7"
                ></path>
                <path d="M65 171.7L65 171.7" className="st7"></path>
                <path
                  d="M65 171.7L65 171.7 65 171.7 65 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 171.7L65.1 171.7 65.1 171.7 65.1 171.7"
                  className="st7"
                ></path>
                <path d="M65.1 171.7" className="st7"></path>
                <path
                  d="M65.1 171.7L65.1 171.7 65.1 171.7 65.1 171.7 65.1 171.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 171.7L65.1 171.7 65.1 171.7 65.1 171.7"
                  className="st7"
                ></path>
                <path d="M65.2 171.7" className="st7"></path>
                <path d="M65.1 171.7L65.1 171.7" className="st7"></path>
                <path d="M65.2 171.6" className="st7"></path>
                <path d="M65.2 171.7L65.2 171.7" className="st7"></path>
                <path
                  d="M65 171.9c-.1 0-.1.1-.1.2s0 .1.1.2M65.3 172.3c.1 0 .1-.1.1-.2s0-.1-.1-.2"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.6L65.1 172.6 65.1 172.6 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.4L65.1 172.4 65.1 172.4 65.1 172.4 65.1 172.4 65.1 172.4 65.1 172.4 65.1 172.4 65.1 172.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.3L65.1 172.3 65.1 172.3 65.1 172.3 65.1 172.4 65.1 172.4 65.1 172.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.3L65.1 172.3 65.1 172.3 65.1 172.3 65.1 172.3 65.1 172.3 65.1 172.3 65 172.4 65 172.4 65 172.4 65 172.4 65 172.4 65 172.4 65 172.4 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.5 65.1 172.6 65.1 172.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.5L65.1 172.5 65.1 172.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.7L65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.6 65.1 172.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 172.7L65.1 172.7 65.1 172.7 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8 65.1 172.8"
                  className="st7"
                ></path>
                <path d="M65.3 172.3L65.3 172.2" className="st7"></path>
                <path
                  d="M65.3 172.8L65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.7 65.3 172.6 65.3 172.6 65.3 172.6 65.3 172.6 65.3 172.6 65.3 172.6 65.3 172.6 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.2 172.3"
                  className="st7"
                ></path>
                <path
                  d="M65.2 172.6L65.2 172.6 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.2 172.5 65.2 172.5 65.2 172.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 172.4L65.2 172.4 65.2 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.2 172.4 65.2 172.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 172.3L65.2 172.3 65.2 172.3 65.2 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.2 172.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 172.3L65.2 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.3 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.4 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.5 65.3 172.6 65.3 172.6"
                  className="st7"
                ></path>
                <path
                  d="M65.2 172.5L65.2 172.5 65.2 172.6"
                  className="st7"
                ></path>
                <path
                  d="M65.3 172.7L65.3 172.6 65.3 172.6 65.3 172.6 65.2 172.6 65.2 172.6 65.2 172.6 65.2 172.6 65.2 172.7"
                  className="st7"
                ></path>
                <path
                  d="M65.2 172.7L65.2 172.7 65.2 172.7 65.2 172.8 65.2 172.8 65.2 172.8 65.2 172.8 65.2 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.4 172.8 65.4 172.8 65.4 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.3 172.8 65.2 172.8 65.2 172.8 65.2 172.8 65.2 172.8"
                  className="st7"
                ></path>
                <path d="M65.1 173.7L65.2 173.7" className="st7"></path>
                <path
                  d="M65.1 173.7L65.1 173.7 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.2 173.6 65.3 173.6 65.3 173.6 65.3 173.6 65.3 173.6 65.3 173.7 65.2 173.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.7L65.1 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65 173.8 65 173.8 65 173.8 65 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.7 65.1 173.7 65.1 173.7 65 173.7 65 173.7 65 173.7 65 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.7L65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.7L65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.1 173.8 65.2 173.8 65.2 173.8 65.2 173.8 65.2 173.8 65.2 173.8 65.2 173.8 65.2 173.8 65.2 173.8 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.8 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7 65.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 173.7L65.3 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.2 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.8 65.2 173.8 65.2 173.8 65.3 173.8 65.3 173.8 65.3 173.8 65.3 173.8 65.3 173.8 65.3 173.8 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7 65.2 173.7 65.2 173.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.7L65.1 173.7 65.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M65.3 173.7L65.3 173.7 65.3 173.7 65.3 173.7 65.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.8L65.1 173.8 65.1 173.8"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.8L65.2 173.8 65.2 173.8 65.2 173.8 65.3 173.8"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.6L65.1 173.6 65.1 173.6 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65 173.3L65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65 173.3 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4 65 173.5 65 173.5 65 173.5"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.1L65.1 173.1 65.1 173.2 65.1 173.2"
                  className="st7"
                ></path>
                <path
                  d="M65 173.3L65 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.5L65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.4 65 173.4 65 173.4 65 173.4 65 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65 173.4L65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3 65.1 173.3"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.3L65.1 173.3 65.1 173.3 65.1 173.3"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.4L65.1 173.4 65.1 173.4 65.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.5L65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.2 173.5 65.1 173.5 65.1 173.6"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.4L65.2 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.6L65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.1 173.4 65.2 173.5 65.2 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.5 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.1 173.6 65.2 173.6"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.6L65.2 173.6 65.2 173.6 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.6L65.3 173.6 65.3 173.6 65.3 173.6 65.3 173.6 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.1 65.3 173.1 65.3 173.1 65.3 173.1 65.3 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173 65.2 173 65.2 173 65.2 173 65.2 173 65.2 173 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.1 65.2 173.2 65.2 173.2 65.2 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65.3 173.3L65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.3 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.5 65.3 173.5 65.3 173.5"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.1L65.2 173.1 65.2 173.2 65.2 173.2"
                  className="st7"
                ></path>
                <path
                  d="M65.3 173.3L65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2 65.2 173.2"
                  className="st7"
                ></path>
                <path
                  d="M65.3 173.5L65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.4 65.3 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.3 173.3 65.3 173.3 65.3 173.3 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4 65.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65.3 173.4L65.3 173.4 65.3 173.4 65.3 173.4 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3 65.2 173.3"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.3L65.2 173.3 65.2 173.3 65.2 173.3"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.4L65.2 173.4 65.2 173.4 65.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.5L65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.6"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.4L65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M65.2 173.6L65.2 173.6 65.2 173.6 65.2 173.6 65.3 173.6 65.3 173.6 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.3 173.5 65.2 173.5 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.4 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.5 65.2 173.6 65.2 173.6 65.2 173.6 65.2 173.6 65.2 173.6 65.2 173.6 65.2 173.6 65.2 173.6 65.2 173.6 65.2 173.6"
                  className="st7"
                ></path>
                <path
                  d="M65.1 173.6L65.1 173.6 65.1 173.6 65 173.6 65 173.5 65 173.5 65 173.5 65 173.5 65 173.5 65 173.5 65 173.5 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.2 65 173.2 65 173.2 65 173.2 65 173.2 65 173.2 65 173.2 65 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173 65.1 173 65.1 173 65.2 173 65.2 173 65.2 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.1 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65.1 173.2 65 173.2 65 173.2 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.3 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4 65 173.4"
                  className="st7"
                ></path>
                <path d="M89.4 170L89.2 170" className="st7"></path>
                <path
                  d="M88.9 171.6L88.9 171.6 88.9 171.6 88.9 171.5 88.9 171.5 88.9 171.5 88.9 171.5 88.8 171.5 88.8 171.5 88.8 171.5 88.8 171.5 88.7 171.5"
                  className="st7"
                ></path>
                <path d="M88.5 171.4L88.5 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M88.5 171.4L88.5 171.4" className="st7"></path>
                <path d="M88.7 171.3L89.3 171.3" className="st7"></path>
                <path d="M88.7 171.3L89.3 171.3" className="st7"></path>
                <path d="M88.7 171.3L89.3 171.3" className="st7"></path>
                <path
                  d="M88.5 171.4L88.5 171.4 88.5 171.4 88.5 171.4 88.5 171.4 88.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 171.5L89.2 171.5 89.2 171.4 89.2 171.4 89.2 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.2 171.5L89.3 171.5 89.3 171.4 89.2 171.4 89.2 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 171.4L89.3 171.4 89.3 171.5 89.3 171.5"
                  className="st7"
                ></path>
                <path d="M89.2 171.4L89.2 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.2 171.4L89.2 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.2 171.4L89.2 171.4" className="st7"></path>
                <path d="M89.2 171.4L88.6 171.4" className="st7"></path>
                <path d="M89.2 171.4L89.2 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89 170.2L89 170.2" className="st7"></path>
                <path
                  d="M89.3 170.1L89 170.1 89 170.2 89 170.2"
                  className="st7"
                ></path>
                <path d="M89.2 170" className="st7"></path>
                <path
                  d="M89.1 170L89.1 170 89.1 170 89.1 170 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89 170.1 89 170.1 89 170.1 89 170.1 89 170.1 89 170.1 89 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89 170.1L89 170.1 89 170.1 89 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.2 170.1 89.2 170 89.2 170 89.2 170 89.2 170 89.2 170 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89.1 170.1L89.1 170.1 89.1 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.2 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170 89.3 170 89.3 170"
                  className="st7"
                ></path>
                <path
                  d="M89.1 170.1L89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1 89.1 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89.2 170.1L89.3 170.1 89.3 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89.3 171.5L89.3 171.5 89.3 171.4 89.3 171.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.6L88.7 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.5 171.5 88.5 171.5 88.5 171.5 88.5 171.5 88.5 171.5 88.5 171.5 88.5 171.5 88.5 171.5 88.5 171.4 88.5 171.4 88.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171.4L88.6 171.4 88.6 171.4 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.5L88.7 171.5 88.7 171.5 88.7 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.5L88.7 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.7 171.5 88.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.6L88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.5L88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171.5L88.6 171.5 88.6 171.4 88.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.5L88.7 171.5 88.7 171.4 88.7 171.4 88.7 171.4 88.7 171.4 88.7 171.4 88.7 171.4 88.6 171.4 88.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.5L88.7 171.5 88.7 171.5 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.6 171.6 88.6 171.6 88.6 171.6"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.5L88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.5 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.7 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.6 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.5 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.3"
                  className="st7"
                ></path>
                <path
                  d="M89 170.2L88.9 170.2 88.9 170.3 88.8 170.3 88.8 170.4 88.7 170.5 88.7 170.6 88.7 170.7 88.7 170.9 88.7 171"
                  className="st7"
                ></path>
                <path
                  d="M88.5 171.4L88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4 88.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.4L88.7 171.4 88.6 171.4"
                  className="st7"
                ></path>
                <path d="M88.6 171L88.7 171" className="st7"></path>
                <path
                  d="M88.6 171L88.6 171 88.6 171 88.7 171 88.7 171 88.7 171 88.7 171 88.7 171"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171L88.6 171 88.6 171 88.6 171 88.6 171 88.6 171 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171 88.6 171 88.6 171 88.6 171"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171.3L88.6 171.3 88.6 171.3 88.6 171.3 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171.1L88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.7 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.2 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171 88.6 171 88.6 171 88.6 171"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171L88.6 171 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171.1 88.6 171 88.6 171 88.6 171 88.6 171"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171L88.6 171 88.6 171 88.7 171 88.7 171 88.7 171 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.2 88.7 171.2 88.6 171.2 88.6 171.2 88.6 171.2"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171.1L88.7 171.1 88.7 171.2"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171.1L88.6 171.1 88.7 171.1 88.7 171.1"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171L88.7 171 88.7 171 88.7 171 88.7 171 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171 88.7 171 88.7 171"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.1L88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.2 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171.1 88.7 171 88.7 171 88.7 171 88.7 171 88.7 171 88.7 171"
                  className="st7"
                ></path>
                <path
                  d="M88.7 171.4L88.7 171.4 88.7 171.4 88.7 171.3 88.7 171.3 88.7 171.3 88.7 171.3 88.7 171.3 88.7 171.3 88.7 171.3 88.7 171.3 88.7 171.3 88.7 171.2"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171.4L88.6 171.4 88.6 171.4"
                  className="st7"
                ></path>
                <path d="M88.6 171.3L88.6 171.3" className="st7"></path>
                <path
                  d="M88.6 171.4L88.6 171.4 88.6 171.4"
                  className="st7"
                ></path>
                <path d="M89.1 170.2L89.1 170.2" className="st7"></path>
                <path
                  d="M89 170.2L89.1 170.2 89.1 170.2 89 170.2"
                  className="st7"
                ></path>
                <path d="M89 170.2L89 170.2" className="st7"></path>
                <path d="M89 170.2L89 170.2" className="st7"></path>
                <path
                  d="M89 170.2L89 170.1 89 170.1 89 170.1 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2"
                  className="st7"
                ></path>
                <path
                  d="M89 170.2L89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2 89 170.2"
                  className="st7"
                ></path>
                <path
                  d="M88.6 171L88.6 170.8 88.6 170.7 88.6 170.6 88.6 170.6 88.7 170.5 88.7 170.5 88.7 170.4 88.7 170.4 88.8 170.3 88.8 170.3 88.8 170.2 88.9 170.2 88.9 170.2 88.9 170.2 89 170.2 89 170.2 89 170.2"
                  className="st7"
                ></path>
                <path
                  d="M88.5 171.5L88.5 171.5 88.5 171.4 88.5 171.4 88.5 171.4 88.5 171.4"
                  className="st7"
                ></path>
                <path d="M88.6 171.5L88.6 171.5" className="st7"></path>
                <path d="M88.7 171.2L89.3 171.2" className="st7"></path>
                <path d="M88.6 171.4L88.5 171.4" className="st7"></path>
                <path d="M88.6 171.4L89.2 171.4" className="st7"></path>
                <path d="M88.6 171.4L89.2 171.4" className="st7"></path>
                <path d="M89.1 170.2L89.3 170.2" className="st7"></path>
                <path d="M89 170.2L89.3 170.2" className="st7"></path>
                <path d="M89.3 170L89.3 170" className="st7"></path>
                <path d="M88.6 171.3L88.6 171.3" className="st7"></path>
                <path
                  d="M89.6 171.6L89.7 171.6 89.7 171.5 89.7 171.5 89.7 171.5 89.7 171.5 89.7 171.5 89.7 171.5 89.7 171.5 89.8 171.5 89.8 171.5 89.8 171.5"
                  className="st7"
                ></path>
                <path d="M90 171.4L90 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M90 171.4L90 171.4" className="st7"></path>
                <path d="M89.9 171.3L89.3 171.3" className="st7"></path>
                <path d="M89.9 171.3L89.3 171.3" className="st7"></path>
                <path d="M89.9 171.3L89.3 171.3" className="st7"></path>
                <path
                  d="M90 171.4L90 171.4 90 171.4 90 171.4 90 171.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 171.5L89.3 171.5 89.3 171.4 89.3 171.4 89.3 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 171.5L89.3 171.5 89.3 171.4 89.3 171.4 89.3 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 171.4L89.3 171.4 89.3 171.5 89.3 171.5"
                  className="st7"
                ></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.9 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.3 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.6 170.2L89.6 170.2" className="st7"></path>
                <path
                  d="M89.3 170.1L89.6 170.1 89.6 170.2 89.6 170.2"
                  className="st7"
                ></path>
                <path d="M89.2 170L89.4 170" className="st7"></path>
                <path d="M89.4 170" className="st7"></path>
                <path
                  d="M89.1 170L89.4 170 89.4 170 89.4 170 89.4 170 89.5 170 89.5 170 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.6 170.1 89.6 170.1 89.6 170.1 89.6 170.1 89.6 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89.5 170.1L89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.5 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170 89.4 170 89.4 170 89.4 170 89.4 170 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89.4 170.1L89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170.1 89.3 170 89.3 170 89.3 170 89.3 170"
                  className="st7"
                ></path>
                <path
                  d="M89.4 170.1L89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.4 170.1 89.5 170.1 89.5 170.1 89.5 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89.3 170.1L89.3 170.1 89.3 170.1 89.3 170.1"
                  className="st7"
                ></path>
                <path
                  d="M89.3 171.5L89.3 171.5 89.3 171.4 89.3 171.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.6L89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 90 171.6 90 171.6 90 171.6 90 171.6 90 171.6 90 171.6 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.4 90 171.4 90 171.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.4L90 171.4 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 89.9 171.5 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.8 171.6 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.9 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.5L89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.8 171.5 89.8 171.5 89.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.5L89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.6L89.9 171.6 89.9 171.6 89.8 171.6 89.8 171.6 89.8 171.6 89.8 171.6 89.8 171.6 89.8 171.6 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.5L89.8 171.5 89.8 171.5 89.8 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.9 171.5 89.8 171.5 89.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.5L89.9 171.4 89.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M89.8 171.5L89.8 171.5 89.8 171.5 89.8 171.4 89.8 171.4 89.8 171.4 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.5L89.9 171.5 89.9 171.5 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6"
                  className="st7"
                ></path>
                <path
                  d="M89.8 171.5L89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.5 89.8 171.6 89.8 171.6 89.8 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 89.9 171.6 90 171.6 90 171.6 90 171.6 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.5 90 171.4 90 171.4 90 171.4 90 171.4 90 171.4 90 171.4 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.3 89.9 171.3"
                  className="st7"
                ></path>
                <path
                  d="M89.6 170.2L89.6 170.2 89.7 170.3 89.7 170.3 89.8 170.4 89.8 170.5 89.8 170.6 89.9 170.7 89.9 170.9 89.9 171"
                  className="st7"
                ></path>
                <path
                  d="M90 171.4L90 171.4 90 171.4 90 171.4 90 171.4 90 171.3 90 171.3 90 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.4 89.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.4L89.9 171.4 89.9 171.4"
                  className="st7"
                ></path>
                <path d="M89.9 171L89.9 171" className="st7"></path>
                <path
                  d="M89.9 171L89.9 171 90 171 90 171 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171L89.9 171 90 171 90 171 90 171 90 171.1 90 171.1 90 171.1 90 171.1 90 171.1 90 171.1 90 171.1 90 171.2 90 171.2 90 171.2 90 171.2 90 171.2 90 171.2 90 171.2 90 171.2 90 171.3 90 171.3 90 171.3 90 171.3 90 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.1 89.9 171.1 89.9 171.1 90 171.1 90 171.1 90 171.1 90 171.1 90 171.1 90 171 89.9 171 89.9 171 89.9 171"
                  className="st7"
                ></path>
                <path
                  d="M90 171.3L89.9 171.3 89.9 171.3 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M90 171.1L89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171L89.9 171 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171 89.9 171 89.9 171"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171L89.9 171 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.1L89.9 171.1 89.9 171.1 89.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.1L89.9 171.1 89.9 171.1 89.9 171.1"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171L89.9 171 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171 89.9 171 89.9 171 89.9 171"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.1L89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.2 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171.1 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171 89.9 171"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.4L89.8 171.4 89.8 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.3 89.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171.4L89.9 171.4 89.9 171.4"
                  className="st7"
                ></path>
                <path d="M89.9 171.3L89.9 171.3" className="st7"></path>
                <path
                  d="M89.9 171.4L89.9 171.4 89.9 171.4 89.9 171.4"
                  className="st7"
                ></path>
                <path d="M89.5 170.2L89.5 170.2" className="st7"></path>
                <path
                  d="M89.5 170.2L89.5 170.2 89.5 170.2 89.5 170.2"
                  className="st7"
                ></path>
                <path d="M89.6 170.2L89.6 170.2" className="st7"></path>
                <path d="M89.5 170.2L89.5 170.2" className="st7"></path>
                <path
                  d="M89.6 170.2L89.6 170.1 89.5 170.1 89.5 170.2 89.5 170.2 89.5 170.2 89.5 170.2 89.5 170.2 89.5 170.2 89.5 170.2 89.6 170.2 89.6 170.2 89.6 170.2"
                  className="st7"
                ></path>
                <path
                  d="M89.6 170.2L89.5 170.2 89.5 170.2 89.5 170.2 89.5 170.2 89.5 170.2 89.5 170.2 89.6 170.2 89.6 170.2"
                  className="st7"
                ></path>
                <path
                  d="M89.9 171L89.9 170.8 89.9 170.7 89.9 170.6 89.9 170.6 89.9 170.5 89.9 170.5 89.8 170.4 89.8 170.4 89.8 170.3 89.7 170.3 89.7 170.2 89.7 170.2 89.7 170.2 89.6 170.2 89.6 170.2 89.6 170.2 89.6 170.2"
                  className="st7"
                ></path>
                <path
                  d="M90 171.5L90 171.4 90 171.4 90 171.4 90 171.4"
                  className="st7"
                ></path>
                <path d="M90 171.5L89.9 171.5" className="st7"></path>
                <path d="M89.9 171.2L89.3 171.2" className="st7"></path>
                <path d="M90 171.4L90 171.4" className="st7"></path>
                <path d="M89.9 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.9 171.4L89.3 171.4" className="st7"></path>
                <path d="M89.5 170.2L89.3 170.2" className="st7"></path>
                <path d="M89.5 170.2L89.3 170.2" className="st7"></path>
                <path d="M89.3 170L89.3 170" className="st7"></path>
                <path d="M89.9 171.3L89.9 171.3" className="st7"></path>
                <path d="M89.4 170L89.4 170 89.3 170" className="st7"></path>
                <path d="M89.3 170L89.3 170" className="st7"></path>
                <path
                  d="M89.3 170L89.3 169.9 89.3 169.9"
                  className="st7"
                ></path>
                <path d="M89.4 169.9L89.3 169.9" className="st7"></path>
                <path d="M89.3 169.9L89.3 169.9" className="st7"></path>
                <path d="M89.4 169.9L89.4 169.9" className="st7"></path>
                <path
                  d="M89.3 170L89.3 170 89.3 170 89.3 170 89.4 170"
                  className="st7"
                ></path>
                <path d="M89.2 170L89.2 170 89.3 170" className="st7"></path>
                <path d="M89.2 170L89.3 170" className="st7"></path>
                <path
                  d="M89.2 170L89.2 169.9 89.3 169.9"
                  className="st7"
                ></path>
                <path d="M89.2 169.9L89.3 169.9" className="st7"></path>
                <path d="M89.2 169.9L89.2 169.9" className="st7"></path>
                <path d="M89.2 169.9L89.2 169.9" className="st7"></path>
                <path
                  d="M89.2 170L89.2 170 89.2 170 89.2 170 89.2 170 89.2 170"
                  className="st7"
                ></path>
                <path
                  d="M89.4 169.9L89.4 169.9 89.4 169.9 89.4 169.9 89.4 169.9 89.4 169.9 89.4 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.4 169.8L89.4 169.8 89.4 169.8 89.4 169.8 89.4 169.8 89.4 169.9 89.4 169.9 89.4 169.8 89.4 169.8 89.4 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.4 169.8L89.4 169.8 89.4 169.9 89.3 169.9 89.3 169.9 89.3 169.8 89.3 169.8 89.3 169.8 89.4 169.8 89.4 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.3 169.8L89.3 169.8 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.8 89.3 169.8 89.3 169.8 89.3 169.8 89.3 169.8 89.3 169.8 89.3 169.8 89.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.4 169.8L89.4 169.8 89.3 169.8 89.3 169.8 89.3 169.8 89.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.4 169.8L89.4 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.4 169.9L89.4 169.8 89.4 169.8 89.4 169.9 89.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.3 169.9L89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.9L89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.8L89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.9 89.2 169.9 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.8L89.2 169.8 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.8L89.2 169.8 89.2 169.9 89.3 169.9 89.3 169.9 89.3 169.8 89.3 169.8 89.3 169.8 89.3 169.8 89.2 169.8 89.2 169.8 89.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.8L89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8 89.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.8L89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.2 169.9 89.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.9L89.2 169.8 89.2 169.8 89.2 169.9 89.2 169.9 89.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.2 169.9L89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9 89.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M89.3 169.7L89.3 169.7 89.3 169.7 89.3 169.7 89.3 169.7 89.3 169.7 89.3 169.7 89.3 169.7 89.4 169.7 89.4 169.7 89.4 169.8 89.4 169.8 89.4 169.8 89.4 169.8 89.4 169.8 89.4 169.8 89.4 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.3 169.8L89.3 169.8 89.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.3 169.7L89.3 169.7 89.2 169.7 89.2 169.7 89.2 169.7 89.2 169.7 89.2 169.7 89.2 169.7 89.2 169.7 89.2 169.7 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8 89.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 172.3L89.4 172.3 89.4 172.2"
                  className="st7"
                ></path>
                <path d="M89.4 172.2L89.4 172.2" className="st7"></path>
                <path d="M89.4 172.2" className="st7"></path>
                <path d="M89.2 172.3L89.2 172.2" className="st7"></path>
                <path
                  d="M89.2 172.2L89.2 172.2 89.2 172.2"
                  className="st7"
                ></path>
                <path d="M89.2 172.2" className="st7"></path>
                <path d="M89.4 172.2L89.2 172.2" className="st7"></path>
                <path d="M89.4 172.2L89.2 172.2" className="st7"></path>
                <path d="M89.4 172.1L89.2 172.1" className="st7"></path>
                <path
                  d="M89.4 172.2s0-.1 0 0M89.2 172.1c0 .1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M89.4 172.1L89.4 172.1 89.2 172.1 89.2 172.1"
                  className="st7"
                ></path>
                <path d="M89.4 172.1" className="st7"></path>
                <path d="M89.3 172.1L89.2 172.1" className="st7"></path>
                <path d="M89.3 172.1L89.2 172.1" className="st7"></path>
                <path d="M89.2 172" className="st7"></path>
                <path
                  d="M89.5 172.8L89.5 172.8 89.4 172.8 89.4 172.7 89.4 172.7 89.4 172.7 89.4 172.7 89.4 172.7 89.4 172.7 89.4 172.7 89.4 172.7 89.4 172.7 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.3"
                  className="st7"
                ></path>
                <path d="M89.3 172.3L89.3 173.1" className="st7"></path>
                <path d="M89.2 172.3L89.2 173.1" className="st7"></path>
                <path d="M89.2 172.1L89.4 172.1" className="st7"></path>
                <path d="M89.2 172.1L89.2 172 89.3 172" className="st7"></path>
                <path
                  d="M89.2 172L89.2 172 89.2 172 89.2 172 89.2 172 89.2 172 89.3 172"
                  className="st7"
                ></path>
                <path d="M89.2 172L89.2 172 89.3 172" className="st7"></path>
                <path
                  d="M89.2 172L89.2 172 89.2 172 89.2 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89.1 171.9 89 171.9 89 171.9 89 171.9 89 171.9 89 171.9 89 171.9 89 171.9 88.9 171.9 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.8 88.9 171.7 88.9 171.7 88.9 171.7 88.9 171.7 88.9 171.7 88.9 171.7 89.3 171.7"
                  className="st7"
                ></path>
                <path d="M88.9 171.7L89.3 171.7" className="st7"></path>
                <path d="M88.9 171.7" className="st7"></path>
                <path d="M89.3 171.6L88.9 171.6" className="st7"></path>
                <path
                  d="M89.3 171.6L88.9 171.6 88.9 171.6"
                  className="st7"
                ></path>
                <path d="M88.9 171.6L88.9 171.6" className="st7"></path>
                <path
                  d="M88.9 171.7L88.9 171.7 88.9 171.7 88.9 171.7 89 171.7 89 171.7 89 171.7 89 171.7 89 171.6 89 171.6 89 171.6 89 171.6 88.9 171.6 88.9 171.6"
                  className="st7"
                ></path>
                <path
                  d="M89 171.7L89 171.7 89 171.7 89 171.7 89 171.7 89 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89 171.7L89 171.7 89 171.7 89 171.7 89 171.7 89 171.7"
                  className="st7"
                ></path>
                <path d="M89 171.7L89 171.7" className="st7"></path>
                <path
                  d="M89 171.7L89 171.7 89 171.7 89 171.7 89 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89 171.7L89 171.7 89 171.7 89 171.7 89 171.7"
                  className="st7"
                ></path>
                <path d="M89 171.7L89 171.7" className="st7"></path>
                <path
                  d="M89 171.7L89 171.7 89 171.7 89 171.7 89 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.1 171.7L89.1 171.7 89.1 171.7 89.1 171.7 89.1 171.7"
                  className="st7"
                ></path>
                <path d="M89.1 171.7L89.1 171.7" className="st7"></path>
                <path
                  d="M89.1 171.7L89.1 171.7 89.1 171.7 89.1 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.1 171.7L89.1 171.7 89.1 171.7 89.1 171.7"
                  className="st7"
                ></path>
                <path d="M89.1 171.7L89.1 171.7" className="st7"></path>
                <path
                  d="M89.1 171.7L89.1 171.7 89.1 171.7 89.1 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 171.7L89.2 171.7 89.2 171.7 89.2 171.7"
                  className="st7"
                ></path>
                <path d="M89.2 171.7" className="st7"></path>
                <path
                  d="M89.2 171.7L89.2 171.7 89.2 171.7 89.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 171.7L89.2 171.7 89.2 171.7 89.2 171.7"
                  className="st7"
                ></path>
                <path d="M89.2 171.7" className="st7"></path>
                <path d="M89.3 171.7L89.3 171.7" className="st7"></path>
                <path d="M89.3 171.6" className="st7"></path>
                <path d="M89.3 171.7L89.3 171.7" className="st7"></path>
                <path d="M89.4 172.1L89.4 172 89.3 172" className="st7"></path>
                <path
                  d="M89.4 172L89.4 172 89.4 172 89.4 172 89.4 172 89.4 172 89.4 172 89.3 172"
                  className="st7"
                ></path>
                <path d="M89.4 172L89.4 172 89.3 172" className="st7"></path>
                <path
                  d="M89.4 172L89.4 172 89.4 171.9 89.4 171.9 89.4 171.9 89.4 171.9 89.4 171.9 89.5 171.9 89.5 171.9 89.5 171.9 89.5 171.9 89.5 171.9 89.5 171.9 89.5 171.9 89.5 171.9 89.5 171.9 89.6 171.9 89.6 171.9 89.6 171.9 89.6 171.9 89.6 171.9 89.6 171.9 89.6 171.9 89.6 171.8 89.6 171.8 89.6 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.8 89.7 171.7 89.7 171.7 89.7 171.7 89.7 171.7 89.7 171.7 89.3 171.7"
                  className="st7"
                ></path>
                <path d="M89.7 171.7L89.3 171.7" className="st7"></path>
                <path d="M89.7 171.7" className="st7"></path>
                <path d="M89.3 171.6L89.6 171.6" className="st7"></path>
                <path
                  d="M89.3 171.6L89.6 171.6 89.6 171.6"
                  className="st7"
                ></path>
                <path d="M89.6 171.6L89.6 171.6" className="st7"></path>
                <path
                  d="M89.6 171.7L89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.6 89.6 171.6 89.6 171.6 89.6 171.6 89.6 171.6 89.6 171.6 89.6 171.6"
                  className="st7"
                ></path>
                <path
                  d="M89.6 171.7L89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.6 171.7L89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7"
                  className="st7"
                ></path>
                <path d="M89.6 171.7L89.6 171.7" className="st7"></path>
                <path
                  d="M89.6 171.7L89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7 89.6 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.6 171.7L89.6 171.7 89.5 171.7 89.5 171.7"
                  className="st7"
                ></path>
                <path d="M89.6 171.7L89.6 171.7" className="st7"></path>
                <path
                  d="M89.5 171.7L89.5 171.7 89.5 171.7 89.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.5 171.7L89.5 171.7 89.5 171.7 89.5 171.7 89.5 171.7"
                  className="st7"
                ></path>
                <path d="M89.5 171.7L89.5 171.7" className="st7"></path>
                <path
                  d="M89.5 171.7L89.5 171.7 89.5 171.7 89.5 171.7 89.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.5 171.7L89.5 171.7 89.4 171.7 89.4 171.7 89.4 171.7"
                  className="st7"
                ></path>
                <path d="M89.5 171.7L89.5 171.7" className="st7"></path>
                <path
                  d="M89.4 171.7L89.4 171.7 89.4 171.7 89.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.4 171.7L89.4 171.7 89.4 171.7 89.4 171.7 89.4 171.7"
                  className="st7"
                ></path>
                <path d="M89.4 171.6" className="st7"></path>
                <path
                  d="M89.4 171.7L89.4 171.7 89.4 171.7 89.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 171.7L89.3 171.7 89.3 171.7 89.3 171.7"
                  className="st7"
                ></path>
                <path d="M89.4 171.6" className="st7"></path>
                <path d="M89.3 171.7L89.3 171.7" className="st7"></path>
                <path d="M89.3 171.6" className="st7"></path>
                <path d="M89.3 171.7L89.3 171.7" className="st7"></path>
                <path
                  d="M89.4 172.3c.1 0 .1-.1.1-.2s0-.1-.1-.2M89.1 171.9c-.1 0-.1.1-.1.2s0 .1.1.2"
                  className="st7"
                ></path>
                <path
                  d="M89.3 172.6L89.4 172.6 89.4 172.6 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.3 172.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 172.4L89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.3 172.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 172.3L89.4 172.3 89.4 172.3 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 172.3L89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.3 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.4 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.5 89.4 172.6 89.4 172.6"
                  className="st7"
                ></path>
                <path
                  d="M89.3 172.5L89.4 172.5 89.4 172.5 89.4 172.6 89.3 172.6"
                  className="st7"
                ></path>
                <path
                  d="M89.4 172.7L89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.4 172.6 89.3 172.6 89.3 172.6 89.3 172.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 172.7L89.3 172.7 89.3 172.7 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.5 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8 89.4 172.8"
                  className="st7"
                ></path>
                <path
                  d="M89.1 172.8L89.1 172.8 89.1 172.8 89.1 172.8 89.2 172.7 89.2 172.7 89.2 172.7 89.2 172.7 89.2 172.7 89.2 172.7 89.2 172.7 89.2 172.7 89.2 172.7 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.1 172.4 89.1 172.4 89.2 172.4 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.2"
                  className="st7"
                ></path>
                <path
                  d="M89.2 172.6L89.2 172.6 89.2 172.6 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5"
                  className="st7"
                ></path>
                <path
                  d="M89.2 172.3L89.2 172.3 89.2 172.3 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 172.3L89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.3 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.4 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.5 89.2 172.6 89.2 172.6"
                  className="st7"
                ></path>
                <path
                  d="M89.2 172.5L89.2 172.5 89.2 172.6"
                  className="st7"
                ></path>
                <path
                  d="M89.2 172.7L89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.6 89.2 172.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 172.7L89.2 172.7 89.2 172.7 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.1 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8 89.2 172.8"
                  className="st7"
                ></path>
                <path d="M89.4 173.7L89.2 173.7" className="st7"></path>
                <path
                  d="M89.4 173.7L89.4 173.7 89.4 173.6 89.4 173.6 89.4 173.6 89.4 173.6 89.4 173.6 89.4 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.7 89.2 173.7"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.7L89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.5 173.7 89.5 173.7 89.5 173.7 89.5 173.7 89.4 173.7 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.8 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.7L89.4 173.7 89.4 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.7L89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.4 173.7 89.4 173.8 89.4 173.8 89.3 173.8 89.3 173.8 89.3 173.8 89.3 173.8 89.3 173.8 89.3 173.8 89.3 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.8 89.3 173.8 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7 89.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.7L89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.2 173.8 89.1 173.8 89.1 173.8 89.1 173.8 89.1 173.8 89.1 173.7 89.1 173.7 89.1 173.7 89.1 173.7 89.1 173.7 89.1 173.7 89.1 173.7 89.1 173.7 89.1 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.7L89.4 173.7 89.4 173.7 89.4 173.7 89.4 173.7"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.7L89.2 173.7 89.2 173.7 89.2 173.7 89.2 173.7"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.8L89.3 173.8 89.4 173.8"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.8L89.2 173.8 89.2 173.8 89.2 173.8"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.6L89.3 173.6 89.3 173.6 89.4 173.6 89.4 173.5 89.4 173.5 89.4 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.4 89.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.3L89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.3 89.3 173.3 89.3 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.5 89.4 173.5 89.4 173.5"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.1L89.3 173.2 89.3 173.2 89.3 173.2"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.3L89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.2 89.4 173.2 89.4 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.5L89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.4L89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.3L89.4 173.3 89.3 173.3"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.4L89.4 173.4 89.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.5L89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.6 89.3 173.6"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.4L89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.6L89.3 173.6 89.4 173.6 89.4 173.6 89.4 173.6 89.4 173.6 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.6 89.3 173.6 89.3 173.6 89.3 173.6 89.3 173.6 89.3 173.6 89.3 173.6 89.3 173.6 89.3 173.6 89.3 173.6"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.6L89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.6L89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.5 89.1 173.5 89.1 173.5 89.1 173.5 89.1 173.5 89.1 173.5 89.1 173.5 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.2 89.1 173.2 89.1 173.2 89.1 173.2 89.1 173.2 89.1 173.2 89.1 173.2 89.1 173.2 89.2 173.2 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173 89.2 173 89.3 173 89.3 173 89.3 173 89.3 173 89.3 173.1 89.3 173.1 89.3 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.1 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.3 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.1 173.3L89.1 173.3 89.1 173.3 89.1 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.3 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4 89.1 173.4 89.1 173.4 89.1 173.4 89.1 173.5 89.2 173.5 89.2 173.5"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.1L89.2 173.2 89.2 173.2"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.3L89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.2 173.2 89.3 173.2 89.3 173.2"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.5L89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.3 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.4L89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.3 89.2 173.3 89.2 173.3 89.2 173.3 89.3 173.3"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.3L89.2 173.3 89.2 173.3 89.2 173.3"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.4L89.2 173.4 89.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.5L89.2 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.6 89.3 173.6"
                  className="st7"
                ></path>
                <path
                  d="M89.3 173.4L89.3 173.4 89.3 173.4 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M89.2 173.6L89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.4 89.2 173.4 89.2 173.4 89.2 173.4 89.3 173.4 89.3 173.4 89.3 173.4 89.3 173.5 89.3 173.5 89.3 173.5 89.3 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.5 89.2 173.6 89.2 173.6 89.3 173.6 89.3 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.2 173.6 89.3 173.6 89.3 173.6"
                  className="st7"
                ></path>
                <path
                  d="M89.4 173.6L89.4 173.6 89.4 173.6 89.4 173.6 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.5 89.4 173.4 89.4 173.4 89.4 173.4 89.5 173.4 89.5 173.4 89.5 173.4 89.5 173.3 89.5 173.3 89.5 173.3 89.5 173.3 89.5 173.3 89.5 173.3 89.5 173.3 89.4 173.3 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.1 89.4 173.1 89.4 173.1 89.4 173.1 89.4 173.1 89.4 173.1 89.4 173.1 89.4 173.1 89.4 173.1 89.3 173.1 89.3 173.1 89.3 173 89.3 173 89.3 173 89.3 173 89.3 173 89.3 173 89.3 173 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.1 89.3 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.2 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.3 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4 89.4 173.4"
                  className="st7"
                ></path>
                <path d="M202.3 203.9L202.1 203.9" className="st7"></path>
                <path
                  d="M201.9 205.5L201.8 205.5 201.8 205.5 201.8 205.5 201.8 205.5 201.8 205.5 201.8 205.5 201.8 205.5 201.8 205.4 201.7 205.4 201.7 205.4 201.7 205.4"
                  className="st7"
                ></path>
                <path d="M201.5 205.3L201.5 205.3" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path d="M201.5 205.3L201.5 205.3" className="st7"></path>
                <path d="M201.6 205.3L202.2 205.3" className="st7"></path>
                <path d="M201.6 205.2L202.2 205.2" className="st7"></path>
                <path d="M201.6 205.2L202.2 205.2" className="st7"></path>
                <path
                  d="M201.5 205.3L201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M202.1 205.4L202.2 205.4 202.2 205.3 202.1 205.3 202.1 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.2 205.4L202.2 205.4 202.2 205.3 202.2 205.3 202.2 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.2 205.3L202.2 205.3 202.2 205.4 202.2 205.4"
                  className="st7"
                ></path>
                <path d="M202.2 205.4L202.2 205.4" className="st7"></path>
                <path d="M202.2 205.4L202.2 205.4" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.2 205.4L202.2 205.4" className="st7"></path>
                <path d="M202.2 205.3L201.6 205.3" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path d="M201.9 204.1L201.9 204.1" className="st7"></path>
                <path
                  d="M202.2 204.1L201.9 204.1 201.9 204.1 201.9 204.1"
                  className="st7"
                ></path>
                <path d="M202.1 203.9" className="st7"></path>
                <path
                  d="M202.1 203.9L202.1 203.9 202.1 204 202.1 204 202 204 202 204 202 204 202 204 202 204 202 204 202 204 202 204 202 204 202 204 202 204 201.9 204 201.9 204 201.9 204 201.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202 204.1L202 204 202 204 202 204 202 204 202 204 202 204 202 204 202 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.1 204L202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.1 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204"
                  className="st7"
                ></path>
                <path
                  d="M202.1 204.1L202.1 204.1 202.1 204 202.1 204 202.1 204 202.1 204 202 204.1 202 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.2 204.1L202.2 204.1 202.2 204 202.2 204"
                  className="st7"
                ></path>
                <path
                  d="M202.2 205.4L202.2 205.4 202.2 205.3 202.2 205.3"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.5L201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.3 201.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M201.5 205.3L201.5 205.3 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.7 205.5 201.7 205.4 201.7 205.4 201.7 205.4 201.6 205.4 201.6 205.4 201.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.4L201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.7 205.4 201.7 205.4 201.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.4L201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.5L201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.7 205.5 201.7 205.5 201.7 205.5 201.7 205.5 201.7 205.5 201.7 205.5 201.7 205.4 201.7 205.4 201.7 205.4 201.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.4L201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.7 205.4"
                  className="st7"
                ></path>
                <path d="M201.6 205.4L201.6 205.4" className="st7"></path>
                <path
                  d="M201.7 205.4L201.7 205.4 201.7 205.4 201.7 205.4 201.7 205.4 201.7 205.4 201.6 205.4 201.6 205.4 201.6 205.4 201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.4L201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5"
                  className="st7"
                ></path>
                <path
                  d="M201.7 205.4L201.7 205.4 201.7 205.4 201.7 205.4 201.7 205.5 201.7 205.5 201.7 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.6 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.5 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.6 205.3 201.6 205.3"
                  className="st7"
                ></path>
                <path
                  d="M201.9 204.1L201.9 204.2 201.8 204.2 201.8 204.3 201.7 204.3 201.7 204.4 201.6 204.6 201.6 204.7 201.6 204.8 201.6 204.9"
                  className="st7"
                ></path>
                <path
                  d="M201.5 205.3L201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.5 205.3 201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.3 201.5 205.3 201.5 205.3 201.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.3L201.6 205.3 201.6 205.3"
                  className="st7"
                ></path>
                <path d="M201.5 204.9L201.6 204.9" className="st7"></path>
                <path
                  d="M201.5 204.9L201.5 204.9 201.5 204.9 201.5 204.9 201.5 204.9 201.6 204.9 201.6 204.9 201.6 204.9 201.6 204.9 201.6 204.9"
                  className="st7"
                ></path>
                <path
                  d="M201.5 204.9L201.5 204.9 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.2 201.5 205.2 201.5 205.2 201.5 205.2 201.5 205.2 201.5 205.2 201.5 205.2 201.5 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205.1 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 204.9"
                  className="st7"
                ></path>
                <path
                  d="M201.5 205.2L201.5 205.2 201.5 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.1 201.6 205.1"
                  className="st7"
                ></path>
                <path
                  d="M201.5 205L201.5 205 201.5 205 201.5 205.1 201.5 205.1 201.5 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.5 205.1 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.6 205 201.6 205 201.6 204.9 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205 201.5 205 201.5 205 201.5 205 201.5 205 201.5 205 201.6 205 201.6 205"
                  className="st7"
                ></path>
                <path
                  d="M201.6 204.9L201.6 204.9 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.1L201.6 205.1 201.6 205.1 201.6 205.1"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.1L201.6 205.1 201.6 205"
                  className="st7"
                ></path>
                <path
                  d="M201.6 204.9L201.6 204.9 201.6 204.9 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.1L201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205.1 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 205 201.6 204.9 201.6 204.9 201.6 204.9"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.3L201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.3 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2 201.6 205.2"
                  className="st7"
                ></path>
                <path
                  d="M201.6 205.3L201.6 205.3 201.6 205.3"
                  className="st7"
                ></path>
                <path d="M201.5 205.3L201.5 205.2" className="st7"></path>
                <path
                  d="M201.6 205.3L201.6 205.3 201.6 205.3 201.6 205.3"
                  className="st7"
                ></path>
                <path d="M202 204.1L202 204.1" className="st7"></path>
                <path
                  d="M202 204.1L202 204.1 202 204.1 202 204.1"
                  className="st7"
                ></path>
                <path
                  d="M201.9 204.1L201.9 204.1 201.9 204.1"
                  className="st7"
                ></path>
                <path d="M202 204.1L202 204.1" className="st7"></path>
                <path
                  d="M201.9 204.1L201.9 204.1 201.9 204.1 201.9 204.1 202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 201.9 204.1 201.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M201.9 204.1L202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 202 204.1 201.9 204.1 201.9 204.1 201.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M201.5 204.9L201.5 204.7 201.6 204.7 201.6 204.6 201.6 204.5 201.6 204.4 201.6 204.4 201.7 204.3 201.7 204.3 201.7 204.2 201.8 204.2 201.8 204.2 201.8 204.1 201.8 204.1 201.9 204.1 201.9 204.1 201.9 204.1 201.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M201.5 205.4L201.5 205.4 201.5 205.4 201.5 205.4 201.5 205.3"
                  className="st7"
                ></path>
                <path d="M201.5 205.4L201.6 205.4" className="st7"></path>
                <path d="M201.6 205.2L202.2 205.2" className="st7"></path>
                <path d="M201.5 205.3L201.5 205.3" className="st7"></path>
                <path d="M201.5 205.3L202.1 205.3" className="st7"></path>
                <path d="M201.5 205.3L202.1 205.3" className="st7"></path>
                <path d="M202 204.1L202.2 204.1" className="st7"></path>
                <path d="M202 204.1L202.2 204.1" className="st7"></path>
                <path d="M202.2 204L202.2 204" className="st7"></path>
                <path d="M201.6 205.2L201.6 205.3" className="st7"></path>
                <path
                  d="M202.6 205.5L202.6 205.5 202.6 205.5 202.6 205.5 202.6 205.5 202.6 205.5 202.7 205.5 202.7 205.4 202.7 205.4 202.7 205.4 202.8 205.4"
                  className="st7"
                ></path>
                <path d="M203 205.3L203 205.3" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path
                  d="M203 205.3L203 205.3 202.9 205.3"
                  className="st7"
                ></path>
                <path d="M202.8 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.8 205.2L202.2 205.2" className="st7"></path>
                <path d="M202.8 205.2L202.2 205.2" className="st7"></path>
                <path
                  d="M203 205.3L203 205.3 203 205.3 203 205.3 203 205.3"
                  className="st7"
                ></path>
                <path
                  d="M202.3 205.4L202.3 205.4 202.3 205.3 202.3 205.3 202.3 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.2 205.4L202.2 205.4 202.2 205.3 202.2 205.3 202.2 205.4"
                  className="st7"
                ></path>
                <path d="M202.2 205.3L202.2 205.4" className="st7"></path>
                <path d="M202.3 205.4L202.2 205.4" className="st7"></path>
                <path d="M202.2 205.4L202.2 205.4" className="st7"></path>
                <path d="M202.3 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.3 205.4L202.3 205.4" className="st7"></path>
                <path d="M202.2 205.3L202.9 205.3" className="st7"></path>
                <path d="M202.3 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.2 205.3L202.2 205.3" className="st7"></path>
                <path d="M202.5 204.1L202.5 204.1" className="st7"></path>
                <path
                  d="M202.2 204.1L202.5 204.1 202.5 204.1 202.5 204.1"
                  className="st7"
                ></path>
                <path d="M202.1 203.9L202.3 203.9" className="st7"></path>
                <path d="M202.4 203.9" className="st7"></path>
                <path
                  d="M202.1 203.9L202.4 203.9 202.4 203.9 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.5 204 202.5 204 202.5 204 202.5 204 202.5 204 202.5 204 202.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.5 204.1L202.5 204.1 202.5 204 202.5 204 202.5 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.4 204 202.4 204 202.4 204 202.4 204.1 202.3 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.4 204L202.4 204 202.4 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.3 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204 202.2 204"
                  className="st7"
                ></path>
                <path
                  d="M202.4 204.1L202.4 204 202.4 204 202.4 204 202.4 204 202.4 204 202.4 204.1 202.4 204.1 202.4 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.2 204.1L202.2 204.1 202.2 204 202.2 204"
                  className="st7"
                ></path>
                <path d="M202.2 205.4L202.2 205.3" className="st7"></path>
                <path
                  d="M202.8 205.5L202.8 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 203 205.5 203 205.4 203 205.4 203 205.4 203 205.4 203 205.4 203 205.4 203 205.4 203 205.3 203 205.3"
                  className="st7"
                ></path>
                <path
                  d="M202.9 205.3L202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.4L202.8 205.4 202.8 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.4L202.8 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.8 205.4 202.8 205.4 202.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.5L202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.4L202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.9 205.4L202.9 205.4 202.9 205.4 202.9 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.4L202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.3 202.8 205.3 202.9 205.3 202.9 205.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.4L202.8 205.4 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.9 205.5 202.9 205.5 202.9 205.5"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.4L202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.4 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.8 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.5 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.4 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3"
                  className="st7"
                ></path>
                <path
                  d="M202.5 204.1L202.5 204.2 202.6 204.2 202.7 204.3 202.7 204.3 202.8 204.4 202.8 204.6 202.8 204.7 202.8 204.8 202.8 204.9"
                  className="st7"
                ></path>
                <path
                  d="M203 205.3L202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3 202.9 205.3"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.3L202.8 205.3 202.9 205.3"
                  className="st7"
                ></path>
                <path d="M202.9 204.9L202.8 204.9" className="st7"></path>
                <path
                  d="M202.9 204.9L202.9 204.9 202.9 204.9 202.9 204.9 202.9 204.9 202.8 204.9 202.8 204.9 202.8 204.9 202.8 204.9 202.8 204.9"
                  className="st7"
                ></path>
                <path
                  d="M202.9 204.9L202.9 204.9 202.9 204.9 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 204.9"
                  className="st7"
                ></path>
                <path
                  d="M202.9 205.2L202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.2 202.9 205.1 202.9 205.1"
                  className="st7"
                ></path>
                <path
                  d="M202.9 205L202.9 205 202.9 205 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.8 205.1 202.8 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 204.9 202.9 204.9 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205.1 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205 202.9 205"
                  className="st7"
                ></path>
                <path
                  d="M202.9 204.9L202.9 204.9 202.8 204.9 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.9 205.1"
                  className="st7"
                ></path>
                <path
                  d="M202.9 205.1L202.9 205.1 202.8 205.1 202.8 205.1"
                  className="st7"
                ></path>
                <path
                  d="M202.9 205.1L202.8 205.1 202.8 205"
                  className="st7"
                ></path>
                <path
                  d="M202.8 204.9L202.8 204.9 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.1L202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.2 202.8 205.2 202.8 205.2 202.8 205.2 202.8 205.2 202.8 205.2 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205.1 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 205 202.8 204.9 202.8 204.9 202.8 204.9"
                  className="st7"
                ></path>
                <path
                  d="M202.8 205.3L202.8 205.3 202.8 205.3 202.8 205.3 202.8 205.3 202.8 205.3 202.8 205.2 202.8 205.2 202.8 205.2 202.8 205.2 202.8 205.2 202.8 205.2"
                  className="st7"
                ></path>
                <path d="M202.9 205.3L202.9 205.3" className="st7"></path>
                <path d="M202.9 205.3L202.9 205.2" className="st7"></path>
                <path
                  d="M202.9 205.3L202.9 205.3 202.9 205.3"
                  className="st7"
                ></path>
                <path d="M202.4 204.1L202.4 204.1" className="st7"></path>
                <path
                  d="M202.5 204.1L202.4 204.1 202.4 204.1 202.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.5 204.1L202.5 204.1 202.5 204.1"
                  className="st7"
                ></path>
                <path d="M202.5 204.1L202.5 204.1" className="st7"></path>
                <path
                  d="M202.5 204.1L202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.5 204.1L202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1 202.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M202.9 204.9L202.9 204.7 202.9 204.7 202.9 204.6 202.8 204.5 202.8 204.4 202.8 204.4 202.8 204.3 202.7 204.3 202.7 204.2 202.7 204.2 202.7 204.2 202.6 204.1 202.6 204.1 202.6 204.1 202.5 204.1 202.5 204.1 202.5 204.1"
                  className="st7"
                ></path>
                <path
                  d="M203 205.4L203 205.4 203 205.4 203 205.4 203 205.4 203 205.3"
                  className="st7"
                ></path>
                <path d="M202.9 205.4L202.9 205.4" className="st7"></path>
                <path d="M202.8 205.2L202.2 205.2" className="st7"></path>
                <path d="M202.9 205.3L203 205.3" className="st7"></path>
                <path d="M202.9 205.3L202.3 205.3" className="st7"></path>
                <path d="M202.9 205.3L202.3 205.3" className="st7"></path>
                <path d="M202.4 204.1L202.2 204.1" className="st7"></path>
                <path d="M202.5 204.1L202.2 204.1" className="st7"></path>
                <path d="M202.2 204L202.2 204" className="st7"></path>
                <path d="M202.9 205.2L202.9 205.3" className="st7"></path>
                <path d="M202.2 203.9L202.3 203.9" className="st7"></path>
                <path d="M202.3 203.9L202.2 203.9" className="st7"></path>
                <path
                  d="M202.3 203.9L202.3 203.9 202.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.9L202.3 203.9 202.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.9L202.3 203.9 202.3 203.9 202.3 203.9"
                  className="st7"
                ></path>
                <path d="M202.2 203.9L202.1 203.9" className="st7"></path>
                <path d="M202.1 203.9L202.2 203.9" className="st7"></path>
                <path
                  d="M202.1 203.9L202.1 203.9 202.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M202.1 203.9L202.1 203.9 202.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M202.1 203.9L202.2 203.9 202.2 203.9 202.1 203.9 202.1 203.9"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.9L202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.7L202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.8L202.3 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.7 202.2 203.7 202.2 203.7 202.3 203.7 202.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.7L202.3 203.7 202.3 203.7 202.3 203.7 202.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.8L202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.3 203.8 202.2 203.8 202.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 203.8L202.3 203.8 202.3 203.8 202.3 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 203.9L202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.1 203.9L202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.1 203.7L202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.7 202.1 203.7 202.2 203.7 202.2 203.8 202.2 203.8 202.2 203.8 202.1 203.8 202.1 203.8 202.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 203.8L202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.7 202.2 203.7 202.2 203.7 202.2 203.7 202.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 203.7L202.1 203.7 202.2 203.7 202.2 203.7 202.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 203.8L202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.1 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.1 203.8L202.1 203.8 202.1 203.8 202.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 203.9L202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8 202.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 203.6L202.2 203.6 202.2 203.6 202.3 203.6 202.3 203.6 202.3 203.6 202.3 203.6 202.3 203.6 202.3 203.6 202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.7 202.3 203.7"
                  className="st7"
                ></path>
                <path
                  d="M202.2 203.7L202.2 203.7 202.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M202.2 203.6L202.2 203.6 202.2 203.6 202.2 203.6 202.2 203.6 202.2 203.6 202.1 203.6 202.1 203.6 202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.7 202.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.2L202.3 206.2 202.3 206.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.1L202.3 206.2 202.3 206.2"
                  className="st7"
                ></path>
                <path d="M202.3 206.1" className="st7"></path>
                <path d="M202.1 206.2L202.1 206.2" className="st7"></path>
                <path
                  d="M202.1 206.1L202.1 206.2 202.1 206.2"
                  className="st7"
                ></path>
                <path d="M202.2 206.2" className="st7"></path>
                <path d="M202.3 206.2L202.1 206.2" className="st7"></path>
                <path d="M202.3 206.1L202.1 206.1" className="st7"></path>
                <path d="M202.3 206.1L202.1 206.1" className="st7"></path>
                <path
                  d="M202.3 206.1c.1 0 .1 0 0 0 .1 0 .1-.1 0 0 0-.1 0-.1 0 0M202.1 206s0 .1 0 0c0 .1 0 .1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.1L202.3 206 202.1 206 202.1 206.1"
                  className="st7"
                ></path>
                <path d="M202.3 206" className="st7"></path>
                <path d="M202.3 206L202.1 206" className="st7"></path>
                <path d="M202.3 206L202.1 206" className="st7"></path>
                <path d="M202.2 206" className="st7"></path>
                <path
                  d="M202.4 206.7L202.4 206.7 202.4 206.7 202.4 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.6 202.3 206.6 202.3 206.6 202.3 206.6 202.3 206.6 202.3 206.6 202.3 206.6 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.4 206.4 202.4 206.3 202.4 206.3 202.4 206.3 202.4 206.3 202.4 206.3 202.4 206.3 202.3 206.3 202.3 206.3 202.3 206.2 202.3 206.2 202.3 206.2 202.3 206.2 202.3 206.2 202.3 206.2"
                  className="st7"
                ></path>
                <path d="M202.3 206.2L202.3 207" className="st7"></path>
                <path d="M202.1 206.2L202.1 207" className="st7"></path>
                <path d="M202.1 206L202.3 206" className="st7"></path>
                <path d="M202.1 206L202.1 206 202.2 206" className="st7"></path>
                <path
                  d="M202.1 206L202.1 205.9 202.1 205.9 202.1 205.9 202.1 205.9 202.1 205.9 202.2 205.9"
                  className="st7"
                ></path>
                <path
                  d="M202.1 205.9L202.1 205.9 202.2 205.9"
                  className="st7"
                ></path>
                <path
                  d="M202.1 205.9L202.1 205.9 202.1 205.9 202.1 205.9 202.1 205.8 202.1 205.8 202.1 205.8 202 205.8 202 205.8 202 205.8 202 205.8 202 205.8 202 205.8 202 205.8 202 205.8 202 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.9 205.8 201.8 205.8 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.7 201.8 205.6 201.8 205.6 201.8 205.6 202.2 205.6"
                  className="st7"
                ></path>
                <path d="M201.9 205.6L202.2 205.6" className="st7"></path>
                <path d="M201.9 205.6" className="st7"></path>
                <path d="M202.2 205.5L201.9 205.5" className="st7"></path>
                <path
                  d="M202.2 205.5L201.9 205.5 201.9 205.5"
                  className="st7"
                ></path>
                <path
                  d="M201.9 205.6L201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.5 201.9 205.5 201.9 205.5 201.9 205.5"
                  className="st7"
                ></path>
                <path
                  d="M201.9 205.6L201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M201.9 205.6L201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M201.9 205.6L201.9 205.6 201.9 205.6 201.9 205.6 201.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M201.9 205.6L201.9 205.6 202 205.6 202 205.6 202 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202 205.6L202 205.6 202 205.6 202 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202 205.6L202 205.6 202 205.6 202 205.6 202 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202 205.6L202 205.6 202 205.6 202 205.6 202 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202 205.6L202.1 205.6 202.1 205.6 202.1 205.6 202.1 205.6"
                  className="st7"
                ></path>
                <path d="M202 205.6L202 205.6" className="st7"></path>
                <path
                  d="M202.1 205.6L202.1 205.6 202.1 205.6 202.1 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.1 205.6L202.1 205.6 202.1 205.6"
                  className="st7"
                ></path>
                <path d="M202.1 205.6" className="st7"></path>
                <path
                  d="M202.1 205.6L202.1 205.6 202.1 205.6 202.1 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.2 205.6L202.2 205.6 202.2 205.6"
                  className="st7"
                ></path>
                <path d="M202.2 205.6" className="st7"></path>
                <path d="M202.2 205.6L202.2 205.6" className="st7"></path>
                <path d="M202.2 205.6" className="st7"></path>
                <path d="M202.2 205.6L202.2 205.6" className="st7"></path>
                <path d="M202.3 206L202.3 206 202.2 206" className="st7"></path>
                <path
                  d="M202.3 206L202.3 205.9 202.3 205.9 202.3 205.9 202.3 205.9 202.3 205.9 202.3 205.9 202.2 205.9"
                  className="st7"
                ></path>
                <path
                  d="M202.3 205.9L202.3 205.9 202.2 205.9"
                  className="st7"
                ></path>
                <path
                  d="M202.3 205.9L202.3 205.9 202.3 205.9 202.4 205.9 202.4 205.8 202.4 205.8 202.4 205.8 202.4 205.8 202.4 205.8 202.4 205.8 202.4 205.8 202.4 205.8 202.4 205.8 202.4 205.8 202.5 205.8 202.5 205.8 202.5 205.8 202.5 205.8 202.5 205.8 202.5 205.8 202.5 205.8 202.5 205.8 202.5 205.8 202.6 205.8 202.6 205.8 202.6 205.8 202.6 205.8 202.6 205.8 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.7 202.6 205.6 202.6 205.6 202.6 205.6 202.2 205.6"
                  className="st7"
                ></path>
                <path d="M202.6 205.6L202.2 205.6" className="st7"></path>
                <path d="M202.6 205.6" className="st7"></path>
                <path d="M202.2 205.5L202.6 205.5" className="st7"></path>
                <path
                  d="M202.2 205.5L202.6 205.5 202.6 205.5"
                  className="st7"
                ></path>
                <path
                  d="M202.6 205.6L202.6 205.6 202.6 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.5 202.5 205.5 202.6 205.5 202.6 205.5"
                  className="st7"
                ></path>
                <path
                  d="M202.5 205.6L202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.5 205.6L202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.5 205.6L202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.5 205.6L202.5 205.6 202.5 205.6 202.5 205.6 202.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.5 205.6L202.5 205.6 202.5 205.6 202.5 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.5 205.6L202.4 205.6 202.4 205.6 202.4 205.6 202.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.4 205.6L202.4 205.6 202.4 205.6 202.4 205.6 202.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.4 205.6L202.4 205.6 202.4 205.6 202.4 205.6 202.4 205.6"
                  className="st7"
                ></path>
                <path d="M202.4 205.6L202.4 205.6" className="st7"></path>
                <path
                  d="M202.4 205.6L202.4 205.6 202.4 205.6 202.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 205.6L202.3 205.6 202.3 205.6"
                  className="st7"
                ></path>
                <path d="M202.4 205.6" className="st7"></path>
                <path
                  d="M202.3 205.6L202.3 205.6 202.3 205.6 202.3 205.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 205.6L202.3 205.6 202.3 205.6"
                  className="st7"
                ></path>
                <path d="M202.3 205.6" className="st7"></path>
                <path d="M202.2 205.6L202.2 205.6" className="st7"></path>
                <path d="M202.2 205.6" className="st7"></path>
                <path d="M202.2 205.6L202.2 205.6" className="st7"></path>
                <path
                  d="M202.3 206.2c.1 0 .1-.1.1-.2s0-.2-.1-.2M202.1 205.9c-.1 0-.1.1-.1.2s0 .1.1.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.5L202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.3L202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.2L202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.2L202.3 206.2 202.3 206.2 202.3 206.2 202.3 206.2 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.3 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.4 202.3 206.5 202.3 206.5 202.3 206.5"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.4L202.3 206.5 202.3 206.5 202.3 206.5"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.6L202.3 206.6 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.5 202.3 206.6 202.3 206.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 206.7L202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.8 202.3 206.8 202.3 206.8 202.4 206.8 202.4 206.8 202.4 206.8 202.4 206.8 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.4 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7 202.3 206.7"
                  className="st7"
                ></path>
                <path
                  d="M202 206.7L202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.6 202.1 206.6 202.1 206.6 202.1 206.6 202.1 206.6 202.1 206.6 202.1 206.6 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.2 202.1 206.2 202.1 206.2 202.1 206.2 202.1 206.2 202.1 206.2 202.1 206.2"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.5L202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.3L202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.2L202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.2L202.1 206.2 202.1 206.2 202.1 206.2 202.1 206.2 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.3 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.4 202.1 206.5 202.1 206.5 202.1 206.5"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.4L202.1 206.5 202.1 206.5 202.1 206.5"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.6L202.1 206.6 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.5 202.1 206.6 202.1 206.6"
                  className="st7"
                ></path>
                <path
                  d="M202.1 206.7L202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.8 202.1 206.8 202.1 206.8 202.1 206.8 202.1 206.8 202.1 206.8 202 206.8 202 206.7 202 206.7 202 206.7 202 206.7 202 206.7 202 206.7 202 206.7 202 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7 202.1 206.7"
                  className="st7"
                ></path>
                <path d="M202.3 207.6L202.1 207.6" className="st7"></path>
                <path
                  d="M202.3 207.6L202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.5 202.3 207.5 202.3 207.5 202.3 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.6L202.3 207.6 202.3 207.6 202.4 207.6 202.4 207.6 202.4 207.6 202.4 207.6 202.4 207.6 202.4 207.6 202.4 207.7 202.4 207.7 202.4 207.7 202.4 207.7 202.4 207.7 202.4 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.6L202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6 202.3 207.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.6L202.3 207.6 202.2 207.6 202.2 207.6 202.3 207.6 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.3 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.2 207.7 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.1 207.6 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.7 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.2 207.6 202.3 207.6 202.3 207.6"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.6L202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.2 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202.1 207.7 202 207.7 202 207.7 202 207.6 202 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6 202.1 207.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.7L202.3 207.7 202.3 207.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.7L202.1 207.7 202.1 207.7 202.1 207.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.7L202.3 207.7 202.3 207.7"
                  className="st7"
                ></path>
                <path
                  d="M202.2 207.7L202.1 207.7 202.1 207.7 202.1 207.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.5L202.3 207.5 202.3 207.5 202.3 207.5 202.3 207.5 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.2 207.4 202.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M202.4 207.3L202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.4 207.3 202.4 207.3 202.4 207.4 202.4 207.4 202.4 207.4 202.4 207.4 202.4 207.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.1L202.3 207.1 202.3 207.1 202.3 207.1"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.2L202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.2 207.1 202.2 207.1 202.2 207.1"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.5L202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.2 202.2 207.2 202.2 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.2 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.4 207.3"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.4L202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.3 202.3 207.2 202.2 207.2 202.2 207.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.2L202.3 207.2 202.3 207.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.3L202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.4L202.3 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.5 202.2 207.5"
                  className="st7"
                ></path>
                <path
                  d="M202.2 207.4L202.2 207.4 202.2 207.4 202.2 207.3 202.2 207.3 202.2 207.3 202.3 207.3 202.3 207.3 202.3 207.3"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.5L202.3 207.5 202.3 207.5 202.3 207.5 202.3 207.5 202.3 207.5 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.3 207.4 202.3 207.4 202.3 207.4 202.3 207.5 202.3 207.5 202.3 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.3 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5"
                  className="st7"
                ></path>
                <path
                  d="M202.2 207.5L202.2 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.4 202.1 207.4 202.1 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.5L202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202 207.3 202 207.3 202 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207 202.1 207 202.1 207 202.1 207 202.1 207 202.1 207 202.1 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.4 202.1 207.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.3L202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.1 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.2 202.2 207.2 202.2 207.2 202.2 207.2 202.2 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4"
                  className="st7"
                ></path>
                <path
                  d="M202.2 207.1L202.2 207.1 202.2 207.1 202.2 207.1"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.2L202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.1 202.1 207.1 202.1 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1 202.2 207.1"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.5L202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.3 202.1 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.2 202.2 207.2 202.2 207.2 202.2 207.2 202.2 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.2 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.4L202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.1 207.3 202.2 207.2 202.2 207.2 202.2 207.2"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.2L202.1 207.2 202.2 207.2"
                  className="st7"
                ></path>
                <path
                  d="M202.1 207.3L202.1 207.4 202.1 207.4 202.1 207.4 202.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M202.2 207.4L202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.5 202.2 207.5"
                  className="st7"
                ></path>
                <path
                  d="M202.2 207.4L202.2 207.4 202.2 207.4 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.3 202.2 207.3"
                  className="st7"
                ></path>
                <path
                  d="M202.2 207.5L202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.5 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.1 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.4 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5 202.2 207.5"
                  className="st7"
                ></path>
                <path
                  d="M202.3 207.5L202.3 207.5 202.3 207.5 202.3 207.5 202.4 207.5 202.4 207.5 202.4 207.4 202.4 207.4 202.4 207.4 202.4 207.4 202.4 207.4 202.4 207.4 202.4 207.4 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.1 202.4 207.1 202.4 207.1 202.4 207.1 202.4 207.1 202.4 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207 202.3 207 202.3 207 202.3 207 202.3 207 202.3 207 202.3 207 202.3 207 202.3 207 202.3 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207 202.2 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.1 202.3 207.2 202.3 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.2 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.3 202.4 207.4 202.4 207.4"
                  className="st7"
                ></path>
                <path d="M178 203.9L178.2 203.9" className="st7"></path>
                <path
                  d="M178.5 205.5L178.5 205.5 178.5 205.5 178.5 205.5 178.5 205.5 178.5 205.5 178.6 205.5 178.6 205.4 178.6 205.4 178.6 205.4 178.6 205.4"
                  className="st7"
                ></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.7 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.7 205.2L178.1 205.2" className="st7"></path>
                <path d="M178.7 205.2L178.1 205.2" className="st7"></path>
                <path
                  d="M178.2 205.4L178.1 205.4 178.1 205.3 178.2 205.3 178.2 205.4"
                  className="st7"
                ></path>
                <path
                  d="M178.1 205.4L178.1 205.4 178.1 205.3 178.1 205.3 178.1 205.4"
                  className="st7"
                ></path>
                <path
                  d="M178.1 205.3L178.1 205.3 178.1 205.4 178.1 205.4"
                  className="st7"
                ></path>
                <path d="M178.1 205.4L178.1 205.4" className="st7"></path>
                <path d="M178.1 205.4L178.1 205.4" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.2 205.4L178.2 205.4" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.4 204.1L178.4 204.1" className="st7"></path>
                <path
                  d="M178.1 204.1L178.4 204.1 178.4 204.1 178.4 204.1"
                  className="st7"
                ></path>
                <path d="M178.2 203.9" className="st7"></path>
                <path
                  d="M178.2 203.9L178.3 203.9 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.4 204 178.4 204 178.4 204 178.4 204 178.4 204 178.4 204.1"
                  className="st7"
                ></path>
                <path
                  d="M178.4 204.1L178.4 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204.1"
                  className="st7"
                ></path>
                <path
                  d="M178.2 204L178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.2 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204"
                  className="st7"
                ></path>
                <path
                  d="M178.2 204.1L178.3 204.1 178.3 204 178.3 204 178.3 204 178.3 204 178.3 204.1 178.3 204.1 178.3 204.1"
                  className="st7"
                ></path>
                <path
                  d="M178.1 204.1L178.1 204.1 178.1 204 178.1 204"
                  className="st7"
                ></path>
                <path
                  d="M178.1 205.4L178.1 205.4 178.1 205.3 178.1 205.3"
                  className="st7"
                ></path>
                <path
                  d="M178.7 205.5L178.7 205.5 178.7 205.5 178.7 205.5 178.7 205.5 178.7 205.5 178.7 205.5 178.6 205.5 178.6 205.4 178.6 205.4 178.6 205.4 178.6 205.4 178.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M178.7 205.4L178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4 178.7 205.4"
                  className="st7"
                ></path>
                <path
                  d="M178.4 204.1L178.5 204.2 178.5 204.2 178.6 204.3 178.6 204.3 178.7 204.4 178.7 204.6 178.7 204.7 178.7 204.8 178.7 204.9"
                  className="st7"
                ></path>
                <path
                  d="M178.7 205.1L178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.2 178.7 205.2 178.7 205.2 178.7 205.2 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205.1 178.7 205 178.7 205 178.7 205 178.7 205 178.7 205 178.7 205 178.7 205 178.7 205 178.7 204.9 178.7 204.9 178.7 204.9"
                  className="st7"
                ></path>
                <path
                  d="M178.7 205.3L178.7 205.3 178.7 205.3 178.7 205.3 178.7 205.3 178.7 205.3 178.7 205.3 178.7 205.2 178.7 205.2 178.7 205.2 178.7 205.2 178.7 205.2 178.7 205.2"
                  className="st7"
                ></path>
                <path d="M178.3 204.1L178.3 204.1" className="st7"></path>
                <path
                  d="M178.4 204.1L178.3 204.1 178.3 204.1 178.4 204.1"
                  className="st7"
                ></path>
                <path d="M178.4 204.1L178.4 204.1" className="st7"></path>
                <path d="M178.4 204.1L178.3 204.1" className="st7"></path>
                <path
                  d="M178.4 204.1L178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.3 204.1 178.3 204.1 178.3 204.1 178.3 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1"
                  className="st7"
                ></path>
                <path
                  d="M178.4 204.1L178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1 178.4 204.1"
                  className="st7"
                ></path>
                <path d="M178.7 205.2L178.1 205.2" className="st7"></path>
                <path d="M178.3 204.1L178.1 204.1" className="st7"></path>
                <path d="M178.4 204.1L178.1 204.1" className="st7"></path>
                <path d="M178.1 204L178.1 204" className="st7"></path>
                <path
                  d="M177.7 205.5L177.7 205.5 177.7 205.5 177.7 205.5 177.7 205.5 177.7 205.5 177.6 205.5 177.6 205.4 177.6 205.4 177.6 205.4 177.6 205.4"
                  className="st7"
                ></path>
                <path d="M177.3 205.3L177.4 205.3" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M177.4 205.3L177.4 205.3" className="st7"></path>
                <path d="M177.5 205.3L178.1 205.3" className="st7"></path>
                <path d="M177.5 205.2L178.1 205.2" className="st7"></path>
                <path d="M177.5 205.2L178.1 205.2" className="st7"></path>
                <path
                  d="M177.3 205.3L177.3 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3"
                  className="st7"
                ></path>
                <path
                  d="M178 205.4L178.1 205.4 178.1 205.3 178 205.3 178 205.4"
                  className="st7"
                ></path>
                <path
                  d="M178.1 205.4L178.1 205.4 178.1 205.3 178.1 205.3 178.1 205.4"
                  className="st7"
                ></path>
                <path
                  d="M178.1 205.3L178.1 205.3 178.1 205.4 178.1 205.4"
                  className="st7"
                ></path>
                <path d="M178.1 205.4L178.1 205.4" className="st7"></path>
                <path d="M178.1 205.4L178.1 205.4" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178 205.4L178 205.4" className="st7"></path>
                <path d="M178.1 205.3L177.4 205.3" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M178.1 205.3L178.1 205.3" className="st7"></path>
                <path d="M177.8 204.1L177.8 204.1" className="st7"></path>
                <path
                  d="M178.1 204.1L177.8 204.1 177.8 204.1 177.8 204.1"
                  className="st7"
                ></path>
                <path d="M178.2 203.9L178 203.9" className="st7"></path>
                <path d="M178 203.9" className="st7"></path>
                <path
                  d="M178.2 203.9L178 203.9 178 203.9 178 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.8 204 177.8 204 177.8 204 177.8 204.1"
                  className="st7"
                ></path>
                <path
                  d="M177.9 204.1L177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 177.9 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204.1"
                  className="st7"
                ></path>
                <path
                  d="M178 204L178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204 178.1 204"
                  className="st7"
                ></path>
                <path
                  d="M178 204.1L178 204.1 178 204 178 204 178 204 177.9 204 177.9 204.1 177.9 204.1 177.9 204.1"
                  className="st7"
                ></path>
                <path
                  d="M178.1 204.1L178.1 204.1 178.1 204 178.1 204"
                  className="st7"
                ></path>
                <path
                  d="M178.1 205.4L178.1 205.4 178.1 205.3 178.1 205.3"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.5L177.5 205.5 177.5 205.5 177.5 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.3 177.4 205.3"
                  className="st7"
                ></path>
                <path
                  d="M177.4 205.3L177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.4L177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.6 205.4 177.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.4L177.5 205.4 177.5 205.4 177.5 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.5L177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.6 205.5 177.6 205.5 177.6 205.5 177.6 205.5 177.6 205.4 177.6 205.4 177.6 205.4 177.6 205.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.4L177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4"
                  className="st7"
                ></path>
                <path d="M177.5 205.4L177.5 205.4" className="st7"></path>
                <path
                  d="M177.6 205.4L177.6 205.4 177.6 205.4 177.6 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.4 177.5 205.3 177.5 205.3 177.5 205.3 177.5 205.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.4L177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.4 205.5"
                  className="st7"
                ></path>
                <path
                  d="M177.6 205.4L177.6 205.4 177.6 205.4 177.6 205.4 177.6 205.4 177.6 205.5 177.6 205.5 177.6 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.5 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.5 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.4 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.5 205.3"
                  className="st7"
                ></path>
                <path
                  d="M177.8 204.1L177.8 204.2 177.7 204.2 177.6 204.3 177.6 204.3 177.6 204.4 177.5 204.6 177.5 204.7 177.5 204.8 177.5 204.9"
                  className="st7"
                ></path>
                <path
                  d="M177.4 205.3L177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.5 205.3 177.5 205.3 177.5 205.3 177.5 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3 177.4 205.3"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.3L177.5 205.3 177.5 205.3"
                  className="st7"
                ></path>
                <path d="M177.4 204.9L177.5 204.9" className="st7"></path>
                <path
                  d="M177.4 204.9L177.4 204.9 177.4 204.9 177.4 204.9 177.4 204.9 177.5 204.9 177.5 204.9 177.5 204.9"
                  className="st7"
                ></path>
                <path
                  d="M177.4 204.9L177.4 204.9 177.4 204.9 177.4 204.9 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.2 177.4 205.2 177.4 205.2 177.4 205.2 177.4 205.2 177.4 205.2 177.4 205.2 177.4 205.2 177.4 205.2 177.4 205.2 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.1 177.5 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 204.9 177.4 204.9"
                  className="st7"
                ></path>
                <path
                  d="M177.4 205.2L177.4 205.2 177.4 205.2 177.4 205.2 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.1 177.5 205.1"
                  className="st7"
                ></path>
                <path
                  d="M177.4 205L177.4 205 177.4 205 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.4 205.1 177.4 205.1 177.4 205.1 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 204.9 177.5 204.9 177.4 204.9 177.4 205 177.4 205 177.4 205 177.4 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.4 205.1 177.4 205.1 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205 177.4 205"
                  className="st7"
                ></path>
                <path
                  d="M177.5 204.9L177.5 204.9 177.5 204.9 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.1L177.5 205.1 177.5 205.1 177.5 205.1"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.1L177.5 205.1 177.5 205"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.1L177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 204.9 177.5 204.9 177.5 204.9 177.5 204.9 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205.1 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205 177.5 205"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.3L177.5 205.3 177.5 205.3 177.5 205.3 177.5 205.3 177.5 205.3 177.5 205.3 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.2 177.5 205.2"
                  className="st7"
                ></path>
                <path
                  d="M177.5 205.3L177.5 205.3 177.4 205.3"
                  className="st7"
                ></path>
                <path d="M177.4 205.3L177.4 205.2" className="st7"></path>
                <path
                  d="M177.5 205.3L177.5 205.3 177.5 205.3"
                  className="st7"
                ></path>
                <path d="M177.9 204.1L177.9 204.1" className="st7"></path>
                <path
                  d="M177.8 204.1L177.9 204.1 177.9 204.1 177.9 204.1"
                  className="st7"
                ></path>
                <path d="M177.8 204.1L177.8 204.1" className="st7"></path>
                <path d="M177.9 204.1L177.9 204.1" className="st7"></path>
                <path
                  d="M177.8 204.1L177.8 204.1 177.8 204.1 177.8 204.1 177.8 204.1 177.9 204.1 177.9 204.1 177.9 204.1 177.9 204.1 177.9 204.1 177.9 204.1 177.9 204.1 177.8 204.1 177.8 204.1 177.8 204.1"
                  className="st7"
                ></path>
                <path
                  d="M177.8 204.1L177.8 204.1 177.8 204.1 177.9 204.1 177.9 204.1 177.9 204.1 177.9 204.1 177.8 204.1 177.8 204.1 177.8 204.1 177.8 204.1"
                  className="st7"
                ></path>
                <path
                  d="M177.4 204.9L177.4 204.7 177.4 204.7 177.5 204.6 177.5 204.5 177.5 204.4 177.5 204.4 177.5 204.3 177.6 204.3 177.6 204.2 177.6 204.2 177.7 204.2 177.7 204.1 177.7 204.1 177.8 204.1 177.8 204.1 177.8 204.1 177.8 204.1"
                  className="st7"
                ></path>
                <path
                  d="M177.4 205.4L177.4 205.4 177.4 205.4 177.3 205.4 177.3 205.3"
                  className="st7"
                ></path>
                <path d="M177.4 205.4L177.4 205.4" className="st7"></path>
                <path d="M177.5 205.2L178.1 205.2" className="st7"></path>
                <path d="M177.4 205.3L177.4 205.3" className="st7"></path>
                <path d="M177.4 205.3L178 205.3" className="st7"></path>
                <path d="M177.4 205.3L178 205.3" className="st7"></path>
                <path d="M177.9 204.1L178.1 204.1" className="st7"></path>
                <path d="M177.9 204.1L178.1 204.1" className="st7"></path>
                <path d="M178.1 204L178.1 204" className="st7"></path>
                <path d="M177.5 205.2L177.5 205.3" className="st7"></path>
                <path d="M178.1 203.9L178 203.9" className="st7"></path>
                <path d="M178 203.9L178.1 203.9" className="st7"></path>
                <path
                  d="M178 203.9L178 203.9 178.1 203.9"
                  className="st7"
                ></path>
                <path d="M178 203.9L178.1 203.9" className="st7"></path>
                <path d="M178 203.9L178 203.9" className="st7"></path>
                <path
                  d="M178 203.9L178 203.9 178 203.9 178 203.9 178 203.9 178 203.9"
                  className="st7"
                ></path>
                <path d="M178.1 203.9L178.2 203.9" className="st7"></path>
                <path d="M178.2 203.9L178.1 203.9" className="st7"></path>
                <path d="M178.2 203.9L178.1 203.9" className="st7"></path>
                <path d="M178.2 203.9L178.2 203.9" className="st7"></path>
                <path d="M178.2 203.9L178.1 203.9" className="st7"></path>
                <path d="M178.2 203.9L178.2 203.9" className="st7"></path>
                <path d="M178.2 203.9L178.2 203.9" className="st7"></path>
                <path
                  d="M178.2 203.9L178.1 203.9 178.1 203.9 178.2 203.9 178.2 203.9 178.2 203.9"
                  className="st7"
                ></path>
                <path
                  d="M178 203.9L178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178 203.7L178 203.7 178 203.7 178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.7 178 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178 203.8L178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.7 178 203.7 178 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178 203.8L178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.7 178.1 203.7 178.1 203.7 178.1 203.7 178 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178 203.7L178 203.7 178 203.7 178 203.7 178.1 203.7 178.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178 203.8L178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178 203.8L178 203.8 178 203.8 178 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 203.9L178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178.2 203.9L178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178.2 203.7L178.2 203.7 178.2 203.7 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.7 178.2 203.7 178.2 203.7 178.1 203.8 178.1 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 203.8L178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.7 178.1 203.7 178.1 203.7 178.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 203.7L178.2 203.7 178.2 203.7 178.1 203.7 178.1 203.7 178.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 203.8L178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.2 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178.2 203.8L178.2 203.8 178.2 203.8 178.2 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 203.9L178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8 178.1 203.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 203.6L178.1 203.6 178.1 203.6 178.1 203.6 178 203.6 178 203.6 178 203.6 178 203.6 178 203.7 178 203.7 178 203.7 178 203.7 178 203.7 178 203.7 178 203.7 178 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178.1 203.7L178.1 203.7 178.1 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178.1 203.6L178.1 203.6 178.1 203.6 178.1 203.6 178.2 203.6 178.2 203.6 178.2 203.6 178.2 203.6 178.2 203.7 178.2 203.7 178.2 203.7 178.2 203.7 178.2 203.7 178.2 203.7 178.2 203.7 178.2 203.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.2L178 206.2 178 206.2"
                  className="st7"
                ></path>
                <path d="M178 206.1L178 206.2" className="st7"></path>
                <path d="M178 206.2" className="st7"></path>
                <path d="M178.2 206.2L178.2 206.2" className="st7"></path>
                <path
                  d="M178.2 206.1L178.2 206.2 178.2 206.2"
                  className="st7"
                ></path>
                <path d="M178.2 206.1" className="st7"></path>
                <path d="M178 206.2L178.2 206.2" className="st7"></path>
                <path d="M178 206.1L178.2 206.1" className="st7"></path>
                <path d="M178 206.1L178.2 206.1" className="st7"></path>
                <path
                  d="M178 206s0 .1 0 0c0 .1 0 .1 0 0M178.2 206.1s.1 0 0 0c.1 0 0-.1 0 0 0-.1 0-.1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M178 206.1L178 206 178.2 206 178.2 206.1"
                  className="st7"
                ></path>
                <path d="M178.2 206" className="st7"></path>
                <path d="M178 206L178.2 206" className="st7"></path>
                <path d="M178 206L178.2 206" className="st7"></path>
                <path d="M178.1 206" className="st7"></path>
                <path
                  d="M177.9 206.7L177.9 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.6 178 206.6 178 206.6 178 206.6 178 206.6 178 206.6 178 206.6 178 206.5 178 206.5 178 206.5 178 206.5 178 206.5 178 206.5 178 206.5 178 206.4 178 206.4 178 206.4 178 206.4 178 206.4 178 206.4 178 206.4 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.2 178 206.2 178 206.2 178 206.2 178 206.2"
                  className="st7"
                ></path>
                <path d="M178 206.2L178 207" className="st7"></path>
                <path d="M178.2 206.2L178.2 207" className="st7"></path>
                <path d="M178.2 206L178 206" className="st7"></path>
                <path d="M178.2 206L178.2 206 178.1 206" className="st7"></path>
                <path
                  d="M178.2 206L178.2 205.9 178.2 205.9 178.2 205.9 178.2 205.9 178.2 205.9 178.2 205.9 178.2 205.9 178.1 205.9"
                  className="st7"
                ></path>
                <path
                  d="M178.2 205.9L178.2 205.9 178.1 205.9"
                  className="st7"
                ></path>
                <path
                  d="M178.2 205.9L178.2 205.9 178.2 205.9 178.2 205.9 178.2 205.8 178.3 205.8 178.3 205.8 178.3 205.8 178.3 205.8 178.3 205.8 178.3 205.8 178.3 205.8 178.3 205.8 178.3 205.8 178.4 205.8 178.4 205.8 178.4 205.8 178.4 205.8 178.4 205.8 178.4 205.8 178.4 205.8 178.4 205.8 178.4 205.8 178.5 205.8 178.5 205.8 178.5 205.8 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.7 178.5 205.6 178.5 205.6 178.1 205.6"
                  className="st7"
                ></path>
                <path d="M178.5 205.6L178.1 205.6" className="st7"></path>
                <path d="M178.5 205.6" className="st7"></path>
                <path d="M178.1 205.5L178.5 205.5" className="st7"></path>
                <path
                  d="M178.1 205.5L178.5 205.5 178.5 205.5"
                  className="st7"
                ></path>
                <path
                  d="M178.5 205.6L178.5 205.6 178.5 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.5 178.4 205.5 178.4 205.5 178.5 205.5 178.5 205.5"
                  className="st7"
                ></path>
                <path
                  d="M178.4 205.6L178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178.4 205.6L178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178.4 205.6L178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178.4 205.6L178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6 178.4 205.6"
                  className="st7"
                ></path>
                <path d="M178.4 205.6L178.4 205.6" className="st7"></path>
                <path
                  d="M178.4 205.6L178.4 205.6 178.3 205.6 178.3 205.6 178.3 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178.3 205.6L178.3 205.6 178.3 205.6 178.3 205.6 178.3 205.6 178.3 205.6"
                  className="st7"
                ></path>
                <path d="M178.3 205.6L178.3 205.6" className="st7"></path>
                <path
                  d="M178.3 205.6L178.3 205.6 178.3 205.6 178.3 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178.3 205.6L178.3 205.6 178.3 205.6 178.3 205.6"
                  className="st7"
                ></path>
                <path d="M178.3 205.6L178.3 205.6" className="st7"></path>
                <path
                  d="M178.2 205.6L178.2 205.6 178.2 205.6 178.2 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178.2 205.6L178.2 205.6 178.2 205.6"
                  className="st7"
                ></path>
                <path d="M178.3 205.6" className="st7"></path>
                <path
                  d="M178.2 205.6L178.2 205.6 178.2 205.6 178.2 205.6 178.2 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178.1 205.6L178.1 205.6 178.1 205.6"
                  className="st7"
                ></path>
                <path d="M178.2 205.6" className="st7"></path>
                <path d="M178.1 205.6L178.1 205.6" className="st7"></path>
                <path d="M178.1 205.6" className="st7"></path>
                <path d="M178.1 205.6L178.1 205.6" className="st7"></path>
                <path d="M178 206L178 206 178.1 206" className="st7"></path>
                <path
                  d="M178 206L178 205.9 178 205.9 178 205.9 178 205.9 178 205.9 178 205.9 178 205.9 178.1 205.9"
                  className="st7"
                ></path>
                <path
                  d="M178 205.9L178 205.9 178.1 205.9"
                  className="st7"
                ></path>
                <path
                  d="M178 205.9L178 205.9 178 205.9 178 205.9 178 205.9 178 205.8 177.9 205.8 177.9 205.8 177.9 205.8 177.9 205.8 177.9 205.8 177.9 205.8 177.9 205.8 177.9 205.8 177.9 205.8 177.8 205.8 177.8 205.8 177.8 205.8 177.8 205.8 177.8 205.8 177.8 205.8 177.8 205.8 177.7 205.8 177.7 205.8 177.7 205.8 177.7 205.8 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.7 177.7 205.6 177.7 205.6 177.7 205.6 178.1 205.6"
                  className="st7"
                ></path>
                <path d="M177.7 205.6L178.1 205.6" className="st7"></path>
                <path d="M177.7 205.6" className="st7"></path>
                <path d="M178.1 205.5L177.7 205.5" className="st7"></path>
                <path
                  d="M178.1 205.5L177.7 205.5 177.7 205.5"
                  className="st7"
                ></path>
                <path d="M177.7 205.5L177.7 205.5" className="st7"></path>
                <path
                  d="M177.7 205.6L177.7 205.6 177.8 205.6 177.8 205.6 177.8 205.6 177.8 205.6 177.8 205.6 177.8 205.6 177.8 205.6 177.8 205.5 177.8 205.5 177.8 205.5 177.8 205.5 177.7 205.5"
                  className="st7"
                ></path>
                <path
                  d="M177.8 205.6L177.8 205.6 177.8 205.6 177.8 205.6"
                  className="st7"
                ></path>
                <path
                  d="M177.8 205.6L177.8 205.6 177.8 205.6 177.8 205.6"
                  className="st7"
                ></path>
                <path d="M177.8 205.6L177.8 205.6" className="st7"></path>
                <path
                  d="M177.8 205.6L177.8 205.6 177.8 205.6 177.8 205.6 177.8 205.6"
                  className="st7"
                ></path>
                <path
                  d="M177.8 205.6L177.8 205.6 177.8 205.6 177.8 205.6 177.8 205.6"
                  className="st7"
                ></path>
                <path
                  d="M177.8 205.6L177.9 205.6 177.9 205.6 177.9 205.6 177.9 205.6 177.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M177.9 205.6L177.9 205.6 177.9 205.6 177.9 205.6"
                  className="st7"
                ></path>
                <path d="M177.9 205.6L177.9 205.6" className="st7"></path>
                <path
                  d="M177.9 205.6L177.9 205.6 177.9 205.6 177.9 205.6"
                  className="st7"
                ></path>
                <path
                  d="M177.9 205.6L177.9 205.6 177.9 205.6 177.9 205.6 177.9 205.6"
                  className="st7"
                ></path>
                <path d="M177.9 205.6L177.9 205.6" className="st7"></path>
                <path
                  d="M178 205.6L178 205.6 178 205.6 178 205.6 178 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178 205.6L178 205.6 178 205.6 178 205.6"
                  className="st7"
                ></path>
                <path d="M178 205.6" className="st7"></path>
                <path
                  d="M178 205.6L178 205.6 178 205.6 178 205.6"
                  className="st7"
                ></path>
                <path
                  d="M178 205.6L178 205.6 178.1 205.6 178.1 205.6"
                  className="st7"
                ></path>
                <path d="M178.1 205.6" className="st7"></path>
                <path d="M178.1 205.6L178.1 205.6" className="st7"></path>
                <path d="M178.1 205.6" className="st7"></path>
                <path d="M178.1 205.6L178.1 205.6" className="st7"></path>
                <path
                  d="M178 205.9c-.1 0-.1.1-.1.2s0 .1.1.2M178.2 206.2c.1 0 .1-.1.1-.2s0-.1-.1-.2"
                  className="st7"
                ></path>
                <path
                  d="M178 206.5L178 206.5 178 206.5 178 206.5 178 206.5 178 206.4 178 206.4 178 206.4 178 206.4 178 206.4 178 206.4"
                  className="st7"
                ></path>
                <path
                  d="M178 206.3L178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.4 178 206.4 178 206.4"
                  className="st7"
                ></path>
                <path
                  d="M178 206.2L178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3"
                  className="st7"
                ></path>
                <path
                  d="M178 206.2L178 206.2 178 206.2 178 206.2 178 206.2 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.3 178 206.4 178 206.4 178 206.4 178 206.4 178 206.4 178 206.4 178 206.5 178 206.5 178 206.5"
                  className="st7"
                ></path>
                <path
                  d="M178 206.4L178 206.5 178 206.5 178 206.5"
                  className="st7"
                ></path>
                <path
                  d="M178 206.6L178 206.6 178 206.5 178 206.5 178 206.5 178 206.5 178 206.5 178 206.5 178 206.6 178 206.6"
                  className="st7"
                ></path>
                <path
                  d="M178 206.7L178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.8 178 206.8 178 206.8 178 206.8 178 206.8 177.9 206.8 177.9 206.8 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 177.9 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7 178 206.7"
                  className="st7"
                ></path>
                <path
                  d="M178.3 206.7L178.3 206.7 178.3 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.6 178.2 206.6 178.2 206.6 178.2 206.6 178.2 206.6 178.2 206.6 178.2 206.6 178.2 206.6 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.2 178.2 206.2 178.2 206.2 178.2 206.2 178.2 206.2 178.2 206.2 178.2 206.2 178.2 206.2"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.5L178.2 206.5 178.2 206.5 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.3L178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.2L178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.2L178.2 206.2 178.2 206.2 178.2 206.2 178.2 206.2 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.3 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.4 178.2 206.5 178.2 206.5 178.2 206.5"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.4L178.2 206.5 178.2 206.5 178.2 206.5"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.6L178.2 206.6 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.5 178.2 206.6 178.2 206.6"
                  className="st7"
                ></path>
                <path
                  d="M178.2 206.7L178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.8 178.2 206.8 178.2 206.8 178.2 206.8 178.3 206.8 178.3 206.8 178.3 206.8 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.3 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7 178.2 206.7"
                  className="st7"
                ></path>
                <path d="M178 207.6L178.2 207.6" className="st7"></path>
                <path
                  d="M178 207.6L178 207.6 178 207.6 178 207.6 178 207.5 178 207.5 178 207.5 178 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6"
                  className="st7"
                ></path>
                <path
                  d="M178 207.6L178 207.6 178 207.6 178 207.6 178 207.6 177.9 207.6 177.9 207.6 177.9 207.6 177.9 207.7 177.9 207.7 177.9 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.7 178 207.7 178 207.7 178 207.7 178 207.6 178 207.6 178 207.6 178.1 207.6 178.1 207.6 178.1 207.6"
                  className="st7"
                ></path>
                <path
                  d="M178 207.6L178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6 178 207.6"
                  className="st7"
                ></path>
                <path
                  d="M178.1 207.6L178.1 207.6 178.1 207.6 178.1 207.6 178 207.6 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.2 207.6 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.7 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178.1 207.6 178 207.6"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.6L178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.2 207.7 178.3 207.7 178.3 207.7 178.3 207.7 178.3 207.7 178.3 207.7 178.3 207.7 178.3 207.6 178.3 207.6 178.3 207.6 178.3 207.6 178.3 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6 178.2 207.6"
                  className="st7"
                ></path>
                <path
                  d="M178 207.7L178 207.7 178 207.7 178 207.7 178 207.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.7L178.2 207.7 178.2 207.7"
                  className="st7"
                ></path>
                <path d="M178 207.7L178 207.7 178 207.7" className="st7"></path>
                <path
                  d="M178.1 207.7L178.2 207.7 178.2 207.7 178.2 207.7"
                  className="st7"
                ></path>
                <path
                  d="M178.1 207.5L178 207.5 178 207.5 178 207.5 178 207.5 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178.1 207.4 178.1 207.4"
                  className="st7"
                ></path>
                <path
                  d="M177.9 207.3L178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.2 178.1 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4"
                  className="st7"
                ></path>
                <path
                  d="M178 207.1L178 207.1 178 207.1 178 207.1 178 207.1"
                  className="st7"
                ></path>
                <path
                  d="M178 207.2L178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.1 178 207.1 178 207.1 178 207.1 178.1 207.1 178.1 207.1 178.1 207.1"
                  className="st7"
                ></path>
                <path
                  d="M178 207.5L178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.2 178.1 207.2 178.1 207.2 178.1 207.2 178.1 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178 207.3"
                  className="st7"
                ></path>
                <path
                  d="M178 207.4L178 207.3 178 207.3 178 207.3 178 207.3 178 207.3 178.1 207.2 178.1 207.2 178.1 207.2"
                  className="st7"
                ></path>
                <path d="M178 207.2L178 207.2" className="st7"></path>
                <path d="M178 207.3L178 207.4 178 207.4" className="st7"></path>
                <path
                  d="M178.1 207.4L178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.5 178.1 207.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 207.4L178.1 207.4 178.1 207.4 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3"
                  className="st7"
                ></path>
                <path
                  d="M178 207.5L178 207.5 178 207.5 178 207.5 178 207.5 178 207.5 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178 207.4 178 207.4 178 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 207.5L178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.5L178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.4 178.2 207.4 178.3 207.4 178.3 207.4 178.3 207.4 178.3 207.4 178.3 207.4 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.2 178.3 207.2 178.3 207.2 178.3 207.2 178.3 207.2 178.3 207.2 178.3 207.2 178.3 207.1 178.3 207.1 178.3 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207 178.2 207 178.2 207 178.2 207 178.2 207 178.2 207 178.2 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207.1 178.1 207.1 178.1 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.3 207.2 178.3 207.2 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.3 178.3 207.4 178.3 207.4"
                  className="st7"
                ></path>
                <path
                  d="M178.3 207.3L178.3 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.2 178.1 207.2 178.1 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M178.1 207.1L178.2 207.1 178.2 207.1"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.2L178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.1 178.2 207.1 178.2 207.1 178.2 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1 178.1 207.1"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.5L178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.2 178.1 207.2 178.1 207.2 178.1 207.2 178.1 207.2 178.1 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.2 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.4L178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.2 207.3 178.1 207.2 178.1 207.2 178.1 207.2"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.2L178.2 207.2 178.2 207.2"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.3L178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4"
                  className="st7"
                ></path>
                <path
                  d="M178.1 207.4L178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 207.4L178.1 207.4 178.1 207.4 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3 178.1 207.3"
                  className="st7"
                ></path>
                <path
                  d="M178.2 207.5L178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.5 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.2 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.4 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5 178.1 207.5"
                  className="st7"
                ></path>
                <path
                  d="M178 207.5L178 207.5 178 207.5 178 207.5 178 207.5 178 207.5 178 207.4 178 207.4 178 207.4 178 207.4 177.9 207.4 177.9 207.4 177.9 207.4 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.2 177.9 207.2 177.9 207.2 177.9 207.2 177.9 207.2 177.9 207.2 177.9 207.2 177.9 207.1 177.9 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207 178 207 178 207 178 207 178 207 178 207 178 207 178 207 178 207 178 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207 178.1 207.1 178.1 207.1 178.1 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.1 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.2 178 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.3 177.9 207.4 177.9 207.4"
                  className="st7"
                ></path>
                <path d="M202.3 170L202.1 170" className="st7"></path>
                <path
                  d="M201.9 171.6L201.8 171.6 201.8 171.5 201.8 171.5 201.8 171.5 201.8 171.5 201.8 171.5 201.8 171.5 201.8 171.5 201.7 171.5 201.7 171.5 201.7 171.5"
                  className="st7"
                ></path>
                <path d="M201.5 171.4L201.5 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M201.5 171.4L201.5 171.4" className="st7"></path>
                <path d="M201.6 171.3L202.2 171.3" className="st7"></path>
                <path d="M201.6 171.3L202.2 171.3" className="st7"></path>
                <path d="M201.6 171.3L202.2 171.3" className="st7"></path>
                <path
                  d="M201.5 171.4L201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 171.5L202.2 171.5 202.2 171.4 202.1 171.4 202.1 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.2 171.5L202.2 171.5 202.2 171.4 202.2 171.4 202.2 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.2 171.4L202.2 171.4 202.2 171.5 202.2 171.5"
                  className="st7"
                ></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L201.6 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M201.9 170.2L201.9 170.2" className="st7"></path>
                <path
                  d="M202.2 170.1L201.9 170.1 201.9 170.2 201.9 170.2"
                  className="st7"
                ></path>
                <path d="M202.1 170" className="st7"></path>
                <path
                  d="M202.1 170L202.1 170 202.1 170 202.1 170 202 170 202 170 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 201.9 170.1 201.9 170.1 201.9 170.1 201.9 170.1 201.9 170.1"
                  className="st7"
                ></path>
                <path
                  d="M202 170.1L202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170 202.1 170 202.1 170 202.1 170 202.1 170 202.1 170 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1"
                  className="st7"
                ></path>
                <path
                  d="M202.1 170.1L202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170 202.2 170 202.2 170 202.2 170"
                  className="st7"
                ></path>
                <path
                  d="M202.1 170.1L202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202.1 170.1 202 170.1 202 170.1 202 170.1"
                  className="st7"
                ></path>
                <path
                  d="M202.2 170.1L202.2 170.1 202.2 170.1 202.2 170.1"
                  className="st7"
                ></path>
                <path
                  d="M202.2 171.5L202.2 171.5 202.2 171.4 202.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.6L201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M201.5 171.4L201.5 171.4 201.5 171.4 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.5 201.7 171.5 201.7 171.5 201.7 171.5 201.7 171.5 201.6 171.5 201.6 171.5 201.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.5L201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.7 171.5 201.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.5L201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.6L201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.7 171.6 201.7 171.6 201.7 171.6 201.7 171.6 201.7 171.5 201.7 171.5 201.7 171.5 201.7 171.5 201.7 171.5 201.7 171.5 201.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.5L201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.6 171.5 201.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.5L201.6 171.4 201.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M201.7 171.5L201.7 171.5 201.7 171.5 201.7 171.4 201.7 171.4 201.6 171.4 201.6 171.4 201.6 171.4 201.6 171.4 201.6 171.4 201.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.5L201.6 171.5 201.6 171.5 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6"
                  className="st7"
                ></path>
                <path
                  d="M201.7 171.5L201.7 171.5 201.7 171.5 201.7 171.5 201.7 171.5 201.7 171.6 201.7 171.6 201.7 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.6 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.6 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.5 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.6 171.4 201.6 171.3"
                  className="st7"
                ></path>
                <path
                  d="M201.9 170.2L201.9 170.2 201.8 170.3 201.8 170.3 201.7 170.4 201.7 170.5 201.6 170.6 201.6 170.7 201.6 170.9 201.6 171"
                  className="st7"
                ></path>
                <path
                  d="M201.5 171.4L201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.3 201.5 171.3 201.5 171.3 201.5 171.3 201.5 171.3 201.5 171.3 201.6 171.3 201.6 171.3 201.6 171.4 201.6 171.4 201.6 171.4 201.6 171.4 201.5 171.4 201.5 171.4 201.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.4L201.6 171.4 201.6 171.4"
                  className="st7"
                ></path>
                <path d="M201.5 171L201.6 171" className="st7"></path>
                <path
                  d="M201.5 171L201.5 171 201.5 171 201.5 171 201.6 171 201.6 171 201.6 171 201.6 171 201.6 171"
                  className="st7"
                ></path>
                <path
                  d="M201.5 171L201.5 171 201.5 171 201.5 171 201.5 171 201.5 171 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.2 201.5 171.2 201.5 171.2 201.5 171.2 201.5 171.2 201.5 171.2 201.5 171.2 201.5 171.2 201.5 171.2 201.5 171.3 201.5 171.3 201.5 171.3 201.5 171.3 201.5 171.3 201.5 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.5 171.2 201.5 171.2 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171 201.5 171 201.5 171"
                  className="st7"
                ></path>
                <path
                  d="M201.5 171.3L201.5 171.3 201.6 171.3 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2"
                  className="st7"
                ></path>
                <path
                  d="M201.5 171.1L201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.1 201.6 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171 201.5 171 201.6 171 201.6 171 201.6 171"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171L201.5 171 201.5 171.1 201.5 171.1 201.5 171.1 201.5 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171 201.6 171 201.6 171"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171L201.6 171 201.6 171 201.6 171 201.6 171 201.6 171 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.1L201.6 171.1 201.6 171.2 201.6 171.2"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.1L201.6 171.1 201.6 171.1 201.6 171.1"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171L201.6 171 201.6 171 201.6 171 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171 201.6 171 201.6 171 201.6 171"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.1L201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.2 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171.1 201.6 171 201.6 171 201.6 171 201.6 171 201.6 171 201.6 171 201.6 171"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.4L201.6 171.4 201.6 171.4 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.3 201.6 171.2"
                  className="st7"
                ></path>
                <path
                  d="M201.6 171.4L201.6 171.4 201.6 171.4"
                  className="st7"
                ></path>
                <path d="M201.5 171.3L201.5 171.3" className="st7"></path>
                <path
                  d="M201.6 171.4L201.6 171.4 201.6 171.4 201.6 171.4"
                  className="st7"
                ></path>
                <path d="M202 170.2L202 170.2" className="st7"></path>
                <path
                  d="M202 170.2L202 170.2 202 170.2 202 170.2"
                  className="st7"
                ></path>
                <path
                  d="M201.9 170.2L201.9 170.2 201.9 170.2"
                  className="st7"
                ></path>
                <path d="M202 170.2L202 170.2" className="st7"></path>
                <path
                  d="M201.9 170.2L201.9 170.2 201.9 170.1 202 170.1 202 170.2 202 170.2 202 170.2 202 170.2 202 170.2 202 170.2 201.9 170.2 201.9 170.2"
                  className="st7"
                ></path>
                <path
                  d="M201.9 170.2L202 170.2 202 170.2 202 170.2 202 170.2 202 170.2 202 170.2 201.9 170.2 201.9 170.2"
                  className="st7"
                ></path>
                <path
                  d="M201.5 171L201.5 170.8 201.6 170.7 201.6 170.6 201.6 170.6 201.6 170.5 201.6 170.5 201.7 170.4 201.7 170.4 201.7 170.3 201.8 170.3 201.8 170.2 201.8 170.2 201.8 170.2 201.9 170.2 201.9 170.2 201.9 170.2 201.9 170.2"
                  className="st7"
                ></path>
                <path
                  d="M201.5 171.5L201.5 171.4 201.5 171.4 201.5 171.4 201.5 171.4"
                  className="st7"
                ></path>
                <path d="M201.5 171.5L201.6 171.5" className="st7"></path>
                <path d="M201.6 171.2L202.2 171.2" className="st7"></path>
                <path d="M201.5 171.4L201.5 171.4" className="st7"></path>
                <path d="M201.5 171.4L202.1 171.4" className="st7"></path>
                <path d="M201.5 171.4L202.1 171.4" className="st7"></path>
                <path d="M202 170.2L202.2 170.2" className="st7"></path>
                <path d="M202 170.2L202.2 170.2" className="st7"></path>
                <path d="M202.2 170L202.2 170" className="st7"></path>
                <path d="M201.6 171.3L201.6 171.3" className="st7"></path>
                <path
                  d="M202.6 171.6L202.6 171.6 202.6 171.5 202.6 171.5 202.6 171.5 202.6 171.5 202.7 171.5 202.7 171.5 202.7 171.5 202.7 171.5 202.8 171.5"
                  className="st7"
                ></path>
                <path d="M203 171.4L203 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path
                  d="M203 171.4L203 171.4 202.9 171.4"
                  className="st7"
                ></path>
                <path d="M202.8 171.3L202.2 171.3" className="st7"></path>
                <path d="M202.8 171.3L202.2 171.3" className="st7"></path>
                <path d="M202.8 171.3L202.2 171.3" className="st7"></path>
                <path
                  d="M203 171.4L203 171.4 203 171.4 203 171.4 203 171.4 203 171.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 171.5L202.3 171.5 202.3 171.4 202.3 171.4 202.3 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.2 171.5L202.2 171.5 202.2 171.4 202.2 171.4 202.2 171.5"
                  className="st7"
                ></path>
                <path d="M202.2 171.4L202.2 171.5" className="st7"></path>
                <path d="M202.3 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.3 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.3 171.4L202.3 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.9 171.4" className="st7"></path>
                <path d="M202.3 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.2 171.4L202.2 171.4" className="st7"></path>
                <path d="M202.5 170.2L202.5 170.2" className="st7"></path>
                <path
                  d="M202.2 170.1L202.5 170.1 202.5 170.2 202.5 170.2"
                  className="st7"
                ></path>
                <path d="M202.1 170L202.3 170" className="st7"></path>
                <path d="M202.4 170" className="st7"></path>
                <path
                  d="M202.1 170L202.4 170 202.4 170 202.4 170 202.4 170 202.4 170 202.4 170 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.5 170.1 202.5 170.1 202.5 170.1 202.5 170.1 202.5 170.1 202.5 170.1 202.5 170.1"
                  className="st7"
                ></path>
                <path
                  d="M202.5 170.1L202.5 170.1 202.5 170.1 202.5 170.1 202.5 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.3 170.1 202.3 170 202.3 170 202.3 170 202.3 170 202.3 170 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.3 170.1"
                  className="st7"
                ></path>
                <path
                  d="M202.4 170.1L202.4 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.3 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170.1 202.2 170 202.2 170 202.2 170"
                  className="st7"
                ></path>
                <path
                  d="M202.4 170.1L202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1 202.4 170.1"
                  className="st7"
                ></path>
                <path
                  d="M202.2 170.1L202.2 170.1 202.2 170.1"
                  className="st7"
                ></path>
                <path d="M202.2 171.5L202.2 171.4" className="st7"></path>
                <path
                  d="M202.8 171.6L202.8 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.5 203 171.5 203 171.5 203 171.5 203 171.5 203 171.5 203 171.5 203 171.5 203 171.4 203 171.4 203 171.4"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171.4L202.9 171.4 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.5L202.8 171.5 202.8 171.5 202.8 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.5L202.8 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.8 171.5 202.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.6L202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.5L202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171.5L202.9 171.5 202.9 171.4 202.9 171.4 202.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.5L202.8 171.5 202.8 171.4 202.8 171.4 202.8 171.4 202.8 171.4 202.8 171.4 202.8 171.4 202.8 171.4 202.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.5L202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.9 171.6 202.9 171.6 202.9 171.6"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.5L202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.5 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.8 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.6 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.5 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.3"
                  className="st7"
                ></path>
                <path
                  d="M202.5 170.2L202.5 170.2 202.6 170.3 202.7 170.3 202.7 170.4 202.8 170.5 202.8 170.6 202.8 170.7 202.8 170.9 202.8 171"
                  className="st7"
                ></path>
                <path
                  d="M203 171.4L202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4 202.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.4L202.8 171.4 202.9 171.4"
                  className="st7"
                ></path>
                <path d="M202.9 171L202.8 171" className="st7"></path>
                <path
                  d="M202.9 171L202.9 171 202.9 171 202.9 171 202.9 171 202.8 171 202.8 171 202.8 171 202.8 171 202.8 171"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171L202.9 171 202.9 171 202.9 171 202.9 171 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171 202.9 171 202.9 171 202.9 171"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171.3L202.9 171.3 202.9 171.3 202.9 171.3 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171.1L202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.2 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171 202.9 171 202.9 171 202.9 171 202.9 171"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171L202.9 171 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171.1 202.9 171 202.9 171 202.9 171"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171L202.9 171 202.9 171 202.8 171 202.8 171 202.8 171 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.2 202.8 171.2 202.8 171.2 202.9 171.2 202.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171.1L202.8 171.1 202.8 171.2"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171.1L202.8 171.1 202.8 171.1 202.8 171.1"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171L202.8 171 202.8 171 202.8 171 202.8 171 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171 202.8 171 202.8 171"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.1L202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.2 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171.1 202.8 171 202.8 171 202.8 171 202.8 171 202.8 171 202.8 171"
                  className="st7"
                ></path>
                <path
                  d="M202.8 171.4L202.8 171.4 202.8 171.4 202.8 171.3 202.8 171.3 202.8 171.3 202.8 171.3 202.8 171.3 202.8 171.3 202.8 171.3 202.8 171.3 202.8 171.2"
                  className="st7"
                ></path>
                <path d="M202.9 171.4L202.9 171.4" className="st7"></path>
                <path d="M202.9 171.3L202.9 171.3" className="st7"></path>
                <path
                  d="M202.9 171.4L202.9 171.4 202.9 171.4"
                  className="st7"
                ></path>
                <path d="M202.4 170.2L202.4 170.2" className="st7"></path>
                <path
                  d="M202.5 170.2L202.4 170.2 202.4 170.2 202.5 170.2"
                  className="st7"
                ></path>
                <path
                  d="M202.5 170.2L202.5 170.2 202.5 170.2"
                  className="st7"
                ></path>
                <path d="M202.5 170.2L202.5 170.2" className="st7"></path>
                <path
                  d="M202.5 170.2L202.5 170.2 202.5 170.1 202.5 170.1 202.5 170.1 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2"
                  className="st7"
                ></path>
                <path
                  d="M202.5 170.2L202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2 202.5 170.2"
                  className="st7"
                ></path>
                <path
                  d="M202.9 171L202.9 170.8 202.9 170.7 202.9 170.6 202.8 170.6 202.8 170.5 202.8 170.5 202.8 170.4 202.7 170.4 202.7 170.3 202.7 170.3 202.7 170.2 202.6 170.2 202.6 170.2 202.6 170.2 202.5 170.2 202.5 170.2 202.5 170.2"
                  className="st7"
                ></path>
                <path
                  d="M203 171.5L203 171.4 203 171.4 203 171.4"
                  className="st7"
                ></path>
                <path d="M202.9 171.5L202.9 171.5" className="st7"></path>
                <path d="M202.8 171.2L202.2 171.2" className="st7"></path>
                <path d="M202.9 171.4L203 171.4" className="st7"></path>
                <path d="M202.9 171.4L202.3 171.4" className="st7"></path>
                <path d="M202.9 171.4L202.3 171.4" className="st7"></path>
                <path d="M202.4 170.2L202.2 170.2" className="st7"></path>
                <path d="M202.5 170.2L202.2 170.2" className="st7"></path>
                <path d="M202.2 170L202.2 170" className="st7"></path>
                <path d="M202.9 171.3L202.9 171.3" className="st7"></path>
                <path d="M202.3 170L202.3 170 202.2 170" className="st7"></path>
                <path d="M202.3 170L202.2 170" className="st7"></path>
                <path
                  d="M202.3 170L202.3 169.9 202.2 169.9"
                  className="st7"
                ></path>
                <path d="M202.3 169.9L202.2 169.9" className="st7"></path>
                <path d="M202.3 169.9L202.3 169.9" className="st7"></path>
                <path
                  d="M202.3 170L202.3 170 202.3 170 202.3 170"
                  className="st7"
                ></path>
                <path d="M202.1 170L202.1 170 202.2 170" className="st7"></path>
                <path d="M202.1 170L202.2 170" className="st7"></path>
                <path
                  d="M202.1 170L202.1 169.9 202.2 169.9"
                  className="st7"
                ></path>
                <path d="M202.1 169.9L202.2 169.9" className="st7"></path>
                <path d="M202.1 169.9L202.1 169.9" className="st7"></path>
                <path
                  d="M202.1 170L202.2 170 202.2 170 202.2 170 202.1 170"
                  className="st7"
                ></path>
                <path
                  d="M202.3 169.9L202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.3 169.8L202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 169.8L202.3 169.8 202.3 169.9 202.3 169.9 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 169.8L202.2 169.8 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8 202.3 169.8 202.3 169.8 202.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 169.8L202.3 169.8 202.3 169.8 202.3 169.8 202.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 169.8L202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.3 169.9 202.2 169.9 202.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.3 169.9L202.3 169.8 202.3 169.8 202.3 169.9 202.3 169.9 202.3 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.2 169.9L202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.1 169.9L202.1 169.9 202.1 169.9 202.1 169.9 202.1 169.9 202.1 169.9 202.1 169.9 202.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.1 169.8L202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.9 202.1 169.9 202.1 169.9 202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.1 169.8L202.1 169.8 202.1 169.9 202.2 169.9 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8 202.1 169.8 202.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 169.8L202.2 169.8 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8 202.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.1 169.8L202.1 169.8 202.2 169.8 202.2 169.8 202.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.1 169.8L202.1 169.9 202.1 169.9 202.1 169.9 202.1 169.9 202.1 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.1 169.9L202.1 169.8 202.1 169.8 202.1 169.9 202.1 169.9 202.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.2 169.9L202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9 202.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M202.2 169.7L202.2 169.7 202.2 169.7 202.2 169.7 202.3 169.7 202.3 169.7 202.3 169.7 202.3 169.7 202.3 169.7 202.3 169.7 202.3 169.7 202.3 169.7 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8 202.3 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 169.8L202.2 169.8 202.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 169.7L202.2 169.7 202.2 169.7 202.2 169.7 202.2 169.7 202.2 169.7 202.2 169.7 202.2 169.7 202.1 169.7 202.1 169.7 202.1 169.7 202.1 169.7 202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.8 202.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.3L202.3 172.3 202.3 172.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.2L202.3 172.2 202.3 172.2"
                  className="st7"
                ></path>
                <path d="M202.3 172.2" className="st7"></path>
                <path d="M202.1 172.3L202.1 172.2" className="st7"></path>
                <path
                  d="M202.1 172.2L202.1 172.2 202.1 172.2"
                  className="st7"
                ></path>
                <path d="M202.2 172.2" className="st7"></path>
                <path d="M202.3 172.2L202.1 172.2" className="st7"></path>
                <path d="M202.3 172.2L202.1 172.2" className="st7"></path>
                <path d="M202.3 172.1L202.1 172.1" className="st7"></path>
                <path
                  d="M202.3 172.2c.1 0 .1 0 0 0 .1 0 .1-.1 0 0 0-.1 0-.1 0 0M202.1 172.1c0 .1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.1L202.3 172.1 202.1 172.1 202.1 172.1"
                  className="st7"
                ></path>
                <path d="M202.3 172.1" className="st7"></path>
                <path d="M202.3 172.1L202.1 172.1" className="st7"></path>
                <path d="M202.3 172.1L202.1 172.1" className="st7"></path>
                <path d="M202.2 172" className="st7"></path>
                <path
                  d="M202.4 172.8L202.4 172.8 202.4 172.8 202.4 172.8 202.3 172.7 202.3 172.7 202.3 172.7 202.3 172.7 202.3 172.7 202.3 172.7 202.3 172.7 202.3 172.7 202.3 172.7 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.4 202.4 172.4 202.4 172.4 202.4 172.4 202.4 172.4 202.4 172.4 202.4 172.4 202.4 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3"
                  className="st7"
                ></path>
                <path d="M202.3 172.3L202.3 173.1" className="st7"></path>
                <path d="M202.1 172.3L202.1 173.1" className="st7"></path>
                <path d="M202.1 172.1L202.3 172.1" className="st7"></path>
                <path
                  d="M202.1 172.1L202.1 172 202.2 172"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172L202.1 172 202.1 172 202.1 172 202.1 172 202.1 172 202.1 172 202.2 172"
                  className="st7"
                ></path>
                <path d="M202.1 172L202.1 172 202.2 172" className="st7"></path>
                <path
                  d="M202.1 172L202.1 172 202.1 172 202.1 171.9 202.1 171.9 202.1 171.9 202.1 171.9 202.1 171.9 202.1 171.9 202 171.9 202 171.9 202 171.9 202 171.9 202 171.9 202 171.9 202 171.9 202 171.9 202 171.9 201.9 171.9 201.9 171.9 201.9 171.9 201.9 171.9 201.9 171.9 201.9 171.9 201.9 171.9 201.9 171.8 201.9 171.8 201.9 171.8 201.9 171.8 201.8 171.8 201.8 171.8 201.8 171.8 201.8 171.8 201.8 171.8 201.8 171.8 201.8 171.8 201.8 171.8 201.8 171.7 201.8 171.7 201.8 171.7 201.8 171.7 201.8 171.7 201.8 171.7 202.2 171.7"
                  className="st7"
                ></path>
                <path d="M201.9 171.7L202.2 171.7" className="st7"></path>
                <path d="M201.9 171.7" className="st7"></path>
                <path d="M202.2 171.6L201.9 171.6" className="st7"></path>
                <path
                  d="M202.2 171.6L201.9 171.6 201.9 171.6"
                  className="st7"
                ></path>
                <path
                  d="M201.9 171.7L201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.6 201.9 171.6 201.9 171.6 201.9 171.6 201.9 171.6 201.9 171.6 201.9 171.6 201.9 171.6"
                  className="st7"
                ></path>
                <path
                  d="M201.9 171.7L201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M201.9 171.7L201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.7 201.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M201.9 171.7L201.9 171.7 201.9 171.7 201.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M201.9 171.7L201.9 171.7 202 171.7 202 171.7 202 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202 171.7L202 171.7 202 171.7 202 171.7 202 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202 171.7L202 171.7 202 171.7 202 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202 171.7L202 171.7 202 171.7 202 171.7 202 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202 171.7L202.1 171.7 202.1 171.7 202.1 171.7"
                  className="st7"
                ></path>
                <path d="M202 171.7L202 171.7" className="st7"></path>
                <path
                  d="M202.1 171.7L202.1 171.7 202.1 171.7 202.1 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 171.7L202.1 171.7 202.1 171.7 202.1 171.7"
                  className="st7"
                ></path>
                <path d="M202.1 171.7" className="st7"></path>
                <path
                  d="M202.1 171.7L202.1 171.7 202.1 171.7 202.1 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.2 171.7L202.2 171.7 202.2 171.7 202.2 171.7"
                  className="st7"
                ></path>
                <path d="M202.2 171.7" className="st7"></path>
                <path d="M202.2 171.7L202.2 171.7" className="st7"></path>
                <path d="M202.2 171.6" className="st7"></path>
                <path d="M202.2 171.7L202.2 171.7" className="st7"></path>
                <path
                  d="M202.3 172.1L202.3 172 202.2 172"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172L202.3 172 202.3 172 202.3 172 202.3 172 202.3 172 202.3 172 202.2 172"
                  className="st7"
                ></path>
                <path d="M202.3 172L202.3 172 202.2 172" className="st7"></path>
                <path
                  d="M202.3 172L202.3 172 202.3 172 202.3 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.4 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.5 171.9 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.8 202.6 171.7 202.6 171.7 202.6 171.7 202.6 171.7 202.6 171.7 202.6 171.7 202.2 171.7"
                  className="st7"
                ></path>
                <path d="M202.6 171.7L202.2 171.7" className="st7"></path>
                <path d="M202.6 171.7" className="st7"></path>
                <path d="M202.2 171.6L202.6 171.6" className="st7"></path>
                <path
                  d="M202.2 171.6L202.6 171.6 202.6 171.6"
                  className="st7"
                ></path>
                <path
                  d="M202.6 171.7L202.6 171.7 202.6 171.7 202.6 171.7 202.5 171.7 202.5 171.7 202.5 171.7 202.5 171.7 202.5 171.6 202.5 171.6 202.5 171.6 202.5 171.6 202.5 171.6 202.5 171.6 202.6 171.6 202.6 171.6"
                  className="st7"
                ></path>
                <path
                  d="M202.5 171.7L202.5 171.7 202.5 171.7 202.5 171.7 202.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.5 171.7L202.5 171.7 202.5 171.7 202.5 171.7 202.5 171.7 202.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.5 171.7L202.5 171.7 202.5 171.7 202.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.5 171.7L202.5 171.7 202.5 171.7 202.5 171.7 202.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.5 171.7L202.5 171.7 202.5 171.7 202.5 171.7 202.5 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.5 171.7L202.4 171.7 202.4 171.7 202.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.4 171.7L202.4 171.7 202.4 171.7 202.4 171.7 202.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.4 171.7L202.4 171.7 202.4 171.7 202.4 171.7"
                  className="st7"
                ></path>
                <path d="M202.4 171.7L202.4 171.7" className="st7"></path>
                <path
                  d="M202.4 171.7L202.4 171.7 202.4 171.7 202.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 171.7L202.3 171.7 202.3 171.7 202.3 171.7"
                  className="st7"
                ></path>
                <path d="M202.4 171.6" className="st7"></path>
                <path
                  d="M202.3 171.7L202.3 171.7 202.3 171.7 202.3 171.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 171.7L202.3 171.7 202.3 171.7 202.3 171.7"
                  className="st7"
                ></path>
                <path d="M202.3 171.6" className="st7"></path>
                <path d="M202.2 171.7L202.2 171.7" className="st7"></path>
                <path d="M202.2 171.6" className="st7"></path>
                <path d="M202.2 171.7L202.2 171.7" className="st7"></path>
                <path
                  d="M202.3 172.3c.1 0 .1-.1.1-.2s0-.1-.1-.2M202.1 171.9c-.1 0-.1.1-.1.2s0 .1.1.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.6L202.3 172.6 202.3 172.6 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.4L202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.3L202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.4 202.3 172.4 202.3 172.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.3L202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.3 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.4 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.5 202.3 172.6 202.3 172.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.5L202.3 172.5 202.3 172.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.7L202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.6 202.3 172.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 172.7L202.3 172.7 202.3 172.7 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.4 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8 202.3 172.8"
                  className="st7"
                ></path>
                <path
                  d="M202 172.8L202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.7 202.1 172.7 202.1 172.7 202.1 172.7 202.1 172.7 202.1 172.7 202.1 172.7 202.1 172.7 202.1 172.7 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.2"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.6L202.1 172.6 202.1 172.6 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.4L202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.3L202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.4 202.1 172.4 202.1 172.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.3L202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.3 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.4 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.5 202.1 172.6 202.1 172.6"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.5L202.1 172.5 202.1 172.6"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.7L202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.6 202.1 172.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 172.7L202.1 172.7 202.1 172.7 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202 172.8 202 172.8 202 172.8 202 172.8 202 172.8 202 172.8 202 172.8 202 172.8 202 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8 202.1 172.8"
                  className="st7"
                ></path>
                <path d="M202.3 173.7L202.1 173.7" className="st7"></path>
                <path
                  d="M202.3 173.7L202.3 173.7 202.3 173.6 202.3 173.6 202.3 173.6 202.3 173.6 202.3 173.6 202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.7 202.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.7L202.3 173.7 202.3 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.7 202.4 173.8 202.4 173.8 202.4 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.7L202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.7L202.2 173.7 202.2 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.7 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.3 173.8 202.2 173.8 202.2 173.8 202.2 173.8 202.2 173.8 202.2 173.8 202.2 173.8 202.2 173.8 202.2 173.8 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.7 202.1 173.7 202.1 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.8 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.3 173.7 202.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.7L202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.2 173.7 202.2 173.7 202.2 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.7 202 173.7 202 173.7 202 173.7 202 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7 202.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.7L202.3 173.7 202.3 173.7"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.7L202.1 173.7 202.1 173.7 202.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.8L202.3 173.8 202.3 173.8"
                  className="st7"
                ></path>
                <path
                  d="M202.2 173.8L202.1 173.8 202.1 173.8 202.1 173.8 202.1 173.8"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.6L202.3 173.6 202.3 173.6 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.4 173.3L202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.3 173.3 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.3 173.2 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.4 202.3 173.4 202.3 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.5 202.4 173.5 202.4 173.5"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.1L202.3 173.1 202.3 173.2 202.3 173.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.3L202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.2 173.2 202.2 173.2"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.5L202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.2 173.4 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.3 202.3 173.4 202.3 173.4 202.3 173.4 202.4 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.4L202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.3 202.3 173.3 202.3 173.3 202.2 173.3 202.2 173.3"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.3L202.3 173.3 202.3 173.3 202.3 173.3"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.4L202.3 173.4 202.3 173.4 202.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.5L202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.6"
                  className="st7"
                ></path>
                <path
                  d="M202.2 173.4L202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.3 173.4 202.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.6L202.3 173.6 202.3 173.6 202.3 173.6 202.3 173.6 202.3 173.6 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.3 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.5 202.3 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.3 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6"
                  className="st7"
                ></path>
                <path
                  d="M202.2 173.6L202.2 173.6 202.1 173.6 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.6L202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.3 202 173.3 202 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.1 202.1 173.1 202.1 173.1 202.1 173.1 202.1 173.1 202.1 173.1 202.1 173.1 202.1 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173 202.2 173 202.2 173 202.2 173 202.2 173 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.3L202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.3 202.2 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.5 202.1 173.5 202.1 173.5"
                  className="st7"
                ></path>
                <path
                  d="M202.2 173.1L202.2 173.1 202.2 173.2 202.2 173.2"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.3L202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.1 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2 202.2 173.2"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.5L202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.2 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.3 202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.4L202.1 173.4 202.1 173.4 202.1 173.4 202.1 173.3 202.1 173.3 202.2 173.3 202.2 173.3 202.2 173.3"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.3L202.1 173.3 202.1 173.3 202.2 173.3"
                  className="st7"
                ></path>
                <path
                  d="M202.1 173.4L202.1 173.4 202.1 173.4 202.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.2 173.5L202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.6"
                  className="st7"
                ></path>
                <path
                  d="M202.2 173.4L202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M202.2 173.6L202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.6 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.5 202.1 173.4 202.1 173.4 202.1 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.4 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.5 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6 202.2 173.6"
                  className="st7"
                ></path>
                <path
                  d="M202.3 173.6L202.3 173.6 202.3 173.6 202.3 173.6 202.4 173.5 202.4 173.5 202.4 173.5 202.4 173.5 202.4 173.5 202.4 173.5 202.4 173.5 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.2 202.4 173.2 202.4 173.2 202.4 173.2 202.4 173.2 202.4 173.2 202.4 173.2 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173 202.2 173 202.2 173 202.2 173 202.2 173 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.2 173.1 202.3 173.1 202.3 173.1 202.3 173.1 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.3 173.2 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.3 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4 202.4 173.4"
                  className="st7"
                ></path>
                <path d="M178 170L178.2 170" className="st7"></path>
                <path
                  d="M178.5 171.6L178.5 171.6 178.5 171.5 178.5 171.5 178.5 171.5 178.5 171.5 178.6 171.5 178.6 171.5 178.6 171.5 178.6 171.5 178.6 171.5"
                  className="st7"
                ></path>
                <path d="M178.9 171.4L178.8 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.8 171.4L178.8 171.4" className="st7"></path>
                <path d="M178.7 171.3L178.1 171.3" className="st7"></path>
                <path d="M178.7 171.3L178.1 171.3" className="st7"></path>
                <path d="M178.7 171.3L178.1 171.3" className="st7"></path>
                <path
                  d="M178.9 171.4L178.9 171.4 178.9 171.4 178.9 171.4 178.8 171.4 178.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 171.5L178.1 171.5 178.1 171.4 178.2 171.4 178.2 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 171.5L178.1 171.5 178.1 171.4 178.1 171.4 178.1 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 171.4L178.1 171.4 178.1 171.5 178.1 171.5"
                  className="st7"
                ></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.2 171.4L178.2 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.8 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.4 170.2L178.4 170.2" className="st7"></path>
                <path
                  d="M178.1 170.1L178.4 170.1 178.4 170.2 178.4 170.2"
                  className="st7"
                ></path>
                <path d="M178.2 170" className="st7"></path>
                <path
                  d="M178.2 170L178.3 170 178.3 170 178.3 170 178.3 170 178.3 170 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.4 170.1 178.4 170.1 178.4 170.1 178.4 170.1 178.4 170.1 178.4 170.1"
                  className="st7"
                ></path>
                <path
                  d="M178.4 170.1L178.4 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170 178.2 170 178.2 170 178.2 170 178.2 170 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1"
                  className="st7"
                ></path>
                <path
                  d="M178.2 170.1L178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.2 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170 178.1 170 178.1 170 178.1 170"
                  className="st7"
                ></path>
                <path
                  d="M178.2 170.1L178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1 178.3 170.1"
                  className="st7"
                ></path>
                <path
                  d="M178.1 170.1L178.1 170.1 178.1 170.1 178.1 170.1"
                  className="st7"
                ></path>
                <path
                  d="M178.1 171.5L178.1 171.5 178.1 171.4 178.1 171.4"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.6L178.7 171.6 178.7 171.6 178.7 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.4 178.8 171.4 178.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171.4L178.8 171.4 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.6 178.8 171.6 178.8 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.5L178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.5L178.7 171.5 178.7 171.5 178.7 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.6L178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.5 178.6 171.5 178.6 171.5 178.6 171.5 178.6 171.5 178.6 171.5 178.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.5L178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5 178.7 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.5L178.7 171.4 178.7 171.4"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.5L178.6 171.5 178.6 171.5 178.7 171.4 178.7 171.4 178.7 171.4 178.7 171.4 178.7 171.4 178.7 171.4 178.7 171.4 178.7 171.4"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.5L178.7 171.5 178.7 171.5 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.8 171.6"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.5L178.7 171.5 178.6 171.5 178.6 171.5 178.6 171.5 178.7 171.5 178.7 171.5 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.7 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.6 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.5 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.3 178.7 171.3"
                  className="st7"
                ></path>
                <path
                  d="M178.4 170.2L178.5 170.2 178.5 170.3 178.6 170.3 178.6 170.4 178.7 170.5 178.7 170.6 178.7 170.7 178.7 170.9 178.7 171"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171.4L178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.7 171.3 178.7 171.4 178.7 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4 178.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.4L178.7 171.4 178.7 171.4"
                  className="st7"
                ></path>
                <path d="M178.8 171L178.7 171" className="st7"></path>
                <path
                  d="M178.8 171L178.8 171 178.8 171 178.8 171 178.7 171 178.7 171 178.7 171"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171L178.8 171 178.8 171 178.8 171 178.8 171 178.8 171 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.8 171.3 178.7 171.3 178.7 171.3 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.2 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171 178.8 171 178.8 171"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171.3L178.8 171.3 178.8 171.3 178.7 171.3 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171.1L178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.2 178.8 171.2 178.8 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.8 171.2 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171 178.8 171 178.8 171 178.8 171 178.8 171 178.7 171"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171L178.8 171 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.8 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.8 171.1 178.8 171.1 178.8 171 178.8 171 178.8 171 178.7 171"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171L178.7 171 178.7 171 178.7 171 178.7 171 178.7 171 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.1L178.7 171.1 178.7 171.1 178.7 171.2"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.1L178.7 171.1 178.7 171.1 178.7 171.1"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171L178.7 171 178.7 171 178.7 171 178.7 171 178.7 171 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171 178.7 171 178.7 171"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.1L178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.2 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171.1 178.7 171 178.7 171 178.7 171 178.7 171 178.7 171 178.7 171 178.7 171"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.4L178.7 171.4 178.7 171.3 178.7 171.3 178.7 171.3 178.7 171.3 178.7 171.3 178.7 171.3 178.7 171.3 178.7 171.3 178.7 171.2"
                  className="st7"
                ></path>
                <path
                  d="M178.7 171.4L178.7 171.4 178.8 171.4"
                  className="st7"
                ></path>
                <path d="M178.8 171.3L178.8 171.3" className="st7"></path>
                <path
                  d="M178.7 171.4L178.7 171.4 178.7 171.4"
                  className="st7"
                ></path>
                <path d="M178.3 170.2L178.3 170.2" className="st7"></path>
                <path
                  d="M178.4 170.2L178.3 170.2 178.3 170.2 178.4 170.2"
                  className="st7"
                ></path>
                <path d="M178.4 170.2L178.4 170.2" className="st7"></path>
                <path d="M178.4 170.2L178.3 170.2" className="st7"></path>
                <path
                  d="M178.4 170.2L178.4 170.1 178.4 170.1 178.4 170.1 178.4 170.2 178.3 170.2 178.3 170.2 178.3 170.2 178.3 170.2 178.3 170.2 178.4 170.2 178.4 170.2 178.4 170.2 178.4 170.2 178.4 170.2"
                  className="st7"
                ></path>
                <path
                  d="M178.4 170.2L178.4 170.2 178.4 170.2 178.4 170.2 178.4 170.2 178.4 170.2 178.4 170.2 178.4 170.2 178.4 170.2"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171L178.8 170.8 178.8 170.7 178.7 170.6 178.7 170.6 178.7 170.5 178.7 170.5 178.7 170.4 178.6 170.4 178.6 170.3 178.6 170.3 178.5 170.2 178.5 170.2 178.5 170.2 178.5 170.2 178.4 170.2 178.4 170.2 178.4 170.2"
                  className="st7"
                ></path>
                <path
                  d="M178.8 171.5L178.8 171.5 178.8 171.4 178.9 171.4 178.9 171.4 178.9 171.4"
                  className="st7"
                ></path>
                <path d="M178.8 171.5L178.8 171.5" className="st7"></path>
                <path d="M178.7 171.2L178.1 171.2" className="st7"></path>
                <path d="M178.8 171.4L178.8 171.4" className="st7"></path>
                <path d="M178.8 171.4L178.2 171.4" className="st7"></path>
                <path d="M178.8 171.4L178.2 171.4" className="st7"></path>
                <path d="M178.3 170.2L178.1 170.2" className="st7"></path>
                <path d="M178.4 170.2L178.1 170.2" className="st7"></path>
                <path d="M178.1 170L178.1 170" className="st7"></path>
                <path d="M178.7 171.3L178.7 171.3" className="st7"></path>
                <path
                  d="M177.7 171.6L177.7 171.6 177.7 171.5 177.7 171.5 177.7 171.5 177.7 171.5 177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.5"
                  className="st7"
                ></path>
                <path d="M177.3 171.4L177.4 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M177.4 171.4L177.4 171.4" className="st7"></path>
                <path d="M177.5 171.3L178.1 171.3" className="st7"></path>
                <path d="M177.5 171.3L178.1 171.3" className="st7"></path>
                <path d="M177.5 171.3L178.1 171.3" className="st7"></path>
                <path
                  d="M177.3 171.4L177.3 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4"
                  className="st7"
                ></path>
                <path
                  d="M178 171.5L178.1 171.5 178.1 171.4 178 171.4 178 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 171.5L178.1 171.5 178.1 171.4 178.1 171.4 178.1 171.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 171.4L178.1 171.4 178.1 171.5 178.1 171.5"
                  className="st7"
                ></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178 171.4L178 171.4" className="st7"></path>
                <path d="M178.1 171.4L177.4 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M178.1 171.4L178.1 171.4" className="st7"></path>
                <path d="M177.8 170.2L177.8 170.2" className="st7"></path>
                <path
                  d="M178.1 170.1L177.8 170.1 177.8 170.2 177.8 170.2"
                  className="st7"
                ></path>
                <path d="M178.2 170L178 170" className="st7"></path>
                <path d="M178 170" className="st7"></path>
                <path
                  d="M178.2 170L178 170 178 170 177.9 170 177.9 170 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.8 170.1 177.8 170.1 177.8 170.1 177.8 170.1 177.8 170.1"
                  className="st7"
                ></path>
                <path
                  d="M177.9 170.1L177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170 178 170 178 170 178 170 178 170 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1"
                  className="st7"
                ></path>
                <path
                  d="M178 170.1L178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170.1 178.1 170 178.1 170 178.1 170 178.1 170"
                  className="st7"
                ></path>
                <path
                  d="M178 170.1L178 170.1 178 170.1 178 170.1 178 170.1 177.9 170.1 177.9 170.1 177.9 170.1 177.9 170.1"
                  className="st7"
                ></path>
                <path
                  d="M178.1 170.1L178.1 170.1 178.1 170.1"
                  className="st7"
                ></path>
                <path
                  d="M178.1 171.5L178.1 171.5 178.1 171.4 178.1 171.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.6L177.5 171.6 177.5 171.6 177.5 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.4 177.4 171.4 177.4 171.4"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171.4L177.4 171.4 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.6 177.4 171.6 177.4 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.5L177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.6 171.5 177.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.5L177.5 171.5 177.5 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.6L177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.6 171.6 177.6 171.6 177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.5L177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5 177.5 171.5"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.5L177.5 171.4 177.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M177.6 171.5L177.6 171.5 177.6 171.4 177.5 171.4 177.5 171.4 177.5 171.4 177.5 171.4 177.5 171.4 177.5 171.4 177.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.5L177.5 171.5 177.5 171.5 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.4 171.6"
                  className="st7"
                ></path>
                <path
                  d="M177.6 171.5L177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.5 177.6 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.5 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.6 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.5 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.5 171.3"
                  className="st7"
                ></path>
                <path
                  d="M177.8 170.2L177.8 170.2 177.7 170.3 177.6 170.3 177.6 170.4 177.6 170.5 177.5 170.6 177.5 170.7 177.5 170.9 177.5 171"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171.4L177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.5 171.3 177.5 171.4 177.5 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4 177.4 171.4"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.4L177.5 171.4 177.5 171.4"
                  className="st7"
                ></path>
                <path d="M177.4 171L177.5 171" className="st7"></path>
                <path
                  d="M177.4 171L177.4 171 177.4 171 177.4 171 177.5 171 177.5 171 177.5 171"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171L177.4 171 177.4 171 177.4 171 177.4 171 177.4 171 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.4 171.3 177.5 171.3 177.5 171.3 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.2 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171 177.4 171 177.4 171 177.4 171"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171.3L177.4 171.3 177.4 171.3 177.5 171.3 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171.1L177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.2 177.4 171.2 177.4 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171 177.4 171 177.4 171 177.4 171 177.4 171 177.5 171"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171L177.4 171 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.4 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.4 171.1 177.4 171 177.4 171 177.4 171 177.5 171"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171L177.5 171 177.5 171 177.5 171 177.5 171 177.5 171 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.1L177.5 171.1 177.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.1L177.5 171.1 177.5 171.1 177.5 171.1"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171L177.5 171 177.5 171 177.5 171 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171 177.5 171 177.5 171"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.1L177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.2 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171.1 177.5 171 177.5 171 177.5 171 177.5 171 177.5 171 177.5 171"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.4L177.5 171.4 177.5 171.4 177.5 171.3 177.5 171.3 177.5 171.3 177.5 171.3 177.5 171.3 177.5 171.3 177.5 171.3 177.5 171.3 177.5 171.3 177.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M177.5 171.4L177.5 171.4 177.4 171.4"
                  className="st7"
                ></path>
                <path d="M177.4 171.3L177.4 171.3" className="st7"></path>
                <path
                  d="M177.5 171.4L177.5 171.4 177.5 171.4"
                  className="st7"
                ></path>
                <path d="M177.9 170.2L177.9 170.2" className="st7"></path>
                <path
                  d="M177.8 170.2L177.9 170.2 177.9 170.2 177.9 170.2"
                  className="st7"
                ></path>
                <path d="M177.8 170.2L177.8 170.2" className="st7"></path>
                <path d="M177.9 170.2L177.9 170.2" className="st7"></path>
                <path
                  d="M177.8 170.2L177.8 170.1 177.8 170.1 177.9 170.1 177.9 170.2 177.9 170.2 177.9 170.2 177.9 170.2 177.9 170.2 177.9 170.2 177.9 170.2 177.8 170.2 177.8 170.2 177.8 170.2 177.8 170.2"
                  className="st7"
                ></path>
                <path
                  d="M177.8 170.2L177.8 170.2 177.9 170.2 177.9 170.2 177.9 170.2 177.9 170.2 177.8 170.2 177.8 170.2 177.8 170.2"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171L177.4 170.8 177.4 170.7 177.5 170.6 177.5 170.6 177.5 170.5 177.5 170.5 177.5 170.4 177.6 170.4 177.6 170.3 177.6 170.3 177.7 170.2 177.7 170.2 177.7 170.2 177.8 170.2 177.8 170.2 177.8 170.2 177.8 170.2"
                  className="st7"
                ></path>
                <path
                  d="M177.4 171.5L177.4 171.5 177.4 171.4 177.4 171.4 177.3 171.4 177.3 171.4"
                  className="st7"
                ></path>
                <path d="M177.4 171.5L177.4 171.5" className="st7"></path>
                <path d="M177.5 171.2L178.1 171.2" className="st7"></path>
                <path d="M177.4 171.4L177.4 171.4" className="st7"></path>
                <path d="M177.4 171.4L178 171.4" className="st7"></path>
                <path d="M177.4 171.4L178 171.4" className="st7"></path>
                <path d="M177.9 170.2L178.1 170.2" className="st7"></path>
                <path d="M177.9 170.2L178.1 170.2" className="st7"></path>
                <path d="M178.1 170L178.1 170" className="st7"></path>
                <path d="M177.5 171.3L177.5 171.3" className="st7"></path>
                <path d="M178 170L178 170 178.1 170" className="st7"></path>
                <path d="M178 170L178.1 170" className="st7"></path>
                <path d="M178 170L178 169.9 178.1 169.9" className="st7"></path>
                <path d="M178 169.9L178.1 169.9" className="st7"></path>
                <path d="M178 169.9L178 169.9" className="st7"></path>
                <path
                  d="M178 170L178 170 178 170 178 170 178 170 178 170"
                  className="st7"
                ></path>
                <path d="M178.2 170L178.2 170 178.1 170" className="st7"></path>
                <path d="M178.2 170L178.1 170" className="st7"></path>
                <path d="M178.2 169.9L178.1 169.9" className="st7"></path>
                <path d="M178.2 170L178.2 169.9" className="st7"></path>
                <path d="M178.2 169.9L178.1 169.9" className="st7"></path>
                <path d="M178.2 169.9L178.2 169.9" className="st7"></path>
                <path d="M178.2 169.9L178.2 169.9" className="st7"></path>
                <path
                  d="M178.2 170L178.2 170 178.1 170 178.1 170 178.2 170 178.2 170"
                  className="st7"
                ></path>
                <path
                  d="M178 169.9L178 169.9 178 169.9 178 169.9 178 169.9 178 169.9 178 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178 169.8L178 169.8 178 169.8 178 169.8 178 169.8 178 169.9 178 169.9 178 169.9 178 169.8 178 169.8 178 169.8 178 169.8 178 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178 169.8L178 169.8 178 169.9 178 169.9 178 169.9 178 169.8 178 169.8 178 169.8 178 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178 169.8L178.1 169.8 178.1 169.8 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8 178 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178 169.8L178 169.8 178 169.8 178 169.8 178.1 169.8 178.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178 169.8L178 169.9 178 169.9 178 169.9 178 169.9 178 169.9 178 169.9 178 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178 169.9L178 169.9 178 169.8 178 169.8 178 169.9 178 169.9 178 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178.1 169.9L178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178.2 169.9L178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178.2 169.8L178.2 169.8 178.2 169.8 178.2 169.8 178.2 169.8 178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.8 178.2 169.8 178.2 169.8 178.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178.2 169.8L178.2 169.8 178.2 169.9 178.2 169.9 178.2 169.8 178.1 169.8 178.1 169.8 178.2 169.8 178.2 169.8 178.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 169.8L178.1 169.8 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8 178.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178.2 169.8L178.2 169.8 178.2 169.8 178.1 169.8 178.1 169.8 178.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178.2 169.8L178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9 178.2 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178.2 169.9L178.2 169.8 178.2 169.8 178.2 169.9 178.2 169.9 178.2 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178.1 169.9L178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9 178.1 169.9"
                  className="st7"
                ></path>
                <path
                  d="M178.1 169.7L178.1 169.7 178.1 169.7 178.1 169.7 178.1 169.7 178.1 169.7 178 169.7 178 169.7 178 169.7 178 169.7 178 169.7 178 169.7 178 169.7 178 169.8 178 169.8 178 169.8 178 169.8 178 169.8 178 169.8 178 169.8 178 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 169.8L178.1 169.8 178.1 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 169.7L178.1 169.7 178.1 169.7 178.1 169.7 178.1 169.7 178.2 169.7 178.2 169.7 178.2 169.7 178.2 169.7 178.2 169.7 178.2 169.8 178.2 169.8 178.2 169.8 178.2 169.8 178.2 169.8 178.2 169.8 178.2 169.8"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172.3L178 172.3 178 172.2"
                  className="st7"
                ></path>
                <path d="M178 172.2L178 172.2" className="st7"></path>
                <path d="M178 172.2" className="st7"></path>
                <path d="M178.2 172.3L178.2 172.2" className="st7"></path>
                <path
                  d="M178.2 172.2L178.2 172.2 178.2 172.2"
                  className="st7"
                ></path>
                <path d="M178.2 172.2" className="st7"></path>
                <path d="M178 172.2L178.2 172.2" className="st7"></path>
                <path d="M178 172.2L178.2 172.2" className="st7"></path>
                <path d="M178 172.1L178.2 172.1" className="st7"></path>
                <path
                  d="M178 172.1c0 .1 0 .1 0 0M178.2 172.2s.1 0 0 0c.1 0 0-.1 0 0 0-.1 0-.1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M178 172.1L178 172.1 178.2 172.1 178.2 172.1"
                  className="st7"
                ></path>
                <path d="M178.2 172.1" className="st7"></path>
                <path d="M178 172.1L178.2 172.1" className="st7"></path>
                <path d="M178 172.1L178.2 172.1" className="st7"></path>
                <path d="M178.1 172.1" className="st7"></path>
                <path
                  d="M177.9 172.8L177.9 172.8 178 172.8 178 172.8 178 172.7 178 172.7 178 172.7 178 172.7 178 172.7 178 172.7 178 172.7 178 172.7 178 172.7 178 172.7 178 172.6 178 172.6 178 172.6 178 172.6 178 172.6 178 172.6 178 172.6 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.3 178 172.3 178 172.3 178 172.3 178 172.3 178 172.3 178 172.3 178 172.3 178 172.3"
                  className="st7"
                ></path>
                <path d="M178 172.3L178 173.1" className="st7"></path>
                <path d="M178.2 172.3L178.2 173.1" className="st7"></path>
                <path d="M178.2 172.1L178 172.1" className="st7"></path>
                <path
                  d="M178.2 172.1L178.2 172 178.1 172"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172L178.2 172 178.2 172 178.2 172 178.2 172 178.2 172 178.1 172"
                  className="st7"
                ></path>
                <path d="M178.2 172L178.2 172 178.1 172" className="st7"></path>
                <path
                  d="M178.2 172L178.2 172 178.2 172 178.2 171.9 178.2 171.9 178.2 171.9 178.3 171.9 178.3 171.9 178.3 171.9 178.3 171.9 178.3 171.9 178.3 171.9 178.3 171.9 178.3 171.9 178.3 171.9 178.4 171.9 178.4 171.9 178.4 171.9 178.4 171.9 178.4 171.9 178.4 171.9 178.4 171.9 178.4 171.9 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.8 178.5 171.7 178.5 171.7 178.5 171.7 178.5 171.7 178.5 171.7 178.1 171.7"
                  className="st7"
                ></path>
                <path d="M178.5 171.7L178.1 171.7" className="st7"></path>
                <path d="M178.5 171.7" className="st7"></path>
                <path d="M178.1 171.6L178.5 171.6" className="st7"></path>
                <path
                  d="M178.1 171.6L178.5 171.6 178.5 171.6"
                  className="st7"
                ></path>
                <path
                  d="M178.5 171.7L178.5 171.7 178.5 171.7 178.4 171.7 178.4 171.7 178.4 171.7 178.4 171.7 178.4 171.6 178.4 171.6 178.4 171.6 178.4 171.6 178.4 171.6 178.5 171.6 178.5 171.6"
                  className="st7"
                ></path>
                <path
                  d="M178.4 171.7L178.4 171.7 178.4 171.7 178.4 171.7 178.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178.4 171.7L178.4 171.7 178.4 171.7 178.4 171.7 178.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178.4 171.7L178.4 171.7 178.4 171.7 178.4 171.7 178.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178.4 171.7L178.4 171.7 178.4 171.7 178.4 171.7 178.4 171.7 178.4 171.7"
                  className="st7"
                ></path>
                <path d="M178.4 171.7L178.4 171.7" className="st7"></path>
                <path
                  d="M178.4 171.7L178.4 171.7 178.3 171.7 178.3 171.7 178.3 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178.3 171.7L178.3 171.7 178.3 171.7 178.3 171.7 178.3 171.7 178.3 171.7"
                  className="st7"
                ></path>
                <path d="M178.3 171.7L178.3 171.7" className="st7"></path>
                <path
                  d="M178.3 171.7L178.3 171.7 178.3 171.7 178.3 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178.3 171.7L178.3 171.7 178.3 171.7 178.3 171.7"
                  className="st7"
                ></path>
                <path d="M178.3 171.7L178.3 171.7" className="st7"></path>
                <path
                  d="M178.2 171.7L178.2 171.7 178.2 171.7 178.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 171.7L178.2 171.7 178.2 171.7 178.2 171.7"
                  className="st7"
                ></path>
                <path d="M178.3 171.6" className="st7"></path>
                <path
                  d="M178.2 171.7L178.2 171.7 178.2 171.7 178.2 171.7 178.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178.1 171.7L178.1 171.7 178.1 171.7 178.1 171.7"
                  className="st7"
                ></path>
                <path d="M178.2 171.6" className="st7"></path>
                <path d="M178.1 171.7L178.1 171.7" className="st7"></path>
                <path d="M178.1 171.6" className="st7"></path>
                <path d="M178.1 171.7L178.1 171.7" className="st7"></path>
                <path d="M178 172.1L178 172 178.1 172" className="st7"></path>
                <path
                  d="M178 172L178 172 178 172 178 172 178 172 178 172 178.1 172"
                  className="st7"
                ></path>
                <path d="M178 172L178 172 178.1 172" className="st7"></path>
                <path
                  d="M178 172L178 172 178 171.9 178 171.9 178 171.9 178 171.9 178 171.9 177.9 171.9 177.9 171.9 177.9 171.9 177.9 171.9 177.9 171.9 177.9 171.9 177.9 171.9 177.9 171.9 177.8 171.9 177.8 171.9 177.8 171.9 177.8 171.9 177.8 171.9 177.8 171.9 177.8 171.9 177.8 171.9 177.8 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.8 177.7 171.7 177.7 171.7 177.7 171.7 177.7 171.7 177.7 171.7 177.7 171.7 178.1 171.7"
                  className="st7"
                ></path>
                <path d="M177.7 171.7L178.1 171.7" className="st7"></path>
                <path d="M177.7 171.7" className="st7"></path>
                <path d="M178.1 171.6L177.7 171.6" className="st7"></path>
                <path
                  d="M178.1 171.6L177.7 171.6 177.7 171.6"
                  className="st7"
                ></path>
                <path d="M177.7 171.6L177.7 171.6" className="st7"></path>
                <path
                  d="M177.7 171.7L177.7 171.7 177.7 171.7 177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.6 177.8 171.6 177.8 171.6 177.8 171.6 177.8 171.6 177.8 171.6 177.7 171.6"
                  className="st7"
                ></path>
                <path
                  d="M177.8 171.7L177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7"
                  className="st7"
                ></path>
                <path
                  d="M177.8 171.7L177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7"
                  className="st7"
                ></path>
                <path d="M177.8 171.7L177.8 171.7" className="st7"></path>
                <path
                  d="M177.8 171.7L177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7"
                  className="st7"
                ></path>
                <path
                  d="M177.8 171.7L177.8 171.7 177.8 171.7 177.8 171.7 177.8 171.7"
                  className="st7"
                ></path>
                <path
                  d="M177.8 171.7L177.9 171.7 177.9 171.7 177.9 171.7 177.9 171.7 177.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M177.9 171.7L177.9 171.7 177.9 171.7 177.9 171.7 177.9 171.7"
                  className="st7"
                ></path>
                <path d="M177.9 171.7L177.9 171.7" className="st7"></path>
                <path
                  d="M177.9 171.7L177.9 171.7 177.9 171.7 177.9 171.7 177.9 171.7"
                  className="st7"
                ></path>
                <path
                  d="M177.9 171.7L177.9 171.7 177.9 171.7 177.9 171.7 177.9 171.7"
                  className="st7"
                ></path>
                <path d="M177.9 171.7L177.9 171.7" className="st7"></path>
                <path
                  d="M178 171.7L178 171.7 178 171.7 178 171.7 178 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178 171.7L178 171.7 178 171.7 178 171.7"
                  className="st7"
                ></path>
                <path d="M178 171.7" className="st7"></path>
                <path
                  d="M178 171.7L178 171.7 178 171.7 178 171.7"
                  className="st7"
                ></path>
                <path
                  d="M178 171.7L178 171.7 178 171.7 178.1 171.7 178.1 171.7"
                  className="st7"
                ></path>
                <path d="M178.1 171.7" className="st7"></path>
                <path d="M178.1 171.7L178.1 171.7" className="st7"></path>
                <path d="M178.1 171.6" className="st7"></path>
                <path d="M178.1 171.7L178.1 171.7" className="st7"></path>
                <path
                  d="M178 171.9c-.1 0-.1.1-.1.2s0 .1.1.2M178.2 172.3c.1 0 .1-.1.1-.2s0-.1-.1-.2"
                  className="st7"
                ></path>
                <path
                  d="M178 172.6L178 172.6 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5"
                  className="st7"
                ></path>
                <path
                  d="M178 172.4L178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4"
                  className="st7"
                ></path>
                <path
                  d="M178 172.3L178 172.3 178 172.3 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4"
                  className="st7"
                ></path>
                <path
                  d="M178 172.3L178 172.3 178 172.3 178 172.3 178 172.3 178 172.3 178 172.3 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.4 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.5 178 172.6 178 172.6"
                  className="st7"
                ></path>
                <path d="M178 172.5L178 172.5 178 172.6" className="st7"></path>
                <path
                  d="M178 172.7L178 172.6 178 172.6 178 172.6 178 172.6 178 172.6 178 172.6 178 172.6 178 172.7"
                  className="st7"
                ></path>
                <path
                  d="M178 172.7L178 172.7 178 172.7 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 177.9 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8 178 172.8"
                  className="st7"
                ></path>
                <path
                  d="M178.3 172.8L178.3 172.8 178.3 172.8 178.2 172.8 178.2 172.7 178.2 172.7 178.2 172.7 178.2 172.7 178.2 172.7 178.2 172.7 178.2 172.7 178.2 172.7 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.2"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172.6L178.2 172.6 178.2 172.6 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172.3L178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172.3L178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.3 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.4 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.5 178.2 172.6 178.2 172.6"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172.5L178.2 172.5 178.2 172.6"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172.7L178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.6 178.2 172.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 172.7L178.2 172.7 178.2 172.7 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.3 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8 178.2 172.8"
                  className="st7"
                ></path>
                <path d="M178 173.7L178.2 173.7" className="st7"></path>
                <path
                  d="M178 173.7L178 173.6 178 173.6 178 173.6 178 173.6 178 173.6 178 173.6 178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.7 178.2 173.7"
                  className="st7"
                ></path>
                <path
                  d="M178 173.7L178 173.7 178 173.7 178 173.7 178 173.7 177.9 173.7 177.9 173.7 177.9 173.7 177.9 173.7 177.9 173.7 177.9 173.7 178 173.8 178 173.8 178 173.8 178 173.8 178 173.8 178 173.8 178 173.8 178 173.8 178 173.8 178 173.8 178 173.8 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178.1 173.7 178.1 173.7 178.1 173.7"
                  className="st7"
                ></path>
                <path
                  d="M178 173.7L178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7"
                  className="st7"
                ></path>
                <path
                  d="M178.1 173.7L178.1 173.7 178.1 173.7 178.1 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.7 178 173.8 178 173.8 178 173.8 178 173.8 178.1 173.8 178.1 173.8 178.1 173.8 178.1 173.8 178.1 173.8 178.1 173.8 178.1 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.8 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178.1 173.7 178 173.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.7L178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.2 173.8 178.3 173.8 178.3 173.8 178.3 173.7 178.3 173.7 178.3 173.7 178.3 173.7 178.3 173.7 178.3 173.7 178.3 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7 178.2 173.7"
                  className="st7"
                ></path>
                <path
                  d="M178 173.7L178 173.7 178 173.7 178 173.7 178 173.7"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.7L178.2 173.7 178.2 173.7"
                  className="st7"
                ></path>
                <path d="M178 173.8L178 173.8 178 173.8" className="st7"></path>
                <path
                  d="M178.1 173.8L178.2 173.8 178.2 173.8 178.2 173.8"
                  className="st7"
                ></path>
                <path
                  d="M178.1 173.6L178 173.6 178 173.6 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178.1 173.5 178.1 173.4 178.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M177.9 173.3L178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178 173.5 178 173.5 178 173.5"
                  className="st7"
                ></path>
                <path
                  d="M178 173.1L178 173.2 178 173.2 178 173.2"
                  className="st7"
                ></path>
                <path
                  d="M178 173.3L178 173.3 178 173.3 178 173.3 178 173.3 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2"
                  className="st7"
                ></path>
                <path
                  d="M178 173.5L178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4 178 173.4"
                  className="st7"
                ></path>
                <path
                  d="M178 173.4L178 173.4 178 173.4 178 173.4 178 173.3 178 173.3 178.1 173.3 178.1 173.3 178.1 173.3"
                  className="st7"
                ></path>
                <path d="M178 173.3L178 173.3 178 173.3" className="st7"></path>
                <path d="M178 173.4L178 173.4 178 173.4" className="st7"></path>
                <path
                  d="M178.1 173.5L178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.6"
                  className="st7"
                ></path>
                <path
                  d="M178.1 173.4L178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M178 173.6L178 173.6 178 173.6 178 173.6 178 173.6 178 173.6 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.4 178 173.4 178 173.4 178 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178 173.5 178 173.5 178 173.5 178.1 173.5 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6"
                  className="st7"
                ></path>
                <path
                  d="M178.1 173.6L178.2 173.6 178.2 173.6 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.6L178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.3 173.5 178.3 173.5 178.3 173.5 178.3 173.4 178.3 173.4 178.3 173.4 178.3 173.4 178.3 173.4 178.3 173.4 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.2 178.3 173.2 178.3 173.2 178.3 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.1 178.2 173.1 178.2 173.1 178.2 173.1 178.2 173.1 178.2 173.1 178.2 173.1 178.2 173.1 178.2 173.1 178.2 173.1 178.1 173.1 178.1 173 178.1 173 178.1 173 178.1 173 178.1 173 178.1 173 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.2 173.1 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.3 178.3 173.4 178.3 173.4 178.3 173.4 178.3 173.4 178.3 173.4 178.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M178.3 173.3L178.3 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.5 178.2 173.5 178.2 173.5"
                  className="st7"
                ></path>
                <path
                  d="M178.1 173.1L178.2 173.2 178.2 173.2"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.3L178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.2 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2 178.1 173.2"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.5L178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.1 173.4 178.1 173.4 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.1 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.3 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.4L178.2 173.4 178.2 173.4 178.2 173.4 178.2 173.3 178.2 173.3 178.1 173.3 178.1 173.3 178.1 173.3"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.3L178.2 173.3 178.2 173.3 178.2 173.3"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.4L178.2 173.4 178.2 173.4 178.2 173.4"
                  className="st7"
                ></path>
                <path
                  d="M178.1 173.5L178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.6 178.1 173.6"
                  className="st7"
                ></path>
                <path
                  d="M178.1 173.4L178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4"
                  className="st7"
                ></path>
                <path
                  d="M178.2 173.6L178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.6 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.5 178.2 173.4 178.2 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.4 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.5 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6 178.1 173.6"
                  className="st7"
                ></path>
                <path
                  d="M178 173.6L178 173.6 178 173.6 178 173.6 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 178 173.5 177.9 173.5 177.9 173.4 177.9 173.4 177.9 173.4 177.9 173.4 177.9 173.4 177.9 173.4 177.9 173.3 177.9 173.3 177.9 173.3 177.9 173.3 177.9 173.3 177.9 173.3 177.9 173.3 177.9 173.3 177.9 173.2 177.9 173.2 177.9 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.1 178 173.1 178 173.1 178 173.1 178 173.1 178 173.1 178 173.1 178 173.1 178 173.1 178 173.1 178.1 173 178.1 173 178.1 173 178.1 173 178.1 173 178.1 173 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178.1 173.1 178 173.1 178 173.1 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.2 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 178 173.3 177.9 173.3 177.9 173.4 177.9 173.4 177.9 173.4 177.9 173.4 177.9 173.4 177.9 173.4"
                  className="st7"
                ></path>
                <path
                  d="M109.5 201.7L102.8 201.7 102.8 209.9 109.5 209.9 109.5 201.7"
                  className="st5"
                ></path>
                <path
                  d="M109.4 203.2L106.2 203.2 106.2 209.9"
                  className="st5"
                ></path>
                <path d="M102.9 203.2L106.2 203.2" className="st5"></path>
                <path d="M109.5 203.2L102.8 203.2" className="st5"></path>
                <path
                  d="M227.3 155.8L227.3 136.3 223.4 136.3 223.4 155.8"
                  className="st4"
                ></path>
                <path
                  d="M50.3 155.8L50.3 136.3 46.4 136.3 46.4 155.8"
                  className="st4"
                ></path>
                <path
                  d="M175.6 93.6L175.6 93.9 175.3 93.9 175.3 94.1 175.2 94.1 175.2 94.3 175 94.3 90.5 94.3"
                  className="st4"
                ></path>
                <path
                  d="M172.9 72.9L172.9 73.2 172.6 73.2 172.6 73.4 172.4 73.4 172.4 73.5 172.2 73.5 125.4 73.5"
                  className="st4"
                ></path>
                <path
                  d="M89.8 93.6L89.8 93.9 90.1 93.9 90.1 94.1 90.3 94.1 90.3 94.3 90.5 94.3"
                  className="st4"
                ></path>
                <path d="M175.6 100.1L89.8 100.1" className="st4"></path>
                <path d="M175.3 100.7L90.5 100.7" className="st4"></path>
                <path
                  d="M90.5 100.7L90.3 100.7 90.3 100.6 90.1 100.6 90.1 100.4 89.8 100.4 89.8 100.1"
                  className="st4"
                ></path>
                <path
                  d="M175.6 100.1L175.6 100.4 175.3 100.4 175.3 100.6 175.2 100.6 175.2 100.7 175 100.7"
                  className="st4"
                ></path>
                <path
                  d="M124.9 72.9L124.9 73.2 125.3 73.2 125.3 73.4 125.4 73.4 125.4 73.5 125.6 73.5"
                  className="st4"
                ></path>
                <path d="M172.9 79.4L124.9 79.4" className="st4"></path>
                <path
                  d="M172.9 79.4L172.9 79.7 172.6 79.7 172.6 79.8 172.4 79.8 172.4 80 172.2 80 125.4 80"
                  className="st4"
                ></path>
                <path
                  d="M124.9 79.4L124.9 79.7 125.3 79.7 125.3 79.8 125.4 79.8 125.4 80 125.6 80"
                  className="st4"
                ></path>
                <path d="M154.8 41.8L124.9 41.8" className="st4"></path>
                <path
                  d="M154.8 41.8L154.8 42.1 154.5 42.1 154.5 42.3 154.3 42.3 154.3 42.4 154.2 42.4 125.4 42.4"
                  className="st4"
                ></path>
                <path
                  d="M124.9 41.8L124.9 42.1 125.3 42.1 125.3 42.3 125.4 42.3 125.4 42.4 125.6 42.4"
                  className="st4"
                ></path>
                <path d="M153.5 37.9L153.5 31.4" className="st4"></path>
                <path d="M144.4 37.9L144.4 31.4" className="st4"></path>
                <path d="M135.3 37.9L135.3 31.4" className="st4"></path>
                <path
                  d="M153.5 31.4L126.3 31.4 126.3 37.9"
                  className="st4"
                ></path>
                <path
                  d="M132.5 47.6L132.5 52.6 128.6 52.6 128.6 47.6"
                  className="st5"
                ></path>
                <path
                  d="M128.6 47.8L128.6 47.6 132.5 47.6 132.5 47.8"
                  className="st5"
                ></path>
                <path
                  d="M132.5 47.8L132.5 52.6 130.6 52.6 130.6 47.8"
                  className="st5"
                ></path>
                <path d="M130.6 52.6L130.6 47.6" className="st5"></path>
                <path d="M129.2 46.3L130.5 47.6" className="st5"></path>
                <path d="M132 46.3L130.7 47.6" className="st5"></path>
                <path d="M130.6 45.7L130.6 47.6" className="st5"></path>
                <path d="M154.2 58.6L152.4 58.6" className="st8"></path>
                <path d="M151.6 58.6L150 58.6" className="st8"></path>
                <path d="M149.2 58.6L147.6 58.6" className="st8"></path>
                <path d="M146.8 58.6L145.1 58.6" className="st8"></path>
                <path d="M144.3 58.6L142.7 58.6" className="st8"></path>
                <path d="M141.9 58.6L140.3 58.6" className="st8"></path>
                <path d="M139.5 58.6L137.9 58.6" className="st8"></path>
                <path d="M137 58.6L135.4 58.6" className="st8"></path>
                <path d="M134.6 58.6L133 58.6" className="st8"></path>
                <path d="M132.2 58.6L130.6 58.6" className="st8"></path>
                <path d="M129.8 58.6L128.1 58.6" className="st8"></path>
                <path d="M127.3 58.6L125.6 58.6" className="st8"></path>
                <path d="M227.3 183L226.4 183" className="st8"></path>
                <path d="M225.6 183L224 183" className="st8"></path>
                <path d="M223.2 183L221.5 183" className="st9"></path>
                <path d="M220.7 183L219.1 183" className="st9"></path>
                <path d="M218.3 183L216.7 183" className="st9"></path>
                <path d="M215.9 183L214.3 183" className="st9"></path>
                <path d="M213.4 183L211.8 183" className="st9"></path>
                <path d="M211 183L209.4 183" className="st9"></path>
                <path d="M208.6 183L207 183" className="st8"></path>
                <path d="M206.2 183L204.5 183" className="st8"></path>
                <path d="M203.7 183L202.1 183" className="st8"></path>
                <path d="M201.3 183L199.7 183" className="st8"></path>
                <path d="M198.9 183L197.2 183" className="st8"></path>
                <path d="M196.4 183L194.8 183" className="st8"></path>
                <path d="M194 183L192.4 183" className="st8"></path>
                <path d="M191.6 183L190 183" className="st8"></path>
                <path d="M189.2 183L187.5 183" className="st8"></path>
                <path d="M186.7 183L185.1 183" className="st8"></path>
                <path d="M184.3 183L182.7 183" className="st8"></path>
                <path d="M181.9 183L180.2 183" className="st8"></path>
                <path d="M179.4 183L177.8 183" className="st8"></path>
                <path d="M177 183L175.4 183" className="st8"></path>
                <path d="M174.6 183L173 183" className="st8"></path>
                <path d="M172.2 183L170.5 183" className="st8"></path>
                <path d="M169.7 183L168.1 183" className="st8"></path>
                <path d="M167.3 183L165.7 183" className="st8"></path>
                <path d="M164.9 183L163.2 183" className="st8"></path>
                <path d="M162.4 183L160.8 183" className="st8"></path>
                <path d="M160 183L158.4 183" className="st8"></path>
                <path d="M157.6 183L156 183" className="st8"></path>
                <path d="M155.2 183L153.5 183" className="st8"></path>
                <path d="M152.7 183L151.1 183" className="st8"></path>
                <path d="M150.3 183L148.7 183" className="st8"></path>
                <path d="M147.9 183L146.2 183" className="st8"></path>
                <path d="M145.4 183L143.8 183" className="st8"></path>
                <path d="M143 183L141.4 183" className="st8"></path>
                <path d="M140.6 183L138.9 183" className="st8"></path>
                <path d="M138.1 183L136.5 183" className="st8"></path>
                <path d="M135.7 183L134.1 183" className="st8"></path>
                <path d="M133.3 183L131.7 183" className="st8"></path>
                <path d="M130.9 183L129.2 183" className="st8"></path>
                <path d="M128.4 183L126.8 183" className="st8"></path>
                <path d="M126 183L124.4 183" className="st8"></path>
                <path d="M123.6 183L121.9 183" className="st8"></path>
                <path d="M121.1 183L119.5 183" className="st8"></path>
                <path d="M118.7 183L117.1 183" className="st8"></path>
                <path d="M116.3 183L114.7 183" className="st8"></path>
                <path d="M113.9 183L112.2 183" className="st8"></path>
                <path d="M111.4 183L109.8 183" className="st8"></path>
                <path d="M109 183L107.4 183" className="st8"></path>
                <path d="M106.6 183L104.9 183" className="st8"></path>
                <path d="M104.1 183L102.5 183" className="st8"></path>
                <path d="M101.7 183L100.1 183" className="st8"></path>
                <path d="M99.3 183L97.7 183" className="st8"></path>
                <path d="M96.9 183L95.2 183" className="st8"></path>
                <path d="M94.4 183L92.8 183" className="st8"></path>
                <path d="M92 183L90.4 183" className="st8"></path>
                <path d="M89.6 183L87.9 183" className="st8"></path>
                <path d="M87.1 183L85.5 183" className="st8"></path>
                <path d="M84.7 183L83.1 183" className="st8"></path>
                <path d="M82.3 183L80.6 183" className="st8"></path>
                <path d="M79.8 183L78.2 183" className="st8"></path>
                <path d="M77.4 183L75.8 183" className="st8"></path>
                <path d="M75 183L73.4 183" className="st8"></path>
                <path d="M72.6 183L70.9 183" className="st8"></path>
                <path d="M70.1 183L68.5 183" className="st8"></path>
                <path d="M67.7 183L66.1 183" className="st8"></path>
                <path d="M65.3 183L63.6 183" className="st8"></path>
                <path d="M62.8 183L61.2 183" className="st8"></path>
                <path d="M60.4 183L58.8 183" className="st8"></path>
                <path d="M58 183L56.4 183" className="st8"></path>
                <path d="M55.6 183L53.9 183" className="st8"></path>
                <path d="M53.1 183L51.5 183" className="st8"></path>
                <path d="M50.7 183L49.1 183" className="st8"></path>
                <path d="M48.3 183L46.6 183" className="st8"></path>
                <path d="M45.8 183L44.2 183" className="st8"></path>
                <path d="M43.4 183L41.8 183" className="st8"></path>
                <path d="M41 183L40.1 183" className="st8"></path>
                <path d="M227.3 162.3L225.9 162.3" className="st8"></path>
                <path d="M225.1 162.3L223.5 162.3" className="st8"></path>
                <path d="M222.7 162.3L221 162.3" className="st8"></path>
                <path d="M220.2 162.3L218.6 162.3" className="st8"></path>
                <path d="M217.8 162.3L216.2 162.3" className="st8"></path>
                <path d="M215.4 162.3L213.8 162.3" className="st8"></path>
                <path d="M212.9 162.3L211.3 162.3" className="st8"></path>
                <path d="M210.5 162.3L208.9 162.3" className="st8"></path>
                <path d="M208.1 162.3L206.5 162.3" className="st8"></path>
                <path d="M205.7 162.3L204 162.3" className="st8"></path>
                <path d="M203.2 162.3L201.6 162.3" className="st8"></path>
                <path d="M200.8 162.3L199.2 162.3" className="st8"></path>
                <path d="M198.4 162.3L196.7 162.3" className="st8"></path>
                <path d="M195.9 162.3L194.3 162.3" className="st8"></path>
                <path d="M193.5 162.3L191.9 162.3" className="st8"></path>
                <path d="M191.1 162.3L189.5 162.3" className="st8"></path>
                <path d="M188.7 162.3L187 162.3" className="st8"></path>
                <path d="M186.2 162.3L184.6 162.3" className="st8"></path>
                <path d="M183.8 162.3L182.2 162.3" className="st8"></path>
                <path d="M181.4 162.3L179.7 162.3" className="st8"></path>
                <path d="M178.9 162.3L177.3 162.3" className="st8"></path>
                <path d="M176.5 162.3L174.9 162.3" className="st8"></path>
                <path d="M174.1 162.3L172.5 162.3" className="st8"></path>
                <path d="M171.6 162.3L170 162.3" className="st8"></path>
                <path d="M169.2 162.3L167.6 162.3" className="st8"></path>
                <path d="M166.8 162.3L165.2 162.3" className="st8"></path>
                <path d="M164.4 162.3L162.7 162.3" className="st8"></path>
                <path d="M161.9 162.3L160.3 162.3" className="st8"></path>
                <path d="M159.5 162.3L157.9 162.3" className="st8"></path>
                <path d="M157.1 162.3L155.5 162.3" className="st8"></path>
                <path d="M154.6 162.3L153 162.3" className="st8"></path>
                <path d="M152.2 162.3L150.6 162.3" className="st8"></path>
                <path d="M149.8 162.3L148.2 162.3" className="st8"></path>
                <path d="M147.4 162.3L145.7 162.3" className="st8"></path>
                <path d="M144.9 162.3L143.3 162.3" className="st8"></path>
                <path d="M142.5 162.3L140.9 162.3" className="st8"></path>
                <path d="M140.1 162.3L138.5 162.3" className="st8"></path>
                <path d="M137.6 162.3L136 162.3" className="st8"></path>
                <path d="M135.2 162.3L133.6 162.3" className="st8"></path>
                <path d="M132.8 162.3L131.2 162.3" className="st8"></path>
                <path d="M130.4 162.3L128.7 162.3" className="st8"></path>
                <path d="M127.9 162.3L126.3 162.3" className="st8"></path>
                <path d="M125.5 162.3L123.9 162.3" className="st8"></path>
                <path d="M123.1 162.3L121.5 162.3" className="st8"></path>
                <path d="M120.6 162.3L119 162.3" className="st8"></path>
                <path d="M118.2 162.3L116.6 162.3" className="st8"></path>
                <path d="M115.8 162.3L114.2 162.3" className="st8"></path>
                <path d="M113.4 162.3L111.7 162.3" className="st8"></path>
                <path d="M110.9 162.3L109.3 162.3" className="st8"></path>
                <path d="M108.5 162.3L106.9 162.3" className="st8"></path>
                <path d="M106.1 162.3L104.5 162.3" className="st8"></path>
                <path d="M103.6 162.3L102 162.3" className="st8"></path>
                <path d="M101.2 162.3L99.6 162.3" className="st8"></path>
                <path d="M98.8 162.3L97.2 162.3" className="st8"></path>
                <path d="M96.4 162.3L94.7 162.3" className="st8"></path>
                <path d="M93.9 162.3L92.3 162.3" className="st8"></path>
                <path d="M91.5 162.3L89.9 162.3" className="st8"></path>
                <path d="M89.1 162.3L87.5 162.3" className="st8"></path>
                <path d="M86.6 162.3L85 162.3" className="st8"></path>
                <path d="M84.2 162.3L82.6 162.3" className="st8"></path>
                <path d="M81.8 162.3L80.2 162.3" className="st8"></path>
                <path d="M79.4 162.3L77.7 162.3" className="st8"></path>
                <path d="M76.9 162.3L75.3 162.3" className="st8"></path>
                <path d="M74.5 162.3L72.9 162.3" className="st8"></path>
                <path d="M72.1 162.3L70.5 162.3" className="st8"></path>
                <path d="M69.6 162.3L68 162.3" className="st8"></path>
                <path d="M67.2 162.3L65.6 162.3" className="st8"></path>
                <path d="M64.8 162.3L63.2 162.3" className="st8"></path>
                <path d="M62.4 162.3L60.7 162.3" className="st8"></path>
                <path d="M59.9 162.3L58.3 162.3" className="st8"></path>
                <path d="M57.5 162.3L55.9 162.3" className="st8"></path>
                <path d="M55.1 162.3L53.4 162.3" className="st8"></path>
                <path d="M52.6 162.3L51 162.3" className="st8"></path>
                <path d="M50.2 162.3L48.6 162.3" className="st8"></path>
                <path d="M47.8 162.3L46.4 162.3" className="st8"></path>
                <path d="M214.3 141.5L213.2 141.5" className="st8"></path>
                <path d="M212.4 141.5L210.8 141.5" className="st8"></path>
                <path d="M210 141.5L208.4 141.5" className="st8"></path>
                <path d="M207.6 141.5L205.9 141.5" className="st8"></path>
                <path d="M205.1 141.5L203.5 141.5" className="st8"></path>
                <path d="M202.7 141.5L201.1 141.5" className="st8"></path>
                <path d="M200.3 141.5L198.6 141.5" className="st8"></path>
                <path d="M197.8 141.5L196.2 141.5" className="st8"></path>
                <path d="M195.4 141.5L193.8 141.5" className="st8"></path>
                <path d="M193 141.5L191.4 141.5" className="st8"></path>
                <path d="M190.6 141.5L188.9 141.5" className="st8"></path>
                <path d="M188.1 141.5L186.5 141.5" className="st8"></path>
                <path d="M185.7 141.5L184.1 141.5" className="st8"></path>
                <path d="M183.3 141.5L181.6 141.5" className="st8"></path>
                <path d="M180.8 141.5L179.2 141.5" className="st8"></path>
                <path d="M178.4 141.5L176.8 141.5" className="st8"></path>
                <path d="M176 141.5L174.3 141.5" className="st8"></path>
                <path d="M173.5 141.5L171.9 141.5" className="st8"></path>
                <path d="M171.1 141.5L169.5 141.5" className="st8"></path>
                <path d="M168.7 141.5L167.1 141.5" className="st8"></path>
                <path d="M166.3 141.5L164.6 141.5" className="st8"></path>
                <path d="M163.8 141.5L162.2 141.5" className="st8"></path>
                <path d="M161.4 141.5L159.8 141.5" className="st8"></path>
                <path d="M159 141.5L157.3 141.5" className="st8"></path>
                <path d="M156.5 141.5L154.9 141.5" className="st8"></path>
                <path d="M154.1 141.5L152.5 141.5" className="st8"></path>
                <path d="M151.7 141.5L150.1 141.5" className="st8"></path>
                <path d="M149.3 141.5L147.6 141.5" className="st8"></path>
                <path d="M146.8 141.5L145.2 141.5" className="st8"></path>
                <path d="M144.4 141.5L142.8 141.5" className="st8"></path>
                <path d="M142 141.5L140.3 141.5" className="st8"></path>
                <path d="M139.5 141.5L137.9 141.5" className="st8"></path>
                <path d="M137.1 141.5L135.5 141.5" className="st8"></path>
                <path d="M134.7 141.5L133.1 141.5" className="st8"></path>
                <path d="M132.3 141.5L130.6 141.5" className="st8"></path>
                <path d="M129.8 141.5L128.2 141.5" className="st8"></path>
                <path d="M127.4 141.5L125.8 141.5" className="st8"></path>
                <path d="M125 141.5L123.3 141.5" className="st8"></path>
                <path d="M122.5 141.5L120.9 141.5" className="st8"></path>
                <path d="M120.1 141.5L118.5 141.5" className="st8"></path>
                <path d="M117.7 141.5L116.1 141.5" className="st8"></path>
                <path d="M115.2 141.5L113.6 141.5" className="st8"></path>
                <path d="M112.8 141.5L111.2 141.5" className="st8"></path>
                <path d="M110.4 141.5L108.8 141.5" className="st8"></path>
                <path d="M108 141.5L106.3 141.5" className="st8"></path>
                <path d="M105.5 141.5L103.9 141.5" className="st8"></path>
                <path d="M103.1 141.5L101.5 141.5" className="st8"></path>
                <path d="M100.7 141.5L99.1 141.5" className="st8"></path>
                <path d="M98.2 141.5L96.6 141.5" className="st8"></path>
                <path d="M95.8 141.5L94.2 141.5" className="st8"></path>
                <path d="M93.4 141.5L91.8 141.5" className="st8"></path>
                <path d="M91 141.5L89.3 141.5" className="st8"></path>
                <path d="M88.5 141.5L86.9 141.5" className="st8"></path>
                <path d="M86.1 141.5L84.5 141.5" className="st8"></path>
                <path d="M83.7 141.5L82.1 141.5" className="st8"></path>
                <path d="M81.2 141.5L79.6 141.5" className="st8"></path>
                <path d="M78.8 141.5L77.2 141.5" className="st8"></path>
                <path d="M76.4 141.5L74.8 141.5" className="st8"></path>
                <path d="M74 141.5L72.3 141.5" className="st8"></path>
                <path d="M71.5 141.5L69.9 141.5" className="st8"></path>
                <path d="M69.1 141.5L67.5 141.5" className="st8"></path>
                <path d="M66.7 141.5L65.1 141.5" className="st8"></path>
                <path d="M64.2 141.5L62.6 141.5" className="st8"></path>
                <path d="M61.8 141.5L60.2 141.5" className="st8"></path>
                <path d="M59.4 141.5L57.8 141.5" className="st8"></path>
                <path d="M56.9 141.5L55.3 141.5" className="st8"></path>
                <path d="M54.5 141.5L52.9 141.5" className="st8"></path>
                <path d="M52.1 141.5L51 141.5" className="st8"></path>
                <path d="M61.2 168.7L56.3 168.7" className="st4"></path>
                <path d="M61.2 168L56 168" className="st4"></path>
                <path d="M56 168L61.2 166.1" className="st4"></path>
                <path d="M56.1 168.2L56 168.2" className="st4"></path>
                <path d="M56.3 168.7L56.3 168.6" className="st4"></path>
                <path d="M56.1 168.2c0 .1.1.3.2.4" className="st4"></path>
                <path d="M210.6 183.3c0 .5.1.9.3 1.3" className="st5"></path>
                <path d="M56 168.2L56 168" className="st4"></path>
                <path
                  d="M222.6 184.6L222.6 184.8 222.4 184.8 222.4 184.9"
                  className="st5"
                ></path>
                <path d="M173.7 123.3L88.7 123.3" className="st4"></path>
                <path d="M174 122.8L88.3 122.8" className="st4"></path>
                <path d="M206.9 183.3L206.2 183.3" className="st5"></path>
                <path d="M88.3 122.8L93.5 120.8" className="st4"></path>
                <path d="M88.5 122.9L88.3 122.9" className="st4"></path>
                <path d="M88.5 122.9c0 .1.1.3.2.4" className="st4"></path>
                <path d="M88.3 122.9L88.3 122.8" className="st4"></path>
                <path d="M174 122.8L168.9 120.8" className="st4"></path>
                <path d="M173.9 122.9L174 122.9" className="st4"></path>
                <path d="M173.7 123.3c.1-.1.1-.2.2-.4" className="st4"></path>
                <path d="M174 122.9L174 122.8" className="st4"></path>
                <path d="M168.9 120.8L93.5 120.8" className="st4"></path>
                <path d="M207.2 123.3L207.2 135.1" className="st4"></path>
                <path d="M219.7 122.8L214.5 120.8" className="st4"></path>
                <path d="M219.6 122.9L219.7 122.9" className="st4"></path>
                <path d="M219.4 123.4L219.4 123.3" className="st4"></path>
                <path d="M219.4 123.3c.1-.1.2-.2.2-.4" className="st4"></path>
                <path d="M219.7 122.9L219.7 122.8" className="st4"></path>
                <path d="M214.5 120.8L203.7 120.8" className="st4"></path>
                <path d="M208.9 122.8L219.7 122.8" className="st4"></path>
                <path d="M208.6 123.3L219.4 123.3" className="st4"></path>
                <path
                  d="M214.5 120.8L214.5 115 214.7 115 214.7 114.8 214.9 114.8 214.9 114.7 215.2 114.7 215.2 114.3 204.4 114.3"
                  className="st4"
                ></path>
                <path d="M214.5 115L203.9 115" className="st4"></path>
                <path
                  d="M54.1 120.8L54.1 115 54 115 54 114.8 53.8 114.8 53.8 114.7 53.5 114.7 53.5 114.3 65 114.3"
                  className="st4"
                ></path>
                <path d="M54.1 115L65.5 115" className="st4"></path>
                <path d="M56.5 123.4L56.5 135.1" className="st4"></path>
                <path d="M61.2 171.9L60.5 171.9" className="st4"></path>
                <path
                  d="M60.7 171.3c-.1-.1-.3-.1-.5 0-.1.1-.1.2-.1.3 0 .1.2.2.3.2M60.7 171.3c.1-.1.1-.3 0-.4M60.8 170.9c-.1-.3-.3-.5-.6-.6M60.2 168.8c-.4.4-.4 1.1 0 1.5"
                  className="st4"
                ></path>
                <path d="M61.2 171.8L60.5 171.8" className="st4"></path>
                <path
                  d="M60.7 171.5c0-.1-.1-.2-.3-.2-.1 0-.2.1-.2.2s.1.2.2.2M60.7 171.5c.2-.2.2-.4.1-.6M60.9 170.9c-.1-.3-.3-.5-.6-.7M60.4 168.8c-.2.2-.3.4-.3.7 0 .3.1.5.3.7"
                  className="st4"
                ></path>
                <path
                  d="M61.2 168.8L59.9 168.8 59.9 168.7 61.2 168.7 61.2 168.8"
                  className="st4"
                ></path>
                <path d="M40.1 201.2L39.5 201.2" className="st4"></path>
                <path
                  d="M39.7 200.7c-.1-.1-.3-.1-.5 0-.1.1-.1.2-.1.3 0 .1.2.2.3.2M39.7 200.7c.1-.1.1-.3 0-.4M39.7 200.3c-.1-.3-.3-.5-.6-.6M39.1 198.1c-.4.4-.4 1.1 0 1.5"
                  className="st4"
                ></path>
                <path d="M40.1 201.1L39.5 201.1" className="st4"></path>
                <path
                  d="M39.7 200.8c0-.1-.2-.2-.3-.2-.1 0-.2.2-.2.3 0 .1.1.2.2.2M39.7 200.8c.2-.2.2-.4.1-.6M39.8 200.2c-.1-.3-.3-.5-.6-.7M39.3 198.1c-.2.2-.3.4-.3.7 0 .3.1.5.3.7"
                  className="st4"
                ></path>
                <path
                  d="M40.1 198.1L38.8 198.1 38.8 198 40.1 198 40.1 198.1"
                  className="st4"
                ></path>
                <path
                  d="M40.1 193.5L34.9 193.5 34.9 196.1 40.1 196.1 40.1 193.5"
                  className="st4"
                ></path>
                <path
                  d="M40.1 198L34.9 198 34.9 196.1 40.1 196.1 40.1 198"
                  className="st4"
                ></path>
                <path d="M116.7 201.8L116.7 201.9" className="st4"></path>
                <path d="M206.2 201.2L206.9 201.2" className="st4"></path>
                <path
                  d="M206.9 201.2c.1 0 .3-.1.3-.2 0-.2-.1-.4-.2-.4s-.2 0-.3.1M206.6 200.3c-.1.1-.1.3 0 .4M207.2 199.6c-.3.1-.5.4-.6.6M207.2 199.6c.4-.4.4-1.1 0-1.5"
                  className="st4"
                ></path>
                <path d="M206.2 201.1L206.9 201.1" className="st4"></path>
                <path
                  d="M206.9 201.1c.1 0 .2-.1.2-.2s-.1-.2-.2-.2-.2.1-.3.2M206.5 200.2c-.1.2 0 .5.1.6M207.1 199.5c-.3.2-.5.4-.6.7M207.1 199.5c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7"
                  className="st4"
                ></path>
                <path
                  d="M206.2 198.1L207.5 198.1 207.5 198 206.2 198 206.2 198.1"
                  className="st4"
                ></path>
                <path
                  d="M206.2 193.5L211.4 193.5 211.4 196.1 206.2 196.1 206.2 193.5"
                  className="st4"
                ></path>
                <path
                  d="M206.2 198L211.4 198 211.4 196.1 206.2 196.1 206.2 198"
                  className="st4"
                ></path>
                <path
                  d="M221.9 177.3L211.6 177.3 211.6 166.4 221.9 166.4 221.9 177.3"
                  className="st5"
                ></path>
                <path
                  d="M221.9 166.4L216.8 166.4 216.8 177.3 221.9 177.3 221.9 166.4"
                  className="st5"
                ></path>
                <path
                  d="M211.6 166.4L216.8 166.4 216.8 177.3 211.6 177.3 211.6 166.4"
                  className="st5"
                ></path>
                <path
                  d="M227.3 219.3L233.8 219.3 233.8 217.3 232.5 217.3 232.5 216.4 207.3 216.4"
                  className="st4"
                ></path>
                <path d="M211.1 184.9L222.4 184.9" className="st5"></path>
                <path d="M223.2 183L210.3 183" className="st5"></path>
                <path
                  d="M210.6 183.3L210.4 183.3 210.4 183.2 210.3 183.2 210.3 183"
                  className="st5"
                ></path>
                <path
                  d="M210.9 184.6L210.9 184.8 211.1 184.8 211.1 184.9"
                  className="st5"
                ></path>
                <path d="M222.6 184.6c.2-.4.3-.8.3-1.3" className="st5"></path>
                <path d="M207 183L206.2 183" className="st5"></path>
                <path
                  d="M222.9 183.3L223.1 183.3 223.1 183.2 223.2 183.2 223.2 183"
                  className="st5"
                ></path>
                <path d="M150.7 201.8L150.7 201.9" className="st4"></path>
                <path
                  d="M207 183L207 183.3 206.9 183.3 206.9 183.5 206.7 183.5 206.7 183.6 206.2 183.6"
                  className="st5"
                ></path>
                <path d="M206.7 183.5L206.2 183.5" className="st5"></path>
                <path d="M210.1 162.3L226.6 162.3" className="st4"></path>
                <path
                  d="M150.2 203.1L150.2 203.2 149.9 203.5 149.9 203.7 150 203.7 150 203.8 149.9 203.8 149.9 204 150 204"
                  className="st4"
                ></path>
                <path d="M150.7 201.9L150.4 202.2" className="st4"></path>
                <path d="M209.6 163.6L226.1 163.6" className="st4"></path>
                <path
                  d="M226.1 163.6L226.1 163.4 226.3 163.4 226.3 163.2"
                  className="st4"
                ></path>
                <path d="M226.3 163.2c.1-.2.1-.4.2-.6" className="st4"></path>
                <path
                  d="M226.5 162.6L226.6 162.6 226.6 162.3"
                  className="st4"
                ></path>
                <path d="M206.2 162.3L210.1 162.3" className="st4"></path>
                <path
                  d="M206.2 163.6L209.6 163.6 209.6 163.4 209.8 163.4 209.8 163.2"
                  className="st4"
                ></path>
                <path d="M209.8 163.2c.1-.2.1-.4.2-.6" className="st4"></path>
                <path
                  d="M210 162.6L210.1 162.6 210.1 162.3"
                  className="st4"
                ></path>
                <path d="M227.3 162.3L231.2 162.3" className="st4"></path>
                <path
                  d="M227.3 163.6L230.7 163.6 230.7 163.4 230.8 163.4 230.8 163.2"
                  className="st4"
                ></path>
                <path d="M230.8 163.2c.1-.2.1-.4.2-.6" className="st4"></path>
                <path
                  d="M231 162.6L231.2 162.6 231.2 162.3"
                  className="st4"
                ></path>
                <path
                  d="M76.6 156.8c.1.3.3.5.6.5s.6-.2.7-.5"
                  className="st4"
                ></path>
                <path
                  d="M77.9 156.8L78.2 156.8 78.2 156.5"
                  className="st4"
                ></path>
                <path
                  d="M78.2 156.5c.5-.3.7-1 .4-1.6-.1-.1-.2-.3-.4-.4"
                  className="st4"
                ></path>
                <path
                  d="M78.2 154.5L78.2 154.2 77.9 154.2"
                  className="st4"
                ></path>
                <path
                  d="M77.9 154.2c-.1-.3-.3-.5-.7-.5-.3 0-.6.2-.6.5"
                  className="st4"
                ></path>
                <path
                  d="M76.6 154.2L76.3 154.2 76.3 154.5"
                  className="st4"
                ></path>
                <path
                  d="M76.3 154.5c-.5.3-.7 1-.4 1.6.1.1.2.3.4.4"
                  className="st4"
                ></path>
                <path
                  d="M76.3 156.5L76.3 156.8 76.6 156.8"
                  className="st4"
                ></path>
                <path
                  d="M115.5 185.6L115.5 185.3 115.1 185.3"
                  className="st4"
                ></path>
                <path d="M122.6 203.6L122.4 219.3" className="st4"></path>
                <path d="M124.8 219.3L124.6 203.6" className="st4"></path>
                <path
                  d="M122.2 203.1c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5"
                  className="st4"
                ></path>
                <path d="M122.2 203.1L125.1 203.1" className="st4"></path>
                <path
                  d="M124.6 203.6c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5M122.5 203.6c0-.2-.1-.3-.3-.3s-.3.1-.3.3c0 .2.1.3.3.3.1 0 .3-.2.3-.3"
                  className="st4"
                ></path>
                <path
                  d="M125.4 203.6c0-.2-.1-.3-.3-.3s-.3.1-.3.3c0 .2.1.3.3.3.2 0 .3-.2.3-.3"
                  className="st4"
                ></path>
                <path
                  d="M117.2 203.1L117.2 203.2 117.5 203.5 117.5 203.7 117.4 203.7 117.4 203.8 117.5 203.8 117.5 204 117.4 204"
                  className="st4"
                ></path>
                <path d="M125.4 201.7L116.7 201.8" className="st4"></path>
                <path
                  d="M121.7 203.1L121.7 203.2 121.4 203.5 121.4 203.7 121.5 203.7 121.5 203.8 121.4 203.8 121.4 204 121.5 204"
                  className="st4"
                ></path>
                <path
                  d="M116.7 201.9L117 202.2 117 202.2 117 202.2 117 202.3 117.1 202.3 117.1 202.4 117.5 202.4 117.5 202.7 117.4 202.7 117.4 202.8 117.5 202.8 117.5 203.1"
                  className="st4"
                ></path>
                <path d="M125.4 201.7L125.4 201.8" className="st4"></path>
                <path
                  d="M125.4 201.8L125.1 202.1 125.1 202.2 125 202.2 125 202.3 125 202.3 125 202.3 124.6 202.3 124.6 202.6 124.7 202.6 124.7 202.7 124.6 202.7 124.6 203"
                  className="st4"
                ></path>
                <path d="M124.6 201.7L124.6 199.8" className="st4"></path>
                <path
                  d="M142.8 199.8c-5.3-4.4-12.9-4.4-18.2 0"
                  className="st4"
                ></path>
                <path d="M142.8 199.8L142.8 201.7" className="st4"></path>
                <path d="M145.7 203.1L150.2 203.1" className="st4"></path>
                <path d="M145.9 204L150 204" className="st4"></path>
                <path d="M149.9 185.6L149.9 201.8" className="st4"></path>
                <path d="M149.9 204L149.9 219.3" className="st4"></path>
                <path d="M146 204L146 219.3" className="st4"></path>
                <path d="M144.7 203.6L144.9 219.3" className="st4"></path>
                <path d="M142.6 219.3L142.8 203.6" className="st4"></path>
                <path
                  d="M144.7 203.6c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5"
                  className="st4"
                ></path>
                <path d="M145.2 203.1L142.3 203.1" className="st4"></path>
                <path
                  d="M142.3 203.1c-.3 0-.5.2-.5.5s.2.5.4.5c.3 0 .5-.2.5-.4v-.1M145.6 203.6c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3 0 .2.1.3.3.3.1 0 .3-.2.3-.3"
                  className="st4"
                ></path>
                <path
                  d="M142.6 203.6c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.2.3-.3"
                  className="st4"
                ></path>
                <path d="M141.9 201.7L150.7 201.8" className="st4"></path>
                <path
                  d="M150.4 202.2L150.4 202.2 150.3 202.2 150.3 202.3 150.3 202.3 150.3 202.4 149.9 202.4 149.9 202.7 149.9 202.7 149.9 202.8 149.9 202.8 149.9 203.1"
                  className="st4"
                ></path>
                <path
                  d="M145.7 203.1L145.7 203.2 146 203.5 146 203.7 145.9 203.7 145.9 203.8 146 203.8 146 204 145.9 204"
                  className="st4"
                ></path>
                <path d="M141.9 201.8L142.3 202.1" className="st4"></path>
                <path
                  d="M100.8 201.7L97.9 201.7 97.9 209.9 100.8 209.9 100.8 201.7"
                  className="st5"
                ></path>
                <path
                  d="M142.3 202.1L142.3 202.2 142.3 202.2 142.3 202.3 142.4 202.3 142.4 202.3 142.8 202.3 142.8 202.6 142.7 202.6 142.7 202.7 142.8 202.7 142.8 203.1"
                  className="st4"
                ></path>
                <path
                  d="M114.4 201.7L111.5 201.7 111.5 209.9 114.4 209.9 114.4 201.7"
                  className="st5"
                ></path>
                <path
                  d="M157.8 201.7L164.6 201.7 164.6 209.9 157.8 209.9 157.8 201.7"
                  className="st5"
                ></path>
                <path
                  d="M164.6 203.2L161.2 203.2 161.2 209.9"
                  className="st5"
                ></path>
                <path
                  d="M157.8 203.2L161.2 203.2 161.2 209.7"
                  className="st5"
                ></path>
                <path
                  d="M166.6 201.7L169.5 201.7 169.5 209.9 166.6 209.9 166.6 201.7"
                  className="st5"
                ></path>
                <path
                  d="M153 201.7L155.9 201.7 155.9 209.9 153 209.9 153 201.7"
                  className="st5"
                ></path>
                <path
                  d="M132.8 187.5L132.5 187.6 132.2 187.7 131.8 187.8 131.5 187.9 131.4 188 131.2 188.1 131.1 188.2 131 188.2 130.8 188.3 130.7 188.4 130.6 188.5 130.5 188.6 130.3 188.7 130.2 188.9 130.1 189 130.1 189.1 130 189.2 129.9 189.3 129.8 189.5 129.7 189.6 129.7 189.7 129.6 189.9 129.6 190 129.5 190.1 129.5 190.3 129.5 190.4 129.5 190.6 129.5 190.7 129.5 190.8 129.5 191 129.5 191.1 129.5 191.3 129.6 191.4 129.6 191.6 129.7 191.7 129.7 191.8 129.8 192 129.9 192.1 130 192.2 130.1 192.3 130.1 192.4 130.2 192.6 130.3 192.7 130.5 192.8 130.6 192.9 130.7 193 130.8 193.1 131 193.2 131.1 193.3 131.2 193.3 131.4 193.4 131.5 193.5 131.8 193.6 132.2 193.7 132.5 193.8 132.8 193.9"
                  className="st4"
                ></path>
                <path
                  d="M134.5 193.9L134.9 193.8 135.2 193.7 135.5 193.6 135.9 193.5 136 193.4 136.1 193.3 136.3 193.3 136.4 193.2 136.6 193.1 136.7 193 136.8 192.9 136.9 192.8 137 192.7 137.1 192.6 137.2 192.4 137.3 192.3 137.4 192.2 137.5 192.1 137.6 192 137.6 191.8 137.7 191.7 137.8 191.6 137.8 191.4 137.8 191.3 137.9 191.1 137.9 191 137.9 190.8 137.9 190.7 137.9 190.6 137.9 190.4 137.9 190.3 137.8 190.1 137.8 190 137.8 189.9 137.7 189.7 137.6 189.6 137.6 189.5 137.5 189.3 137.4 189.2 137.3 189.1 137.2 189 137.1 188.9 137 188.7 136.9 188.6 136.8 188.5 136.7 188.4 136.6 188.3 136.4 188.2 136.3 188.2 136.1 188.1 136 188 135.9 187.9 135.5 187.8 135.2 187.7 134.9 187.6 134.5 187.5"
                  className="st4"
                ></path>
                <path
                  d="M128 194.7c1.1-.1 2.2-.7 2.8-1.6M125.9 192.6c0 .6.2 1.1.6 1.5.4.4.9.6 1.5.6M128.1 192.6c0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1"
                  className="st4"
                ></path>
                <path
                  d="M126.9 192.6c0 .3.3.6.6.6s.6-.3.6-.6M127.5 192.5c0-.2-.2-.3-.3-.3-.2 0-.3.2-.3.3M136.6 193.1c.7.9 1.7 1.5 2.8 1.6M139.4 194.7c.6 0 1.1-.2 1.5-.6.4-.4.6-.9.6-1.5M141.5 192.6c0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1"
                  className="st4"
                ></path>
                <path
                  d="M139.3 192.6c0 .3.3.6.6.6s.6-.3.6-.6M140.5 192.6c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.2M126.7 195c0-.1 0-.1-.1-.2h-.2M125.8 195c0 .2.2.4.4.4s.4-.2.4-.4M126.6 194.1c-.4.1-.7.5-.7.9M126 195.7c0-.1.1-.1.1-.2M125.1 195c-.2.2-.2.6.1.8.2.2.6.2.8-.1"
                  className="st4"
                ></path>
                <path
                  d="M125.6 195.4c.1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0M141 194.8h-.2c-.1 0-.1.1-.1.2M140.7 195c0 .2.2.4.5.4.2 0 .3-.2.4-.4M141.3 195.5c0 .1.1.1.1.2M141.4 195.7c.2.2.5.3.8.1.2-.2.3-.6.1-.8"
                  className="st4"
                ></path>
                <path
                  d="M142.3 195c-.1-.1-.3-.2-.4-.1-.1.1-.2.3 0 .4"
                  className="st4"
                ></path>
                <path d="M133.8 188.1L133.8 187" className="st4"></path>
                <path d="M133.6 187L133.6 188.1" className="st4"></path>
                <path d="M134.2 188.2c.1 0 .2-.1.2-.2" className="st4"></path>
                <path d="M134.3 188L134.4 187.1" className="st4"></path>
                <path d="M134.4 187.1c0-.1-.1-.2-.2-.2" className="st4"></path>
                <path d="M134.3 186.9L133.9 186.9" className="st4"></path>
                <path d="M133.9 186.9c-.1 0-.2.1-.2.2" className="st4"></path>
                <path d="M133.8 187.1L133.8 188" className="st4"></path>
                <path d="M133.8 188c0 .1.1.2.2.2" className="st4"></path>
                <path d="M133.9 188.2L134.2 188.2" className="st4"></path>
                <path
                  d="M133.6 188.1c0 .1.1.1 0 0 .1.1.1.1 0 0 .1.1.2 0 .2 0M133.8 187c0-.1-.1-.1 0 0-.1-.1-.1 0-.2 0"
                  className="st4"
                ></path>
                <path d="M133.4 188.2L133.2 188.2" className="st4"></path>
                <path d="M133.1 188c0 .1.1.2.2.2" className="st4"></path>
                <path d="M133.1 188.1L133 187.1" className="st4"></path>
                <path d="M133.1 186.9c-.1 0-.2.1-.2.2" className="st4"></path>
                <path d="M133.1 186.9L133.4 186.9" className="st4"></path>
                <path d="M133.6 187.1c0-.1-.1-.2-.2-.2" className="st4"></path>
                <path d="M133.6 187.1L133.6 188" className="st4"></path>
                <path
                  d="M133.5 188.2c.1 0 .2-.1.2-.2M132.6 187.1c-.2 0-.3.1-.4.2-.1.1-.1.3-.1.4"
                  className="st4"
                ></path>
                <path d="M132.8 187.2L132.9 188.1" className="st4"></path>
                <path
                  d="M132.8 187.2c-.1-.1-.2-.1-.3-.1M132.9 188.1c0 .1.1.1 0 0 .1.1.1 0 .1 0M135.3 187.7c0-.1 0-.3-.1-.4-.1-.1-.2-.2-.4-.2"
                  className="st4"
                ></path>
                <path d="M134.6 187.2L134.5 188.1" className="st4"></path>
                <path
                  d="M134.9 187.1c-.1 0-.2 0-.3.1M134.3 188.1s0 .1 0 0c.1.1.1.1 0 0 .1.1.1.1.2 0"
                  className="st4"
                ></path>
                <path d="M133.8 193.3L133.8 194.5" className="st4"></path>
                <path d="M133.6 194.5L133.6 193.3" className="st4"></path>
                <path d="M134.3 193.4c0-.1-.1-.2-.2-.2" className="st4"></path>
                <path d="M134.3 193.4L134.4 194.5" className="st4"></path>
                <path d="M134.3 194.7c.1 0 .2-.1.2-.2" className="st4"></path>
                <path d="M134.3 194.6L133.9 194.6" className="st4"></path>
                <path d="M133.8 194.5c0 .1.1.2.2.2" className="st4"></path>
                <path d="M133.8 194.5L133.8 193.4" className="st4"></path>
                <path d="M133.9 193.2c-.1 0-.2.1-.2.2" className="st4"></path>
                <path d="M133.9 193.2L134.2 193.2" className="st4"></path>
                <path
                  d="M133.8 193.3s-.1-.1 0 0c-.1-.1-.1 0-.2 0M133.6 194.5c0 .1.1.1 0 0 .1.1.2 0 .2 0"
                  className="st4"
                ></path>
                <path d="M133.4 193.2L133.2 193.2" className="st4"></path>
                <path d="M133.2 193.2c-.1 0-.2.1-.2.2" className="st4"></path>
                <path d="M133.1 193.3L133 194.5" className="st4"></path>
                <path d="M133 194.5c0 .1.1.2.2.2" className="st4"></path>
                <path d="M133.1 194.6L133.4 194.6" className="st4"></path>
                <path d="M133.5 194.7c.1 0 .2-.1.2-.2" className="st4"></path>
                <path d="M133.6 194.5L133.6 193.4" className="st4"></path>
                <path
                  d="M133.6 193.4c0-.1-.1-.2-.2-.2M132.1 193.7c0 .1 0 .3.1.4.1.1.2.2.4.2"
                  className="st4"
                ></path>
                <path d="M132.8 194.2L132.9 193.3" className="st4"></path>
                <path
                  d="M132.6 194.3c.1 0 .2 0 .3-.1M133.1 193.3c0-.1-.1-.1 0 0-.1-.1-.1-.1 0 0-.1-.1-.1-.1-.1 0M134.9 194.3c.2 0 .3-.1.4-.2.1-.1.1-.3.1-.4"
                  className="st4"
                ></path>
                <path d="M134.6 194.2L134.5 193.3" className="st4"></path>
                <path
                  d="M134.6 194.2c.1.1.2.1.3.1M134.5 193.3c0-.1-.1-.1 0 0-.1-.1-.2 0-.2 0"
                  className="st4"
                ></path>
                <path d="M121.4 177.5L121.4 183" className="st4"></path>
                <path d="M146 177.5L146 183" className="st4"></path>
                <path
                  d="M143.3 158.5c-1-1.2-2.6-1.8-4.1-1.6M143.3 158.5c1.3 1.4 3.1 2.3 5 2.5M144.1 157.5c-1.3-1.3-3.1-2-4.9-1.9M144.1 157.5c1.3 1.4 3.1 2.2 4.9 2.2M139.2 155.5c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3"
                  className="st4"
                ></path>
                <path
                  d="M139.8 157.5c0-.4-.3-.6-.6-.6-.4 0-.6.3-.6.6s.3.6.6.6.6-.2.6-.6"
                  className="st4"
                ></path>
                <path d="M148.3 161L149 159.7" className="st4"></path>
                <path
                  d="M128.2 156.8c-1.6-.1-3.1.5-4.1 1.6M119.1 161c1.9-.2 3.7-1.1 5-2.5M128.2 155.5c-1.8-.1-3.7.6-4.9 1.9M118.4 159.7c1.9-.1 3.7-.9 5-2.2M128.2 158.1c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3"
                  className="st4"
                ></path>
                <path
                  d="M128.9 157.5c0-.4-.3-.6-.6-.6-.4 0-.6.3-.6.6 0 .4.3.6.6.6s.6-.2.6-.6"
                  className="st4"
                ></path>
                <path d="M119.1 161L118.4 159.7" className="st4"></path>
                <path d="M174.1 162.3L145.7 162.3" className="st4"></path>
                <path
                  d="M174.1 163.6L146.2 163.6 146.2 163.4 146.1 163.4 146.1 163.2"
                  className="st4"
                ></path>
                <path d="M145.9 162.6c0 .2.1.4.2.6" className="st4"></path>
                <path
                  d="M145.9 162.6L145.7 162.6 145.7 162.3"
                  className="st4"
                ></path>
                <path
                  d="M136.9 176.5L136.9 168.7 130.4 168.7 130.4 176.5"
                  className="st4"
                ></path>
                <path
                  d="M130.4 168.7L136.9 168.7 136.9 168.1 133.7 167.2 130.4 168.1 130.4 168.7"
                  className="st4"
                ></path>
                <path
                  d="M127 169.3L124.8 169.3 124.8 174.9 127 174.9 127 169.3"
                  className="st4"
                ></path>
                <path d="M129 170L128.8 170" className="st7"></path>
                <path
                  d="M128.5 171.6L128.5 171.6 128.5 171.5 128.5 171.5 128.5 171.5 128.5 171.5 128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.5"
                  className="st7"
                ></path>
                <path d="M128.1 171.4L128.2 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path
                  d="M128.2 171.4L128.2 171.4 128.2 171.4"
                  className="st7"
                ></path>
                <path d="M128.3 171.3L128.9 171.3" className="st7"></path>
                <path d="M128.3 171.3L128.9 171.3" className="st7"></path>
                <path d="M128.3 171.3L128.9 171.3" className="st7"></path>
                <path
                  d="M128.1 171.4L128.1 171.4 128.1 171.4 128.1 171.4 128.1 171.4 128.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M128.8 171.5L128.8 171.5 128.8 171.4 128.8 171.4 128.8 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.9 171.5L128.9 171.5 128.9 171.4 128.9 171.4 128.9 171.5"
                  className="st7"
                ></path>
                <path d="M128.9 171.4L128.9 171.5" className="st7"></path>
                <path d="M128.8 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.8 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.8 171.4L128.8 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.2 171.4" className="st7"></path>
                <path d="M128.8 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.6 170.2L128.6 170.2" className="st7"></path>
                <path
                  d="M128.9 170.1L128.6 170.1 128.6 170.2 128.6 170.2"
                  className="st7"
                ></path>
                <path d="M128.8 170" className="st7"></path>
                <path
                  d="M128.7 170L128.7 170 128.7 170 128.7 170 128.7 170 128.7 170 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.6 170.1 128.6 170.1 128.6 170.1 128.6 170.1 128.6 170.1 128.6 170.1 128.6 170.1"
                  className="st7"
                ></path>
                <path
                  d="M128.6 170.1L128.6 170.1 128.6 170.1 128.6 170.1 128.6 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.8 170.1 128.8 170.1 128.8 170 128.8 170 128.8 170 128.8 170 128.8 170 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.8 170.1"
                  className="st7"
                ></path>
                <path
                  d="M128.7 170.1L128.7 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.8 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170 128.9 170 128.9 170"
                  className="st7"
                ></path>
                <path
                  d="M128.7 170.1L128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1 128.7 170.1"
                  className="st7"
                ></path>
                <path
                  d="M128.9 170.1L128.9 170.1 128.9 170.1"
                  className="st7"
                ></path>
                <path d="M128.9 171.5L128.9 171.4" className="st7"></path>
                <path
                  d="M128.3 171.6L128.3 171.6 128.3 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.4 128.2 171.4 128.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171.4L128.2 171.4 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.5L128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.4 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.5L128.3 171.5 128.3 171.5 128.3 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.3 171.5 128.3 171.5 128.3 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.6L128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.4 171.6 128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.5L128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.5L128.2 171.5 128.2 171.4 128.3 171.4 128.3 171.4"
                  className="st7"
                ></path>
                <path
                  d="M128.4 171.5L128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.4 128.3 171.4 128.3 171.4 128.3 171.4 128.3 171.4 128.3 171.4 128.3 171.4 128.3 171.4"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.5L128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.5 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.2 171.6 128.2 171.6"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.5L128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.5 128.4 171.5 128.3 171.5 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.3 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.6 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.5 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.3"
                  className="st7"
                ></path>
                <path
                  d="M128.6 170.2L128.6 170.2 128.5 170.3 128.4 170.3 128.4 170.4 128.3 170.5 128.3 170.6 128.3 170.7 128.3 170.9 128.3 171"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171.4L128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4 128.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.4L128.3 171.4 128.3 171.4"
                  className="st7"
                ></path>
                <path d="M128.2 171L128.3 171" className="st7"></path>
                <path
                  d="M128.2 171L128.2 171 128.2 171 128.2 171 128.2 171 128.3 171 128.3 171 128.3 171 128.3 171 128.3 171"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171L128.2 171 128.2 171 128.2 171 128.2 171 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.3 128.3 171.3 128.3 171.2 128.3 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171 128.2 171 128.2 171 128.2 171"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171.3L128.2 171.3 128.2 171.3 128.2 171.3 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171.1L128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.2 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.2 171.2 128.2 171.2 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171 128.2 171 128.2 171 128.2 171 128.2 171"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171L128.2 171 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171.1 128.2 171 128.2 171 128.2 171"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171L128.3 171 128.3 171 128.3 171 128.3 171 128.3 171 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.1L128.3 171.1 128.3 171.2"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.1L128.3 171.1 128.3 171.1 128.3 171.1"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171L128.3 171 128.3 171 128.3 171 128.3 171 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171 128.3 171 128.3 171"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.1L128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.2 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171.1 128.3 171 128.3 171 128.3 171 128.3 171 128.3 171 128.3 171"
                  className="st7"
                ></path>
                <path
                  d="M128.3 171.4L128.3 171.4 128.3 171.4 128.3 171.3 128.3 171.3 128.3 171.3 128.3 171.3 128.3 171.3 128.3 171.3 128.3 171.3 128.3 171.3 128.3 171.2"
                  className="st7"
                ></path>
                <path d="M128.3 171.4L128.2 171.4" className="st7"></path>
                <path d="M128.2 171.3L128.2 171.3" className="st7"></path>
                <path
                  d="M128.2 171.4L128.2 171.4 128.3 171.4"
                  className="st7"
                ></path>
                <path d="M128.7 170.2L128.7 170.2" className="st7"></path>
                <path
                  d="M128.6 170.2L128.7 170.2 128.7 170.2 128.6 170.2"
                  className="st7"
                ></path>
                <path
                  d="M128.6 170.2L128.6 170.2 128.6 170.2"
                  className="st7"
                ></path>
                <path d="M128.6 170.2L128.6 170.2" className="st7"></path>
                <path
                  d="M128.6 170.2L128.6 170.2 128.6 170.1 128.6 170.1 128.6 170.1 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2"
                  className="st7"
                ></path>
                <path
                  d="M128.6 170.2L128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2 128.6 170.2"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171L128.2 170.8 128.2 170.7 128.2 170.6 128.3 170.6 128.3 170.5 128.3 170.5 128.3 170.4 128.4 170.4 128.4 170.3 128.4 170.3 128.4 170.2 128.5 170.2 128.5 170.2 128.5 170.2 128.6 170.2 128.6 170.2 128.6 170.2"
                  className="st7"
                ></path>
                <path
                  d="M128.2 171.5L128.1 171.4 128.1 171.4 128.1 171.4 128.1 171.4"
                  className="st7"
                ></path>
                <path d="M128.2 171.5L128.2 171.5" className="st7"></path>
                <path d="M128.3 171.2L128.9 171.2" className="st7"></path>
                <path d="M128.2 171.4L128.2 171.4" className="st7"></path>
                <path d="M128.2 171.4L128.8 171.4" className="st7"></path>
                <path d="M128.2 171.4L128.8 171.4" className="st7"></path>
                <path d="M128.7 170.2L128.9 170.2" className="st7"></path>
                <path d="M128.6 170.2L128.9 170.2" className="st7"></path>
                <path d="M128.9 170L128.9 170" className="st7"></path>
                <path d="M128.2 171.3L128.2 171.3" className="st7"></path>
                <path
                  d="M129.3 171.6L129.3 171.6 129.3 171.5 129.3 171.5 129.3 171.5 129.3 171.5 129.3 171.5 129.3 171.5 129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.5"
                  className="st7"
                ></path>
                <path d="M129.7 171.4L129.6 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M129.6 171.4L129.6 171.4" className="st7"></path>
                <path d="M129.5 171.3L128.9 171.3" className="st7"></path>
                <path d="M129.5 171.3L128.9 171.3" className="st7"></path>
                <path d="M129.5 171.3L128.9 171.3" className="st7"></path>
                <path
                  d="M129.7 171.4L129.7 171.4 129.7 171.4 129.6 171.4 129.6 171.4 129.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M129 171.5L128.9 171.5 128.9 171.4 129 171.4 129 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.9 171.5L128.9 171.5 128.9 171.4 128.9 171.4 128.9 171.5"
                  className="st7"
                ></path>
                <path
                  d="M128.9 171.4L128.9 171.4 128.9 171.5 128.9 171.5"
                  className="st7"
                ></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L129.5 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M128.9 171.4L128.9 171.4" className="st7"></path>
                <path d="M129.2 170.2L129.2 170.2" className="st7"></path>
                <path
                  d="M128.9 170.1L129.2 170.1 129.2 170.2 129.2 170.2"
                  className="st7"
                ></path>
                <path d="M128.8 170L129 170" className="st7"></path>
                <path d="M129 170" className="st7"></path>
                <path
                  d="M128.7 170L129 170 129 170 129 170 129 170 129.1 170 129.1 170 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.2 170.1 129.2 170.1 129.2 170.1 129.2 170.1 129.2 170.1"
                  className="st7"
                ></path>
                <path
                  d="M129.1 170.1L129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129.1 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170 129 170 129 170 129 170 129 170 129 170 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1"
                  className="st7"
                ></path>
                <path
                  d="M129 170.1L129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 129 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170.1 128.9 170 128.9 170 128.9 170 128.9 170"
                  className="st7"
                ></path>
                <path
                  d="M129 170.1L129 170.1 129 170.1 129 170.1 129 170.1 129.1 170.1 129.1 170.1 129.1 170.1"
                  className="st7"
                ></path>
                <path
                  d="M128.9 170.1L128.9 170.1 128.9 170.1 128.9 170.1"
                  className="st7"
                ></path>
                <path
                  d="M128.9 171.5L128.9 171.5 128.9 171.4 128.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.6L129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.6 171.6 129.6 171.6 129.6 171.6 129.6 171.6 129.6 171.6 129.6 171.6 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M129.6 171.4L129.6 171.4 129.6 171.4 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.5 129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.5 129.5 171.5 129.5 171.5 129.5 171.5"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.5L129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.4 171.5 129.4 171.5"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.5L129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.6L129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.4 171.6 129.4 171.6 129.4 171.6 129.4 171.6 129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.5"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.5L129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.5 171.5 129.4 171.5"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.5L129.5 171.4 129.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M129.4 171.5L129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.4 129.4 171.4 129.5 171.4 129.5 171.4 129.5 171.4 129.5 171.4 129.5 171.4 129.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.5L129.5 171.5 129.5 171.5 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6"
                  className="st7"
                ></path>
                <path
                  d="M129.4 171.5L129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.5 129.4 171.6 129.4 171.6 129.4 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.5 171.6 129.6 171.6 129.6 171.6 129.6 171.6 129.6 171.6 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.5 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.5 171.4 129.5 171.3"
                  className="st7"
                ></path>
                <path
                  d="M129.2 170.2L129.2 170.2 129.3 170.3 129.3 170.3 129.4 170.4 129.4 170.5 129.5 170.6 129.5 170.7 129.5 170.9 129.5 171"
                  className="st7"
                ></path>
                <path
                  d="M129.6 171.4L129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.4 129.6 171.3 129.6 171.3 129.6 171.3 129.6 171.3 129.6 171.3 129.6 171.3 129.5 171.3 129.5 171.3 129.5 171.4 129.5 171.4 129.5 171.4 129.5 171.4 129.6 171.4 129.6 171.4 129.6 171.4"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.4L129.5 171.4 129.5 171.4"
                  className="st7"
                ></path>
                <path d="M129.6 171L129.5 171" className="st7"></path>
                <path
                  d="M129.6 171L129.6 171 129.6 171 129.6 171 129.5 171 129.5 171 129.5 171 129.5 171 129.5 171"
                  className="st7"
                ></path>
                <path
                  d="M129.6 171L129.6 171 129.6 171 129.6 171 129.6 171 129.6 171 129.6 171 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.2 129.6 171.2 129.6 171.2 129.6 171.2 129.6 171.2 129.6 171.2 129.6 171.2 129.6 171.2 129.6 171.2 129.6 171.3 129.6 171.3 129.6 171.3 129.6 171.3 129.6 171.3 129.6 171.3 129.5 171.3 129.5 171.3 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.6 171.2 129.6 171.2 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171 129.6 171 129.6 171"
                  className="st7"
                ></path>
                <path
                  d="M129.6 171.3L129.6 171.3 129.5 171.3 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M129.6 171.1L129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.1 129.5 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171 129.6 171 129.5 171 129.5 171 129.5 171"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171L129.6 171 129.6 171 129.6 171.1 129.6 171.1 129.6 171.1 129.6 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171 129.5 171 129.5 171"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171L129.5 171 129.5 171 129.5 171 129.5 171 129.5 171 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.1L129.5 171.1 129.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.1L129.5 171.1 129.5 171.1"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171L129.5 171 129.5 171 129.5 171 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171 129.5 171 129.5 171 129.5 171"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.1L129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.2 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171.1 129.5 171 129.5 171 129.5 171 129.5 171 129.5 171 129.5 171 129.5 171"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.4L129.5 171.4 129.5 171.4 129.5 171.3 129.5 171.3 129.5 171.3 129.5 171.3 129.5 171.3 129.5 171.3 129.5 171.3 129.5 171.3 129.5 171.2"
                  className="st7"
                ></path>
                <path
                  d="M129.5 171.4L129.5 171.4 129.5 171.4"
                  className="st7"
                ></path>
                <path d="M129.6 171.3L129.6 171.3" className="st7"></path>
                <path
                  d="M129.5 171.4L129.5 171.4 129.5 171.4 129.5 171.4"
                  className="st7"
                ></path>
                <path d="M129.1 170.2L129.1 170.2" className="st7"></path>
                <path
                  d="M129.1 170.2L129.1 170.2 129.1 170.2 129.1 170.2"
                  className="st7"
                ></path>
                <path
                  d="M129.2 170.2L129.2 170.2 129.2 170.2"
                  className="st7"
                ></path>
                <path d="M129.1 170.2L129.1 170.2" className="st7"></path>
                <path
                  d="M129.2 170.2L129.2 170.2 129.2 170.1 129.2 170.1 129.1 170.1 129.1 170.2 129.1 170.2 129.1 170.2 129.1 170.2 129.1 170.2 129.1 170.2 129.1 170.2 129.2 170.2 129.2 170.2"
                  className="st7"
                ></path>
                <path
                  d="M129.2 170.2L129.1 170.2 129.1 170.2 129.1 170.2 129.1 170.2 129.1 170.2 129.1 170.2 129.2 170.2 129.2 170.2 129.2 170.2"
                  className="st7"
                ></path>
                <path
                  d="M129.6 171L129.6 170.8 129.5 170.7 129.5 170.6 129.5 170.6 129.5 170.5 129.5 170.5 129.4 170.4 129.4 170.4 129.4 170.3 129.4 170.3 129.3 170.2 129.3 170.2 129.3 170.2 129.2 170.2 129.2 170.2 129.2 170.2 129.2 170.2"
                  className="st7"
                ></path>
                <path
                  d="M129.6 171.5L129.6 171.4 129.6 171.4 129.7 171.4 129.7 171.4 129.7 171.4"
                  className="st7"
                ></path>
                <path d="M129.6 171.5L129.5 171.5" className="st7"></path>
                <path d="M129.5 171.2L128.9 171.2" className="st7"></path>
                <path d="M129.6 171.4L129.6 171.4" className="st7"></path>
                <path d="M129.6 171.4L129 171.4" className="st7"></path>
                <path d="M129.6 171.4L129 171.4" className="st7"></path>
                <path d="M129.1 170.2L128.9 170.2" className="st7"></path>
                <path d="M129.1 170.2L128.9 170.2" className="st7"></path>
                <path d="M128.9 170L128.9 170" className="st7"></path>
                <path d="M129.5 171.3L129.5 171.3" className="st7"></path>
                <path d="M129 170L129 170 128.9 170" className="st7"></path>
                <path d="M129 170L128.9 170" className="st7"></path>
                <path d="M129 170L129 169.9 128.9 169.9" className="st7"></path>
                <path d="M129 169.9L128.9 169.9" className="st7"></path>
                <path d="M129 169.9L129 169.9" className="st7"></path>
                <path d="M129 169.9L129 169.9" className="st7"></path>
                <path
                  d="M129 170L129 170 128.9 170 128.9 170 129 170 129 170"
                  className="st7"
                ></path>
                <path d="M128.8 170L128.8 170 128.9 170" className="st7"></path>
                <path d="M128.8 170L128.9 170" className="st7"></path>
                <path
                  d="M128.8 170L128.8 169.9 128.9 169.9"
                  className="st7"
                ></path>
                <path d="M128.8 169.9L128.9 169.9" className="st7"></path>
                <path d="M128.8 169.9L128.8 169.9" className="st7"></path>
                <path d="M128.8 169.9L128.8 169.9" className="st7"></path>
                <path
                  d="M128.8 170L128.8 170 128.8 170 128.8 170 128.8 170 128.8 170"
                  className="st7"
                ></path>
                <path
                  d="M129 169.9L129 169.9 129 169.9 129 169.9 129 169.9 129 169.9 129 169.9 129 169.9 129 169.9"
                  className="st7"
                ></path>
                <path
                  d="M129 169.8L129 169.8 129 169.8 129 169.8 129 169.8 129 169.9 129 169.9 129 169.8 129 169.8 129 169.8 129 169.8"
                  className="st7"
                ></path>
                <path
                  d="M129 169.8L129 169.8 129 169.9 129 169.9 128.9 169.9 128.9 169.8 128.9 169.8 129 169.8 129 169.8 129 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.9 169.8L128.9 169.8 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.8 128.9 169.8 128.9 169.8 128.9 169.8 128.9 169.8 128.9 169.8 128.9 169.8"
                  className="st7"
                ></path>
                <path
                  d="M129 169.8L129 169.8 129 169.8 128.9 169.8 128.9 169.8 128.9 169.8"
                  className="st7"
                ></path>
                <path
                  d="M129 169.8L129 169.9 129 169.9 129 169.9 129 169.9 129 169.9 129 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9"
                  className="st7"
                ></path>
                <path
                  d="M129 169.9L129 169.8 129 169.8 129 169.9 129 169.9 129 169.9"
                  className="st7"
                ></path>
                <path
                  d="M128.9 169.9L128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9"
                  className="st7"
                ></path>
                <path
                  d="M128.8 169.9L128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9"
                  className="st7"
                ></path>
                <path
                  d="M128.8 169.8L128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.9 128.8 169.9 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.8 169.8L128.8 169.8 128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.8 169.8L128.9 169.8 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.8 128.9 169.8 128.9 169.8 128.9 169.8 128.9 169.8 128.9 169.8 128.8 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.8 169.8L128.8 169.8 128.8 169.8 128.8 169.8 128.9 169.8 128.9 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.8 169.8L128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9 128.8 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9"
                  className="st7"
                ></path>
                <path
                  d="M128.8 169.9L128.8 169.8 128.8 169.9 128.8 169.9"
                  className="st7"
                ></path>
                <path
                  d="M128.9 169.9L128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9 128.9 169.9"
                  className="st7"
                ></path>
                <path
                  d="M128.9 169.7L128.9 169.7 128.9 169.7 128.9 169.7 129 169.7 129 169.7 129 169.7 129 169.7 129 169.8 129 169.8 129 169.8 129 169.8 129 169.8 129 169.8 129 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.9 169.8L128.9 169.8 128.9 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.9 169.7L128.9 169.7 128.9 169.7 128.9 169.7 128.8 169.7 128.8 169.7 128.8 169.7 128.8 169.7 128.8 169.7 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8 128.8 169.8"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.3L129 172.3 129 172.2"
                  className="st7"
                ></path>
                <path d="M129 172.2L129 172.2 129 172.2" className="st7"></path>
                <path d="M129 172.2" className="st7"></path>
                <path d="M128.8 172.3L128.8 172.2" className="st7"></path>
                <path d="M128.8 172.2L128.8 172.2" className="st7"></path>
                <path d="M128.8 172.2" className="st7"></path>
                <path d="M129 172.2L128.8 172.2" className="st7"></path>
                <path d="M129 172.2L128.8 172.2" className="st7"></path>
                <path d="M129 172.1L128.8 172.1" className="st7"></path>
                <path
                  d="M129 172.2s.1 0 0 0c.1 0 0-.1 0 0 0-.1 0-.1 0 0M128.8 172.1s-.1 0 0 0c-.1.1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M129 172.1L129 172.1 128.8 172.1 128.8 172.1"
                  className="st7"
                ></path>
                <path d="M128.8 172.1" className="st7"></path>
                <path d="M129 172.1L128.8 172.1" className="st7"></path>
                <path d="M129 172.1L128.8 172.1" className="st7"></path>
                <path d="M128.8 172" className="st7"></path>
                <path
                  d="M129.1 172.8L129.1 172.8 129 172.8 129 172.8 129 172.7 129 172.7 129 172.7 129 172.7 129 172.7 129 172.7 129 172.7 129 172.7 129 172.7 129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.3 129 172.3 129 172.3 129 172.3 129 172.3 129 172.3 129 172.3"
                  className="st7"
                ></path>
                <path d="M129 172.3L129 173.1" className="st7"></path>
                <path d="M128.8 172.3L128.8 173.1" className="st7"></path>
                <path d="M128.8 172.1L129 172.1" className="st7"></path>
                <path
                  d="M128.8 172.1L128.8 172 128.9 172"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172L128.8 172 128.8 172 128.8 172 128.8 172 128.8 172 128.9 172"
                  className="st7"
                ></path>
                <path d="M128.8 172L128.8 172 128.9 172" className="st7"></path>
                <path
                  d="M128.8 172L128.8 172 128.8 172 128.8 171.9 128.7 171.9 128.7 171.9 128.7 171.9 128.7 171.9 128.7 171.9 128.7 171.9 128.7 171.9 128.7 171.9 128.6 171.9 128.6 171.9 128.6 171.9 128.6 171.9 128.6 171.9 128.6 171.9 128.6 171.9 128.6 171.9 128.6 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.8 128.5 171.7 128.5 171.7 128.5 171.7 128.5 171.7 128.5 171.7 128.5 171.7 128.9 171.7"
                  className="st7"
                ></path>
                <path d="M128.5 171.7L128.9 171.7" className="st7"></path>
                <path d="M128.5 171.7" className="st7"></path>
                <path d="M128.9 171.6L128.5 171.6" className="st7"></path>
                <path
                  d="M128.9 171.6L128.5 171.6 128.5 171.6"
                  className="st7"
                ></path>
                <path d="M128.5 171.6L128.5 171.6" className="st7"></path>
                <path
                  d="M128.5 171.7L128.5 171.7 128.5 171.7 128.5 171.7 128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.6 128.6 171.6 128.6 171.6 128.6 171.6 128.6 171.6 128.6 171.6 128.5 171.6"
                  className="st7"
                ></path>
                <path
                  d="M128.6 171.7L128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7"
                  className="st7"
                ></path>
                <path
                  d="M128.6 171.7L128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7"
                  className="st7"
                ></path>
                <path d="M128.6 171.7L128.6 171.7" className="st7"></path>
                <path
                  d="M128.6 171.7L128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7"
                  className="st7"
                ></path>
                <path
                  d="M128.6 171.7L128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7"
                  className="st7"
                ></path>
                <path d="M128.6 171.7L128.6 171.7" className="st7"></path>
                <path
                  d="M128.6 171.7L128.6 171.7 128.6 171.7 128.6 171.7 128.6 171.7"
                  className="st7"
                ></path>
                <path
                  d="M128.7 171.7L128.7 171.7 128.7 171.7 128.7 171.7 128.7 171.7"
                  className="st7"
                ></path>
                <path d="M128.7 171.7L128.7 171.7" className="st7"></path>
                <path
                  d="M128.7 171.7L128.7 171.7 128.7 171.7 128.7 171.7"
                  className="st7"
                ></path>
                <path
                  d="M128.7 171.7L128.7 171.7 128.7 171.7 128.7 171.7 128.7 171.7"
                  className="st7"
                ></path>
                <path d="M128.7 171.7L128.7 171.7" className="st7"></path>
                <path
                  d="M128.7 171.7L128.7 171.7 128.7 171.7 128.8 171.7 128.8 171.7"
                  className="st7"
                ></path>
                <path
                  d="M128.8 171.7L128.8 171.7 128.8 171.7 128.8 171.7 128.8 171.7"
                  className="st7"
                ></path>
                <path d="M128.8 171.7" className="st7"></path>
                <path
                  d="M128.8 171.7L128.8 171.7 128.8 171.7 128.8 171.7"
                  className="st7"
                ></path>
                <path
                  d="M128.8 171.7L128.8 171.7 128.8 171.7 128.8 171.7"
                  className="st7"
                ></path>
                <path d="M128.9 171.7" className="st7"></path>
                <path d="M128.9 171.7L128.9 171.7" className="st7"></path>
                <path d="M128.9 171.6" className="st7"></path>
                <path d="M128.9 171.7L128.9 171.7" className="st7"></path>
                <path d="M129 172.1L129 172 128.9 172" className="st7"></path>
                <path
                  d="M129 172L129 172 129 172 129 172 129 172 128.9 172"
                  className="st7"
                ></path>
                <path d="M129 172L129 172 128.9 172" className="st7"></path>
                <path
                  d="M129 172L129 172 129 172 129 171.9 129 171.9 129 171.9 129 171.9 129.1 171.9 129.1 171.9 129.1 171.9 129.1 171.9 129.1 171.9 129.1 171.9 129.1 171.9 129.1 171.9 129.2 171.9 129.2 171.9 129.2 171.9 129.2 171.9 129.2 171.9 129.2 171.9 129.2 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.8 129.3 171.7 129.3 171.7 129.3 171.7 129.3 171.7 129.3 171.7 129.3 171.7 128.9 171.7"
                  className="st7"
                ></path>
                <path d="M129.3 171.7L128.9 171.7" className="st7"></path>
                <path d="M129.3 171.7" className="st7"></path>
                <path d="M128.9 171.6L129.2 171.6" className="st7"></path>
                <path
                  d="M128.9 171.6L129.3 171.6 129.3 171.6"
                  className="st7"
                ></path>
                <path d="M129.2 171.6L129.2 171.6" className="st7"></path>
                <path
                  d="M129.3 171.7L129.3 171.7 129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.6 129.2 171.6 129.2 171.6 129.2 171.6 129.2 171.6 129.2 171.6 129.2 171.6"
                  className="st7"
                ></path>
                <path
                  d="M129.2 171.7L129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M129.2 171.7L129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7"
                  className="st7"
                ></path>
                <path d="M129.2 171.7L129.2 171.7" className="st7"></path>
                <path
                  d="M129.2 171.7L129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7 129.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M129.2 171.7L129.2 171.7 129.2 171.7 129.2 171.7 129.1 171.7 129.1 171.7"
                  className="st7"
                ></path>
                <path d="M129.2 171.7L129.2 171.7" className="st7"></path>
                <path
                  d="M129.1 171.7L129.1 171.7 129.1 171.7 129.1 171.7 129.1 171.7"
                  className="st7"
                ></path>
                <path
                  d="M129.1 171.7L129.1 171.7 129.1 171.7 129.1 171.7"
                  className="st7"
                ></path>
                <path d="M129.1 171.7L129.1 171.7" className="st7"></path>
                <path
                  d="M129.1 171.7L129.1 171.7 129.1 171.7 129.1 171.7 129.1 171.7"
                  className="st7"
                ></path>
                <path
                  d="M129.1 171.7L129.1 171.7 129.1 171.7 129.1 171.7 129 171.7"
                  className="st7"
                ></path>
                <path d="M129.1 171.7L129.1 171.7" className="st7"></path>
                <path
                  d="M129 171.7L129 171.7 129 171.7 129 171.7"
                  className="st7"
                ></path>
                <path
                  d="M129 171.7L129 171.7 129 171.7 129 171.7 129 171.7"
                  className="st7"
                ></path>
                <path d="M129 171.6" className="st7"></path>
                <path
                  d="M129 171.7L129 171.7 129 171.7 129 171.7"
                  className="st7"
                ></path>
                <path
                  d="M128.9 171.7L128.9 171.7 128.9 171.7 128.9 171.7"
                  className="st7"
                ></path>
                <path d="M129 171.6" className="st7"></path>
                <path d="M128.9 171.7L128.9 171.7" className="st7"></path>
                <path d="M128.9 171.6" className="st7"></path>
                <path d="M128.9 171.7L128.9 171.7" className="st7"></path>
                <path
                  d="M129 172.3c.1 0 .1-.1.1-.2s0-.1-.1-.2M128.8 171.9c-.1 0-.1.1-.1.2s0 .1.1.2"
                  className="st7"
                ></path>
                <path
                  d="M129 172.6L129 172.6 129 172.6 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5"
                  className="st7"
                ></path>
                <path
                  d="M129 172.3L129 172.3 129 172.3 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4"
                  className="st7"
                ></path>
                <path
                  d="M129 172.3L129 172.3 129 172.3 129 172.3 129 172.3 129 172.3 129 172.3 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.4 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5 129 172.5 129 172.6 129 172.6"
                  className="st7"
                ></path>
                <path d="M129 172.5L129 172.5 129 172.6" className="st7"></path>
                <path
                  d="M129 172.7L129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.6 129 172.7"
                  className="st7"
                ></path>
                <path
                  d="M129 172.7L129 172.7 129 172.7 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129.1 172.8 129.1 172.8 129.1 172.8 129.1 172.8 129.1 172.8 129.1 172.8 129.1 172.8 129.1 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8 129 172.8"
                  className="st7"
                ></path>
                <path
                  d="M128.7 172.8L128.7 172.8 128.7 172.8 128.7 172.8 128.8 172.7 128.8 172.7 128.8 172.7 128.8 172.7 128.8 172.7 128.8 172.7 128.8 172.7 128.8 172.7 128.8 172.7 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.2"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.6L128.8 172.6 128.8 172.6 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.4L128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.3L128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.3L128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.3 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.4 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.5 128.8 172.6 128.8 172.6"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.5L128.8 172.5 128.8 172.5 128.8 172.6 128.8 172.6"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.7L128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.6 128.8 172.7"
                  className="st7"
                ></path>
                <path
                  d="M128.8 172.7L128.8 172.7 128.8 172.7 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.7 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8 128.8 172.8"
                  className="st7"
                ></path>
                <path d="M129 173.7L128.8 173.7" className="st7"></path>
                <path
                  d="M129 173.7L129 173.7 129 173.6 129 173.6 129 173.6 129 173.6 129 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.7 128.8 173.7"
                  className="st7"
                ></path>
                <path
                  d="M129 173.7L129 173.7 129 173.7 129 173.7 129 173.7 129.1 173.7 129.1 173.7 129.1 173.7 129.1 173.7 129.1 173.7 129 173.7 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.8 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7"
                  className="st7"
                ></path>
                <path
                  d="M129 173.7L129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.7"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.7L128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 129 173.7 129 173.7 129 173.7 129 173.7 129 173.8 129 173.8 129 173.8 129 173.8 128.9 173.8 128.9 173.8 128.9 173.8 128.9 173.8 128.9 173.8 128.9 173.8 128.9 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.8 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 128.9 173.7 129 173.7"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.7L128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8 128.7 173.8 128.7 173.8 128.7 173.8 128.7 173.7 128.7 173.7 128.7 173.7 128.7 173.7 128.7 173.7 128.7 173.7 128.7 173.7 128.7 173.7 128.7 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7"
                  className="st7"
                ></path>
                <path d="M129 173.7L129 173.7 129 173.7" className="st7"></path>
                <path
                  d="M128.8 173.7L128.8 173.7 128.8 173.7 128.8 173.7 128.8 173.7"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.8L129 173.8 129 173.8"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.8L128.8 173.8 128.8 173.8 128.8 173.8 128.8 173.8"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.6L129 173.6 129 173.6 129 173.6 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.4 128.9 173.4"
                  className="st7"
                ></path>
                <path
                  d="M129 173.3L129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4 129 173.5 129 173.5 129 173.5"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.1L128.9 173.2 129 173.2 129 173.2"
                  className="st7"
                ></path>
                <path
                  d="M129 173.3L129 173.3 129 173.3 129 173.3 129 173.3 129 173.2 129 173.2 129 173.2 129 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2"
                  className="st7"
                ></path>
                <path
                  d="M129 173.5L129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4 128.9 173.4 128.9 173.4 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4"
                  className="st7"
                ></path>
                <path
                  d="M129 173.4L129 173.4 129 173.4 129 173.4 129 173.3 129 173.3 128.9 173.3 128.9 173.3 128.9 173.3"
                  className="st7"
                ></path>
                <path
                  d="M129 173.3L129 173.3 129 173.3 129 173.3"
                  className="st7"
                ></path>
                <path d="M129 173.4L129 173.4 129 173.4" className="st7"></path>
                <path
                  d="M128.9 173.5L128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.6 128.9 173.6"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.4L128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.6L129 173.6 129 173.6 129 173.6 129 173.6 129 173.6 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.4 129 173.4 129 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.6L128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.9 173.5 128.9 173.4 128.9 173.4"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.6L128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.5 128.8 173.5 128.7 173.5 128.7 173.5 128.7 173.5 128.7 173.5 128.7 173.5 128.7 173.4 128.7 173.4 128.7 173.4 128.7 173.4 128.7 173.4 128.7 173.4 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.2 128.7 173.2 128.7 173.2 128.7 173.2 128.7 173.2 128.7 173.2 128.8 173.2 128.8 173.2 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173.1 128.8 173 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.8 173.1 128.8 173.1 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.3 128.8 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.3 128.7 173.4 128.7 173.4 128.7 173.4 128.7 173.4 128.7 173.4 128.7 173.4"
                  className="st7"
                ></path>
                <path
                  d="M128.7 173.3L128.7 173.3 128.7 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.5 128.8 173.5 128.8 173.5"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.1L128.8 173.2 128.8 173.2 128.8 173.2"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.3L128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.2 128.8 173.2 128.8 173.2 128.8 173.2 128.9 173.2 128.9 173.2 128.9 173.2 128.9 173.2"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.5L128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.9 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.3 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.4L128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.3 128.8 173.3 128.8 173.3 128.9 173.3 128.9 173.3"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.3L128.8 173.3 128.8 173.3 128.8 173.3"
                  className="st7"
                ></path>
                <path
                  d="M128.8 173.4L128.8 173.4 128.8 173.4"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.5L128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.6 128.9 173.6"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.4L128.8 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4"
                  className="st7"
                ></path>
                <path
                  d="M128.9 173.6L128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.9 173.6 128.8 173.5 128.8 173.5 128.8 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.5 128.9 173.4 128.9 173.4 128.9 173.4 128.9 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.4 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.5 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6 128.8 173.6"
                  className="st7"
                ></path>
                <path
                  d="M129 173.6L129 173.6 129 173.6 129 173.6 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.5 129 173.4 129 173.4 129.1 173.4 129.1 173.4 129.1 173.4 129.1 173.4 129.1 173.3 129.1 173.3 129.1 173.3 129.1 173.3 129.1 173.3 129.1 173.3 129.1 173.3 129.1 173.3 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.1 129 173.1 129 173.1 129 173.1 129 173.1 129 173.1 129 173.1 129 173.1 129 173.1 129 173.1 129 173.1 128.9 173.1 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 128.9 173.1 129 173.1 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.2 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.3 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4 129 173.4"
                  className="st7"
                ></path>
                <path d="M138.4 170L138.6 170" className="st7"></path>
                <path
                  d="M138.9 171.6L138.9 171.6 138.9 171.6 138.9 171.5 138.9 171.5 138.9 171.5 138.9 171.5 138.9 171.5 139 171.5 139 171.5 139 171.5 139 171.5"
                  className="st7"
                ></path>
                <path d="M139.3 171.4L139.2 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M139.2 171.4L139.2 171.4" className="st7"></path>
                <path d="M139.1 171.3L138.5 171.3" className="st7"></path>
                <path d="M139.1 171.3L138.5 171.3" className="st7"></path>
                <path d="M139.1 171.3L138.5 171.3" className="st7"></path>
                <path
                  d="M139.3 171.4L139.3 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M138.6 171.5L138.5 171.5 138.5 171.4 138.6 171.4 138.6 171.5"
                  className="st7"
                ></path>
                <path
                  d="M138.5 171.5L138.5 171.5 138.5 171.4 138.5 171.4 138.5 171.5"
                  className="st7"
                ></path>
                <path d="M138.5 171.4L138.5 171.5" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.6 171.4L138.6 171.4" className="st7"></path>
                <path d="M138.5 171.4L139.2 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.8 170.2L138.8 170.2" className="st7"></path>
                <path
                  d="M138.5 170.1L138.8 170.1 138.8 170.2 138.8 170.2"
                  className="st7"
                ></path>
                <path d="M138.6 170" className="st7"></path>
                <path
                  d="M138.6 170L138.6 170 138.6 170 138.7 170 138.7 170 138.7 170 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.8 170.1 138.8 170.1 138.8 170.1 138.8 170.1 138.8 170.1"
                  className="st7"
                ></path>
                <path
                  d="M138.7 170.1L138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170 138.6 170 138.6 170 138.6 170 138.6 170 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1"
                  className="st7"
                ></path>
                <path
                  d="M138.6 170.1L138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170 138.5 170 138.5 170"
                  className="st7"
                ></path>
                <path
                  d="M138.6 170.1L138.6 170.1 138.6 170.1 138.6 170.1 138.6 170.1 138.7 170.1 138.7 170.1 138.7 170.1 138.7 170.1"
                  className="st7"
                ></path>
                <path
                  d="M138.5 170.1L138.5 170.1 138.5 170.1"
                  className="st7"
                ></path>
                <path d="M138.5 171.5L138.5 171.4" className="st7"></path>
                <path
                  d="M139.1 171.6L139.1 171.6 139.1 171.6 139.1 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.4 139.2 171.4 139.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171.4L139.2 171.4 139.2 171.4 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.6 139.2 171.6 139.2 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.5L139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139 171.5 139 171.5"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.5L139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.6L139.1 171.6 139.1 171.6 139.1 171.6 139 171.6 139 171.6 139 171.6 139 171.5 139 171.5 139 171.5 139 171.5 139 171.5 139 171.5"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.5L139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.5"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.5L139.1 171.5 139.1 171.4 139.1 171.4 139.1 171.4"
                  className="st7"
                ></path>
                <path
                  d="M139 171.5L139 171.5 139 171.4 139 171.4 139.1 171.4 139.1 171.4 139.1 171.4 139.1 171.4 139.1 171.4 139.1 171.4"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.5L139.1 171.5 139.1 171.5 139.1 171.5 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.2 171.6"
                  className="st7"
                ></path>
                <path
                  d="M139 171.5L139 171.5 139 171.5 139 171.5 139 171.5 139 171.5 139 171.5 139 171.6 139 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.1 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.6 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.5 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.1 171.3"
                  className="st7"
                ></path>
                <path
                  d="M138.8 170.2L138.8 170.2 138.9 170.3 139 170.3 139 170.4 139 170.5 139.1 170.6 139.1 170.7 139.1 170.9 139.1 171"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171.4L139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.3 139.2 171.3 139.2 171.3 139.2 171.3 139.2 171.3 139.1 171.3 139.1 171.3 139.1 171.4 139.1 171.4 139.1 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4 139.2 171.4"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.4L139.1 171.4 139.1 171.4"
                  className="st7"
                ></path>
                <path d="M139.2 171L139.1 171" className="st7"></path>
                <path
                  d="M139.2 171L139.2 171 139.2 171 139.1 171 139.1 171 139.1 171 139.1 171 139.1 171"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171L139.2 171 139.2 171 139.2 171 139.2 171 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.3 139.2 171.3 139.2 171.3 139.2 171.3 139.2 171.3 139.2 171.3 139.2 171.3 139.2 171.3 139.1 171.3 139.1 171.3 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.2 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171 139.2 171 139.2 171 139.2 171"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171.3L139.2 171.3 139.2 171.3 139.1 171.3 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171.1L139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.2 139.2 171.2 139.2 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171 139.2 171 139.2 171 139.1 171"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171L139.2 171 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.2 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.2 171 139.2 171 139.1 171 139.1 171"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171L139.1 171 139.1 171 139.1 171 139.1 171 139.1 171 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.1L139.1 171.1 139.1 171.2"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.1L139.1 171.1 139.1 171.1"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171L139.1 171 139.1 171 139.1 171 139.1 171 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171 139.1 171 139.1 171"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.1L139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.2 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171.1 139.1 171 139.1 171 139.1 171 139.1 171 139.1 171 139.1 171 139.1 171"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.4L139.1 171.4 139.1 171.4 139.1 171.3 139.1 171.3 139.1 171.3 139.1 171.3 139.1 171.3 139.1 171.3 139.1 171.3 139.1 171.3 139.1 171.3 139.1 171.2"
                  className="st7"
                ></path>
                <path
                  d="M139.1 171.4L139.1 171.4 139.2 171.4"
                  className="st7"
                ></path>
                <path d="M139.2 171.3L139.2 171.3" className="st7"></path>
                <path
                  d="M139.1 171.4L139.1 171.4 139.1 171.4"
                  className="st7"
                ></path>
                <path d="M138.7 170.2L138.7 170.2" className="st7"></path>
                <path
                  d="M138.8 170.2L138.7 170.2 138.7 170.2 138.7 170.2"
                  className="st7"
                ></path>
                <path d="M138.8 170.2L138.8 170.2" className="st7"></path>
                <path d="M138.7 170.2L138.7 170.2" className="st7"></path>
                <path
                  d="M138.8 170.2L138.8 170.2 138.8 170.1 138.8 170.1 138.7 170.1 138.7 170.2 138.7 170.2 138.7 170.2 138.7 170.2 138.7 170.2 138.7 170.2 138.7 170.2 138.7 170.2 138.8 170.2 138.8 170.2 138.8 170.2 138.8 170.2"
                  className="st7"
                ></path>
                <path
                  d="M138.8 170.2L138.7 170.2 138.7 170.2 138.7 170.2 138.7 170.2 138.7 170.2 138.8 170.2 138.8 170.2 138.8 170.2"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171L139.2 170.8 139.2 170.7 139.1 170.6 139.1 170.6 139.1 170.5 139.1 170.5 139.1 170.4 139 170.4 139 170.3 139 170.3 138.9 170.2 138.9 170.2 138.9 170.2 138.8 170.2 138.8 170.2 138.8 170.2 138.8 170.2"
                  className="st7"
                ></path>
                <path
                  d="M139.2 171.5L139.2 171.5 139.2 171.4 139.2 171.4 139.3 171.4 139.3 171.4"
                  className="st7"
                ></path>
                <path d="M139.2 171.5L139.2 171.5" className="st7"></path>
                <path d="M139.1 171.2L138.5 171.2" className="st7"></path>
                <path d="M139.2 171.4L139.2 171.4" className="st7"></path>
                <path d="M139.2 171.4L138.6 171.4" className="st7"></path>
                <path d="M139.2 171.4L138.6 171.4" className="st7"></path>
                <path d="M138.7 170.2L138.5 170.2" className="st7"></path>
                <path d="M138.7 170.2L138.5 170.2" className="st7"></path>
                <path d="M138.5 170L138.5 170" className="st7"></path>
                <path d="M139.1 171.3L139.1 171.3" className="st7"></path>
                <path
                  d="M138.1 171.6L138.1 171.6 138.1 171.5 138.1 171.5 138.1 171.5 138.1 171.5 138.1 171.5 138 171.5 138 171.5 138 171.5 138 171.5 138 171.5"
                  className="st7"
                ></path>
                <path d="M137.7 171.4L137.8 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M137.8 171.4L137.8 171.4" className="st7"></path>
                <path d="M137.9 171.3L138.5 171.3" className="st7"></path>
                <path d="M137.9 171.3L138.5 171.3" className="st7"></path>
                <path d="M137.9 171.3L138.5 171.3" className="st7"></path>
                <path
                  d="M137.7 171.4L137.7 171.4 137.7 171.4 137.8 171.4 137.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M138.4 171.5L138.5 171.5 138.5 171.4 138.4 171.4 138.4 171.5"
                  className="st7"
                ></path>
                <path
                  d="M138.5 171.5L138.5 171.5 138.5 171.4 138.5 171.4 138.5 171.5"
                  className="st7"
                ></path>
                <path
                  d="M138.5 171.4L138.5 171.4 138.5 171.5 138.5 171.5"
                  className="st7"
                ></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.4 171.4L138.4 171.4" className="st7"></path>
                <path d="M138.5 171.4L137.8 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.5 171.4L138.5 171.4" className="st7"></path>
                <path d="M138.2 170.2L138.2 170.2" className="st7"></path>
                <path
                  d="M138.5 170.1L138.2 170.1 138.2 170.2 138.2 170.2"
                  className="st7"
                ></path>
                <path d="M138.6 170L138.4 170" className="st7"></path>
                <path d="M138.4 170" className="st7"></path>
                <path
                  d="M138.6 170L138.4 170 138.3 170 138.3 170 138.3 170 138.3 170 138.3 170 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.2 170.1 138.2 170.1 138.2 170.1 138.2 170.1 138.2 170.1 138.2 170.1 138.2 170.1"
                  className="st7"
                ></path>
                <path
                  d="M138.2 170.1L138.2 170.1 138.2 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170 138.4 170 138.4 170 138.4 170 138.4 170 138.4 170 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.3 170.1 138.3 170.1 138.4 170.1 138.4 170.1"
                  className="st7"
                ></path>
                <path
                  d="M138.4 170.1L138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.4 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170.1 138.5 170 138.5 170 138.5 170 138.5 170"
                  className="st7"
                ></path>
                <path
                  d="M138.4 170.1L138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1 138.3 170.1"
                  className="st7"
                ></path>
                <path
                  d="M138.5 170.1L138.5 170.1 138.5 170.1 138.5 170.1"
                  className="st7"
                ></path>
                <path
                  d="M138.5 171.5L138.5 171.5 138.5 171.4 138.5 171.4"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.6L137.9 171.6 137.9 171.6 137.9 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.4 137.8 171.4 137.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171.4L137.8 171.4 137.8 171.4 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.6 137.8 171.6 137.8 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.5L137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 138 171.5"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.5L137.9 171.5 137.9 171.5 137.9 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.6L137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 138 171.6 138 171.6 138 171.5 138 171.5 138 171.5 138 171.5 138 171.5 138 171.5 138 171.5 138 171.5"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.5L137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5 137.9 171.5"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.5L137.9 171.4 137.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M138 171.5L138 171.5 138 171.5 138 171.4 137.9 171.4 137.9 171.4 137.9 171.4 137.9 171.4 137.9 171.4 137.9 171.4 137.9 171.4"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.5L137.9 171.5 137.9 171.5 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.8 171.6"
                  className="st7"
                ></path>
                <path
                  d="M138 171.5L138 171.5 138 171.5 138 171.5 138 171.5 138 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.9 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.6 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.5 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.3 137.9 171.3"
                  className="st7"
                ></path>
                <path
                  d="M138.2 170.2L138.2 170.2 138.1 170.3 138 170.3 138 170.4 138 170.5 137.9 170.6 137.9 170.7 137.9 170.9 137.9 171"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171.4L137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.9 171.3 137.9 171.4 137.9 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4 137.8 171.4"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.4L137.9 171.4 137.9 171.4"
                  className="st7"
                ></path>
                <path d="M137.8 171L137.9 171" className="st7"></path>
                <path
                  d="M137.8 171L137.8 171 137.8 171 137.8 171 137.8 171 137.9 171 137.9 171 137.9 171 137.9 171 137.9 171"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171L137.8 171 137.8 171 137.8 171 137.8 171 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.8 171.3 137.9 171.3 137.9 171.3 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171 137.8 171 137.8 171 137.8 171"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171.3L137.8 171.3 137.8 171.3 137.8 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.8 171.2"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171.1L137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.8 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.8 171.2 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171 137.8 171 137.8 171 137.8 171"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171L137.8 171 137.8 171 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.8 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.8 171.1 137.8 171.1 137.8 171 137.8 171 137.8 171"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171L137.9 171 137.9 171 137.9 171 137.9 171 137.9 171 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.1L137.9 171.1 137.9 171.1 137.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.1L137.9 171.1 137.9 171.1 137.9 171.1"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171L137.9 171 137.9 171 137.9 171 137.9 171 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171 137.9 171 137.9 171 137.9 171"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.1L137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.2 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171.1 137.9 171 137.9 171 137.9 171 137.9 171 137.9 171 137.9 171"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.4L137.9 171.4 137.9 171.4 137.9 171.3 137.9 171.3 137.9 171.3 137.9 171.3 137.9 171.3 137.9 171.3 137.9 171.3 137.9 171.3 137.9 171.3 137.9 171.2"
                  className="st7"
                ></path>
                <path
                  d="M137.9 171.4L137.9 171.4 137.8 171.4"
                  className="st7"
                ></path>
                <path d="M137.8 171.3L137.8 171.3" className="st7"></path>
                <path
                  d="M137.8 171.4L137.8 171.4 137.9 171.4 137.9 171.4"
                  className="st7"
                ></path>
                <path d="M138.3 170.2L138.3 170.2" className="st7"></path>
                <path
                  d="M138.2 170.2L138.3 170.2 138.3 170.2 138.2 170.2"
                  className="st7"
                ></path>
                <path d="M138.2 170.2L138.2 170.2" className="st7"></path>
                <path d="M138.2 170.2L138.2 170.2" className="st7"></path>
                <path
                  d="M138.2 170.2L138.2 170.1 138.2 170.1 138.2 170.2 138.3 170.2 138.3 170.2 138.3 170.2 138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2"
                  className="st7"
                ></path>
                <path
                  d="M138.2 170.2L138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171L137.8 170.8 137.8 170.7 137.9 170.6 137.9 170.6 137.9 170.5 137.9 170.5 137.9 170.4 138 170.4 138 170.3 138 170.3 138.1 170.2 138.1 170.2 138.1 170.2 138.2 170.2 138.2 170.2 138.2 170.2 138.2 170.2"
                  className="st7"
                ></path>
                <path
                  d="M137.8 171.5L137.8 171.4 137.7 171.4 137.7 171.4 137.7 171.4"
                  className="st7"
                ></path>
                <path d="M137.8 171.5L137.8 171.5" className="st7"></path>
                <path d="M137.9 171.2L138.5 171.2" className="st7"></path>
                <path d="M137.8 171.4L137.8 171.4" className="st7"></path>
                <path d="M137.8 171.4L138.4 171.4" className="st7"></path>
                <path d="M137.8 171.4L138.4 171.4" className="st7"></path>
                <path d="M138.3 170.2L138.5 170.2" className="st7"></path>
                <path d="M138.2 170.2L138.5 170.2" className="st7"></path>
                <path d="M138.5 170L138.5 170" className="st7"></path>
                <path d="M137.9 171.3L137.8 171.3" className="st7"></path>
                <path d="M138.4 170L138.4 170 138.5 170" className="st7"></path>
                <path d="M138.4 170L138.5 170" className="st7"></path>
                <path
                  d="M138.4 170L138.4 169.9 138.5 169.9"
                  className="st7"
                ></path>
                <path d="M138.4 169.9L138.5 169.9" className="st7"></path>
                <path d="M138.4 169.9L138.4 169.9" className="st7"></path>
                <path d="M138.4 169.9L138.4 169.9" className="st7"></path>
                <path
                  d="M138.4 170L138.4 170 138.4 170 138.4 170 138.4 170 138.4 170"
                  className="st7"
                ></path>
                <path d="M138.6 170L138.6 170 138.5 170" className="st7"></path>
                <path d="M138.6 170L138.5 170" className="st7"></path>
                <path
                  d="M138.6 170L138.6 169.9 138.5 169.9"
                  className="st7"
                ></path>
                <path d="M138.6 169.9L138.5 169.9" className="st7"></path>
                <path d="M138.6 169.9L138.6 169.9" className="st7"></path>
                <path d="M138.6 169.9L138.6 169.9" className="st7"></path>
                <path
                  d="M138.6 170L138.6 170 138.5 170 138.5 170 138.6 170 138.6 170"
                  className="st7"
                ></path>
                <path
                  d="M138.4 169.9L138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.4 169.8L138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.9 138.4 169.9 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.4 169.8L138.4 169.8 138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.4 169.8L138.5 169.8 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8 138.4 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.4 169.8L138.4 169.8 138.4 169.8 138.4 169.8 138.5 169.8 138.5 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.4 169.8L138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9 138.4 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.4 169.9L138.4 169.8 138.4 169.9 138.4 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.5 169.9L138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.6 169.9L138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.6 169.8L138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.9 138.6 169.9 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.6 169.8L138.6 169.8 138.6 169.9 138.6 169.9 138.5 169.9 138.5 169.8 138.5 169.8 138.6 169.8 138.6 169.8 138.6 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.5 169.8L138.5 169.8 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8 138.5 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.6 169.8L138.6 169.8 138.6 169.8 138.5 169.8 138.5 169.8 138.5 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.6 169.8L138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9 138.6 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.6 169.9L138.6 169.8 138.6 169.8 138.6 169.9 138.6 169.9 138.6 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.5 169.9L138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9 138.5 169.9"
                  className="st7"
                ></path>
                <path
                  d="M138.5 169.7L138.5 169.7 138.5 169.7 138.5 169.7 138.4 169.7 138.4 169.7 138.4 169.7 138.4 169.7 138.4 169.7 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8 138.4 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.5 169.8L138.5 169.8 138.5 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.5 169.7L138.5 169.7 138.5 169.7 138.5 169.7 138.6 169.7 138.6 169.7 138.6 169.7 138.6 169.7 138.6 169.7 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8 138.6 169.8"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172.3L138.4 172.3 138.4 172.2"
                  className="st7"
                ></path>
                <path d="M138.4 172.2L138.4 172.2" className="st7"></path>
                <path d="M138.4 172.2" className="st7"></path>
                <path d="M138.6 172.3L138.6 172.2" className="st7"></path>
                <path
                  d="M138.6 172.2L138.6 172.2 138.6 172.2"
                  className="st7"
                ></path>
                <path d="M138.6 172.2" className="st7"></path>
                <path d="M138.4 172.2L138.6 172.2" className="st7"></path>
                <path d="M138.4 172.2L138.6 172.2" className="st7"></path>
                <path d="M138.4 172.1L138.6 172.1" className="st7"></path>
                <path
                  d="M138.4 172.1s-.1 0 0 0c-.1.1 0 .1 0 0 0 .1 0 .1 0 0M138.6 172.2s.1 0 0 0c.1 0 0-.1 0 0 0-.1 0-.1 0 0"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.1L138.4 172.1 138.6 172.1 138.6 172.1"
                  className="st7"
                ></path>
                <path d="M138.6 172.1" className="st7"></path>
                <path d="M138.4 172.1L138.6 172.1" className="st7"></path>
                <path d="M138.4 172.1L138.6 172.1" className="st7"></path>
                <path d="M138.6 172.1" className="st7"></path>
                <path
                  d="M138.3 172.8L138.3 172.8 138.3 172.8 138.3 172.8 138.4 172.7 138.4 172.7 138.4 172.7 138.4 172.7 138.4 172.7 138.4 172.7 138.4 172.7 138.4 172.7 138.4 172.7 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3"
                  className="st7"
                ></path>
                <path d="M138.4 172.3L138.4 173.1" className="st7"></path>
                <path d="M138.6 172.3L138.6 173.1" className="st7"></path>
                <path d="M138.6 172.1L138.4 172.1" className="st7"></path>
                <path
                  d="M138.6 172.1L138.6 172 138.5 172"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172L138.6 172 138.6 172 138.6 172 138.6 172 138.5 172"
                  className="st7"
                ></path>
                <path d="M138.6 172L138.6 172 138.5 172" className="st7"></path>
                <path
                  d="M138.6 172L138.6 172 138.6 172 138.6 171.9 138.6 171.9 138.6 171.9 138.6 171.9 138.7 171.9 138.7 171.9 138.7 171.9 138.7 171.9 138.7 171.9 138.7 171.9 138.7 171.9 138.7 171.9 138.8 171.9 138.8 171.9 138.8 171.9 138.8 171.9 138.8 171.9 138.8 171.9 138.8 171.8 138.9 171.8 138.9 171.8 138.9 171.8 138.9 171.8 138.9 171.8 138.9 171.8 138.9 171.8 138.9 171.8 138.9 171.8 138.9 171.7 138.9 171.7 138.9 171.7 138.9 171.7 138.9 171.7 138.9 171.7 138.5 171.7"
                  className="st7"
                ></path>
                <path d="M138.9 171.7L138.5 171.7" className="st7"></path>
                <path d="M138.9 171.7" className="st7"></path>
                <path d="M138.5 171.6L138.8 171.6" className="st7"></path>
                <path
                  d="M138.5 171.6L138.9 171.6 138.9 171.6"
                  className="st7"
                ></path>
                <path d="M138.8 171.6L138.8 171.6" className="st7"></path>
                <path
                  d="M138.9 171.7L138.9 171.7 138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.6 138.8 171.6 138.8 171.6 138.8 171.6 138.8 171.6 138.8 171.6 138.8 171.6"
                  className="st7"
                ></path>
                <path
                  d="M138.8 171.7L138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.8 171.7L138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7"
                  className="st7"
                ></path>
                <path d="M138.8 171.7L138.8 171.7" className="st7"></path>
                <path
                  d="M138.8 171.7L138.8 171.7 138.8 171.7 138.8 171.7 138.8 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.8 171.7L138.8 171.7 138.8 171.7 138.7 171.7 138.7 171.7"
                  className="st7"
                ></path>
                <path d="M138.8 171.7L138.8 171.7" className="st7"></path>
                <path
                  d="M138.7 171.7L138.7 171.7 138.7 171.7 138.7 171.7 138.7 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.7 171.7L138.7 171.7 138.7 171.7 138.7 171.7"
                  className="st7"
                ></path>
                <path d="M138.7 171.7L138.7 171.7" className="st7"></path>
                <path
                  d="M138.7 171.7L138.7 171.7 138.7 171.7 138.7 171.7 138.7 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.7 171.7L138.7 171.7 138.7 171.7 138.7 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.6 171.7L138.6 171.7 138.6 171.7 138.6 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.6 171.7L138.6 171.7 138.6 171.7 138.6 171.7"
                  className="st7"
                ></path>
                <path d="M138.6 171.6" className="st7"></path>
                <path
                  d="M138.6 171.7L138.6 171.7 138.6 171.7 138.6 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.5 171.7L138.5 171.7 138.5 171.7 138.5 171.7"
                  className="st7"
                ></path>
                <path d="M138.6 171.6" className="st7"></path>
                <path d="M138.5 171.7L138.5 171.7" className="st7"></path>
                <path d="M138.5 171.6" className="st7"></path>
                <path d="M138.5 171.7L138.5 171.7" className="st7"></path>
                <path
                  d="M138.4 172.1L138.4 172 138.5 172"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172L138.4 172 138.4 172 138.4 172 138.4 172 138.4 172 138.5 172"
                  className="st7"
                ></path>
                <path d="M138.4 172L138.4 172 138.5 172" className="st7"></path>
                <path
                  d="M138.4 172L138.4 172 138.4 171.9 138.3 171.9 138.3 171.9 138.3 171.9 138.3 171.9 138.3 171.9 138.3 171.9 138.3 171.9 138.3 171.9 138.2 171.9 138.2 171.9 138.2 171.9 138.2 171.9 138.2 171.9 138.2 171.9 138.2 171.9 138.2 171.9 138.2 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.8 138.1 171.7 138.1 171.7 138.1 171.7 138.1 171.7 138.1 171.7 138.5 171.7"
                  className="st7"
                ></path>
                <path d="M138.1 171.7L138.5 171.7" className="st7"></path>
                <path d="M138.1 171.7" className="st7"></path>
                <path d="M138.5 171.6L138.1 171.6" className="st7"></path>
                <path
                  d="M138.5 171.6L138.1 171.6 138.1 171.6"
                  className="st7"
                ></path>
                <path d="M138.1 171.6L138.1 171.6" className="st7"></path>
                <path
                  d="M138.1 171.7L138.1 171.7 138.1 171.7 138.1 171.7 138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.6 138.2 171.6 138.2 171.6 138.2 171.6 138.2 171.6 138.2 171.6 138.1 171.6"
                  className="st7"
                ></path>
                <path
                  d="M138.2 171.7L138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.2 171.7L138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7"
                  className="st7"
                ></path>
                <path d="M138.2 171.7L138.2 171.7" className="st7"></path>
                <path
                  d="M138.2 171.7L138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.2 171.7L138.2 171.7 138.2 171.7 138.2 171.7"
                  className="st7"
                ></path>
                <path d="M138.2 171.7L138.2 171.7" className="st7"></path>
                <path
                  d="M138.2 171.7L138.2 171.7 138.2 171.7 138.2 171.7 138.2 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.3 171.7L138.3 171.7 138.3 171.7 138.3 171.7 138.3 171.7"
                  className="st7"
                ></path>
                <path d="M138.3 171.7L138.3 171.7" className="st7"></path>
                <path
                  d="M138.3 171.7L138.3 171.7 138.3 171.7 138.3 171.7 138.3 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.3 171.7L138.3 171.7 138.3 171.7 138.3 171.7 138.3 171.7"
                  className="st7"
                ></path>
                <path d="M138.3 171.7L138.3 171.7" className="st7"></path>
                <path
                  d="M138.3 171.7L138.3 171.7 138.3 171.7 138.4 171.7 138.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.4 171.7L138.4 171.7 138.4 171.7 138.4 171.7"
                  className="st7"
                ></path>
                <path d="M138.4 171.7" className="st7"></path>
                <path
                  d="M138.4 171.7L138.4 171.7 138.4 171.7 138.4 171.7"
                  className="st7"
                ></path>
                <path
                  d="M138.4 171.7L138.4 171.7 138.4 171.7 138.4 171.7"
                  className="st7"
                ></path>
                <path d="M138.5 171.7" className="st7"></path>
                <path d="M138.5 171.7L138.5 171.7" className="st7"></path>
                <path d="M138.5 171.6" className="st7"></path>
                <path d="M138.5 171.7L138.5 171.7" className="st7"></path>
                <path
                  d="M138.4 171.9c-.1 0-.1.1-.1.2s0 .1.1.2M138.6 172.3c.1 0 .1-.1.1-.2s0-.1-.1-.2"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.6L138.4 172.6 138.4 172.6 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.4L138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.3L138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.3L138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.3 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.4 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.5 138.4 172.6 138.4 172.6"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.5L138.4 172.5 138.4 172.5 138.4 172.6 138.4 172.6"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.7L138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.6 138.4 172.7"
                  className="st7"
                ></path>
                <path
                  d="M138.4 172.7L138.4 172.7 138.4 172.7 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.3 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8 138.4 172.8"
                  className="st7"
                ></path>
                <path
                  d="M138.7 172.8L138.7 172.8 138.6 172.8 138.6 172.8 138.6 172.7 138.6 172.7 138.6 172.7 138.6 172.7 138.6 172.7 138.6 172.7 138.6 172.7 138.6 172.7 138.6 172.7 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.2"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172.6L138.6 172.6 138.6 172.6 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172.3L138.6 172.3 138.6 172.3 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172.3L138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.3 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.4 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.5 138.6 172.6 138.6 172.6"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172.5L138.6 172.5 138.6 172.6"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172.7L138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.6 138.6 172.7"
                  className="st7"
                ></path>
                <path
                  d="M138.6 172.7L138.6 172.7 138.6 172.7 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.7 172.8 138.7 172.8 138.7 172.8 138.7 172.8 138.7 172.8 138.7 172.8 138.7 172.8 138.7 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8 138.6 172.8"
                  className="st7"
                ></path>
                <path d="M138.4 173.7L138.6 173.7" className="st7"></path>
                <path
                  d="M138.4 173.7L138.4 173.7 138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.6 138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.7 138.6 173.7"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.7L138.4 173.7 138.4 173.7 138.3 173.7 138.3 173.7 138.3 173.7 138.3 173.7 138.3 173.7 138.3 173.7 138.3 173.7 138.3 173.7 138.3 173.8 138.3 173.8 138.3 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.5 173.7 138.5 173.7"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.7L138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.7L138.5 173.7 138.5 173.7 138.5 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.4 173.8 138.5 173.8 138.5 173.8 138.5 173.8 138.5 173.8 138.5 173.8 138.5 173.8 138.5 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.8 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.5 173.7 138.4 173.7"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.7L138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.6 173.8 138.7 173.7 138.7 173.7 138.7 173.7 138.7 173.7 138.7 173.7 138.7 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.7L138.4 173.7 138.4 173.7 138.4 173.7 138.4 173.7"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.7L138.6 173.7 138.6 173.7 138.6 173.7 138.6 173.7"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.8L138.4 173.8 138.4 173.8"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.8L138.6 173.8 138.6 173.8 138.6 173.8"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.6L138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.5 173.5 138.5 173.4 138.5 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.3 173.3L138.3 173.3 138.3 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.5 138.4 173.5 138.4 173.5"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.1L138.4 173.2 138.4 173.2 138.4 173.2"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.3L138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.5L138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.3 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.4L138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.3 138.4 173.3 138.4 173.3 138.5 173.3 138.5 173.3"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.3L138.4 173.3 138.4 173.3 138.4 173.3"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.4L138.4 173.4 138.4 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.5L138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.6 138.5 173.6"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.4L138.4 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.6L138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.4 173.5 138.4 173.5 138.4 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.4 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.5 138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.6"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.6L138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.6L138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.4 138.6 173.4 138.7 173.4 138.7 173.4 138.7 173.4 138.7 173.4 138.7 173.3 138.7 173.3 138.7 173.3 138.7 173.3 138.7 173.3 138.7 173.3 138.7 173.3 138.7 173.3 138.7 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.6 173.1 138.5 173.1 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.6 173.1 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.3L138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.5 138.6 173.5 138.6 173.5"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.1L138.5 173.2 138.6 173.2 138.6 173.2"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.3L138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.2 138.6 173.2 138.6 173.2 138.6 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2 138.5 173.2"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.5L138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.5 173.4 138.5 173.4 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.5 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.3 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.4L138.6 173.4 138.6 173.4 138.6 173.4 138.6 173.3 138.6 173.3 138.5 173.3 138.5 173.3 138.5 173.3"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.3L138.6 173.3 138.6 173.3 138.6 173.3"
                  className="st7"
                ></path>
                <path
                  d="M138.6 173.4L138.6 173.4 138.6 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.5L138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.6 138.5 173.6"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.4L138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4"
                  className="st7"
                ></path>
                <path
                  d="M138.5 173.6L138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.6 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.5 138.6 173.4 138.6 173.4 138.6 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.4 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.5 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6 138.5 173.6"
                  className="st7"
                ></path>
                <path
                  d="M138.4 173.6L138.4 173.6 138.4 173.6 138.4 173.6 138.4 173.5 138.4 173.5 138.3 173.5 138.3 173.5 138.3 173.5 138.3 173.5 138.3 173.5 138.3 173.4 138.3 173.4 138.3 173.4 138.3 173.4 138.3 173.4 138.3 173.4 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.2 138.3 173.2 138.3 173.2 138.3 173.2 138.3 173.2 138.3 173.2 138.4 173.2 138.4 173.2 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.4 173.1 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.5 173.1 138.4 173.1 138.4 173.1 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.2 138.4 173.3 138.4 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.3 138.3 173.4 138.3 173.4 138.3 173.4 138.3 173.4 138.3 173.4 138.3 173.4"
                  className="st7"
                ></path>
                <path
                  d="M140.4 169.3L142.6 169.3 142.6 174.9 140.4 174.9 140.4 169.3"
                  className="st4"
                ></path>
                <path
                  d="M52.8 201.9L48.9 201.9 48.9 209.7 52.8 209.7 52.8 201.9"
                  className="st5"
                ></path>
                <path
                  d="M50.9 203.1L50.9 209.7 52.8 209.7 52.8 203.2"
                  className="st5"
                ></path>
                <path d="M50.9 204L50.9 209.7" className="st5"></path>
                <path
                  d="M48.9 203.2L48.9 203.1 52.8 203.1 52.8 203.2"
                  className="st5"
                ></path>
                <path d="M40.1 177.5L40.1 183" className="st4"></path>
                <path d="M42.7 177.5L42.7 183" className="st4"></path>
                <path d="M58.6 177.5L58.6 183" className="st4"></path>
                <path d="M100.4 177.3L100.4 169.5" className="st5"></path>
                <path
                  d="M100.4 169.5L97.2 169.5 97.2 177.3"
                  className="st5"
                ></path>
                <path d="M97.2 177.3L97.2 170.9" className="st5"></path>
                <path
                  d="M97.2 170.9L100.4 170.9 100.4 177.3"
                  className="st5"
                ></path>
                <path d="M100.4 170.7L100.4 170.9" className="st5"></path>
                <path
                  d="M100.4 170.9L97.2 170.9 97.2 170.7"
                  className="st5"
                ></path>
                <path d="M109.5 177.3L109.5 169.5" className="st5"></path>
                <path
                  d="M109.5 169.5L112.8 169.5 112.8 177.3"
                  className="st5"
                ></path>
                <path d="M112.8 177.3L112.8 170.9" className="st5"></path>
                <path
                  d="M112.8 170.9L109.5 170.9 109.5 177.3"
                  className="st5"
                ></path>
                <path d="M109.5 170.7L109.5 170.9" className="st5"></path>
                <path
                  d="M109.5 170.9L112.8 170.9 112.8 170.7"
                  className="st5"
                ></path>
                <path
                  d="M144.5 146.7L143.2 146.7 143.2 144.1 144.5 144.1 144.5 146.7"
                  className="st4"
                ></path>
                <path
                  d="M171.5 155.8L171.5 147.9 166.8 147.9 166.8 155.8"
                  className="st5"
                ></path>
                <path
                  d="M166.9 149.5L169.1 149.5 169.1 155.8"
                  className="st5"
                ></path>
                <path d="M171.5 149.5L166.8 149.5" className="st5"></path>
                <path
                  d="M162 155.8L162 147.9 166.8 147.9 166.8 155.8"
                  className="st5"
                ></path>
                <path
                  d="M166.6 149.5L164.4 149.5 164.4 155.8"
                  className="st5"
                ></path>
                <path d="M162 149.5L166.8 149.5" className="st5"></path>
                <path
                  d="M171.5 155.8L171.5 147.9 162 147.9 162 155.8"
                  className="st5"
                ></path>
                <path
                  d="M103.5 146.7L104.8 146.7 104.8 144.1 103.5 144.1 103.5 146.7"
                  className="st4"
                ></path>
                <path
                  d="M163.9 146.7L162.6 146.7 162.6 144.1 163.9 144.1 163.9 146.7"
                  className="st4"
                ></path>
                <path
                  d="M134.4 135.1L134.4 127.9 128.2 127.9 128.2 135.1"
                  className="st5"
                ></path>
                <path
                  d="M134.5 135.1L134.5 127.8 128.1 127.8 128.1 135.1"
                  className="st5"
                ></path>
                <path
                  d="M134.4 135.1L134.4 127.8 128.1 127.8 128.1 135.1"
                  className="st5"
                ></path>
                <path
                  d="M159.8 132.5L165 132.5 165 127.3 159.8 127.3 159.8 132.5"
                  className="st5"
                ></path>
                <path
                  d="M159.9 132.4L164.9 132.4 164.9 127.4 159.9 127.4 159.9 132.4"
                  className="st5"
                ></path>
                <path
                  d="M160 132.3L164.8 132.3 164.8 127.4 160 127.4 160 132.3"
                  className="st5"
                ></path>
                <path
                  d="M79.8 135.1L79.8 129.4 82.6 129.4 82.6 135.1 82.6 128 76.9 128 76.9 135.1"
                  className="st5"
                ></path>
                <path
                  d="M76.9 135.1L76.9 129.4 79.8 129.4 79.8 135.1"
                  className="st5"
                ></path>
                <path d="M82.6 129.2L82.6 129.4" className="st5"></path>
                <path
                  d="M90.6 135.1L90.6 129.4 93.4 129.4 93.4 135.1 93.4 128 87.7 128 87.7 135.1"
                  className="st5"
                ></path>
                <path
                  d="M87.7 135.1L87.7 129.4 90.6 129.4 90.6 135.1"
                  className="st5"
                ></path>
                <path d="M93.4 129.2L93.4 129.4" className="st5"></path>
                <path
                  d="M93.4 129.4L87.7 129.4 87.7 129.2"
                  className="st5"
                ></path>
                <path d="M93.5 102.7L93.5 115" className="st4"></path>
                <path d="M168.9 115L168.9 102.7" className="st4"></path>
                <path
                  d="M65.7 123.3L88.7 123.3 49.3 123.3"
                  className="st4"
                ></path>
                <path d="M88.7 122.8L60.5 122.8" className="st4"></path>
                <path d="M60.5 122.8L65.7 120.8" className="st4"></path>
                <path d="M60.6 122.9L60.5 122.9" className="st4"></path>
                <path d="M60.7 122.9c0 .1.1.3.2.4" className="st4"></path>
                <path d="M60.5 122.9L60.5 122.8" className="st4"></path>
                <path d="M93.5 120.8L65.7 120.8" className="st4"></path>
                <path d="M77.2 122.8L49 122.8" className="st4"></path>
                <path d="M49 122.8L54.1 120.8" className="st4"></path>
                <path d="M49.1 122.9L49 122.9" className="st4"></path>
                <path d="M49.1 122.9c0 .1.1.3.2.4" className="st4"></path>
                <path d="M49 122.9L49 122.8" className="st4"></path>
                <path d="M82 120.8L54.1 120.8" className="st4"></path>
                <path d="M208.9 122.8L203.7 120.8" className="st4"></path>
                <path d="M208.8 122.9L208.9 122.9" className="st4"></path>
                <path d="M208.6 123.3c.1-.1.2-.2.2-.4" className="st4"></path>
                <path d="M208.9 122.9L208.9 122.8" className="st4"></path>
                <path d="M203.7 120.8L168.9 120.8" className="st4"></path>
                <path d="M173.2 122.8L208.9 122.8" className="st4"></path>
                <path d="M172.8 123.3L208.6 123.3" className="st4"></path>
                <path
                  d="M105.8 107.4L99.3 107.4 99.3 115.2 105.8 115.2 105.8 107.4"
                  className="st5"
                ></path>
                <path
                  d="M105.8 108.7L102.6 108.7 102.6 115.2 105.8 115.2 105.8 108.7"
                  className="st5"
                ></path>
                <path
                  d="M99.3 108.7L102.6 108.7 102.6 115.2 99.3 115.2 99.3 108.7"
                  className="st5"
                ></path>
                <path d="M105.8 108.6L105.8 108.7" className="st5"></path>
                <path
                  d="M105.8 108.7L99.3 108.7 99.3 108.6"
                  className="st5"
                ></path>
                <path
                  d="M121.5 107.4L115 107.4 115 115.2 121.5 115.2 121.5 107.4"
                  className="st5"
                ></path>
                <path
                  d="M121.5 108.7L118.2 108.7 118.2 115.2 121.5 115.2 121.5 108.7"
                  className="st5"
                ></path>
                <path
                  d="M115 108.7L118.2 108.7 118.2 115.2 115 115.2 115 108.7"
                  className="st5"
                ></path>
                <path d="M121.5 108.6L121.5 108.7" className="st5"></path>
                <path
                  d="M121.5 108.7L115 108.7 115 108.6"
                  className="st5"
                ></path>
                <path
                  d="M137.1 107.4L130.6 107.4 130.6 115.2 137.1 115.2 137.1 107.4"
                  className="st5"
                ></path>
                <path
                  d="M137.1 108.7L133.9 108.7 133.9 115.2 137.1 115.2 137.1 108.7"
                  className="st5"
                ></path>
                <path
                  d="M130.6 108.7L133.9 108.7 133.9 115.2 130.6 115.2 130.6 108.7"
                  className="st5"
                ></path>
                <path d="M137.1 108.6L137.1 108.7" className="st5"></path>
                <path
                  d="M137.1 108.7L130.6 108.7 130.6 108.6"
                  className="st5"
                ></path>
                <path
                  d="M164.3 107.4L157.9 107.4 157.9 115.2 164.3 115.2 164.3 107.4"
                  className="st5"
                ></path>
                <path
                  d="M164.3 108.7L161.1 108.7 161.1 115.2 164.3 115.2 164.3 108.7"
                  className="st5"
                ></path>
                <path
                  d="M157.9 108.7L161.1 108.7 161.1 115.2 157.9 115.2 157.9 108.7"
                  className="st5"
                ></path>
                <path d="M164.3 108.7L157.9 108.7" className="st5"></path>
                <path d="M106.6 116L98.5 116" className="st5"></path>
                <path
                  d="M98.5 116L98.5 115.2 106.6 115.2"
                  className="st5"
                ></path>
                <path d="M106.6 115.4L106.6 116" className="st5"></path>
                <path d="M122.3 116L114.2 116" className="st5"></path>
                <path
                  d="M114.2 116L114.2 115.2 122.3 115.2"
                  className="st5"
                ></path>
                <path d="M122.3 115.4L122.3 116" className="st5"></path>
                <path d="M137.9 116L129.8 116" className="st5"></path>
                <path
                  d="M129.8 116L129.8 115.2 137.9 115.2"
                  className="st5"
                ></path>
                <path d="M137.9 115.4L137.9 116" className="st5"></path>
                <path d="M165.2 116L157 116" className="st5"></path>
                <path d="M157 116L157 115.2 165.2 115.2" className="st5"></path>
                <path d="M165.2 115.4L165.2 116" className="st5"></path>
                <path
                  d="M137.4 93.6L137.4 86.5 133.5 86.5 133.5 93.6"
                  className="st5"
                ></path>
                <path
                  d="M137.5 93.6L137.5 86.3 133.3 86.3 133.3 93.6"
                  className="st5"
                ></path>
                <path
                  d="M137.5 93.6L137.5 86.4 133.4 86.4 133.4 93.6"
                  className="st5"
                ></path>
                <path
                  d="M135.4 72.9L135.4 67.2 138.3 67.2 138.3 72.9 138.3 65.8 132.6 65.8 132.6 72.9"
                  className="st5"
                ></path>
                <path
                  d="M132.6 72.9L132.6 67.2 135.4 67.2 135.4 72.9"
                  className="st5"
                ></path>
                <path d="M138.3 67.1L138.3 67.2" className="st5"></path>
                <path
                  d="M138.3 67.2L132.6 67.2 132.6 67.1"
                  className="st5"
                ></path>
                <path d="M125.6 72.9L100 72.9" className="st4"></path>
                <path d="M100.7 73.5L100.7 79.4" className="st4"></path>
                <path
                  d="M100.7 80L100.7 81.9 125.6 81.9"
                  className="st4"
                ></path>
                <path d="M125.6 73.5L100.5 73.5" className="st4"></path>
                <path
                  d="M100 72.9L100 73.2 100.3 73.2 100.3 73.4 100.5 73.4 100.5 73.5 100.7 73.5"
                  className="st4"
                ></path>
                <path d="M125.6 79.4L100 79.4" className="st4"></path>
                <path d="M125.6 80L100.5 80" className="st4"></path>
                <path
                  d="M100 79.4L100 79.7 100.3 79.7 100.3 79.8 100.5 79.8 100.5 80 100.7 80"
                  className="st4"
                ></path>
                <path d="M168.9 81.9L168.9 93.6" className="st4"></path>
                <path d="M105.9 81.9L105.9 93.6" className="st4"></path>
                <path
                  d="M132.5 47.6c0-1.1-.9-1.9-1.9-1.9-1.1 0-1.9.9-1.9 1.9"
                  className="st5"
                ></path>
                <path
                  d="M138 47.6L138 52.6 134.1 52.6 134.1 47.6"
                  className="st5"
                ></path>
                <path
                  d="M134.1 47.8L134.1 47.6 138 47.6 138 47.8"
                  className="st5"
                ></path>
                <path
                  d="M138 47.8L138 52.6 136.1 52.6 136.1 47.8"
                  className="st5"
                ></path>
                <path d="M136.1 52.6L136.1 47.5" className="st5"></path>
                <path d="M134.7 46.3L136 47.6" className="st5"></path>
                <path d="M137.5 46.3L136.1 47.6" className="st5"></path>
                <path d="M136.1 45.7L136.1 47.6" className="st5"></path>
                <path
                  d="M138 47.6c0-1.1-.9-1.9-1.9-1.9-1.1 0-1.9.9-1.9 1.9"
                  className="st5"
                ></path>
                <path
                  d="M147.2 47.6L147.2 52.6 151.1 52.6 151.1 47.6"
                  className="st5"
                ></path>
                <path
                  d="M151.1 47.8L151.1 47.6 147.2 47.6 147.2 47.8"
                  className="st5"
                ></path>
                <path
                  d="M147.2 47.8L147.2 52.6 149.2 52.6 149.2 47.8"
                  className="st5"
                ></path>
                <path
                  d="M151.1 47.8L151.1 52.6 149.2 52.6 149.2 47.5"
                  className="st5"
                ></path>
                <path d="M150.6 46.3L149.3 47.6" className="st5"></path>
                <path d="M147.8 46.3L149.1 47.6" className="st5"></path>
                <path d="M149.2 45.7L149.2 47.6" className="st5"></path>
                <path
                  d="M151.1 47.6c-.1-1.1-1-1.9-2.1-1.8-1 .1-1.8.8-1.8 1.8"
                  className="st5"
                ></path>
                <path
                  d="M141.7 47.6L141.7 52.6 145.6 52.6 145.6 47.6"
                  className="st5"
                ></path>
                <path
                  d="M145.6 47.8L145.6 47.6 141.7 47.6 141.7 47.8"
                  className="st5"
                ></path>
                <path
                  d="M141.7 47.8L141.7 52.6 143.7 52.6 143.7 47.6"
                  className="st5"
                ></path>
                <path d="M145.1 46.3L143.8 47.6" className="st5"></path>
                <path d="M142.3 46.3L143.6 47.6" className="st5"></path>
                <path d="M143.7 45.7L143.7 47.6" className="st5"></path>
                <path
                  d="M145.6 47.6c-.1-1.1-1-1.9-2.1-1.8-1 .1-1.8.8-1.8 1.8"
                  className="st5"
                ></path>
                <path d="M165.6 177.3L165.6 169.4" className="st5"></path>
                <path
                  d="M165.6 169.4L159.2 169.4 159.2 177.3"
                  className="st5"
                ></path>
                <path d="M165.6 177.3L165.6 170.8" className="st5"></path>
                <path
                  d="M165.6 170.8L162.4 170.8 162.4 177.3"
                  className="st5"
                ></path>
                <path d="M159.2 177.3L159.2 170.8" className="st5"></path>
                <path
                  d="M159.2 170.8L162.4 170.8 162.4 177.3"
                  className="st5"
                ></path>
                <path d="M165.6 170.7L165.6 170.8" className="st5"></path>
                <path
                  d="M165.6 170.8L159.2 170.8 159.2 170.7"
                  className="st5"
                ></path>
                <path d="M153.8 177.3H171V177.8H153.8z" className="st6"></path>
                <path d="M157.9 177.3L157.9 169.4" className="st5"></path>
                <path
                  d="M157.9 169.4L154.6 169.4 154.6 177.3"
                  className="st5"
                ></path>
                <path d="M154.6 177.3L154.6 170.8" className="st5"></path>
                <path
                  d="M154.6 170.8L157.9 170.8 157.9 177.3"
                  className="st5"
                ></path>
                <path d="M157.9 170.7L157.9 170.8" className="st5"></path>
                <path
                  d="M157.9 170.8L154.6 170.8 154.6 170.7"
                  className="st5"
                ></path>
                <path d="M166.9 177.3L166.9 169.4" className="st5"></path>
                <path
                  d="M166.9 169.4L170.2 169.4 170.2 177.3"
                  className="st5"
                ></path>
                <path d="M170.2 177.3L170.2 170.8" className="st5"></path>
                <path
                  d="M170.2 170.8L166.9 170.8 166.9 177.3"
                  className="st5"
                ></path>
                <path d="M166.9 170.7L166.9 170.8" className="st5"></path>
                <path
                  d="M166.9 170.8L170.2 170.8 170.2 170.7"
                  className="st5"
                ></path>
                <path d="M197.9 197.7L197.9 200.3" className="st5"></path>
                <path d="M197.9 200.3L197.9 215.1" className="st5"></path>
                <path d="M198.9 197.7L198.9 200.3" className="st5"></path>
                <path d="M198.9 200.3L198.9 215.1" className="st5"></path>
                <path d="M182.4 200.3L182.4 215.1" className="st5"></path>
                <path d="M181.4 200.3L181.4 215.1" className="st5"></path>
                <path d="M198.9 197.7L181.4 197.7" className="st5"></path>
                <path d="M190.2 194.7L199.3 196.9" className="st5"></path>
                <path d="M190.2 193.2L200 195.8" className="st5"></path>
                <path d="M190.2 194.7L181 196.9" className="st5"></path>
                <path d="M190.2 193.2L180.3 195.8" className="st5"></path>
                <path d="M200 195.8L199.2 197.1" className="st5"></path>
                <path d="M199.2 197.1L181.1 197.1" className="st5"></path>
                <path d="M181.4 197.4L181.4 197.7" className="st5"></path>
                <path d="M181.1 197.1L181.1 197.4" className="st5"></path>
                <path d="M198.9 197.4L198.9 197.7" className="st5"></path>
                <path d="M199.2 197.1L199.2 197.4" className="st5"></path>
                <path d="M180.3 195.8L181.1 197.1" className="st5"></path>
                <path
                  d="M197.4 198.5L194 198.5 194 209.4 197.4 209.4 197.4 198.5"
                  className="st5"
                ></path>
                <path
                  d="M190.3 198.5L194 198.5 194 209.4 190.3 209.4 190.3 198.5"
                  className="st5"
                ></path>
                <path
                  d="M182.9 198.5L186.6 198.5 186.6 209.4 183 209.4 183 198.5"
                  className="st5"
                ></path>
                <path
                  d="M190.3 198.5L186.6 198.5 186.6 209.4 190.3 209.4 190.3 198.5"
                  className="st5"
                ></path>
                <path d="M182.4 210.6L197.9 210.6" className="st5"></path>
                <path d="M193.7 210.6L193.7 215.1" className="st5"></path>
                <path d="M190 210.6L190 215.1" className="st5"></path>
                <path d="M186.3 210.6L186.3 215.1" className="st5"></path>
                <path d="M182.4 197.7L182.4 200.3" className="st5"></path>
                <path d="M181.4 197.7L181.4 200.3" className="st5"></path>
                <path d="M144.5 182.7L144.2 182.7" className="st5"></path>
                <path d="M144.3 180.4c-.2.4-.3.9-.1 1.3" className="st5"></path>
                <path d="M144.5 180.4L144.3 180.4" className="st5"></path>
                <path
                  d="M144.3 180.2c0 .1 0 .1 0 0M144.3 180.3c0 .1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M144.5 180.2L144.3 180.2" className="st5"></path>
                <path d="M144.5 180.3L144.3 180.3" className="st5"></path>
                <path d="M144.5 178L144.3 178" className="st5"></path>
                <path d="M144.3 178s-.1 0 0 0v.1" className="st5"></path>
                <path d="M144.5 178.1L144.3 178.1" className="st5"></path>
                <path d="M144.2 178.9c-.2.4-.1.9.1 1.3" className="st5"></path>
                <path d="M144.2 182.6L144.5 182.6" className="st5"></path>
                <path d="M144.7 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M144.5 178.1L144.8 178.1" className="st5"></path>
                <path
                  d="M144.7 178.1c.1 0 .1 0 0 0 .1-.1.1-.1 0 0 .1-.1.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M144.5 178L144.8 178" className="st5"></path>
                <path d="M144.5 180.3L144.7 180.3" className="st5"></path>
                <path d="M144.5 180.2L144.7 180.2" className="st5"></path>
                <path
                  d="M144.7 180.3s.1 0 0 0c.1 0 .1-.1 0 0 .1-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M144.8 182.6L144.5 182.6" className="st5"></path>
                <path
                  d="M144.7 180.4c0 .1 0 .1 0 0 .1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M144.5 180.4L144.7 180.4" className="st5"></path>
                <path
                  d="M144.8 181.8c.2-.4.1-.9-.1-1.3M144.8 182.6c.1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M144.5 182.7L144.8 182.7" className="st5"></path>
                <path
                  d="M144.8 178.1c-.1.2-.1.5 0 .8M144.2 178.9c.1-.2.1-.5 0-.8M144.8 181.8c-.1.3-.1.5 0 .8M144.2 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M145 182.9L144 182.9 144 182.7 145 182.7 145 182.9"
                  className="st5"
                ></path>
                <path
                  d="M145 178L144 178 144 177.7 145 177.7 145 178"
                  className="st5"
                ></path>
                <path d="M141.4 182.7L141.1 182.7" className="st5"></path>
                <path
                  d="M141.1 182.5c0 .1 0 .1 0 0 0 .1 0 .1 0 0M141.2 180.4c-.2.4-.3.9-.1 1.3"
                  className="st5"
                ></path>
                <path d="M141.4 180.4L141.2 180.4" className="st5"></path>
                <path
                  d="M141.2 180.2c0 .1 0 .1 0 0 0 .1 0 .1 0 0M141.2 180.3c0 .1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M141.4 180.2L141.2 180.2" className="st5"></path>
                <path d="M141.4 180.3L141.2 180.3" className="st5"></path>
                <path d="M141.4 178L141.1 178" className="st5"></path>
                <path
                  d="M141.2 178c-.1 0-.1 0 0 0-.1.1-.1.1 0 0v.1"
                  className="st5"
                ></path>
                <path d="M141.4 178.1L141.1 178.1" className="st5"></path>
                <path d="M141.1 178.9c-.2.4-.1.9.1 1.3" className="st5"></path>
                <path d="M141.1 182.6L141.4 182.6" className="st5"></path>
                <path d="M141.6 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M141.4 178.1L141.6 178.1" className="st5"></path>
                <path
                  d="M141.6 178.1c.1 0 .1 0 0 0 .1-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M141.4 178L141.6 178" className="st5"></path>
                <path d="M141.4 180.3L141.6 180.3" className="st5"></path>
                <path d="M141.4 180.2L141.6 180.2" className="st5"></path>
                <path
                  d="M141.6 180.3c.1 0 .1-.1 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M141.7 182.6L141.4 182.6" className="st5"></path>
                <path
                  d="M141.6 180.4c0 .1 0 .1 0 0 .1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M141.4 180.4L141.6 180.4" className="st5"></path>
                <path
                  d="M141.7 181.8c.2-.4.1-.9-.1-1.3M141.7 182.6c.1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M141.4 182.7L141.7 182.7" className="st5"></path>
                <path
                  d="M141.7 178.1c-.1.2-.1.5 0 .8M141.1 178.9c.1-.2.1-.5 0-.8M141.7 181.8c-.1.3-.1.5 0 .8M141.1 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M141.9 182.9L140.9 182.9 140.9 182.7 141.9 182.7 141.9 182.9"
                  className="st5"
                ></path>
                <path
                  d="M141.9 178L140.9 178 140.9 177.7 141.9 177.7 141.9 178"
                  className="st5"
                ></path>
                <path d="M138.3 182.7L138 182.7" className="st5"></path>
                <path
                  d="M138 182.5c-.1.1-.1.1 0 0 0 .1 0 .1 0 0M138.1 180.4c-.2.4-.3.9-.1 1.3"
                  className="st5"
                ></path>
                <path d="M138.3 180.4L138.1 180.4" className="st5"></path>
                <path
                  d="M138.1 180.2c0 .1 0 .1 0 0 0 .1 0 .1 0 0M138.1 180.3c-.1.1-.1.1 0 0 0 .1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M138.3 180.2L138.1 180.2" className="st5"></path>
                <path d="M138.3 180.3L138.1 180.3" className="st5"></path>
                <path d="M138.3 178L138 178" className="st5"></path>
                <path d="M138.1 178s-.1 0 0 0v.1" className="st5"></path>
                <path d="M138.3 178.1L138 178.1" className="st5"></path>
                <path d="M138 178.9c-.2.4-.2 1 .1 1.4" className="st5"></path>
                <path d="M138 182.6L138.3 182.6" className="st5"></path>
                <path d="M138.5 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M138.3 178.1L138.5 178.1" className="st5"></path>
                <path
                  d="M138.5 178.1s.1 0 0 0c.1 0 .1 0 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M138.3 178L138.5 178" className="st5"></path>
                <path d="M138.3 180.3L138.5 180.3" className="st5"></path>
                <path d="M138.3 180.2L138.5 180.2" className="st5"></path>
                <path
                  d="M138.5 180.3s0-.1 0 0c0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M138.6 182.6L138.3 182.6" className="st5"></path>
                <path d="M138.5 180.4c0 .1 0 .1 0 0" className="st5"></path>
                <path d="M138.3 180.4L138.5 180.4" className="st5"></path>
                <path
                  d="M138.6 181.8c.2-.4.1-.9-.1-1.3M138.6 182.6"
                  className="st5"
                ></path>
                <path d="M138.3 182.7L138.6 182.7" className="st5"></path>
                <path
                  d="M138.5 178.1c-.1.2-.1.5 0 .8M138 178.9c.1-.2.1-.5 0-.8M138.6 181.8c-.1.3-.1.5 0 .8M138 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M138.8 182.9L137.8 182.9 137.8 182.7 138.8 182.7 138.8 182.9"
                  className="st5"
                ></path>
                <path
                  d="M138.8 178L137.8 178 137.8 177.7 138.8 177.7 138.8 178"
                  className="st5"
                ></path>
                <path d="M135.2 182.7L134.9 182.7" className="st5"></path>
                <path
                  d="M134.9 182.5s-.1 0 0 0c-.1.1-.1.1 0 0-.1.1 0 .1 0 0M135 180.4c-.2.4-.3.9-.1 1.3"
                  className="st5"
                ></path>
                <path d="M135.2 180.4L135 180.4" className="st5"></path>
                <path
                  d="M135 180.2c-.1.1-.1.1 0 0M135 180.3c-.1.1-.1.1 0 0 0 .1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M135.2 180.2L135 180.2" className="st5"></path>
                <path d="M135.2 180.3L135 180.3" className="st5"></path>
                <path d="M135.2 178L134.9 178" className="st5"></path>
                <path d="M134.9 178v.1" className="st5"></path>
                <path d="M135.2 178.1L134.9 178.1" className="st5"></path>
                <path d="M134.9 178.9c-.2.4-.1.9.1 1.3" className="st5"></path>
                <path d="M134.9 182.6L135.2 182.6" className="st5"></path>
                <path d="M135.4 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M135.2 178.1L135.4 178.1" className="st5"></path>
                <path
                  d="M135.4 178.1c.1 0 .1 0 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M135.2 178L135.4 178" className="st5"></path>
                <path d="M135.2 180.3L135.4 180.3" className="st5"></path>
                <path d="M135.2 180.2L135.4 180.2" className="st5"></path>
                <path
                  d="M135.4 180.3s0-.1 0 0c0-.1-.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M135.5 182.6L135.2 182.6" className="st5"></path>
                <path d="M135.4 180.4c0 .1 0 .1 0 0" className="st5"></path>
                <path d="M135.2 180.4L135.4 180.4" className="st5"></path>
                <path
                  d="M135.5 181.8c.2-.4.1-.9-.1-1.3M135.5 182.6"
                  className="st5"
                ></path>
                <path d="M135.2 182.7L135.5 182.7" className="st5"></path>
                <path
                  d="M135.4 178.1c-.1.2-.1.5 0 .8M134.9 178.9c.1-.2.1-.5 0-.8M135.5 181.8c-.1.3-.1.5 0 .8M134.9 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M135.7 182.9L134.7 182.9 134.7 182.7 135.7 182.7 135.7 182.9"
                  className="st5"
                ></path>
                <path
                  d="M135.7 178L134.7 178 134.7 177.7 135.7 177.7 135.7 178"
                  className="st5"
                ></path>
                <path d="M132.1 182.7L131.8 182.7" className="st5"></path>
                <path
                  d="M131.8 182.5s-.1 0 0 0c-.1.1-.1.1 0 0-.1.1 0 .1 0 0M131.9 180.4c-.2.4-.3.9-.1 1.3"
                  className="st5"
                ></path>
                <path d="M132.1 180.4L131.9 180.4" className="st5"></path>
                <path
                  d="M131.9 180.2s-.1 0 0 0c-.1.1-.1.1 0 0-.1.1-.1.1 0 0M131.9 180.3s-.1 0 0 0c-.1.1-.1.1 0 0-.1.1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M132.1 180.2L131.9 180.2" className="st5"></path>
                <path d="M132.1 180.3L131.9 180.3" className="st5"></path>
                <path d="M132.1 178L131.8 178" className="st5"></path>
                <path d="M131.8 178v.1" className="st5"></path>
                <path d="M132.1 178.1L131.8 178.1" className="st5"></path>
                <path d="M131.8 178.9c-.2.4-.1.9.1 1.3" className="st5"></path>
                <path d="M131.8 182.6L132.1 182.6" className="st5"></path>
                <path d="M132.2 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M132.1 178.1L132.3 178.1" className="st5"></path>
                <path
                  d="M132.3 178.1c.1 0 .1 0 0 0 0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M132.1 178L132.3 178" className="st5"></path>
                <path d="M132.1 180.3L132.2 180.3" className="st5"></path>
                <path d="M132.1 180.2L132.2 180.2" className="st5"></path>
                <path
                  d="M132.3 180.3s0-.1 0 0c0-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M132.4 182.6L132.1 182.6" className="st5"></path>
                <path
                  d="M132.2 180.4c.1.1.1.1 0 0 .1 0 .1 0 0 0 .1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M132.1 180.4L132.2 180.4" className="st5"></path>
                <path
                  d="M132.4 181.8c.2-.4.1-.9-.1-1.3M132.4 182.6"
                  className="st5"
                ></path>
                <path d="M132.1 182.7L132.4 182.7" className="st5"></path>
                <path
                  d="M132.3 178.1c-.1.2-.1.5 0 .8M131.8 178.9c.1-.2.1-.5 0-.8M132.3 181.8c-.1.3-.1.5 0 .8M131.8 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M132.6 182.9L131.6 182.9 131.6 182.7 132.6 182.7 132.6 182.9"
                  className="st5"
                ></path>
                <path
                  d="M132.6 178L131.6 178 131.6 177.7 132.6 177.7 132.6 178"
                  className="st5"
                ></path>
                <path d="M128.9 182.7L128.7 182.7" className="st5"></path>
                <path
                  d="M128.7 182.5c-.1 0-.1 0 0 0m-.1.1M128.8 180.4c-.2.4-.3.9-.1 1.3"
                  className="st5"
                ></path>
                <path d="M128.9 180.4L128.8 180.4" className="st5"></path>
                <path
                  d="M128.7 180.2c0 .1 0 .1 0 0M128.8 180.3s-.1 0 0 0c-.1.1-.1.1 0 0-.1.1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M128.9 180.2L128.8 180.2" className="st5"></path>
                <path d="M128.9 180.3L128.8 180.3" className="st5"></path>
                <path d="M128.9 178L128.7 178" className="st5"></path>
                <path d="M128.7 178v.1" className="st5"></path>
                <path d="M128.9 178.1L128.7 178.1" className="st5"></path>
                <path d="M128.7 178.9c-.2.4-.1.9.1 1.3" className="st5"></path>
                <path d="M128.7 182.6L128.9 182.6" className="st5"></path>
                <path d="M129.1 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M128.9 178.1L129.2 178.1" className="st5"></path>
                <path d="M129.2 178.1c0-.1 0-.1 0 0" className="st5"></path>
                <path d="M128.9 178L129.2 178" className="st5"></path>
                <path d="M128.9 180.3L129.1 180.3" className="st5"></path>
                <path d="M128.9 180.2L129.1 180.2" className="st5"></path>
                <path
                  d="M129.2 180.3s0-.1 0 0c-.1-.1-.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M129.2 182.6L128.9 182.6" className="st5"></path>
                <path
                  d="M129.1 180.4c0 .1.1.1 0 0 .1 0 .1 0 0 0 .1 0 0 0 0 0"
                  className="st5"
                ></path>
                <path d="M128.9 180.4L129.1 180.4" className="st5"></path>
                <path
                  d="M129.3 181.8c.2-.4.1-.9-.1-1.3M129.3 182.6"
                  className="st5"
                ></path>
                <path d="M128.9 182.7L129.2 182.7" className="st5"></path>
                <path
                  d="M129.2 178.1c-.1.2-.1.5 0 .8M128.7 178.9c.1-.2.1-.5 0-.8M129.3 181.8c-.1.3-.1.5 0 .8M128.7 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M129.4 182.9L128.5 182.9 128.5 182.7 129.4 182.7 129.4 182.9"
                  className="st5"
                ></path>
                <path
                  d="M129.4 178L128.5 178 128.5 177.7 129.4 177.7 129.4 178"
                  className="st5"
                ></path>
                <path d="M125.8 182.7L125.5 182.7" className="st5"></path>
                <path
                  d="M125.6 182.5c-.1 0-.1 0 0 0-.1.1-.1.1 0 0-.1.1-.1.1 0 0M125.7 180.4c-.2.4-.3.9-.1 1.3"
                  className="st5"
                ></path>
                <path d="M125.8 180.4L125.7 180.4" className="st5"></path>
                <path
                  d="M125.7 180.2c-.1 0-.1 0 0 0-.1.1-.1.1 0 0-.1.1-.1.1 0 0M125.7 180.3c-.1 0-.1 0 0 0-.1.1-.1.1 0 0-.1.1-.1.1 0 0"
                  className="st5"
                ></path>
                <path d="M125.8 180.2L125.7 180.2" className="st5"></path>
                <path d="M125.8 180.3L125.7 180.3" className="st5"></path>
                <path d="M125.8 178L125.6 178" className="st5"></path>
                <path d="M125.6 178c0 .1 0 .1.1.1" className="st5"></path>
                <path d="M125.8 178.1L125.6 178.1" className="st5"></path>
                <path d="M125.5 178.9c-.2.4-.1.9.1 1.3" className="st5"></path>
                <path d="M125.5 182.6L125.8 182.6" className="st5"></path>
                <path d="M126.1 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M125.8 178.1L126.1 178.1" className="st5"></path>
                <path d="M126.1 178.1c0-.1 0-.1 0 0" className="st5"></path>
                <path d="M125.8 178L126.1 178" className="st5"></path>
                <path d="M125.8 180.3L126 180.3" className="st5"></path>
                <path d="M125.8 180.2L126 180.2" className="st5"></path>
                <path
                  d="M126.1 180.3s0-.1 0 0c-.1-.1-.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M126.1 182.6L125.8 182.6" className="st5"></path>
                <path d="M126.1 180.4c0 .1 0 .1 0 0" className="st5"></path>
                <path d="M125.8 180.4L126 180.4" className="st5"></path>
                <path
                  d="M126.1 181.8c.2-.4.1-.9-.1-1.3M126.1 182.6c.1.1.1.1 0 0 .1 0 .1 0 0 0 .1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M125.8 182.7L126.1 182.7" className="st5"></path>
                <path
                  d="M126.1 178.1c-.1.2-.1.5 0 .8M125.6 178.9c.1-.2.1-.5 0-.8M126.1 181.8c-.1.3-.1.5 0 .8M125.5 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M126.3 182.9L125.3 182.9 125.3 182.7 126.3 182.7 126.3 182.9"
                  className="st5"
                ></path>
                <path
                  d="M126.3 178L125.3 178 125.3 177.7 126.3 177.7 126.3 178"
                  className="st5"
                ></path>
                <path d="M122.7 182.7L122.4 182.7" className="st5"></path>
                <path d="M122.5 180.4c-.2.4-.3.9-.1 1.3" className="st5"></path>
                <path d="M122.7 180.4L122.5 180.4" className="st5"></path>
                <path
                  d="M122.5 180.2c0 .1 0 .1 0 0 0 .1 0 .1 0 0M122.5 180.3c0 .1 0 .1 0 0 0 .1 0 .1 0 0"
                  className="st5"
                ></path>
                <path d="M122.7 180.2L122.5 180.2" className="st5"></path>
                <path d="M122.7 180.3L122.5 180.3" className="st5"></path>
                <path d="M122.7 178L122.5 178" className="st5"></path>
                <path d="M122.5 178s-.1 0 0 0v.1" className="st5"></path>
                <path d="M122.7 178.1L122.5 178.1" className="st5"></path>
                <path d="M122.4 178.9c-.2.4-.1.9.1 1.3" className="st5"></path>
                <path d="M122.4 182.6L122.7 182.6" className="st5"></path>
                <path d="M122.9 180.2c.2-.4.3-.9.1-1.3" className="st5"></path>
                <path d="M122.7 178.1L123 178.1" className="st5"></path>
                <path
                  d="M122.9 178.1c.1 0 .1 0 0 0 .1 0 .1 0 0 0 .1-.1.1-.1 0 0"
                  className="st5"
                ></path>
                <path d="M122.7 178L123 178" className="st5"></path>
                <path d="M122.7 180.3L122.9 180.3" className="st5"></path>
                <path d="M122.7 180.2L122.9 180.2" className="st5"></path>
                <path
                  d="M122.9 180.3c.1 0 .1-.1 0 0 .1-.1 0-.1 0 0"
                  className="st5"
                ></path>
                <path d="M123 182.6L122.7 182.6" className="st5"></path>
                <path
                  d="M122.9 180.4c0 .1 0 .1 0 0 .1 0 .1 0 0 0"
                  className="st5"
                ></path>
                <path d="M122.7 180.4L122.9 180.4" className="st5"></path>
                <path
                  d="M123 181.8c.2-.4.1-.9-.1-1.3M123 182.6s.1 0 0 0m.1 0s-.1 0 0 0"
                  className="st5"
                ></path>
                <path d="M122.7 182.7L123 182.7" className="st5"></path>
                <path
                  d="M123 178.1c-.1.2-.1.5 0 .8M122.4 178.9c.1-.2.1-.5 0-.8M123 181.8c-.1.3-.1.5 0 .8M122.4 182.5c.1-.3.1-.5 0-.8"
                  className="st5"
                ></path>
                <path
                  d="M123.2 182.9L122.2 182.9 122.2 182.7 123.2 182.7 123.2 182.9"
                  className="st5"
                ></path>
                <path
                  d="M123.2 178L122.2 178 122.2 177.7 123.2 177.7 123.2 178"
                  className="st5"
                ></path>
              </g>
              <text
                className="st1 st2 st10"
                transform="translate(104.54 239.366)"
              >
                SELECT A FLOOR TO VIEW
              </text>
            </g>
          </g>
          <g
            className="svg-container"
            id="first-floor"
            onClick={e => this.onClickHandler(e)}
          >
            <path
              d="M38.4 183h188.7v32.9l.4.6h4.6l.1.4.5.4.8.2v1.5l-194.8.2-.3-2 1.8-2.1-.1-27.8-.5-2.1-.6-.9s-.3-.8-.3-.7"
              className="st11"
            ></path>
            <text
              className="st11 st2 st12"
              transform="translate(119.22 201.385)"
            >
              VIEW FLOOR
            </text>
          </g>
          <g
            className="svg-container"
            id="second-floor"
            onClick={e => this.onClickHandler(e)}
          >
            <path
              d="M46.4 162.3h180.9V183H40.1v-5.5h-.8l-.5-1h7.6v-14.2"
              className="st11"
            ></path>
            <text
              className="st11 st2 st12"
              transform="translate(120.22 173.385)"
            >
              VIEW FLOOR
            </text>
          </g>
          <g
            className="svg-container"
            id="third-floor"
            onClick={e => this.onClickHandler(e)}
          >
            <path
              d="M51 141.5h163.3v3.2l-.6.6-.6-.6-3.5 1.7-2.4.3v9.1H228l-.7.7v5.8H46.4v-5.8l-.8-.6h13.8v-9.1h-2.8l-4.6-2-.4.6-.7-.6v-3.3"
              className="st11"
            ></path>
            <text
              className="st11 st2 st12"
              transform="translate(121.22 152.385)"
            >
              VIEW FLOOR
            </text>
          </g>
          <g
            className="svg-container"
            id="fourth-floor"
            onClick={e => this.onClickHandler(e)}
          >
            <path
              d="M54.1 120.8h160.4l5.2 1.9-.3.5h-12.2V135h7.7l-.6.7v5.8H51v-5.8l-.7-.7h6.2v-11.7l-7.2-.1-.3-.5"
              className="st11"
            ></path>
            <text
              className="st11 st2 st12"
              transform="translate(121.22 133.385)"
            >
              VIEW FLOOR
            </text>
          </g>
          <g
            className="svg-container"
            id="fifth-floor"
            onClick={e => this.onClickHandler(e)}
          >
            <path
              d="M90.5 102.7h78.4v11.7h46.3l-.6.6v5.8H54.1V115l-.6-.6h40v-11.7"
              className="st11"
            ></path>
            <text
              className="st11 st2 st12"
              transform="translate(121.22 114.385)"
            >
              VIEW FLOOR
            </text>
          </g>
          <g
            className="svg-container"
            id="sixth-floor"
            onClick={e => this.onClickHandler(e)}
          >
            <path
              d="M100.8 80h71.6v1.9h-3.3v11.7h6.7l-.6.6-.2 5.8.3.3-.3.3v2H90.5v-2l-.3-.5.4-.1v-5.8l-.6-.6h16V81.9h-5.2"
              className="st11"
            ></path>
            <text
              className="st11 st2 st12"
              transform="translate(122.792 91.775)"
            >
              VIEW FLOOR
            </text>
          </g>
          <g className="svg-container" id="seventh-floor">
            <path
              d="M126.3 31.4h27.3v6.5h.6v3.9h.6l-.6.6v19.4h-8.8v11h27.5l-.6.6v5.8h.6l-.6.6h-71.6l-.6-.6h.6v-5.8l-.6-.6h25.6V42.6l-.3-.5.3-.3v-3.9h.7"
              className="st11"
            ></path>
            <text
              className="st11 st2 st12"
              transform="translate(126.807 55.506)"
            >
              OFF LIMITS
            </text>
          </g>
        </svg>
      </div>
    );
  }
}

export default MansionMap;
